/* Auto-generated by /app/scripts/translate_studio.py — do not edit by hand.
 * Re-run the script to refresh translations when strings change.
 */
export const studioTranslations = {
  "en": {
    "studio_editor_back": "Back",
    "studio_editor_untitled": "Untitled ad",
    "studio_editor_credits_view": "View credits ledger",
    "studio_editor_credits_label": "Credits",
    "studio_editor_credits_unlimited": "∞ Unlimited",
    "studio_editor_smart_resize": "Smart Resize",
    "studio_editor_quick_reel": "Quick Reel",
    "studio_editor_quick_reel_title": "Auto-animate every element for a 15-second reel",
    "studio_editor_save": "Save",
    "studio_editor_export_png": "Export PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Export animated video",
    "studio_editor_mp4_title_need_anim": "Add an animation first",
    "studio_editor_rail_magic": "Magic",
    "studio_editor_rail_text": "Text",
    "studio_editor_rail_shapes": "Shapes",
    "studio_editor_rail_images": "Images",
    "studio_editor_rail_anim": "Animate",
    "studio_editor_rail_layers": "Layers",
    "studio_editor_close_panel": "Close panel",
    "studio_editor_close_props": "Close properties",
    "studio_editor_open_props": "Open properties",
    "studio_editor_director_title": "AI Reel Director — one-shot",
    "studio_editor_director_sub": "One sentence → full animated reel (~10s).",
    "studio_editor_magic_title": "AI Magic — URL → 5 ads",
    "studio_editor_magic_placeholder": "https://your-site.com",
    "studio_editor_magic_generate": "Generate",
    "studio_editor_text_title": "Text",
    "studio_editor_add_heading": "Add heading",
    "studio_editor_shapes_title": "Shapes",
    "studio_editor_rectangle": "Rectangle",
    "studio_editor_circle": "Circle",
    "studio_editor_background_title": "Background",
    "studio_editor_upload_title": "Upload image",
    "studio_editor_stock_btn": "Stock photos",
    "studio_editor_from_url": "From URL",
    "studio_editor_add": "Add",
    "studio_editor_layers_title": "Layers",
    "studio_editor_canvas_empty": "Canvas is empty.",
    "studio_editor_props_title": "Properties",
    "studio_editor_select_element": "Select an element to edit its properties.",
    "studio_editor_prop_text": "Text",
    "studio_editor_prop_font": "Font",
    "studio_editor_prop_size": "Size",
    "studio_editor_prop_fill": "Fill",
    "studio_editor_prop_opacity": "Opacity",
    "studio_editor_duplicate": "Duplicate",
    "studio_editor_delete": "Delete",
    "studio_editor_toast_offline_info": "You're working offline. Log in to save and export.",
    "studio_editor_toast_open_fail": "Couldn't open editor",
    "studio_editor_toast_image_fail": "Couldn't load image",
    "studio_editor_toast_saved": "Saved",
    "studio_editor_toast_save_fail": "Save failed",
    "studio_editor_toast_log_in_save": "Log in to save your ad to the cloud.",
    "studio_editor_toast_add_elements_first": "Add some elements first, then click Quick Reel.",
    "studio_editor_toast_need_animation": "Add at least one animation first (Animate rail).",
    "studio_editor_toast_browser_no_video": "Your browser doesn't support video recording.",
    "studio_editor_toast_video_fail": "Video export failed",
    "studio_editor_toast_export_fail": "Export failed",
    "studio_editor_toast_exported": "Exported!",
    "studio_editor_toast_exported_ext": "Exported .{ext}!",
    "studio_editor_toast_credits_out": "Out of ad credits.",
    "studio_editor_toast_credits_out_upsell": "You're out of ad credits. Upgrade to Pro for 30/month.",
    "studio_editor_toast_ai_fail": "AI Magic failed",
    "studio_editor_toast_no_variants": "No variants returned",
    "studio_editor_toast_applied": "Applied: {angle}",
    "studio_editor_toast_quick_reel_done": "Quick Reel · {n} animations · {s}s",
    "studio_editor_toast_smart_resize_done": "Created {n} sibling ad{plural}",
    "studio_editor_toast_smart_resize_fail": "Smart resize failed",
    "studio_my_have_coupon": "Have a coupon?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Redeem",
    "studio_my_toast_credits_added": "+{amount} credits added 🎉",
    "studio_my_toast_not_found": "Code not found",
    "studio_my_toast_already": "Already redeemed",
    "studio_my_toast_expired": "Expired or deactivated",
    "studio_my_toast_redeem_fail": "Redeem failed",
    "studio_my_toast_load_fail": "Failed to load projects",
    "studio_my_confirm_delete": "Delete \"{title}\"?",
    "studio_my_title": "My designs",
    "studio_my_sub": "All your saved projects and exports in one place.",
    "studio_my_count_one": "{n} project",
    "studio_my_count_many": "{n} projects",
    "studio_my_instant_campaign": "Instant Campaign",
    "studio_my_new_ad": "New ad",
    "studio_my_login_to_see": "Log in to see your saved ads.",
    "studio_my_login": "Log in",
    "studio_my_loading": "Loading…",
    "studio_my_empty_title": "No ads yet.",
    "studio_my_browse": "Browse templates",
    "studio_my_badge_team": "Team",
    "studio_my_badge_shared": "Shared",
    "studio_my_edit": "Edit",
    "studio_gallery_filter_prefix": "Filter",
    "studio_gallery_filter_cancel": "× clear",
    "studio_gallery_title": "Templates",
    "studio_gallery_lead": "Pick a start. Edit anything.",
    "studio_gallery_search": "Search templates…",
    "studio_gallery_loading_count": "Loading…",
    "studio_gallery_count_of": "{start}–{end} of {total} templates",
    "studio_gallery_pack_all": "All",
    "studio_gallery_pack_trending": "Trending",
    "studio_gallery_pack_ai": "AI-Powered",
    "studio_gallery_pack_editorial": "Editorial",
    "studio_gallery_pack_video": "Video Reels",
    "studio_gallery_pack_free": "Free",
    "studio_gallery_video_only": "Video only",
    "studio_gallery_all_formats": "All formats",
    "studio_gallery_all_categories": "All categories",
    "studio_gallery_loading_templates": "Loading templates…",
    "studio_gallery_no_match": "No templates match those filters.",
    "studio_gallery_opening": "Opening editor…",
    "studio_gallery_prev": "← Prev",
    "studio_gallery_next": "Next →",
    "studio_gallery_page_of": "Page {n} of {total}",
    "studio_gallery_type_post": "Post",
    "studio_gallery_type_story": "Story",
    "studio_gallery_type_reel": "Reel",
    "studio_gallery_type_video": "Video",
    "studio_gallery_type_ad": "Ad",
    "studio_landing_meta_title": "Studio — AI designs, reels & videos in 60 seconds | TopRankPulse",
    "studio_landing_meta_desc": "Create posts, reels, videos and ads with AI. 1,600+ templates, one-click export. Part of TopRankPulse.",
    "studio_landing_eyebrow": "NEW · STUDIO BY TOPRANKPULSE",
    "studio_landing_hero_title_a": "Create posts, reels and videos.",
    "studio_landing_hero_title_b": "In minutes, not days.",
    "studio_landing_hero_lead": "Pick a content type, a template, or let AI draft the first version. Edit in a Canva-style editor. Export PNG / MP4 in one click. Ads, reels, stories, videos and posts — all in one.",
    "studio_landing_cta_start": "Start creating",
    "studio_landing_cta_instant": "Instant Campaign — 25 ads",
    "studio_landing_cta_browse": "Browse templates",
    "studio_landing_kpi_projects": "Projects created",
    "studio_landing_kpi_exports": "Exports downloaded",
    "studio_landing_kpi_templates": "Templates",
    "studio_landing_kpi_formats": "Ad formats",
    "studio_landing_features_title": "A studio. Not a slideshow.",
    "studio_landing_features_sub": "Everything a performance marketer actually uses — one screen, no tabs.",
    "studio_landing_feat_ai_title": "AI Magic from URL",
    "studio_landing_feat_ai_text": "Paste a website, get 5 full ad concepts — brand colors, headlines, CTAs, ready-to-ship canvases.",
    "studio_landing_feat_type_title": "Full typography",
    "studio_landing_feat_type_text": "Fonts, weights, tracking, outlines, drop shadows. Textboxes that behave like Adobe, not PowerPoint.",
    "studio_landing_feat_img_title": "AI + stock images",
    "studio_landing_feat_img_text": "Generate pixel-perfect backgrounds with GPT Image 1. Unsplash and Pexels baked in.",
    "studio_landing_feat_brand_title": "Brand kit",
    "studio_landing_feat_brand_text": "Lock your colors, fonts, logos once. Every new ad inherits them automatically.",
    "studio_landing_feat_resize_title": "Smart resize",
    "studio_landing_feat_resize_text": "One canvas → 10 sibling ads auto-scaled to every format. Ship a full campaign in one click.",
    "studio_landing_feat_wl_title": "White-label ready",
    "studio_landing_feat_wl_text": "Built to be embedded. Drop into your agency portal via iframe or API. Your brand, our engine.",
    "studio_landing_formats_title": "10 ad formats. One canvas.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Feed, Story, Reel.",
    "studio_landing_pricing_title": "Simple, credit-based pricing.",
    "studio_landing_pricing_sub": "Start free. Scale when your campaigns do.",
    "studio_landing_pricing_extra": "Extra ads beyond plan: €2.30 / credit · cancel any time",
    "studio_landing_price_free_credits": "3 ads · one-time",
    "studio_landing_price_starter_credits": "10 ads / month",
    "studio_landing_price_pro_credits": "30 ads / month",
    "studio_landing_price_agency_credits": "80 ads / month",
    "studio_landing_price_free_f1": "All 10 formats",
    "studio_landing_price_free_f2": "AI Magic from URL",
    "studio_landing_price_free_f3": "PNG export",
    "studio_landing_price_free_f4": "No credit card",
    "studio_landing_price_starter_f1": "Everything in Free",
    "studio_landing_price_starter_f2": "Brand Kit",
    "studio_landing_price_starter_f3": "Smart Resize",
    "studio_landing_price_starter_f4": "Priority queue",
    "studio_landing_price_pro_f1": "Everything in Starter",
    "studio_landing_price_pro_f2": "AI Image Gen (GPT Image 1)",
    "studio_landing_price_pro_f3": "Video export (coming)",
    "studio_landing_price_pro_f4": "Remove watermark",
    "studio_landing_price_agency_f1": "Everything in Pro",
    "studio_landing_price_agency_f2": "Team seats (coming)",
    "studio_landing_price_agency_f3": "White-label export",
    "studio_landing_price_agency_f4": "Dedicated support",
    "studio_landing_price_free_cta": "Start free",
    "studio_landing_price_starter_cta": "Get Starter",
    "studio_landing_price_pro_cta": "Get Pro",
    "studio_landing_price_agency_cta": "Get Agency",
    "studio_landing_price_most_popular": "Most popular",
    "studio_landing_final_title": "Ship your first ad tonight.",
    "studio_landing_final_sub": "Three free ads. No card. Two clicks to publish.",
    "studio_landing_final_btn": "Open the editor",
    "studio_landing_footer": "Studio · part of",
    "studio_create_back_select": "← Back to selection",
    "studio_create_new_prefix": "New",
    "studio_create_type_desc_suffix": "Pick a template, or start from a blank canvas.",
    "studio_create_opt_templates_title": "Pick a template",
    "studio_create_opt_templates_sub": "Hundreds of ready-made designs — editable",
    "studio_create_opt_blank_title": "Blank canvas",
    "studio_create_opt_blank_sub": "Full control, empty canvas",
    "studio_create_opt_ai_title": "AI Magic ✨",
    "studio_create_opt_ai_sub": "Describe what you want — AI creates the first version",
    "studio_create_hub_eyebrow": "What are you creating?",
    "studio_create_hub_title_a": "Let's get",
    "studio_create_hub_title_b": "creative",
    "studio_create_hub_sub": "Pick a content type. Each preset opens the right dimensions and templates.",
    "studio_create_card_start": "Start",
    "studio_strip_scenarios_eyebrow": "For you today",
    "studio_strip_scenarios_title": "Start from a scenario",
    "studio_strip_scenarios_sub": "Pick a campaign type → we'll open ready templates",
    "studio_strip_recent_eyebrow": "Continue",
    "studio_strip_recent_title": "Your recent work",
    "studio_strip_recent_sub": "Pick up where you left off",
    "studio_strip_trending_eyebrow": "Most popular",
    "studio_strip_trending_title": "Trending templates",
    "studio_strip_trending_sub": "Templates that are working this week",
    "studio_strip_view_all": "View all →",
    "studio_strip_open": "Open",
    "studio_strip_notify": "Coming soon",
    "studio_strip_coming_soon": "Soon",
    "studio_strip_templates_short": "templates",
    "scen_bf_title": "Black Friday",
    "scen_bf_sub": "Turn discounts into sales — 5 ready sets",
    "scen_launch_title": "Launch Day",
    "scen_launch_sub": "Introduce a new product with the wow factor",
    "scen_holiday_title": "Holiday campaign",
    "scen_holiday_sub": "Christmas, Easter, Mother's Day — ready to go",
    "scen_sale_title": "Sale",
    "scen_sale_sub": "Seasonal -30%, -50%, -70% campaigns",
    "scen_event_title": "Event / Conference",
    "scen_event_sub": "Webinar, meetup, demo day",
    "scen_giveaway_title": "Giveaway",
    "scen_giveaway_sub": "Engagement push with a reward",
    "studio_create_type_post_label": "Post",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Story",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animated · 15–60s",
    "studio_create_type_video_label": "Video",
    "studio_create_type_video_desc": "16:9 · landscape",
    "studio_create_type_ad_label": "Ad",
    "studio_create_type_ad_desc": "FB/IG ad creative",
    "studio_more_title": "More",
    "studio_more_sub": "Settings, account and other tools.",
    "studio_more_settings": "Account settings",
    "studio_more_notifications": "Notifications",
    "studio_more_plan": "Plan & billing",
    "studio_more_invite": "Invite friends",
    "studio_more_redeem": "Redeem a coupon",
    "studio_more_ai": "AI Magic",
    "studio_more_privacy": "Privacy",
    "studio_more_help": "Help & Blog",
    "studio_more_logout": "Log out",
    "studio_nav_create": "Create",
    "studio_nav_mine": "My designs",
    "studio_nav_templates": "Templates",
    "studio_nav_community": "Community",
    "studio_nav_more": "More",
    "studio_nav_home": "Home",
    "studio_nav_projects": "Projects",
    "studio_nav_ai_magic": "AI Magic",
    "studio_nav_business": "Business",
    "studio_nav_create_aria": "Create new design",
    "studio_team_title": "Business — team workspace",
    "studio_team_sub": "Invite colleagues to work together. Max. 10 members per team.",
    "studio_team_load_fail": "Couldn't load team",
    "studio_team_create_title": "Create a new team",
    "studio_team_create_sub": "You become the owner and can invite members.",
    "studio_team_name_placeholder": "Team name",
    "studio_team_create_btn": "Create",
    "studio_team_join_title": "Join with an existing invite",
    "studio_team_join_sub": "If someone sent you an invite code.",
    "studio_team_invite_code_placeholder": "Invite code",
    "studio_team_join_btn": "Join",
    "studio_team_created": "Team created",
    "studio_team_failed": "Failed",
    "studio_team_joined": "Joined team",
    "studio_team_invite_invalid": "Invite invalid",
    "studio_team_member_one": "member",
    "studio_team_members_many": "members",
    "studio_team_you_are_owner": "· you are owner",
    "studio_team_leave_btn": "Leave",
    "studio_team_confirm_leave": "Really leave the team?",
    "studio_team_left": "Left team",
    "studio_team_invite_title": "Invite a new member",
    "studio_team_invite_email_placeholder": "email@example.com",
    "studio_team_send_invite": "Send invite",
    "studio_team_invite_copied": "Invite link copied to clipboard",
    "studio_team_auto_copy_hint": "Invite link is copied to clipboard automatically.",
    "studio_team_members_header": "Members",
    "studio_team_owner_badge": "Owner",
    "studio_team_pending_header": "Pending invites",
    "studio_team_expires": "Expires"
  },
  "sk": {
    "studio_editor_back": "Späť",
    "studio_editor_untitled": "Nepomenovaná reklama",
    "studio_editor_credits_view": "Zobraziť knihu kreditov",
    "studio_editor_credits_label": "Kredity",
    "studio_editor_credits_unlimited": "∞ Neobmedzené",
    "studio_editor_smart_resize": "Inteligentné zmenšenie",
    "studio_editor_quick_reel": "Rýchly reel",
    "studio_editor_quick_reel_title": "Automaticky animovať každý prvok pre 15-sekundový reel",
    "studio_editor_save": "Uložiť",
    "studio_editor_export_png": "Exportovať PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Exportovať animované video",
    "studio_editor_mp4_title_need_anim": "Najprv pridajte animáciu",
    "studio_editor_rail_magic": "Magické",
    "studio_editor_rail_text": "Text",
    "studio_editor_rail_shapes": "Tvary",
    "studio_editor_rail_images": "Obrázky",
    "studio_editor_rail_anim": "Animovať",
    "studio_editor_rail_layers": "Vrstvy",
    "studio_editor_close_panel": "Zavrieť panel",
    "studio_editor_close_props": "Zavrieť vlastnosti",
    "studio_editor_open_props": "Otvoriť vlastnosti",
    "studio_editor_director_title": "AI Reel režisér — jednorazový",
    "studio_editor_director_sub": "Jedna veta → plný animovaný reel (~10s).",
    "studio_editor_magic_title": "AI Magické — URL → 5 reklám",
    "studio_editor_magic_placeholder": "https://vas-web.com",
    "studio_editor_magic_generate": "Vygenerovať",
    "studio_editor_text_title": "Text",
    "studio_editor_add_heading": "Pridať nadpis",
    "studio_editor_shapes_title": "Tvary",
    "studio_editor_rectangle": "Obdĺžnik",
    "studio_editor_circle": "Kruh",
    "studio_editor_background_title": "Pozadie",
    "studio_editor_upload_title": "Nahrať obrázok",
    "studio_editor_stock_btn": "Skladové fotografie",
    "studio_editor_from_url": "Z URL",
    "studio_editor_add": "Pridať",
    "studio_editor_layers_title": "Vrstvy",
    "studio_editor_canvas_empty": "Plátno je prázdne.",
    "studio_editor_props_title": "Vlastnosti",
    "studio_editor_select_element": "Vyberte prvok na úpravu jeho vlastností.",
    "studio_editor_prop_text": "Text",
    "studio_editor_prop_font": "Písmo",
    "studio_editor_prop_size": "Veľkosť",
    "studio_editor_prop_fill": "Výplň",
    "studio_editor_prop_opacity": "Priehľadnosť",
    "studio_editor_duplicate": "Duplicovať",
    "studio_editor_delete": "Odstrániť",
    "studio_editor_toast_offline_info": "Pracujete offline. Prihláste sa na uloženie a export.",
    "studio_editor_toast_open_fail": "Nepodarilo sa otvoriť editor",
    "studio_editor_toast_image_fail": "Nepodarilo sa načítať obrázok",
    "studio_editor_toast_saved": "Uložené",
    "studio_editor_toast_save_fail": "Uloženie zlyhalo",
    "studio_editor_toast_log_in_save": "Prihláste sa na uloženie vášho inzerátu do cloudu.",
    "studio_editor_toast_add_elements_first": "Najskôr pridajte nejaké prvky, potom kliknite na Rýchly film.",
    "studio_editor_toast_need_animation": "Najskôr pridajte aspoň jednu animáciu (Animovať koľajnicu).",
    "studio_editor_toast_browser_no_video": "Váš prehliadač nepodporuje nahrávanie videa.",
    "studio_editor_toast_video_fail": "Export videa zlyhal",
    "studio_editor_toast_export_fail": "Export zlyhal",
    "studio_editor_toast_exported": "Exportované!",
    "studio_editor_toast_exported_ext": "Exportované .{ext}!",
    "studio_editor_toast_credits_out": "Nemáte žiadne kreditné body na inzeráty.",
    "studio_editor_toast_credits_out_upsell": "Nemáte žiadne kreditné body na inzeráty. Prejdite na Pro za 30/mesiac.",
    "studio_editor_toast_ai_fail": "AI Magia zlyhala",
    "studio_editor_toast_no_variants": "Neexistujú žiadne varianty",
    "studio_editor_toast_applied": "Použité: {angle}",
    "studio_editor_toast_quick_reel_done": "Rýchly film · {n} animácií · {s}s",
    "studio_editor_toast_smart_resize_done": "Vytvorené {n} súvisiace inzeráty",
    "studio_editor_toast_smart_resize_fail": "Inteligentné zmenšenie zlyhalo",
    "studio_my_have_coupon": "Máte kupón?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Uplatniť",
    "studio_my_toast_credits_added": "+{amount} kreditné body pridane 🎉",
    "studio_my_toast_not_found": "Kód nebol nájdený",
    "studio_my_toast_already": "Už uplatnené",
    "studio_my_toast_expired": "Platnosť vypršala alebo deaktivované",
    "studio_my_toast_redeem_fail": "Uplatnenie zlyhalo",
    "studio_my_toast_load_fail": "Načítanie projektov zlyhalo",
    "studio_my_confirm_delete": "Odstrániť \"{title}\"?",
    "studio_my_title": "Moje dizajny",
    "studio_my_sub": "Všetky vaše uložené projekty a exporty na jednom mieste.",
    "studio_my_count_one": "{n} projekt",
    "studio_my_count_many": "{n} projekty",
    "studio_my_instant_campaign": "Okamžitá kampaň",
    "studio_my_new_ad": "Nová reklama",
    "studio_my_login_to_see": "Prihláste sa, aby ste videli svoje uložené reklamy.",
    "studio_my_login": "Prihlásiť sa",
    "studio_my_loading": "Načítava sa…",
    "studio_my_empty_title": "Zatiaľ žiadne reklamy.",
    "studio_my_browse": "Prehľadávať šablóny",
    "studio_my_badge_team": "Tím",
    "studio_my_badge_shared": "Zdieľané",
    "studio_my_edit": "Upraviť",
    "studio_gallery_filter_prefix": "Filter",
    "studio_gallery_filter_cancel": "× zrušiť",
    "studio_gallery_title": "Šablóny",
    "studio_gallery_lead": "Vyberte začiatok. Upravte čokoľvek.",
    "studio_gallery_search": "Hľadať šablóny…",
    "studio_gallery_loading_count": "Načítava sa…",
    "studio_gallery_count_of": "{start}–{end} z {total} šablón",
    "studio_gallery_pack_all": "Všetko",
    "studio_gallery_pack_trending": "Trendy",
    "studio_gallery_pack_ai": "Na báze AI",
    "studio_gallery_pack_editorial": "Redakčný",
    "studio_gallery_pack_video": "Video Klipy",
    "studio_gallery_pack_free": "Zadarmo",
    "studio_gallery_video_only": "Iba video",
    "studio_gallery_all_formats": "Všetky formáty",
    "studio_gallery_all_categories": "Všetky kategórie",
    "studio_gallery_loading_templates": "Načítava sa šablóny…",
    "studio_gallery_no_match": "Žiadne šablóny nezodpovedajú týmto filtrom.",
    "studio_gallery_opening": "Otvorenie editora…",
    "studio_gallery_prev": "← Predchádzajúci",
    "studio_gallery_next": "Ďalší →",
    "studio_gallery_page_of": "Strana {n} z {total}",
    "studio_gallery_type_post": "Príspevok",
    "studio_gallery_type_story": "Príbeh",
    "studio_gallery_type_reel": "Klip",
    "studio_gallery_type_video": "Video",
    "studio_gallery_type_ad": "Reklama",
    "studio_landing_meta_title": "Štúdio — AI dizajny, krátke videá a videá za 60 sekúnd | TopRankPulse",
    "studio_landing_meta_desc": "Vytvorte príspevky, krátke videá, videá a reklamy s AI. Viac ako 1 600 šablón, export na jedno kliknutie. Súčasťou TopRankPulse.",
    "studio_landing_eyebrow": "NOVÉ · ŠTÚDIO OD TOPRANKPULSE",
    "studio_landing_hero_title_a": "Vytvorte príspevky, krátke videá a videá.",
    "studio_landing_hero_title_b": "Za minúty, nie dni.",
    "studio_landing_hero_lead": "Vyberte typ obsahu, šablónu alebo nechajte AI pripraviť prvú verziu. Upravené v editore typu Canva. Export PNG / MP4 na jedno kliknutie. Reklamy, krátke videá, príbehy, videá a príspevky — všetko na jednom mieste.",
    "studio_landing_cta_start": "Začnite tvoriť",
    "studio_landing_cta_instant": "Okamžitá kampaň — 25 reklám",
    "studio_landing_cta_browse": "Prehliadať šablóny",
    "studio_landing_kpi_projects": "Vytvorené projekty",
    "studio_landing_kpi_exports": "Stiahnuté exporty",
    "studio_landing_kpi_templates": "Šablóny",
    "studio_landing_kpi_formats": "Reklamné formáty",
    "studio_landing_features_title": "Štúdio. Nie prezentácia.",
    "studio_landing_features_sub": "Všetko, čo výkonový marketér naozaj potrebuje — jedna obrazovka, žiadne karty.",
    "studio_landing_feat_ai_title": "AI Magické z URL",
    "studio_landing_feat_ai_text": "Vložte webovú stránku, získajte 5 kompletných konceptov reklamy — farby značky, nadpisy, CTAs, pripravené kanvas.",
    "studio_landing_feat_type_title": "Plná typografia",
    "studio_landing_feat_type_text": "Písmo, váhy, sledovanie, obrysy, tiene. Textové polia, ktoré sa správajú ako Adobe, nie PowerPoint.",
    "studio_landing_feat_img_title": "AI + stock obrázky",
    "studio_landing_feat_img_text": "Generujte pixelovo presné pozadia s GPT Image 1. Unsplash a Pexels integrované.",
    "studio_landing_feat_brand_title": "Kits značky",
    "studio_landing_feat_brand_text": "Zamknite svoje farby, písma, logá raz. Každá nová reklama ich zdedí automaticky.",
    "studio_landing_feat_resize_title": "Inteligentné zmenšenie",
    "studio_landing_feat_resize_text": "Jedna plátno → 10 súrodeneckých reklám automaticky prispôsobených každému formátu. Dodajte celú kampaň na jedno kliknutie.",
    "studio_landing_feat_wl_title": "Pripravené pre biele označenie",
    "studio_landing_feat_wl_text": "Navrhnuté na vloženie. Vložte do svojho portálu agentúry pomocou iframe alebo API. Vaša značka, náš engine.",
    "studio_landing_formats_title": "10 reklamných formátov. Jeden plátno.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Feed, Príbeh, Krátke video.",
    "studio_landing_pricing_title": "Jednoduché, kreditom založené ceny.",
    "studio_landing_pricing_sub": "Začnite zadarmo. Rastu, keď rastú vaše kampane.",
    "studio_landing_pricing_extra": "Extra reklamy nad rámec plánu: €2.30 / kredit · zrušiť kedykoľvek",
    "studio_landing_price_free_credits": "3 reklamy · jednorázovo",
    "studio_landing_price_starter_credits": "10 reklám / mesiac",
    "studio_landing_price_pro_credits": "30 reklám / mesiac",
    "studio_landing_price_agency_credits": "80 reklám / mesiac",
    "studio_landing_price_free_f1": "Všetky 10 formátov",
    "studio_landing_price_free_f2": "AI Magické z URL",
    "studio_landing_price_free_f3": "PNG export",
    "studio_landing_price_free_f4": "Bez kreditnej karty",
    "studio_landing_price_starter_f1": "Všetko zadarmo",
    "studio_landing_price_starter_f2": "Kreatívna súprava",
    "studio_landing_price_starter_f3": "Inteligentná zmena veľkosti",
    "studio_landing_price_starter_f4": "Prioritná fronta",
    "studio_landing_price_pro_f1": "Všetko v Starter",
    "studio_landing_price_pro_f2": "Generovanie obrázkov AI (GPT Image 1)",
    "studio_landing_price_pro_f3": "Export videa (čoskoro)",
    "studio_landing_price_pro_f4": "Odstrániť watermark",
    "studio_landing_price_agency_f1": "Všetko v Pro",
    "studio_landing_price_agency_f2": "Miesta pre tím (čoskoro)",
    "studio_landing_price_agency_f3": "Export s bielou nálepkou",
    "studio_landing_price_agency_f4": "Osobná podpora",
    "studio_landing_price_free_cta": "Začnite zadarmo",
    "studio_landing_price_starter_cta": "Získať Starter",
    "studio_landing_price_pro_cta": "Získať Pro",
    "studio_landing_price_agency_cta": "Získať Agency",
    "studio_landing_price_most_popular": "Najobľúbenejšie",
    "studio_landing_final_title": "Zverejnite svoju prvú reklamu dnes večer.",
    "studio_landing_final_sub": "Tri zadarmo reklamy. Žiadna karta. Dva kliky na publikovanie.",
    "studio_landing_final_btn": "Otvoriť editor",
    "studio_landing_footer": "Štúdio · súčasť",
    "studio_create_back_select": "← Návrat k výberu",
    "studio_create_new_prefix": "Nové",
    "studio_create_type_desc_suffix": "Vyberte šablónu alebo začnite z prázdneho plátna.",
    "studio_create_opt_templates_title": "Vyberte šablónu",
    "studio_create_opt_templates_sub": "Tisíce hotových návrhov — editovateľné",
    "studio_create_opt_blank_title": "Prázdne plátno",
    "studio_create_opt_blank_sub": "Úplná kontrola, prázdne plátno",
    "studio_create_opt_ai_title": "AI Magické ✨",
    "studio_create_opt_ai_sub": "Popíšte, čo chcete — AI vytvorí prvú verziu",
    "studio_create_hub_eyebrow": "Čo vytvárate?",
    "studio_create_hub_title_a": "Poďme byť",
    "studio_create_hub_title_b": "kreatívni",
    "studio_create_hub_sub": "Vyberte typ obsahu. Každé prednastavenie otvorí správne rozmery a šablóny.",
    "studio_create_card_start": "Začať",
    "studio_strip_scenarios_eyebrow": "Pre teba dnes",
    "studio_strip_scenarios_title": "Začni zo scenára",
    "studio_strip_scenarios_sub": "Vyber typ kampane → otvoríme ti pripravené šablóny",
    "studio_strip_recent_eyebrow": "Pokračuj",
    "studio_strip_recent_title": "Tvoje nedávne práce",
    "studio_strip_recent_sub": "Pokračuj tam kde si skončil",
    "studio_strip_trending_eyebrow": "Najpopulárnejšie",
    "studio_strip_trending_title": "Trending šablóny",
    "studio_strip_trending_sub": "Šablóny, ktoré tento týždeň fungujú",
    "studio_strip_view_all": "Všetky →",
    "studio_strip_open": "Otvoriť",
    "studio_strip_notify": "Pripravujeme",
    "studio_strip_coming_soon": "Soon",
    "studio_strip_templates_short": "šablón",
    "scen_bf_title": "Black Friday",
    "scen_bf_sub": "Konvertujte zľavy na predaj — 5 hotových sád",
    "scen_launch_title": "Launch dňa",
    "scen_launch_sub": "Predstavte nový produkt s wow efektom",
    "scen_holiday_title": "Sviatočná kampaň",
    "scen_holiday_sub": "Vianoce, Veľká Noc, Deň Matiek — pripravené",
    "scen_sale_title": "Výpredaj",
    "scen_sale_sub": "Sezónne -30%, -50%, -70% kampane",
    "scen_event_title": "Event / Konferencia",
    "scen_event_sub": "Webinár, meetup, demo deň",
    "scen_giveaway_title": "Súťaž / Giveaway",
    "scen_giveaway_sub": "Engagement push s odmenou",
    "studio_create_type_post_label": "Príspevok",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Príbeh",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animovaný · 15–60s",
    "studio_create_type_video_label": "Video",
    "studio_create_type_video_desc": "16:9 · na šírku",
    "studio_create_type_ad_label": "Reklama",
    "studio_create_type_ad_desc": "FB/IG reklama",
    "studio_more_title": "Viac",
    "studio_more_sub": "Nastavenia, účet a ďalšie nástroje.",
    "studio_more_settings": "Nastavenia účtu",
    "studio_more_notifications": "Oznámenia",
    "studio_more_plan": "Plán a fakturácia",
    "studio_more_invite": "Pozvať priateľov",
    "studio_more_redeem": "Uplatniť kupón",
    "studio_more_ai": "AI Magia",
    "studio_more_privacy": "Ochrana súkromia",
    "studio_more_help": "Pomoc & Blog",
    "studio_more_logout": "Odhlásiť sa",
    "studio_nav_create": "Vytvoriť",
    "studio_nav_mine": "Moje návrhy",
    "studio_nav_templates": "Šablóny",
    "studio_nav_community": "Komunita",
    "studio_nav_more": "Viac",
    "studio_nav_home": "Domov",
    "studio_nav_projects": "Projekt",
    "studio_nav_ai_magic": "AI Magia",
    "studio_nav_business": "Podnikanie",
    "studio_nav_create_aria": "Vytvoriť nový návrh",
    "studio_team_title": "Podnikanie — tímový pracovný priestor",
    "studio_team_sub": "Pozvite kolegov na spoločnú prácu. Max. 10 členov na tím.",
    "studio_team_load_fail": "Nemožno načítať tím",
    "studio_team_create_title": "Vytvoriť nový tím",
    "studio_team_create_sub": "Stávate sa vlastníkom a môžete pozvať členov.",
    "studio_team_name_placeholder": "Názov tímu",
    "studio_team_create_btn": "Vytvoriť",
    "studio_team_join_title": "Pripojiť sa s existujúcim pozvaním",
    "studio_team_join_sub": "Ak vám niekto poslal kód pozvania.",
    "studio_team_invite_code_placeholder": "Kód pozvania",
    "studio_team_join_btn": "Pripojiť sa",
    "studio_team_created": "Tím vytvorený",
    "studio_team_failed": "Zlyhalo",
    "studio_team_joined": "Pripojený k tímu",
    "studio_team_invite_invalid": "Neplatné pozvanie",
    "studio_team_member_one": "člen",
    "studio_team_members_many": "členovia",
    "studio_team_you_are_owner": "· ste vlastníkom",
    "studio_team_leave_btn": "Odísť",
    "studio_team_confirm_leave": "Naozaj chcete odísť z tímu?",
    "studio_team_left": "Opustil tím",
    "studio_team_invite_title": "Pozvať nového člena",
    "studio_team_invite_email_placeholder": "email@example.com",
    "studio_team_send_invite": "Poslať pozvanie",
    "studio_team_invite_copied": "Odkaz na pozvanie skopírovaný do schránky",
    "studio_team_auto_copy_hint": "Odkaz na pozvanie bol automaticky skopírovaný do schránky.",
    "studio_team_members_header": "Členovia",
    "studio_team_owner_badge": "Vlastník",
    "studio_team_pending_header": "Čakajúce pozvania",
    "studio_team_expires": "Expiruje"
  },
  "cs": {
    "studio_editor_back": "Zpět",
    "studio_editor_untitled": "Název reklamy",
    "studio_editor_credits_view": "Zobrazit účetní knihu kreditů",
    "studio_editor_credits_label": "Kredity",
    "studio_editor_credits_unlimited": "∞ Neomezené",
    "studio_editor_smart_resize": "Chytré změny velikosti",
    "studio_editor_quick_reel": "Rychlý klip",
    "studio_editor_quick_reel_title": "Automaticky animovat každý prvek pro 15sekundový klip",
    "studio_editor_save": "Uložit",
    "studio_editor_export_png": "Exportovat PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Exportovat animované video",
    "studio_editor_mp4_title_need_anim": "Nejprve přidejte animaci",
    "studio_editor_rail_magic": "Magie",
    "studio_editor_rail_text": "Text",
    "studio_editor_rail_shapes": "Tvary",
    "studio_editor_rail_images": "Obrázky",
    "studio_editor_rail_anim": "Animovat",
    "studio_editor_rail_layers": "Vrstvy",
    "studio_editor_close_panel": "Zavřít panel",
    "studio_editor_close_props": "Zavřít vlastnosti",
    "studio_editor_open_props": "Otevřít vlastnosti",
    "studio_editor_director_title": "AI Režisér klipů — jednorázový",
    "studio_editor_director_sub": "Jedna věta → plný animovaný klip (~10s).",
    "studio_editor_magic_title": "AI Magie — URL → 5 reklam",
    "studio_editor_magic_placeholder": "https://vaše-stránka.com",
    "studio_editor_magic_generate": "Vytvořit",
    "studio_editor_text_title": "Text",
    "studio_editor_add_heading": "Přidat nadpis",
    "studio_editor_shapes_title": "Tvary",
    "studio_editor_rectangle": "Obdélník",
    "studio_editor_circle": "Kruh",
    "studio_editor_background_title": "Pozadí",
    "studio_editor_upload_title": "Nahrát obrázek",
    "studio_editor_stock_btn": "Skladové fotografie",
    "studio_editor_from_url": "Z URL",
    "studio_editor_add": "Přidat",
    "studio_editor_layers_title": "Vrstvy",
    "studio_editor_canvas_empty": "Plátno je prázdné.",
    "studio_editor_props_title": "Vlastnosti",
    "studio_editor_select_element": "Vyberte prvek k úpravě jeho vlastností.",
    "studio_editor_prop_text": "Text",
    "studio_editor_prop_font": "Písmo",
    "studio_editor_prop_size": "Velikost",
    "studio_editor_prop_fill": "Výplň",
    "studio_editor_prop_opacity": "Průhlednost",
    "studio_editor_duplicate": "Duplikovat",
    "studio_editor_delete": "Smazat",
    "studio_editor_toast_offline_info": "Pracujete offline. Přihlaste se pro uložení a export.",
    "studio_editor_toast_open_fail": "Nepodařilo se otevřít editor",
    "studio_editor_toast_image_fail": "Nepodařilo se načíst obrázek",
    "studio_editor_toast_saved": "Uloženo",
    "studio_editor_toast_save_fail": "Uložení selhalo",
    "studio_editor_toast_log_in_save": "Přihlaste se pro uložení reklamy do cloudu.",
    "studio_editor_toast_add_elements_first": "Nejprve přidejte nějaké prvky, pak klikněte na Rychlé video.",
    "studio_editor_toast_need_animation": "Nejprve přidejte alespoň jednu animaci (Animovat lištu).",
    "studio_editor_toast_browser_no_video": "Váš prohlížeč nepodporuje nahrávání videa.",
    "studio_editor_toast_video_fail": "Export videa selhal",
    "studio_editor_toast_export_fail": "Export selhal",
    "studio_editor_toast_exported": "Exportováno!",
    "studio_editor_toast_exported_ext": "Exportováno .{ext}!",
    "studio_editor_toast_credits_out": "Nedostatek kreditů na reklamy.",
    "studio_editor_toast_credits_out_upsell": "Nemáte žádné kredity na reklamy. Přepněte na Pro za 30/měsíc.",
    "studio_editor_toast_ai_fail": "AI kouzlo selhalo",
    "studio_editor_toast_no_variants": "Žádné varianty nebyly nalezeny",
    "studio_editor_toast_applied": "Použito: {angle}",
    "studio_editor_toast_quick_reel_done": "Rychlé video · {n} animací · {s}s",
    "studio_editor_toast_smart_resize_done": "Vytvořeno {n} příbuzných reklam{plural}",
    "studio_editor_toast_smart_resize_fail": "Chyba při chytrém změně velikosti",
    "studio_my_have_coupon": "Máte slevový kupón?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Uplatnit",
    "studio_my_toast_credits_added": "+{amount} kredity přidány 🎉",
    "studio_my_toast_not_found": "Kód nenalezen",
    "studio_my_toast_already": "Již uplatněno",
    "studio_my_toast_expired": "Vypršelo nebo deaktivováno",
    "studio_my_toast_redeem_fail": "Uplatnění selhalo",
    "studio_my_toast_load_fail": "Načtení projektů selhalo",
    "studio_my_confirm_delete": "Smazat \"{title}\"?",
    "studio_my_title": "Moje návrhy",
    "studio_my_sub": "Všechny vaše uložené projekty a exporty na jednom místě.",
    "studio_my_count_one": "{n} projekt",
    "studio_my_count_many": "{n} projekty",
    "studio_my_instant_campaign": "Okamžitá kampaň",
    "studio_my_new_ad": "Nová reklama",
    "studio_my_login_to_see": "Přihlaste se a zobrazte si uložené reklamy.",
    "studio_my_login": "Přihlásit se",
    "studio_my_loading": "Načítání…",
    "studio_my_empty_title": "Zatím žádné reklamy.",
    "studio_my_browse": "Procházet šablony",
    "studio_my_badge_team": "Tým",
    "studio_my_badge_shared": "Sdíleno",
    "studio_my_edit": "Upravit",
    "studio_gallery_filter_prefix": "Filtr",
    "studio_gallery_filter_cancel": "× zrušit",
    "studio_gallery_title": "Šablony",
    "studio_gallery_lead": "Vyberte začátek. Upravte cokoliv.",
    "studio_gallery_search": "Hledat šablony…",
    "studio_gallery_loading_count": "Načítání…",
    "studio_gallery_count_of": "{start}–{end} z {total} šablon",
    "studio_gallery_pack_all": "Vše",
    "studio_gallery_pack_trending": "Trendující",
    "studio_gallery_pack_ai": "Poháněno AI",
    "studio_gallery_pack_editorial": "Redakční",
    "studio_gallery_pack_video": "Video klipy",
    "studio_gallery_pack_free": "Zdarma",
    "studio_gallery_video_only": "Jen video",
    "studio_gallery_all_formats": "Všechny formáty",
    "studio_gallery_all_categories": "Všechny kategorie",
    "studio_gallery_loading_templates": "Načítání šablon…",
    "studio_gallery_no_match": "Žádné šablony neodpovídají těmto filtrům.",
    "studio_gallery_opening": "Otevírám editor…",
    "studio_gallery_prev": "← Předchozí",
    "studio_gallery_next": "Další →",
    "studio_gallery_page_of": "Strana {n} z {total}",
    "studio_gallery_type_post": "Příspěvek",
    "studio_gallery_type_story": "Příběh",
    "studio_gallery_type_reel": "Reel",
    "studio_gallery_type_video": "Video",
    "studio_gallery_type_ad": "Reklama",
    "studio_landing_meta_title": "Studio — AI návrhy, videa a reels za 60 sekund | TopRankPulse",
    "studio_landing_meta_desc": "Vytvářejte příspěvky, videa a reklamy s AI. 1 600+ šablon, export na jedno kliknutí. Součást TopRankPulse.",
    "studio_landing_eyebrow": "NOVÉ · STUDIO OD TOPRANKPULSE",
    "studio_landing_hero_title_a": "Vytvářejte příspěvky, videa a reels.",
    "studio_landing_hero_title_b": "Za minuty, ne dny.",
    "studio_landing_hero_lead": "Vyberte typ obsahu, šablonu, nebo nechte AI vytvořit první verzi. Upravujte v editoru ve stylu Canva. Exportujte PNG / MP4 na jedno kliknutí. Reklamy, reels, příběhy, videa a příspěvky — vše na jednom místě.",
    "studio_landing_cta_start": "Začněte tvořit",
    "studio_landing_cta_instant": "Okamžitá kampaně — 25 reklam",
    "studio_landing_cta_browse": "Procházet šablony",
    "studio_landing_kpi_projects": "Vytvořené projekty",
    "studio_landing_kpi_exports": "Stažené exporty",
    "studio_landing_kpi_templates": "Šablony",
    "studio_landing_kpi_formats": "Formáty reklam",
    "studio_landing_features_title": "Studio. Ne slideshow.",
    "studio_landing_features_sub": "Vše, co skutečný performance marketer používá — jedna obrazovka, žádné záložky.",
    "studio_landing_feat_ai_title": "AI magie z URL",
    "studio_landing_feat_ai_text": "Vložte webovou stránku, získejte 5 plných reklamních konceptů — barvy značky, titulky, CTA, připravené plátna.",
    "studio_landing_feat_type_title": "Plná typografie",
    "studio_landing_feat_type_text": "Písma, váhy, sledování, obrysy, stíny. Textová pole, která se chovají jako Adobe, ne PowerPoint.",
    "studio_landing_feat_img_title": "AI + stockové obrázky",
    "studio_landing_feat_img_text": "Generujte pozadí s pixelovou přesností pomocí GPT Image 1. Unsplash a Pexels začleněny.",
    "studio_landing_feat_brand_title": "Brand kit",
    "studio_landing_feat_brand_text": "Zamkněte své barvy, písma, loga jednou. Každá nová reklama je zdědí automaticky.",
    "studio_landing_feat_resize_title": "Inteligentní změna velikosti",
    "studio_landing_feat_resize_text": "Jedno plátno → 10 souvisejících reklam automaticky upravených pro každý formát. Odeslat celou kampaň na jedno kliknutí.",
    "studio_landing_feat_wl_title": "Připraveno pro white-label",
    "studio_landing_feat_wl_text": "Navrženo k začlenění. Vložte do svého portálu agentury přes iframe nebo API. Vaše značka, náš motor.",
    "studio_landing_formats_title": "10 formátů reklam. Jedno plátno.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Feed, Příběh, Reel.",
    "studio_landing_pricing_title": "Jednoduché ceny založené na kreditech.",
    "studio_landing_pricing_sub": "Začněte zdarma. Zvětšujte, když se vaše kampaně rozrůstají.",
    "studio_landing_pricing_extra": "Další reklamy nad rámec plánu: €2.30 / kredit · zrušení kdykoliv",
    "studio_landing_price_free_credits": "3 reklamy · jednorázově",
    "studio_landing_price_starter_credits": "10 reklam / měsíc",
    "studio_landing_price_pro_credits": "30 reklam / měsíc",
    "studio_landing_price_agency_credits": "80 reklam / měsíc",
    "studio_landing_price_free_f1": "Všechny 10 formátů",
    "studio_landing_price_free_f2": "AI magie z URL",
    "studio_landing_price_free_f3": "PNG export",
    "studio_landing_price_free_f4": "Žádná kreditní karta",
    "studio_landing_price_starter_f1": "Všechno ve Verzi zdarma",
    "studio_landing_price_starter_f2": "Brand Kit",
    "studio_landing_price_starter_f3": "Inteligentní změna velikosti",
    "studio_landing_price_starter_f4": "Prioritní fronta",
    "studio_landing_price_pro_f1": "Všechno ve Verzi Starter",
    "studio_landing_price_pro_f2": "Generování obrázků AI (GPT Image 1)",
    "studio_landing_price_pro_f3": "Export videa (brzy)",
    "studio_landing_price_pro_f4": "Odstranit watermark",
    "studio_landing_price_agency_f1": "Všechno ve Verzi Pro",
    "studio_landing_price_agency_f2": "Místa pro tým (brzy)",
    "studio_landing_price_agency_f3": "Export s vlastním označením",
    "studio_landing_price_agency_f4": "Dedicated podpora",
    "studio_landing_price_free_cta": "Začít zdarma",
    "studio_landing_price_starter_cta": "Získat Starter",
    "studio_landing_price_pro_cta": "Získat Pro",
    "studio_landing_price_agency_cta": "Získat Agenturu",
    "studio_landing_price_most_popular": "Nejoblíbenější",
    "studio_landing_final_title": "Zveřejněte svou první reklamu dnes večer.",
    "studio_landing_final_sub": "Tři reklamy zdarma. Bez karty. Dvě kliknutí k publikaci.",
    "studio_landing_final_btn": "Otevřít editor",
    "studio_landing_footer": "Studio · součást",
    "studio_create_back_select": "← Zpět na výběr",
    "studio_create_new_prefix": "Nový",
    "studio_create_type_desc_suffix": "Vyberte šablonu nebo začněte s prázdným plátnem.",
    "studio_create_opt_templates_title": "Vyberte šablonu",
    "studio_create_opt_templates_sub": "Hundreds of ready-made designs — editable",
    "studio_create_opt_blank_title": "Prázdné plátno",
    "studio_create_opt_blank_sub": "Plná kontrola, prázdné plátno",
    "studio_create_opt_ai_title": "AI Magie ✨",
    "studio_create_opt_ai_sub": "Popište, co chcete — AI vytvoří první verzi",
    "studio_create_hub_eyebrow": "Co vytváříte?",
    "studio_create_hub_title_a": "Pojďme být",
    "studio_create_hub_title_b": "kreativní",
    "studio_create_hub_sub": "Vyberte typ obsahu. Každý preset otevře správné rozměry a šablony.",
    "studio_create_card_start": "Začít",
    "studio_create_type_post_label": "Příspěvek",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Příběh",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animovaný · 15–60s",
    "studio_create_type_video_label": "Video",
    "studio_create_type_video_desc": "16:9 · na šířku",
    "studio_create_type_ad_label": "Reklama",
    "studio_create_type_ad_desc": "FB/IG reklamní kreativita",
    "studio_more_title": "Více",
    "studio_more_sub": "Nastavení, účet a další nástroje.",
    "studio_more_settings": "Nastavení účtu",
    "studio_more_notifications": "Oznámení",
    "studio_more_plan": "Plán a fakturace",
    "studio_more_invite": "Pozvat přátele",
    "studio_more_redeem": "Uplatnit kupón",
    "studio_more_ai": "AI Magie",
    "studio_more_privacy": "Ochrana soukromí",
    "studio_more_help": "Nápověda a blog",
    "studio_more_logout": "Odhlásit se",
    "studio_nav_create": "Vytvořit",
    "studio_nav_mine": "Moje návrhy",
    "studio_nav_templates": "Šablony",
    "studio_nav_community": "Komunita",
    "studio_nav_more": "Více",
    "studio_nav_home": "Domů",
    "studio_nav_projects": "Projekty",
    "studio_nav_ai_magic": "AI Magie",
    "studio_nav_business": "Byznys",
    "studio_nav_create_aria": "Vytvořit nový design",
    "studio_team_title": "Byznys — týmový prostor",
    "studio_team_sub": "Pozvěte kolegy k společné práci. Max. 10 členů na tým.",
    "studio_team_load_fail": "Nelze načíst tým",
    "studio_team_create_title": "Vytvořit nový tým",
    "studio_team_create_sub": "Stanete se vlastníkem a můžete pozvat členy.",
    "studio_team_name_placeholder": "Název týmu",
    "studio_team_create_btn": "Vytvořit",
    "studio_team_join_title": "Připojit se s existujícím pozváním",
    "studio_team_join_sub": "Pokud vám někdo poslal kód pozvánky.",
    "studio_team_invite_code_placeholder": "Kód pozvánky",
    "studio_team_join_btn": "Připojit se",
    "studio_team_created": "Tým vytvořen",
    "studio_team_failed": "Neúspěch",
    "studio_team_joined": "Připojen k týmu",
    "studio_team_invite_invalid": "Neplatné pozvání",
    "studio_team_member_one": "člen",
    "studio_team_members_many": "členové",
    "studio_team_you_are_owner": "· jste majitel",
    "studio_team_leave_btn": "Odejít",
    "studio_team_confirm_leave": "Opravdu chcete opustit tým?",
    "studio_team_left": "Opustil tým",
    "studio_team_invite_title": "Pozvat nového člena",
    "studio_team_invite_email_placeholder": "email@example.com",
    "studio_team_send_invite": "Odeslat pozvání",
    "studio_team_invite_copied": "Odkaz na pozvání zkopírován do schránky",
    "studio_team_auto_copy_hint": "Odkaz na pozvání je automaticky zkopírován do schránky.",
    "studio_team_members_header": "Členové",
    "studio_team_owner_badge": "Majitel",
    "studio_team_pending_header": "Čekající pozvání",
    "studio_team_expires": "Expiruje"
  },
  "de": {
    "studio_editor_back": "Zurück",
    "studio_editor_untitled": "Unbetitelte Anzeige",
    "studio_editor_credits_view": "Guthabenbuch anschauen",
    "studio_editor_credits_label": "Guthaben",
    "studio_editor_credits_unlimited": "∞ Unbegrenzt",
    "studio_editor_smart_resize": "Intelligente Anpassung",
    "studio_editor_quick_reel": "Schneller Reel",
    "studio_editor_quick_reel_title": "Jedes Element für einen 15-Sekunden-Reel automatisch animieren",
    "studio_editor_save": "Speichern",
    "studio_editor_export_png": "PNG exportieren",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Animiertes Video exportieren",
    "studio_editor_mp4_title_need_anim": "Fügen Sie zuerst eine Animation hinzu",
    "studio_editor_rail_magic": "Magie",
    "studio_editor_rail_text": "Text",
    "studio_editor_rail_shapes": "Formen",
    "studio_editor_rail_images": "Bilder",
    "studio_editor_rail_anim": "Animieren",
    "studio_editor_rail_layers": "Ebenen",
    "studio_editor_close_panel": "Panel schließen",
    "studio_editor_close_props": "Eigenschaften schließen",
    "studio_editor_open_props": "Eigenschaften öffnen",
    "studio_editor_director_title": "AI Reel Regisseur — One-Shot",
    "studio_editor_director_sub": "Ein Satz → vollständiger animierter Reel (~10s).",
    "studio_editor_magic_title": "AI Magie — URL → 5 Anzeigen",
    "studio_editor_magic_placeholder": "https://deine-seite.com",
    "studio_editor_magic_generate": "Generieren",
    "studio_editor_text_title": "Text",
    "studio_editor_add_heading": "Überschrift hinzufügen",
    "studio_editor_shapes_title": "Formen",
    "studio_editor_rectangle": "Rechteck",
    "studio_editor_circle": "Kreis",
    "studio_editor_background_title": "Hintergrund",
    "studio_editor_upload_title": "Bild hochladen",
    "studio_editor_stock_btn": "Stockfotos",
    "studio_editor_from_url": "Von URL",
    "studio_editor_add": "Hinzufügen",
    "studio_editor_layers_title": "Ebenen",
    "studio_editor_canvas_empty": "Leinwand ist leer.",
    "studio_editor_props_title": "Eigenschaften",
    "studio_editor_select_element": "Wählen Sie ein Element aus, um dessen Eigenschaften zu bearbeiten.",
    "studio_editor_prop_text": "Text",
    "studio_editor_prop_font": "Schriftart",
    "studio_editor_prop_size": "Größe",
    "studio_editor_prop_fill": "Füllung",
    "studio_editor_prop_opacity": "Transparenz",
    "studio_editor_duplicate": "Duplizieren",
    "studio_editor_delete": "Löschen",
    "studio_editor_toast_offline_info": "Sie arbeiten offline. Melden Sie sich an, um zu speichern und zu exportieren.",
    "studio_editor_toast_open_fail": "Editor konnte nicht geöffnet werden",
    "studio_editor_toast_image_fail": "Bild konnte nicht geladen werden",
    "studio_editor_toast_saved": "Gespeichert",
    "studio_editor_toast_save_fail": "Speichern fehlgeschlagen",
    "studio_editor_toast_log_in_save": "Melden Sie sich an, um Ihre Anzeige in der Cloud zu speichern.",
    "studio_editor_toast_add_elements_first": "Fügen Sie zuerst einige Elemente hinzu, und klicken Sie dann auf Quick Reel.",
    "studio_editor_toast_need_animation": "Fügen Sie zuerst mindestens eine Animation hinzu (Animate rail).",
    "studio_editor_toast_browser_no_video": "Ihr Browser unterstützt keine Videoaufzeichnung.",
    "studio_editor_toast_video_fail": "Videoexport fehlgeschlagen",
    "studio_editor_toast_export_fail": "Export fehlgeschlagen",
    "studio_editor_toast_exported": "Exportiert!",
    "studio_editor_toast_exported_ext": "Exportiert .{ext}!",
    "studio_editor_toast_credits_out": "Keine Anzeigenguthaben mehr.",
    "studio_editor_toast_credits_out_upsell": "Sie haben keine Anzeigenguthaben mehr. Upgrade auf Pro für 30/Monat.",
    "studio_editor_toast_ai_fail": "AI-Magie fehlgeschlagen",
    "studio_editor_toast_no_variants": "Keine Varianten zurückgegeben",
    "studio_editor_toast_applied": "Angewendet: {angle}",
    "studio_editor_toast_quick_reel_done": "Quick Reel · {n} Animationen · {s}s",
    "studio_editor_toast_smart_resize_done": "{n} verwandte Anzeige{plural} erstellt",
    "studio_editor_toast_smart_resize_fail": "Intelligente Größenänderung fehlgeschlagen",
    "studio_my_have_coupon": "Haben Sie einen Gutschein?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Einlösen",
    "studio_my_toast_credits_added": "+{amount} Guthaben hinzugefügt 🎉",
    "studio_my_toast_not_found": "Code nicht gefunden",
    "studio_my_toast_already": "Bereits eingelöst",
    "studio_my_toast_expired": "Abgelaufen oder deaktiviert",
    "studio_my_toast_redeem_fail": "Einlösen fehlgeschlagen",
    "studio_my_toast_load_fail": "Projekte konnten nicht geladen werden",
    "studio_my_confirm_delete": "\"{title}\" löschen?",
    "studio_my_title": "Meine Designs",
    "studio_my_sub": "Alle Ihre gespeicherten Projekte und Exporte an einem Ort.",
    "studio_my_count_one": "{n} Projekt",
    "studio_my_count_many": "{n} Projekte",
    "studio_my_instant_campaign": "Sofortkampagne",
    "studio_my_new_ad": "Neue Anzeige",
    "studio_my_login_to_see": "Melden Sie sich an, um Ihre gespeicherten Anzeigen zu sehen.",
    "studio_my_login": "Anmelden",
    "studio_my_loading": "Lade…",
    "studio_my_empty_title": "Noch keine Anzeigen.",
    "studio_my_browse": "Vorlagen durchsuchen",
    "studio_my_badge_team": "Team",
    "studio_my_badge_shared": "Geteilt",
    "studio_my_edit": "Bearbeiten",
    "studio_gallery_filter_prefix": "Filter",
    "studio_gallery_filter_cancel": "× löschen",
    "studio_gallery_title": "Vorlagen",
    "studio_gallery_lead": "Wählen Sie einen Start. Bearbeiten Sie alles.",
    "studio_gallery_search": "Vorlagen suchen…",
    "studio_gallery_loading_count": "Lade…",
    "studio_gallery_count_of": "{start}–{end} von {total} Vorlagen",
    "studio_gallery_pack_all": "Alle",
    "studio_gallery_pack_trending": "Beliebt",
    "studio_gallery_pack_ai": "KI-gesteuert",
    "studio_gallery_pack_editorial": "Redaktionell",
    "studio_gallery_pack_video": "Videoclips",
    "studio_gallery_pack_free": "Kostenlos",
    "studio_gallery_video_only": "Nur Video",
    "studio_gallery_all_formats": "Alle Formate",
    "studio_gallery_all_categories": "Alle Kategorien",
    "studio_gallery_loading_templates": "Vorlagen laden…",
    "studio_gallery_no_match": "Keine Vorlagen entsprechen diesen Filtern.",
    "studio_gallery_opening": "Editor öffnet…",
    "studio_gallery_prev": "← Vorherige",
    "studio_gallery_next": "Nächste →",
    "studio_gallery_page_of": "Seite {n} von {total}",
    "studio_gallery_type_post": "Beitrag",
    "studio_gallery_type_story": "Geschichte",
    "studio_gallery_type_reel": "Reel",
    "studio_gallery_type_video": "Video",
    "studio_gallery_type_ad": "Anzeige",
    "studio_landing_meta_title": "Studio — KI-Designs, Reels & Videos in 60 Sekunden | TopRankPulse",
    "studio_landing_meta_desc": "Erstellen Sie Beiträge, Reels, Videos und Anzeigen mit KI. Über 1.600 Vorlagen, Export mit einem Klick. Teil von TopRankPulse.",
    "studio_landing_eyebrow": "NEU · STUDIO VON TOPRANKPULSE",
    "studio_landing_hero_title_a": "Erstellen Sie Beiträge, Reels und Videos.",
    "studio_landing_hero_title_b": "In Minuten, nicht Tagen.",
    "studio_landing_hero_lead": "Wählen Sie einen Inhaltstyp, eine Vorlage oder lassen Sie die KI die erste Version erstellen. Bearbeiten Sie in einem Canva-ähnlichen Editor. Exportieren Sie PNG / MP4 mit einem Klick. Anzeigen, Reels, Stories, Videos und Beiträge — alles in einem.",
    "studio_landing_cta_start": "Erstellen Sie jetzt",
    "studio_landing_cta_instant": "Sofortige Kampagne — 25 Anzeigen",
    "studio_landing_cta_browse": "Vorlagen durchsuchen",
    "studio_landing_kpi_projects": "Erstellte Projekte",
    "studio_landing_kpi_exports": "Heruntergeladene Exporte",
    "studio_landing_kpi_templates": "Vorlagen",
    "studio_landing_kpi_formats": "Anzeigenformate",
    "studio_landing_features_title": "Ein Studio. Kein Diashow.",
    "studio_landing_features_sub": "Alles, was ein Performance-Marketer tatsächlich nutzt — ein Bildschirm, keine Tabs.",
    "studio_landing_feat_ai_title": "KI-Magie von URL",
    "studio_landing_feat_ai_text": "Fügen Sie eine Website ein, erhalten Sie 5 vollständige Anzeigenkonzepte — Markenfarben, Überschriften, CTAs, einsatzbereite Vorlagen.",
    "studio_landing_feat_type_title": "Volle Typografie",
    "studio_landing_feat_type_text": "Schriften, Gewichtungen, Abstände, Konturen, Schlagschatten. Textfelder, die sich wie Adobe und nicht wie PowerPoint verhalten.",
    "studio_landing_feat_img_title": "KI + Stockbilder",
    "studio_landing_feat_img_text": "Erzeugen Sie pixelgenaue Hintergründe mit GPT Image 1. Unsplash und Pexels integriert.",
    "studio_landing_feat_brand_title": "Markenkit",
    "studio_landing_feat_brand_text": "Sichern Sie Ihre Farben, Schriften und Logos einmal. Jede neue Anzeige erbt sie automatisch.",
    "studio_landing_feat_resize_title": "Intelligente Größenanpassung",
    "studio_landing_feat_resize_text": "Eine Leinwand → 10 Geschwister-Anzeigen automatisch in jedes Format skaliert. Versenden Sie eine komplette Kampagne mit einem Klick.",
    "studio_landing_feat_wl_title": "White-Label bereit",
    "studio_landing_feat_wl_text": "Für die Einbettung gebaut. Fügen Sie es über iframe oder API in Ihr Agenturportal ein. Ihre Marke, unser Motor.",
    "studio_landing_formats_title": "10 Anzeigenformate. Eine Leinwand.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Feed, Story, Reel.",
    "studio_landing_pricing_title": "Einfaches, kreditbasiertes Preismodell.",
    "studio_landing_pricing_sub": "Kostenlos starten. Skalieren, wenn Ihre Kampagnen wachsen.",
    "studio_landing_pricing_extra": "Zusätzliche Anzeigen über den Plan hinaus: €2,30 / Kredit · jederzeit kündigen",
    "studio_landing_price_free_credits": "3 Anzeigen · einmalig",
    "studio_landing_price_starter_credits": "10 Anzeigen / Monat",
    "studio_landing_price_pro_credits": "30 Anzeigen / Monat",
    "studio_landing_price_agency_credits": "80 Anzeigen / Monat",
    "studio_landing_price_free_f1": "Alle 10 Formate",
    "studio_landing_price_free_f2": "KI-Magie von URL",
    "studio_landing_price_free_f3": "PNG-Export",
    "studio_landing_price_free_f4": "Keine Kreditkarte",
    "studio_landing_price_starter_f1": "Alles in Free",
    "studio_landing_price_starter_f2": "Brand-Kit",
    "studio_landing_price_starter_f3": "Intelligente Anpassung",
    "studio_landing_price_starter_f4": "Prioritätenwarteschlange",
    "studio_landing_price_pro_f1": "Alles im Starter",
    "studio_landing_price_pro_f2": "AI Bildgenerierung (GPT Bild 1)",
    "studio_landing_price_pro_f3": "Videoexport (in Kürze)",
    "studio_landing_price_pro_f4": "Wasserzeichen entfernen",
    "studio_landing_price_agency_f1": "Alles im Pro",
    "studio_landing_price_agency_f2": "Teamplätze (in Kürze)",
    "studio_landing_price_agency_f3": "White-Label-Export",
    "studio_landing_price_agency_f4": "Dedizierter Support",
    "studio_landing_price_free_cta": "Kostenlos starten",
    "studio_landing_price_starter_cta": "Starter holen",
    "studio_landing_price_pro_cta": "Pro holen",
    "studio_landing_price_agency_cta": "Agentur holen",
    "studio_landing_price_most_popular": "Am beliebtesten",
    "studio_landing_final_title": "Schalte deine erste Anzeige heute Abend.",
    "studio_landing_final_sub": "Drei kostenlose Anzeigen. Keine Karte. Zwei Klicks zur Veröffentlichung.",
    "studio_landing_final_btn": "Editor öffnen",
    "studio_landing_footer": "Studio · Teil von",
    "studio_create_back_select": "← Zurück zur Auswahl",
    "studio_create_new_prefix": "Neu",
    "studio_create_type_desc_suffix": "Wähle eine Vorlage oder starte mit einer leeren Leinwand.",
    "studio_create_opt_templates_title": "Wähle eine Vorlage",
    "studio_create_opt_templates_sub": "Hunderte von einsatzbereiten Designs — bearbeitbar",
    "studio_create_opt_blank_title": "Leere Leinwand",
    "studio_create_opt_blank_sub": "Volle Kontrolle, leere Leinwand",
    "studio_create_opt_ai_title": "AI Magie ✨",
    "studio_create_opt_ai_sub": "Beschreibe, was du willst — AI erstellt die erste Version",
    "studio_create_hub_eyebrow": "Was erstellst du?",
    "studio_create_hub_title_a": "Lass uns",
    "studio_create_hub_title_b": "kreativ werden",
    "studio_create_hub_sub": "Wähle einen Inhaltstyp. Jede Voreinstellung öffnet die richtigen Dimensionen und Vorlagen.",
    "studio_create_card_start": "Starten",
    "studio_create_type_post_label": "Post",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Story",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animiert · 15–60s",
    "studio_create_type_video_label": "Video",
    "studio_create_type_video_desc": "16:9 · Landschaft",
    "studio_create_type_ad_label": "Anzeige",
    "studio_create_type_ad_desc": "FB/IG Anzeigeninhalt",
    "studio_more_title": "Mehr",
    "studio_more_sub": "Einstellungen, Konto und weitere Tools.",
    "studio_more_settings": "Kontoeinstellungen",
    "studio_more_notifications": "Benachrichtigungen",
    "studio_more_plan": "Plan & Abrechnung",
    "studio_more_invite": "Freunde einladen",
    "studio_more_redeem": "Gutschein einlösen",
    "studio_more_ai": "KI-Magie",
    "studio_more_privacy": "Datenschutz",
    "studio_more_help": "Hilfe & Blog",
    "studio_more_logout": "Abmelden",
    "studio_nav_create": "Erstellen",
    "studio_nav_mine": "Meine Designs",
    "studio_nav_templates": "Vorlagen",
    "studio_nav_community": "Gemeinschaft",
    "studio_nav_more": "Mehr",
    "studio_nav_home": "Startseite",
    "studio_nav_projects": "Projekte",
    "studio_nav_ai_magic": "KI-Magie",
    "studio_nav_business": "Geschäft",
    "studio_nav_create_aria": "Neues Design erstellen",
    "studio_team_title": "Geschäft — Teamarbeitsbereich",
    "studio_team_sub": "Lade Kollegen ein, um gemeinsam zu arbeiten. Max. 10 Mitglieder pro Team.",
    "studio_team_load_fail": "Team konnte nicht geladen werden",
    "studio_team_create_title": "Ein neues Team erstellen",
    "studio_team_create_sub": "Du wirst der Besitzer und kannst Mitglieder einladen.",
    "studio_team_name_placeholder": "Teamname",
    "studio_team_create_btn": "Erstellen",
    "studio_team_join_title": "Mit einer bestehenden Einladung beitreten",
    "studio_team_join_sub": "Wenn dir jemand einen Einladungscode gesendet hat.",
    "studio_team_invite_code_placeholder": "Einladungscode",
    "studio_team_join_btn": "Beitreten",
    "studio_team_created": "Team erstellt",
    "studio_team_failed": "Fehlgeschlagen",
    "studio_team_joined": "Team beigetreten",
    "studio_team_invite_invalid": "Ungültige Einladung",
    "studio_team_member_one": "Mitglied",
    "studio_team_members_many": "Mitglieder",
    "studio_team_you_are_owner": "· du bist Eigentümer",
    "studio_team_leave_btn": "Verlassen",
    "studio_team_confirm_leave": "Wirklich das Team verlassen?",
    "studio_team_left": "Team verlassen",
    "studio_team_invite_title": "Neues Mitglied einladen",
    "studio_team_invite_email_placeholder": "email@example.com",
    "studio_team_send_invite": "Einladung senden",
    "studio_team_invite_copied": "Einladungslink in die Zwischenablage kopiert",
    "studio_team_auto_copy_hint": "Einladungslink wurde automatisch in die Zwischenablage kopiert.",
    "studio_team_members_header": "Mitglieder",
    "studio_team_owner_badge": "Eigentümer",
    "studio_team_pending_header": "Ausstehende Einladungen",
    "studio_team_expires": "Läuft ab"
  },
  "pl": {
    "studio_editor_back": "Wstecz",
    "studio_editor_untitled": "Niezatytułowana reklama",
    "studio_editor_credits_view": "Zobacz rejestr kredytów",
    "studio_editor_credits_label": "Kredyty",
    "studio_editor_credits_unlimited": "∞ Nielimitowane",
    "studio_editor_smart_resize": "Inteligentne dopasowanie",
    "studio_editor_quick_reel": "Szybki film",
    "studio_editor_quick_reel_title": "Automatyczna animacja każdego elementu do 15-sekundowego filmu",
    "studio_editor_save": "Zapisz",
    "studio_editor_export_png": "Eksportuj PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Eksportuj animowane wideo",
    "studio_editor_mp4_title_need_anim": "Najpierw dodaj animację",
    "studio_editor_rail_magic": "Magia",
    "studio_editor_rail_text": "Tekst",
    "studio_editor_rail_shapes": "Kształty",
    "studio_editor_rail_images": "Obrazy",
    "studio_editor_rail_anim": "Animuj",
    "studio_editor_rail_layers": "Warstwy",
    "studio_editor_close_panel": "Zamknij panel",
    "studio_editor_close_props": "Zamknij właściwości",
    "studio_editor_open_props": "Otwórz właściwości",
    "studio_editor_director_title": "Reżyser AI — jedno ujęcie",
    "studio_editor_director_sub": "Jedno zdanie → pełny animowany film (~10s).",
    "studio_editor_magic_title": "Magia AI — URL → 5 reklam",
    "studio_editor_magic_placeholder": "https://twoja-strona.com",
    "studio_editor_magic_generate": "Generuj",
    "studio_editor_text_title": "Tekst",
    "studio_editor_add_heading": "Dodaj nagłówek",
    "studio_editor_shapes_title": "Kształty",
    "studio_editor_rectangle": "Prostokąt",
    "studio_editor_circle": "Koło",
    "studio_editor_background_title": "Tło",
    "studio_editor_upload_title": "Prześlij obraz",
    "studio_editor_stock_btn": "Zdjęcia stockowe",
    "studio_editor_from_url": "Z URL",
    "studio_editor_add": "Dodaj",
    "studio_editor_layers_title": "Warstwy",
    "studio_editor_canvas_empty": "Płótno jest puste.",
    "studio_editor_props_title": "Właściwości",
    "studio_editor_select_element": "Wybierz element, aby edytować jego właściwości.",
    "studio_editor_prop_text": "Tekst",
    "studio_editor_prop_font": "Czcionka",
    "studio_editor_prop_size": "Rozmiar",
    "studio_editor_prop_fill": "Wypełnienie",
    "studio_editor_prop_opacity": "Przezroczystość",
    "studio_editor_duplicate": "Duplikuj",
    "studio_editor_delete": "Usuń",
    "studio_editor_toast_offline_info": "Pracujesz w trybie offline. Zaloguj się, aby zapisać i wyeksportować.",
    "studio_editor_toast_open_fail": "Nie można otworzyć edytora",
    "studio_editor_toast_image_fail": "Nie można załadować obrazu",
    "studio_editor_toast_saved": "Zapisano",
    "studio_editor_toast_save_fail": "Zapis nie powiódł się",
    "studio_editor_toast_log_in_save": "Zaloguj się, aby zapisać swoją reklamę w chmurze.",
    "studio_editor_toast_add_elements_first": "Najpierw dodaj kilka elementów, a następnie kliknij Szybki Zestaw.",
    "studio_editor_toast_need_animation": "Najpierw dodaj co najmniej jedną animację (Animuj szynę).",
    "studio_editor_toast_browser_no_video": "Twój przeglądarka nie obsługuje nagrywania wideo.",
    "studio_editor_toast_video_fail": "Eksport wideo nie powiódł się",
    "studio_editor_toast_export_fail": "Eksport nie powiódł się",
    "studio_editor_toast_exported": "Wyeksportowano!",
    "studio_editor_toast_exported_ext": "Wyeksportowano .{ext}!",
    "studio_editor_toast_credits_out": "Brak kredytów reklamowych.",
    "studio_editor_toast_credits_out_upsell": "Brak kredytów reklamowych. Ulepsz do Pro za 30/miesiąc.",
    "studio_editor_toast_ai_fail": "Błąd AI Magic",
    "studio_editor_toast_no_variants": "Nie zwrócono wariantów",
    "studio_editor_toast_applied": "Zastosowano: {angle}",
    "studio_editor_toast_quick_reel_done": "Szybki Zestaw · {n} animacji · {s}s",
    "studio_editor_toast_smart_resize_done": "Utworzono {n} siostrzaną reklamę{plural}",
    "studio_editor_toast_smart_resize_fail": "Błąd inteligentnego skalowania",
    "studio_my_have_coupon": "Masz kupon?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Zrealizuj",
    "studio_my_toast_credits_added": "+{amount} kredytów dodano 🎉",
    "studio_my_toast_not_found": "Kod nie został znaleziony",
    "studio_my_toast_already": "Już zrealizowano",
    "studio_my_toast_expired": "Wygasł lub dezaktywowany",
    "studio_my_toast_redeem_fail": "Zrealizowanie nie powiodło się",
    "studio_my_toast_load_fail": "Nie udało się załadować projektów",
    "studio_my_confirm_delete": "Usunąć „{title}”?",
    "studio_my_title": "Moje projekty",
    "studio_my_sub": "Wszystkie Twoje zapisane projekty i eksporty w jednym miejscu.",
    "studio_my_count_one": "{n} projekt",
    "studio_my_count_many": "{n} projekty",
    "studio_my_instant_campaign": "Kampania natychmiastowa",
    "studio_my_new_ad": "Nowa reklama",
    "studio_my_login_to_see": "Zaloguj się, aby zobaczyć swoje zapisane reklamy.",
    "studio_my_login": "Zaloguj się",
    "studio_my_loading": "Ładowanie…",
    "studio_my_empty_title": "Brak reklam.",
    "studio_my_browse": "Przeglądaj szablony",
    "studio_my_badge_team": "Zespół",
    "studio_my_badge_shared": "Udostępnione",
    "studio_my_edit": "Edytuj",
    "studio_gallery_filter_prefix": "Filtr",
    "studio_gallery_filter_cancel": "× wyczyść",
    "studio_gallery_title": "Szablony",
    "studio_gallery_lead": "Wybierz początek. Edytuj cokolwiek.",
    "studio_gallery_search": "Szukaj szablonów…",
    "studio_gallery_loading_count": "Ładowanie…",
    "studio_gallery_count_of": "{start}–{end} z {total} szablonów",
    "studio_gallery_pack_all": "Wszystkie",
    "studio_gallery_pack_trending": "Popularne",
    "studio_gallery_pack_ai": "Napędzane AI",
    "studio_gallery_pack_editorial": "Redakcyjne",
    "studio_gallery_pack_video": "Reel wideo",
    "studio_gallery_pack_free": "Darmowe",
    "studio_gallery_video_only": "Tylko wideo",
    "studio_gallery_all_formats": "Wszystkie formaty",
    "studio_gallery_all_categories": "Wszystkie kategorie",
    "studio_gallery_loading_templates": "Ładowanie szablonów…",
    "studio_gallery_no_match": "Brak szablonów odpowiadających tym filtrom.",
    "studio_gallery_opening": "Otwieranie edytora…",
    "studio_gallery_prev": "← Poprzedni",
    "studio_gallery_next": "Następny →",
    "studio_gallery_page_of": "Strona {n} z {total}",
    "studio_gallery_type_post": "Post",
    "studio_gallery_type_story": "Historia",
    "studio_gallery_type_reel": "Reel",
    "studio_gallery_type_video": "Wideo",
    "studio_gallery_type_ad": "Reklama",
    "studio_landing_meta_title": "Studio — projekty AI, reelsy i filmy w 60 sekund | TopRankPulse",
    "studio_landing_meta_desc": "Twórz posty, reelsy, filmy i reklamy z AI. Ponad 1,600 szablonów, eksport jednym kliknięciem. Część TopRankPulse.",
    "studio_landing_eyebrow": "NOWOŚĆ · STUDIO BY TOPRANKPULSE",
    "studio_landing_hero_title_a": "Twórz posty, reelsy i filmy.",
    "studio_landing_hero_title_b": "W minutach, nie w dniach.",
    "studio_landing_hero_lead": "Wybierz typ treści, szablon lub pozwól AI przygotować pierwszą wersję. Edytuj w edytorze w stylu Canvy. Eksportuj PNG / MP4 jednym kliknięciem. Reklamy, reelsy, historie, filmy i posty — wszystko w jednym.",
    "studio_landing_cta_start": "Rozpocznij tworzenie",
    "studio_landing_cta_instant": "Natychmiastowa kampania — 25 reklam",
    "studio_landing_cta_browse": "Przeglądaj szablony",
    "studio_landing_kpi_projects": "Utworzone projekty",
    "studio_landing_kpi_exports": "Pobrane eksporty",
    "studio_landing_kpi_templates": "Szablony",
    "studio_landing_kpi_formats": "Formaty reklam",
    "studio_landing_features_title": "Studio. Nie prezentacja.",
    "studio_landing_features_sub": "Wszystko, co naprawdę używa marketer wydajności — jeden ekran, bez zakładek.",
    "studio_landing_feat_ai_title": "Czary AI z URL",
    "studio_landing_feat_ai_text": "Wklej stronę internetową, otrzymaj 5 pełnych koncepcji reklam — kolory marki, nagłówki, CTA, gotowe płótna.",
    "studio_landing_feat_type_title": "Pełna typografia",
    "studio_landing_feat_type_text": "Czcionki, wagi, śledzenie, kontury, cienie. Pudełka tekstowe, które zachowują się jak Adobe, nie PowerPoint.",
    "studio_landing_feat_img_title": "AI + obrazy stockowe",
    "studio_landing_feat_img_text": "Generuj pikselowo idealne tła z GPT Image 1. Unsplash i Pexels wbudowane.",
    "studio_landing_feat_brand_title": "Zestaw marki",
    "studio_landing_feat_brand_text": "Zablokuj swoje kolory, czcionki, loga raz. Każda nowa reklama automatycznie je dziedziczy.",
    "studio_landing_feat_resize_title": "Inteligentne skalowanie",
    "studio_landing_feat_resize_text": "Jedno płótno → 10 reklam siostrzanych automatycznie skalowanych do każdego formatu. Prześlij całą kampanię jednym kliknięciem.",
    "studio_landing_feat_wl_title": "Gotowe do białej etykiety",
    "studio_landing_feat_wl_text": "Zbudowane do osadzenia. Wstaw do swojego portalu agencji przez iframe lub API. Twoja marka, nasza technologia.",
    "studio_landing_formats_title": "10 formatów reklam. Jedno płótno.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Feed, Historia, Reel.",
    "studio_landing_pricing_title": "Prosta, oparta na kredytach wycena.",
    "studio_landing_pricing_sub": "Zacznij za darmo. Rozwijaj się, gdy Twoje kampanie się rozwijają.",
    "studio_landing_pricing_extra": "Dodatkowe reklamy ponad plan: 2,30 € / kredyt · anuluj w dowolnym momencie",
    "studio_landing_price_free_credits": "3 reklamy · jednorazowo",
    "studio_landing_price_starter_credits": "10 reklam / miesiąc",
    "studio_landing_price_pro_credits": "30 reklam / miesiąc",
    "studio_landing_price_agency_credits": "80 reklam / miesiąc",
    "studio_landing_price_free_f1": "Wszystkie 10 formatów",
    "studio_landing_price_free_f2": "Czary AI z URL",
    "studio_landing_price_free_f3": "Eksport PNG",
    "studio_landing_price_free_f4": "Brak karty kredytowej",
    "studio_landing_price_starter_f1": "Wszystko w wersji darmowej",
    "studio_landing_price_starter_f2": "Zestaw marki",
    "studio_landing_price_starter_f3": "Inteligentne dostosowanie rozmiaru",
    "studio_landing_price_starter_f4": "Priorytetowa kolejka",
    "studio_landing_price_pro_f1": "Wszystko w wersji Starter",
    "studio_landing_price_pro_f2": "Generowanie obrazów AI (GPT Image 1)",
    "studio_landing_price_pro_f3": "Eksport wideo (wkrótce)",
    "studio_landing_price_pro_f4": "Usuń znak wodny",
    "studio_landing_price_agency_f1": "Wszystko w wersji Pro",
    "studio_landing_price_agency_f2": "Miejsca dla zespołu (wkrótce)",
    "studio_landing_price_agency_f3": "Eksport z białą etykietą",
    "studio_landing_price_agency_f4": "Dedykowane wsparcie",
    "studio_landing_price_free_cta": "Rozpocznij za darmo",
    "studio_landing_price_starter_cta": "Weź Starter",
    "studio_landing_price_pro_cta": "Weź Pro",
    "studio_landing_price_agency_cta": "Weź Agencję",
    "studio_landing_price_most_popular": "Najbardziej popularny",
    "studio_landing_final_title": "Wyślij swoją pierwszą reklamę dziś wieczorem.",
    "studio_landing_final_sub": "Trzy darmowe reklamy. Brak karty. Dwa kliknięcia do publikacji.",
    "studio_landing_final_btn": "Otwórz edytor",
    "studio_landing_footer": "Studio · część",
    "studio_create_back_select": "← Powrót do wyboru",
    "studio_create_new_prefix": "Nowy",
    "studio_create_type_desc_suffix": "Wybierz szablon lub zacznij od pustego płótna.",
    "studio_create_opt_templates_title": "Wybierz szablon",
    "studio_create_opt_templates_sub": "Setki gotowych projektów — edytowalne",
    "studio_create_opt_blank_title": "Puste płótno",
    "studio_create_opt_blank_sub": "Pełna kontrola, puste płótno",
    "studio_create_opt_ai_title": "Magia AI ✨",
    "studio_create_opt_ai_sub": "Opisz, co chcesz — AI stworzy pierwszą wersję",
    "studio_create_hub_eyebrow": "Co tworzysz?",
    "studio_create_hub_title_a": "Zacznijmy",
    "studio_create_hub_title_b": "tworzyć",
    "studio_create_hub_sub": "Wybierz typ treści. Każdy preset otwiera odpowiednie wymiary i szablony.",
    "studio_create_card_start": "Rozpocznij",
    "studio_create_type_post_label": "Post",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Historia",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animowany · 15–60 s",
    "studio_create_type_video_label": "Wideo",
    "studio_create_type_video_desc": "16:9 · krajobraz",
    "studio_create_type_ad_label": "Reklama",
    "studio_create_type_ad_desc": "Kreatywność reklamy FB/IG",
    "studio_more_title": "Więcej",
    "studio_more_sub": "Ustawienia, konto i inne narzędzia.",
    "studio_more_settings": "Ustawienia konta",
    "studio_more_notifications": "Powiadomienia",
    "studio_more_plan": "Plan i płatności",
    "studio_more_invite": "Zaproś znajomych",
    "studio_more_redeem": "Zrealizuj kupon",
    "studio_more_ai": "Magia AI",
    "studio_more_privacy": "Prywatność",
    "studio_more_help": "Pomoc i blog",
    "studio_more_logout": "Wyloguj się",
    "studio_nav_create": "Utwórz",
    "studio_nav_mine": "Moje projekty",
    "studio_nav_templates": "Szablony",
    "studio_nav_community": "Społeczność",
    "studio_nav_more": "Więcej",
    "studio_nav_home": "Strona główna",
    "studio_nav_projects": "Projekty",
    "studio_nav_ai_magic": "Magia AI",
    "studio_nav_business": "Biznes",
    "studio_nav_create_aria": "Utwórz nowy projekt",
    "studio_team_title": "Biznes — przestrzeń robocza zespołu",
    "studio_team_sub": "Zaproś współpracowników do wspólnej pracy. Max. 10 członków na zespół.",
    "studio_team_load_fail": "Nie można załadować zespołu",
    "studio_team_create_title": "Utwórz nowy zespół",
    "studio_team_create_sub": "Stajesz się właścicielem i możesz zapraszać członków.",
    "studio_team_name_placeholder": "Nazwa zespołu",
    "studio_team_create_btn": "Utwórz",
    "studio_team_join_title": "Dołącz z istniejącym zaproszeniem",
    "studio_team_join_sub": "Jeśli ktoś wysłał ci kod zaproszenia.",
    "studio_team_invite_code_placeholder": "Kod zaproszenia",
    "studio_team_join_btn": "Dołącz",
    "studio_team_created": "Zespół utworzony",
    "studio_team_failed": "Niepowodzenie",
    "studio_team_joined": "Dołączono do zespołu",
    "studio_team_invite_invalid": "Nieprawidłowe zaproszenie",
    "studio_team_member_one": "członek",
    "studio_team_members_many": "członkowie",
    "studio_team_you_are_owner": "· jesteś właścicielem",
    "studio_team_leave_btn": "Odejście",
    "studio_team_confirm_leave": "Czy na pewno chcesz opuścić zespół?",
    "studio_team_left": "Opuścił zespół",
    "studio_team_invite_title": "Zaproszenie nowego członka",
    "studio_team_invite_email_placeholder": "email@przykład.com",
    "studio_team_send_invite": "Wyślij zaproszenie",
    "studio_team_invite_copied": "Link zaproszenia skopiowany do schowka",
    "studio_team_auto_copy_hint": "Link zaproszenia został automatycznie skopiowany do schowka.",
    "studio_team_members_header": "Członkowie",
    "studio_team_owner_badge": "Właściciel",
    "studio_team_pending_header": "Oczekujące zaproszenia",
    "studio_team_expires": "Wygasa"
  },
  "hu": {
    "studio_editor_back": "Vissza",
    "studio_editor_untitled": "Címezetlen hirdetés",
    "studio_editor_credits_view": "Kredit nyilvántartás megtekintése",
    "studio_editor_credits_label": "Kreditek",
    "studio_editor_credits_unlimited": "∞ Korlátlan",
    "studio_editor_smart_resize": "Intelligens átméretezés",
    "studio_editor_quick_reel": "Gyors videó",
    "studio_editor_quick_reel_title": "Minden elem automatikus animálása egy 15 másodperces videóhoz",
    "studio_editor_save": "Mentés",
    "studio_editor_export_png": "Exportálás PNG-ként",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Animált video exportálása",
    "studio_editor_mp4_title_need_anim": "Először adj hozzá animációt",
    "studio_editor_rail_magic": "Varázs",
    "studio_editor_rail_text": "Szöveg",
    "studio_editor_rail_shapes": "Alakzatok",
    "studio_editor_rail_images": "Képek",
    "studio_editor_rail_anim": "Animál",
    "studio_editor_rail_layers": "Rétegek",
    "studio_editor_close_panel": "Panel bezárása",
    "studio_editor_close_props": "Tulajdonságok bezárása",
    "studio_editor_open_props": "Tulajdonságok megnyitása",
    "studio_editor_director_title": "AI Videó Rendező — egy felvétel",
    "studio_editor_director_sub": "Egy mondat → teljes animált videó (~10s).",
    "studio_editor_magic_title": "AI Varázslat — URL → 5 hirdetés",
    "studio_editor_magic_placeholder": "https://a-te-webhelyed.com",
    "studio_editor_magic_generate": "Generálás",
    "studio_editor_text_title": "Szöveg",
    "studio_editor_add_heading": "Fejléc hozzáadása",
    "studio_editor_shapes_title": "Alakzatok",
    "studio_editor_rectangle": "Téglalap",
    "studio_editor_circle": "Kör",
    "studio_editor_background_title": "Háttér",
    "studio_editor_upload_title": "Kép feltöltése",
    "studio_editor_stock_btn": "Készletképek",
    "studio_editor_from_url": "URL-ből",
    "studio_editor_add": "Hozzáadás",
    "studio_editor_layers_title": "Rétegek",
    "studio_editor_canvas_empty": "A vászon üres.",
    "studio_editor_props_title": "Tulajdonságok",
    "studio_editor_select_element": "Válasszon ki egy elemet a tulajdonságainak szerkesztéséhez.",
    "studio_editor_prop_text": "Szöveg",
    "studio_editor_prop_font": "Betűtípus",
    "studio_editor_prop_size": "Méret",
    "studio_editor_prop_fill": "Kitöltés",
    "studio_editor_prop_opacity": "Átlátszóság",
    "studio_editor_duplicate": "Másolat",
    "studio_editor_delete": "Törlés",
    "studio_editor_toast_offline_info": "Offline dolgozik. Jelentkezzen be a mentéshez és exportáláshoz.",
    "studio_editor_toast_open_fail": "Nem sikerült megnyitni a szerkesztőt",
    "studio_editor_toast_image_fail": "Nem sikerült betölteni a képet",
    "studio_editor_toast_saved": "Mentve",
    "studio_editor_toast_save_fail": "Mentés sikertelen",
    "studio_editor_toast_log_in_save": "Jelentkezzen be a hirdetés felhőbe mentéséhez.",
    "studio_editor_toast_add_elements_first": "Először adjon hozzá elemeket, majd kattintson a Gyors Reakcióra.",
    "studio_editor_toast_need_animation": "Először adjon hozzá legalább egy animációt (Animálja a síneket).",
    "studio_editor_toast_browser_no_video": "Böngészője nem támogatja a videofelvételt.",
    "studio_editor_toast_video_fail": "Videó exportálása sikertelen",
    "studio_editor_toast_export_fail": "Exportálás sikertelen",
    "studio_editor_toast_exported": "Exportálva!",
    "studio_editor_toast_exported_ext": "Exportálva .{ext}!",
    "studio_editor_toast_credits_out": "Elfogytak a hirdetési kreditek.",
    "studio_editor_toast_credits_out_upsell": "Elfogytak a hirdetési kreditek. Frissítsen Pro-ra 30/hónapért.",
    "studio_editor_toast_ai_fail": "AI varázslat sikertelen",
    "studio_editor_toast_no_variants": "Nincs visszaadott variáns",
    "studio_editor_toast_applied": "Alkalmazva: {angle}",
    "studio_editor_toast_quick_reel_done": "Gyors Reakció · {n} animáció · {s}s",
    "studio_editor_toast_smart_resize_done": "Létrehozott {n} testvér hirdetést",
    "studio_editor_toast_smart_resize_fail": "Okos átméretezés sikertelen",
    "studio_my_have_coupon": "Van kupont?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Visszaadás",
    "studio_my_toast_credits_added": "+{amount} kredit hozzáadva 🎉",
    "studio_my_toast_not_found": "A kód nem található",
    "studio_my_toast_already": "Már visszaadták",
    "studio_my_toast_expired": "Lejárt vagy letiltva",
    "studio_my_toast_redeem_fail": "Visszaadás sikertelen",
    "studio_my_toast_load_fail": "A projektek betöltése sikertelen",
    "studio_my_confirm_delete": "Biztosan törli a \"{title}\"-t?",
    "studio_my_title": "Saját terveim",
    "studio_my_sub": "Minden mentett projekted és exportod egy helyen.",
    "studio_my_count_one": "{n} projekt",
    "studio_my_count_many": "{n} projekt",
    "studio_my_instant_campaign": "Azonnali kampány",
    "studio_my_new_ad": "Új hirdetés",
    "studio_my_login_to_see": "Jelentkezz be a mentett hirdetéseid megtekintéséhez.",
    "studio_my_login": "Bejelentkezés",
    "studio_my_loading": "Betöltés…",
    "studio_my_empty_title": "Még nincsenek hirdetések.",
    "studio_my_browse": "Sablonok böngészése",
    "studio_my_badge_team": "Csapat",
    "studio_my_badge_shared": "Megosztott",
    "studio_my_edit": "Szerkesztés",
    "studio_gallery_filter_prefix": "Szűrés",
    "studio_gallery_filter_cancel": "× törlés",
    "studio_gallery_title": "Sablonok",
    "studio_gallery_lead": "Válassz egy kezdést. Szerkeszd meg bármit.",
    "studio_gallery_search": "Sablonok keresése…",
    "studio_gallery_loading_count": "Betöltés…",
    "studio_gallery_count_of": "{start}–{end} a {total} sablonból",
    "studio_gallery_pack_all": "Minden",
    "studio_gallery_pack_trending": "Népszerű",
    "studio_gallery_pack_ai": "AI-alapú",
    "studio_gallery_pack_editorial": "Szerkesztői",
    "studio_gallery_pack_video": "Videósorozatok",
    "studio_gallery_pack_free": "Ingyenes",
    "studio_gallery_video_only": "Csak videó",
    "studio_gallery_all_formats": "Minden formátum",
    "studio_gallery_all_categories": "Minden kategória",
    "studio_gallery_loading_templates": "Sablonok betöltése…",
    "studio_gallery_no_match": "Nincsenek ilyen szűrőknek megfelelő sablonok.",
    "studio_gallery_opening": "Szerkesztő megnyitása…",
    "studio_gallery_prev": "← Előző",
    "studio_gallery_next": "Következő →",
    "studio_gallery_page_of": "{n}. oldal a {total}ból",
    "studio_gallery_type_post": "Bejegyzés",
    "studio_gallery_type_story": "Történet",
    "studio_gallery_type_reel": "Reel",
    "studio_gallery_type_video": "Videó",
    "studio_gallery_type_ad": "Hirdetés",
    "studio_landing_meta_title": "Studio — AI tervezések, reels és videók 60 másodperc alatt | TopRankPulse",
    "studio_landing_meta_desc": "Hozz létre bejegyzéseket, reels-t, videókat és hirdetéseket AI-val. 1,600+ sablon, egy kattintásos exportálás. A TopRankPulse része.",
    "studio_landing_eyebrow": "ÚJ · STÚDIÓ A TOPRANKPULSE-TÓL",
    "studio_landing_hero_title_a": "Hozz létre bejegyzéseket, reels-t és videókat.",
    "studio_landing_hero_title_b": "Pár perc alatt, nem napok alatt.",
    "studio_landing_hero_lead": "Válassz egy tartalom típust, egy sablont, vagy hagyd, hogy az AI készítse el az első verziót. Szerkeszd egy Canva-stílusú szerkesztőben. Exportálj PNG / MP4 egy kattintással. Hirdetések, reels, történetek, videók és bejegyzések — mind egy helyen.",
    "studio_landing_cta_start": "Kezdj el létrehozni",
    "studio_landing_cta_instant": "Azonnali kampány — 25 hirdetés",
    "studio_landing_cta_browse": "Böngéssz a sablonok között",
    "studio_landing_kpi_projects": "Létrehozott projektek",
    "studio_landing_kpi_exports": "Letöltött exportok",
    "studio_landing_kpi_templates": "Sablonok",
    "studio_landing_kpi_formats": "Hirdetési formátumok",
    "studio_landing_features_title": "Egy stúdió. Nem egy diavetítés.",
    "studio_landing_features_sub": "Minden, amit egy teljesítménymarketer valóban használ — egy képernyő, nincsenek lapok.",
    "studio_landing_feat_ai_title": "AI varázslat URL-ből",
    "studio_landing_feat_ai_text": "Illessz be egy weboldalt, és kapj 5 teljes hirdetési koncepciót — márkaszínek, címsorok, CTÁ-k, készen álló vászon.",
    "studio_landing_feat_type_title": "Teljes tipográfia",
    "studio_landing_feat_type_text": "Betűtípusok, vastagságok, követés, kontúrok, árnyékok. Szövegdobozok, amelyek úgy viselkednek, mint az Adobe, nem mint a PowerPoint.",
    "studio_landing_feat_img_title": "AI + stock képek",
    "studio_landing_feat_img_text": "Generálj pixelpontosan tökéletes háttereket a GPT Image 1-től. Unsplash és Pexels beépítve.",
    "studio_landing_feat_brand_title": "Márkakészlet",
    "studio_landing_feat_brand_text": "Zárd le a színeidet, betűtípusokat, logókat egyszer. Minden új hirdetés automatikusan örökli ezeket.",
    "studio_landing_feat_resize_title": "Okos átméretezés",
    "studio_landing_feat_resize_text": "Egy vászon → 10 testvér hirdetés automatikusan átméretezve minden formátumra. Egy kattintással küldj el egy teljes kampányt.",
    "studio_landing_feat_wl_title": "Fehér címkés készenlét",
    "studio_landing_feat_wl_text": "Úgy lett építve, hogy beágyazható legyen. Illeszd be az ügynökséged portáljába iFrame-en vagy API-n keresztül. A te márkád, a mi motorunk.",
    "studio_landing_formats_title": "10 hirdetési formátum. Egy vászon.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Feed, Történet, Reel.",
    "studio_landing_pricing_title": "Egyszerű, kredit alapú árazás.",
    "studio_landing_pricing_sub": "Kezdj ingyen. Terjeszkedj, amikor a kampányaid növekednek.",
    "studio_landing_pricing_extra": "További hirdetések a terven kívül: €2.30 / kredit · bármikor lemondható",
    "studio_landing_price_free_credits": "3 hirdetés · egyszeri",
    "studio_landing_price_starter_credits": "10 hirdetés / hónap",
    "studio_landing_price_pro_credits": "30 hirdetés / hónap",
    "studio_landing_price_agency_credits": "80 hirdetés / hónap",
    "studio_landing_price_free_f1": "Minden 10 formátum",
    "studio_landing_price_free_f2": "AI varázslat URL-ből",
    "studio_landing_price_free_f3": "PNG export",
    "studio_landing_price_free_f4": "Nincs szükség bankkártyára",
    "studio_landing_price_starter_f1": "Minden ingyenesen",
    "studio_landing_price_starter_f2": "Márkakészlet",
    "studio_landing_price_starter_f3": "Okos átméretezés",
    "studio_landing_price_starter_f4": "Prioritásos várólista",
    "studio_landing_price_pro_f1": "Minden a Starterben",
    "studio_landing_price_pro_f2": "AI Kép Generálás (GPT Kép 1)",
    "studio_landing_price_pro_f3": "Videó exportálás (jelenleg fejlesztés alatt)",
    "studio_landing_price_pro_f4": "Vízjel eltávolítása",
    "studio_landing_price_agency_f1": "Minden a Pro-ban",
    "studio_landing_price_agency_f2": "Csapatszékek (jelenleg fejlesztés alatt)",
    "studio_landing_price_agency_f3": "Fehér címkés export",
    "studio_landing_price_agency_f4": "Dedikált támogatás",
    "studio_landing_price_free_cta": "Kezdj ingyen",
    "studio_landing_price_starter_cta": "Starter megszerzése",
    "studio_landing_price_pro_cta": "Pro megszerzése",
    "studio_landing_price_agency_cta": "Ügynökség megszerzése",
    "studio_landing_price_most_popular": "Legnépszerűbb",
    "studio_landing_final_title": "Indítsd el az első hirdetésedet ma este.",
    "studio_landing_final_sub": "Három ingyenes hirdetés. Nem kell kártya. Két kattintás a közzétételhez.",
    "studio_landing_final_btn": "Nyisd meg a szerkesztőt",
    "studio_landing_footer": "Studio · a része",
    "studio_create_back_select": "← Vissza a választáshoz",
    "studio_create_new_prefix": "Új",
    "studio_create_type_desc_suffix": "Válassz egy sablont, vagy kezdj egy üres vászonról.",
    "studio_create_opt_templates_title": "Válassz egy sablont",
    "studio_create_opt_templates_sub": "Százféle kész terv — szerkeszthető",
    "studio_create_opt_blank_title": "Üres vászon",
    "studio_create_opt_blank_sub": "Teljes irányítás, üres vászon",
    "studio_create_opt_ai_title": "AI Varázslat ✨",
    "studio_create_opt_ai_sub": "Írd le, amit szeretnél — az AI létrehozza az első verziót",
    "studio_create_hub_eyebrow": "Mit tervezel?",
    "studio_create_hub_title_a": "Lépjünk",
    "studio_create_hub_title_b": "alkotóként",
    "studio_create_hub_sub": "Válassz egy tartalomtípust. Minden előre beállített formátum a megfelelő méreteket és sablonokat nyitja meg.",
    "studio_create_card_start": "Kezdés",
    "studio_create_type_post_label": "Bejegyzés",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Történet",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animált · 15–60s",
    "studio_create_type_video_label": "Videó",
    "studio_create_type_video_desc": "16:9 · táj",
    "studio_create_type_ad_label": "Hirdetés",
    "studio_create_type_ad_desc": "FB/IG hirdetés kreatív",
    "studio_more_title": "Több",
    "studio_more_sub": "Beállítások, fiók és egyéb eszközök.",
    "studio_more_settings": "Fiókbeállítások",
    "studio_more_notifications": "Értesítések",
    "studio_more_plan": "Terv & számlázás",
    "studio_more_invite": "Barátok meghívása",
    "studio_more_redeem": "Kupon beváltása",
    "studio_more_ai": "AI Varász",
    "studio_more_privacy": "Adatvédelem",
    "studio_more_help": "Segítség & Blog",
    "studio_more_logout": "Kijelentkezés",
    "studio_nav_create": "Létrehozás",
    "studio_nav_mine": "Saját terveim",
    "studio_nav_templates": "Sablonok",
    "studio_nav_community": "Közösség",
    "studio_nav_more": "Több",
    "studio_nav_home": "Kezdőlap",
    "studio_nav_projects": "Projektjeim",
    "studio_nav_ai_magic": "AI Varász",
    "studio_nav_business": "Üzlet",
    "studio_nav_create_aria": "Új dizájn létrehozása",
    "studio_team_title": "Üzlet — csapat munkaterület",
    "studio_team_sub": "Hívj meg kollégákat közös munkára. Max. 10 fő csapatonként.",
    "studio_team_load_fail": "Nem sikerült betölteni a csapatot",
    "studio_team_create_title": "Új csapat létrehozása",
    "studio_team_create_sub": "Te leszel a tulajdonos és meghívhatod a tagokat.",
    "studio_team_name_placeholder": "Csapat neve",
    "studio_team_create_btn": "Létrehozás",
    "studio_team_join_title": "Csatlakozz egy meglévő meghívóval",
    "studio_team_join_sub": "Ha valaki küldött neked egy meghívókódot.",
    "studio_team_invite_code_placeholder": "Meghívó kód",
    "studio_team_join_btn": "Csatlakozás",
    "studio_team_created": "Csapat létrehozva",
    "studio_team_failed": "Sikertelen",
    "studio_team_joined": "Csatlakozott a csapathoz",
    "studio_team_invite_invalid": "Érvénytelen meghívó",
    "studio_team_member_one": "tag",
    "studio_team_members_many": "tagok",
    "studio_team_you_are_owner": "· te vagy a tulajdonos",
    "studio_team_leave_btn": "Kilépés",
    "studio_team_confirm_leave": "Valóban kilépsz a csapatból?",
    "studio_team_left": "Kilépett a csapatból",
    "studio_team_invite_title": "Új tag meghívása",
    "studio_team_invite_email_placeholder": "email@példa.com",
    "studio_team_send_invite": "Meghívó küldése",
    "studio_team_invite_copied": "A meghívó link a vágólapra másolva",
    "studio_team_auto_copy_hint": "A meghívó link automatikusan a vágólapra másolva.",
    "studio_team_members_header": "Tagok",
    "studio_team_owner_badge": "Tulajdonos",
    "studio_team_pending_header": "Függőben lévő meghívók",
    "studio_team_expires": "Lejár"
  },
  "fr": {
    "studio_editor_back": "Retour",
    "studio_editor_untitled": "Annonce sans titre",
    "studio_editor_credits_view": "Voir le registre de crédits",
    "studio_editor_credits_label": "Crédits",
    "studio_editor_credits_unlimited": "∞ Illimité",
    "studio_editor_smart_resize": "Redimensionnement intelligent",
    "studio_editor_quick_reel": "Reel rapide",
    "studio_editor_quick_reel_title": "Animez automatiquement chaque élément pour un reel de 15 secondes",
    "studio_editor_save": "Enregistrer",
    "studio_editor_export_png": "Exporter PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Exporter la vidéo animée",
    "studio_editor_mp4_title_need_anim": "Ajoutez une animation d'abord",
    "studio_editor_rail_magic": "Magique",
    "studio_editor_rail_text": "Texte",
    "studio_editor_rail_shapes": "Formes",
    "studio_editor_rail_images": "Images",
    "studio_editor_rail_anim": "Animer",
    "studio_editor_rail_layers": "Couches",
    "studio_editor_close_panel": "Fermer le panneau",
    "studio_editor_close_props": "Fermer les propriétés",
    "studio_editor_open_props": "Ouvrir les propriétés",
    "studio_editor_director_title": "Directeur de reel AI — prise unique",
    "studio_editor_director_sub": "Une phrase → reel animé complet (~10s).",
    "studio_editor_magic_title": "Magie AI — URL → 5 annonces",
    "studio_editor_magic_placeholder": "https://votre-site.com",
    "studio_editor_magic_generate": "Générer",
    "studio_editor_text_title": "Texte",
    "studio_editor_add_heading": "Ajouter un titre",
    "studio_editor_shapes_title": "Formes",
    "studio_editor_rectangle": "Rectangle",
    "studio_editor_circle": "Cercle",
    "studio_editor_background_title": "Arrière-plan",
    "studio_editor_upload_title": "Télécharger une image",
    "studio_editor_stock_btn": "Photos libres de droits",
    "studio_editor_from_url": "Depuis l'URL",
    "studio_editor_add": "Ajouter",
    "studio_editor_layers_title": "Couches",
    "studio_editor_canvas_empty": "Le canevas est vide.",
    "studio_editor_props_title": "Propriétés",
    "studio_editor_select_element": "Sélectionnez un élément pour modifier ses propriétés.",
    "studio_editor_prop_text": "Texte",
    "studio_editor_prop_font": "Police",
    "studio_editor_prop_size": "Taille",
    "studio_editor_prop_fill": "Remplissage",
    "studio_editor_prop_opacity": "Opacité",
    "studio_editor_duplicate": "Dupliquer",
    "studio_editor_delete": "Supprimer",
    "studio_editor_toast_offline_info": "Vous travaillez hors ligne. Connectez-vous pour enregistrer et exporter.",
    "studio_editor_toast_open_fail": "Impossible d'ouvrir l'éditeur",
    "studio_editor_toast_image_fail": "Impossible de charger l'image",
    "studio_editor_toast_saved": "Enregistré",
    "studio_editor_toast_save_fail": "Échec de l'enregistrement",
    "studio_editor_toast_log_in_save": "Connectez-vous pour enregistrer votre annonce sur le cloud.",
    "studio_editor_toast_add_elements_first": "Ajoutez d'abord des éléments, puis cliquez sur Quick Reel.",
    "studio_editor_toast_need_animation": "Ajoutez au moins une animation d'abord (Animer le rail).",
    "studio_editor_toast_browser_no_video": "Votre navigateur ne prend pas en charge l'enregistrement vidéo.",
    "studio_editor_toast_video_fail": "Échec de l'exportation vidéo",
    "studio_editor_toast_export_fail": "Échec de l'exportation",
    "studio_editor_toast_exported": "Exporté !",
    "studio_editor_toast_exported_ext": "Exporté .{ext} !",
    "studio_editor_toast_credits_out": "Plus de crédits publicitaires.",
    "studio_editor_toast_credits_out_upsell": "Vous n'avez plus de crédits publicitaires. Mettez à niveau vers Pro pour 30/mois.",
    "studio_editor_toast_ai_fail": "Échec de l'IA Magic",
    "studio_editor_toast_no_variants": "Aucune variante retournée",
    "studio_editor_toast_applied": "Appliqué : {angle}",
    "studio_editor_toast_quick_reel_done": "Quick Reel · {n} animations · {s}s",
    "studio_editor_toast_smart_resize_done": "Créé {n} annonce{plural} sœur",
    "studio_editor_toast_smart_resize_fail": "Échec du redimensionnement intelligent",
    "studio_my_have_coupon": "Avez un coupon ?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Échanger",
    "studio_my_toast_credits_added": "+{amount} crédits ajoutés 🎉",
    "studio_my_toast_not_found": "Code introuvable",
    "studio_my_toast_already": "Déjà échangé",
    "studio_my_toast_expired": "Expiré ou désactivé",
    "studio_my_toast_redeem_fail": "Échec de l'échange",
    "studio_my_toast_load_fail": "Échec du chargement des projets",
    "studio_my_confirm_delete": "Supprimer \"{title}\" ?",
    "studio_my_title": "Mes designs",
    "studio_my_sub": "Tous vos projets et exports sauvegardés au même endroit.",
    "studio_my_count_one": "{n} projet",
    "studio_my_count_many": "{n} projets",
    "studio_my_instant_campaign": "Campagne Instantanée",
    "studio_my_new_ad": "Nouvelle annonce",
    "studio_my_login_to_see": "Connectez-vous pour voir vos annonces sauvegardées.",
    "studio_my_login": "Connexion",
    "studio_my_loading": "Chargement…",
    "studio_my_empty_title": "Aucune annonce pour le moment.",
    "studio_my_browse": "Parcourir les modèles",
    "studio_my_badge_team": "Équipe",
    "studio_my_badge_shared": "Partagé",
    "studio_my_edit": "Modifier",
    "studio_gallery_filter_prefix": "Filtrer",
    "studio_gallery_filter_cancel": "× effacer",
    "studio_gallery_title": "Modèles",
    "studio_gallery_lead": "Choisissez un départ. Modifiez tout.",
    "studio_gallery_search": "Rechercher des modèles…",
    "studio_gallery_loading_count": "Chargement…",
    "studio_gallery_count_of": "{start}–{end} de {total} modèles",
    "studio_gallery_pack_all": "Tous",
    "studio_gallery_pack_trending": "Tendance",
    "studio_gallery_pack_ai": "Alimenté par l'IA",
    "studio_gallery_pack_editorial": "Éditorial",
    "studio_gallery_pack_video": "Vidéos",
    "studio_gallery_pack_free": "Gratuit",
    "studio_gallery_video_only": "Vidéos uniquement",
    "studio_gallery_all_formats": "Tous les formats",
    "studio_gallery_all_categories": "Toutes les catégories",
    "studio_gallery_loading_templates": "Chargement des modèles…",
    "studio_gallery_no_match": "Aucun modèle ne correspond à ces filtres.",
    "studio_gallery_opening": "Ouverture de l'éditeur…",
    "studio_gallery_prev": "← Précédent",
    "studio_gallery_next": "Suivant →",
    "studio_gallery_page_of": "Page {n} de {total}",
    "studio_gallery_type_post": "Publication",
    "studio_gallery_type_story": "Histoire",
    "studio_gallery_type_reel": "Reel",
    "studio_gallery_type_video": "Vidéo",
    "studio_gallery_type_ad": "Annonce",
    "studio_landing_meta_title": "Studio — Conceptions AI, reels & vidéos en 60 secondes | TopRankPulse",
    "studio_landing_meta_desc": "Créez des publications, reels, vidéos et annonces avec l'IA. Plus de 1 600 modèles, exportation en un clic. Faisant partie de TopRankPulse.",
    "studio_landing_eyebrow": "NOUVEAU · STUDIO PAR TOPRANKPULSE",
    "studio_landing_hero_title_a": "Créez des publications, reels et vidéos.",
    "studio_landing_hero_title_b": "En quelques minutes, pas en jours.",
    "studio_landing_hero_lead": "Choisissez un type de contenu, un modèle, ou laissez l'IA rédiger la première version. Éditez dans un éditeur style Canva. Exportez en PNG / MP4 en un clic. Annonces, reels, histoires, vidéos et publications — tout en un.",
    "studio_landing_cta_start": "Commencez à créer",
    "studio_landing_cta_instant": "Campagne instantanée — 25 annonces",
    "studio_landing_cta_browse": "Parcourir les modèles",
    "studio_landing_kpi_projects": "Projets créés",
    "studio_landing_kpi_exports": "Exports téléchargés",
    "studio_landing_kpi_templates": "Modèles",
    "studio_landing_kpi_formats": "Formats d'annonce",
    "studio_landing_features_title": "Un studio. Pas un diaporama.",
    "studio_landing_features_sub": "Tout ce qu'un marketeur performant utilise réellement — un écran, aucune onglet.",
    "studio_landing_feat_ai_title": "Magie AI depuis l'URL",
    "studio_landing_feat_ai_text": "Collez un site web, obtenez 5 concepts d'annonces complets — couleurs de marque, titres, CTAs, toiles prêtes à expédier.",
    "studio_landing_feat_type_title": "Typographie complète",
    "studio_landing_feat_type_text": "Polices, poids, interlignage, contours, ombres portées. Zones de texte qui se comportent comme Adobe, pas PowerPoint.",
    "studio_landing_feat_img_title": "IA + images libres de droits",
    "studio_landing_feat_img_text": "Générez des arrière-plans parfaits avec GPT Image 1. Unsplash et Pexels intégrés.",
    "studio_landing_feat_brand_title": "Kit de marque",
    "studio_landing_feat_brand_text": "Verrouillez vos couleurs, polices, logos une fois. Chaque nouvelle annonce les hérite automatiquement.",
    "studio_landing_feat_resize_title": "Redimensionnement intelligent",
    "studio_landing_feat_resize_text": "Une toile → 10 annonces sœurs redimensionnées automatiquement à chaque format. Expédiez une campagne complète en un clic.",
    "studio_landing_feat_wl_title": "Prêt pour la marque blanche",
    "studio_landing_feat_wl_text": "Conçu pour être intégré. Intégrez dans votre portail d'agence via iframe ou API. Votre marque, notre moteur.",
    "studio_landing_formats_title": "10 formats d'annonce. Une toile.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Fil, Histoire, Reel.",
    "studio_landing_pricing_title": "Tarification simple basée sur les crédits.",
    "studio_landing_pricing_sub": "Commencez gratuitement. Évoluez avec vos campagnes.",
    "studio_landing_pricing_extra": "Annonces supplémentaires au-delà du plan : 2,30 € / crédit · annulez à tout moment",
    "studio_landing_price_free_credits": "3 annonces · paiement unique",
    "studio_landing_price_starter_credits": "10 annonces / mois",
    "studio_landing_price_pro_credits": "30 annonces / mois",
    "studio_landing_price_agency_credits": "80 annonces / mois",
    "studio_landing_price_free_f1": "Tous les 10 formats",
    "studio_landing_price_free_f2": "Magie IA depuis l'URL",
    "studio_landing_price_free_f3": "Export PNG",
    "studio_landing_price_free_f4": "Aucune carte de crédit",
    "studio_landing_price_starter_f1": "Tout dans le Gratuit",
    "studio_landing_price_starter_f2": "Kit de marque",
    "studio_landing_price_starter_f3": "Redimensionnement intelligent",
    "studio_landing_price_starter_f4": "File d'attente prioritaire",
    "studio_landing_price_pro_f1": "Tout dans le Starter",
    "studio_landing_price_pro_f2": "Génération d'images IA (GPT Image 1)",
    "studio_landing_price_pro_f3": "Export vidéo (à venir)",
    "studio_landing_price_pro_f4": "Supprimer le filigrane",
    "studio_landing_price_agency_f1": "Tout dans le Pro",
    "studio_landing_price_agency_f2": "Places pour l'équipe (à venir)",
    "studio_landing_price_agency_f3": "Exportation en marque blanche",
    "studio_landing_price_agency_f4": "Support dédié",
    "studio_landing_price_free_cta": "Commencer gratuitement",
    "studio_landing_price_starter_cta": "Obtenir Starter",
    "studio_landing_price_pro_cta": "Obtenir Pro",
    "studio_landing_price_agency_cta": "Obtenir Agence",
    "studio_landing_price_most_popular": "Le plus populaire",
    "studio_landing_final_title": "Publiez votre première annonce ce soir.",
    "studio_landing_final_sub": "Trois annonces gratuites. Pas de carte. Deux clics pour publier.",
    "studio_landing_final_btn": "Ouvrir l'éditeur",
    "studio_landing_footer": "Studio · fait partie de",
    "studio_create_back_select": "← Retour à la sélection",
    "studio_create_new_prefix": "Nouveau",
    "studio_create_type_desc_suffix": "Choisissez un modèle ou commencez avec une toile vierge.",
    "studio_create_opt_templates_title": "Choisissez un modèle",
    "studio_create_opt_templates_sub": "Des centaines de designs prêts à l'emploi — modifiables",
    "studio_create_opt_blank_title": "Toile vierge",
    "studio_create_opt_blank_sub": "Contrôle total, toile vide",
    "studio_create_opt_ai_title": "Magie IA ✨",
    "studio_create_opt_ai_sub": "Décrivez ce que vous voulez — l'IA crée la première version",
    "studio_create_hub_eyebrow": "Que créez-vous?",
    "studio_create_hub_title_a": "Soyons",
    "studio_create_hub_title_b": "créatifs",
    "studio_create_hub_sub": "Choisissez un type de contenu. Chaque préréglage ouvre les bonnes dimensions et modèles.",
    "studio_create_card_start": "Commencer",
    "studio_create_type_post_label": "Publication",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Histoire",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animé · 15–60s",
    "studio_create_type_video_label": "Vidéo",
    "studio_create_type_video_desc": "16:9 · paysage",
    "studio_create_type_ad_label": "Annonce",
    "studio_create_type_ad_desc": "Créatif d'annonce FB/IG",
    "studio_more_title": "Plus",
    "studio_more_sub": "Paramètres, compte et autres outils.",
    "studio_more_settings": "Paramètres du compte",
    "studio_more_notifications": "Notifications",
    "studio_more_plan": "Plan & facturation",
    "studio_more_invite": "Inviter des amis",
    "studio_more_redeem": "Échanger un coupon",
    "studio_more_ai": "Magie de l'IA",
    "studio_more_privacy": "Confidentialité",
    "studio_more_help": "Aide & Blog",
    "studio_more_logout": "Se déconnecter",
    "studio_nav_create": "Créer",
    "studio_nav_mine": "Mes designs",
    "studio_nav_templates": "Modèles",
    "studio_nav_community": "Communauté",
    "studio_nav_more": "Plus",
    "studio_nav_home": "Accueil",
    "studio_nav_projects": "Projets",
    "studio_nav_ai_magic": "Magie de l'IA",
    "studio_nav_business": "Entreprise",
    "studio_nav_create_aria": "Créer un nouveau design",
    "studio_team_title": "Entreprise — espace de travail d'équipe",
    "studio_team_sub": "Invitez des collègues à travailler ensemble. Max. 10 membres par équipe.",
    "studio_team_load_fail": "Impossible de charger l'équipe",
    "studio_team_create_title": "Créer une nouvelle équipe",
    "studio_team_create_sub": "Vous devenez le propriétaire et pouvez inviter des membres.",
    "studio_team_name_placeholder": "Nom de l'équipe",
    "studio_team_create_btn": "Créer",
    "studio_team_join_title": "Rejoindre avec une invitation existante",
    "studio_team_join_sub": "Si quelqu'un vous a envoyé un code d'invitation.",
    "studio_team_invite_code_placeholder": "Code d'invitation",
    "studio_team_join_btn": "Rejoindre",
    "studio_team_created": "Équipe créée",
    "studio_team_failed": "Échec",
    "studio_team_joined": "Équipe rejointe",
    "studio_team_invite_invalid": "Invitation invalide",
    "studio_team_member_one": "membre",
    "studio_team_members_many": "membres",
    "studio_team_you_are_owner": "· vous êtes propriétaire",
    "studio_team_leave_btn": "Quitter",
    "studio_team_confirm_leave": "Voulez-vous vraiment quitter l'équipe ?",
    "studio_team_left": "Quitté l'équipe",
    "studio_team_invite_title": "Inviter un nouveau membre",
    "studio_team_invite_email_placeholder": "email@example.com",
    "studio_team_send_invite": "Envoyer l'invitation",
    "studio_team_invite_copied": "Lien d'invitation copié dans le presse-papiers",
    "studio_team_auto_copy_hint": "Le lien d'invitation est copié dans le presse-papiers automatiquement.",
    "studio_team_members_header": "Membres",
    "studio_team_owner_badge": "Propriétaire",
    "studio_team_pending_header": "Invitations en attente",
    "studio_team_expires": "Expire"
  },
  "es": {
    "studio_editor_back": "Atrás",
    "studio_editor_untitled": "Anuncio sin título",
    "studio_editor_credits_view": "Ver libro de créditos",
    "studio_editor_credits_label": "Créditos",
    "studio_editor_credits_unlimited": "∞ Ilimitado",
    "studio_editor_smart_resize": "Redimensionar inteligente",
    "studio_editor_quick_reel": "Reel rápido",
    "studio_editor_quick_reel_title": "Auto-animar cada elemento para un reel de 15 segundos",
    "studio_editor_save": "Guardar",
    "studio_editor_export_png": "Exportar PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Exportar video animado",
    "studio_editor_mp4_title_need_anim": "Agrega una animación primero",
    "studio_editor_rail_magic": "Mágico",
    "studio_editor_rail_text": "Texto",
    "studio_editor_rail_shapes": "Formas",
    "studio_editor_rail_images": "Imágenes",
    "studio_editor_rail_anim": "Animar",
    "studio_editor_rail_layers": "Capas",
    "studio_editor_close_panel": "Cerrar panel",
    "studio_editor_close_props": "Cerrar propiedades",
    "studio_editor_open_props": "Abrir propiedades",
    "studio_editor_director_title": "Director de Reel AI — toma única",
    "studio_editor_director_sub": "Una frase → reel animado completo (~10s).",
    "studio_editor_magic_title": "Magia AI — URL → 5 anuncios",
    "studio_editor_magic_placeholder": "https://tu-sitio.com",
    "studio_editor_magic_generate": "Generar",
    "studio_editor_text_title": "Texto",
    "studio_editor_add_heading": "Agregar encabezado",
    "studio_editor_shapes_title": "Formas",
    "studio_editor_rectangle": "Rectángulo",
    "studio_editor_circle": "Círculo",
    "studio_editor_background_title": "Fondo",
    "studio_editor_upload_title": "Subir imagen",
    "studio_editor_stock_btn": "Fotos de stock",
    "studio_editor_from_url": "Desde URL",
    "studio_editor_add": "Agregar",
    "studio_editor_layers_title": "Capas",
    "studio_editor_canvas_empty": "El lienzo está vacío.",
    "studio_editor_props_title": "Propiedades",
    "studio_editor_select_element": "Selecciona un elemento para editar sus propiedades.",
    "studio_editor_prop_text": "Texto",
    "studio_editor_prop_font": "Fuente",
    "studio_editor_prop_size": "Tamaño",
    "studio_editor_prop_fill": "Relleno",
    "studio_editor_prop_opacity": "Opacidad",
    "studio_editor_duplicate": "Duplicar",
    "studio_editor_delete": "Eliminar",
    "studio_editor_toast_offline_info": "Estás trabajando sin conexión. Inicia sesión para guardar y exportar.",
    "studio_editor_toast_open_fail": "No se pudo abrir el editor",
    "studio_editor_toast_image_fail": "No se pudo cargar la imagen",
    "studio_editor_toast_saved": "Guardado",
    "studio_editor_toast_save_fail": "Error al guardar",
    "studio_editor_toast_log_in_save": "Inicia sesión para guardar tu anuncio en la nube.",
    "studio_editor_toast_add_elements_first": "Añade algunos elementos primero, luego haz clic en Quick Reel.",
    "studio_editor_toast_need_animation": "Añade al menos una animación primero (Animar riel).",
    "studio_editor_toast_browser_no_video": "Tu navegador no soporta grabación de video.",
    "studio_editor_toast_video_fail": "Error en la exportación de video",
    "studio_editor_toast_export_fail": "Error en la exportación",
    "studio_editor_toast_exported": "¡Exportado!",
    "studio_editor_toast_exported_ext": "¡Exportado .{ext}!",
    "studio_editor_toast_credits_out": "Sin créditos para anuncios.",
    "studio_editor_toast_credits_out_upsell": "Te has quedado sin créditos para anuncios. Mejora a Pro por 30/mes.",
    "studio_editor_toast_ai_fail": "Error en Magic AI",
    "studio_editor_toast_no_variants": "No se devolvieron variantes",
    "studio_editor_toast_applied": "Aplicado: {angle}",
    "studio_editor_toast_quick_reel_done": "Quick Reel · {n} animaciones · {s}s",
    "studio_editor_toast_smart_resize_done": "Creado {n} anuncio(s) hermano(s)",
    "studio_editor_toast_smart_resize_fail": "Error en el ajuste inteligente",
    "studio_my_have_coupon": "¿Tienes un cupón?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Canjear",
    "studio_my_toast_credits_added": "+{amount} créditos añadidos 🎉",
    "studio_my_toast_not_found": "Código no encontrado",
    "studio_my_toast_already": "Ya canjeado",
    "studio_my_toast_expired": "Caducado o desactivado",
    "studio_my_toast_redeem_fail": "Error al canjear",
    "studio_my_toast_load_fail": "Error al cargar proyectos",
    "studio_my_confirm_delete": "¿Eliminar \"{title}\"?",
    "studio_my_title": "Mis diseños",
    "studio_my_sub": "Todos tus proyectos y exportaciones guardados en un solo lugar.",
    "studio_my_count_one": "{n} proyecto",
    "studio_my_count_many": "{n} proyectos",
    "studio_my_instant_campaign": "Campaña instantánea",
    "studio_my_new_ad": "Nuevo anuncio",
    "studio_my_login_to_see": "Inicia sesión para ver tus anuncios guardados.",
    "studio_my_login": "Iniciar sesión",
    "studio_my_loading": "Cargando…",
    "studio_my_empty_title": "Aún no hay anuncios.",
    "studio_my_browse": "Explorar plantillas",
    "studio_my_badge_team": "Equipo",
    "studio_my_badge_shared": "Compartido",
    "studio_my_edit": "Editar",
    "studio_gallery_filter_prefix": "Filtrar",
    "studio_gallery_filter_cancel": "× limpiar",
    "studio_gallery_title": "Plantillas",
    "studio_gallery_lead": "Elige un inicio. Edita lo que desees.",
    "studio_gallery_search": "Buscar plantillas…",
    "studio_gallery_loading_count": "Cargando…",
    "studio_gallery_count_of": "{start}–{end} de {total} plantillas",
    "studio_gallery_pack_all": "Todo",
    "studio_gallery_pack_trending": "Tendencias",
    "studio_gallery_pack_ai": "Con IA",
    "studio_gallery_pack_editorial": "Editorial",
    "studio_gallery_pack_video": "Reels de video",
    "studio_gallery_pack_free": "Gratis",
    "studio_gallery_video_only": "Solo video",
    "studio_gallery_all_formats": "Todos los formatos",
    "studio_gallery_all_categories": "Todas las categorías",
    "studio_gallery_loading_templates": "Cargando plantillas…",
    "studio_gallery_no_match": "No hay plantillas que coincidan con esos filtros.",
    "studio_gallery_opening": "Abriendo editor…",
    "studio_gallery_prev": "← Anterior",
    "studio_gallery_next": "Siguiente →",
    "studio_gallery_page_of": "Página {n} de {total}",
    "studio_gallery_type_post": "Publicación",
    "studio_gallery_type_story": "Historia",
    "studio_gallery_type_reel": "Reel",
    "studio_gallery_type_video": "Video",
    "studio_gallery_type_ad": "Anuncio",
    "studio_landing_meta_title": "Studio — Diseños, reels y videos en 60 segundos | TopRankPulse",
    "studio_landing_meta_desc": "Crea publicaciones, reels, videos y anuncios con IA. Más de 1,600 plantillas, exportación con un clic. Parte de TopRankPulse.",
    "studio_landing_eyebrow": "NUEVO · STUDIO DE TOPRANKPULSE",
    "studio_landing_hero_title_a": "Crea publicaciones, reels y videos.",
    "studio_landing_hero_title_b": "En minutos, no en días.",
    "studio_landing_hero_lead": "Elige un tipo de contenido, una plantilla o deja que la IA redacte la primera versión. Edita en un editor estilo Canva. Exporta PNG / MP4 con un clic. Anuncios, reels, historias, videos y publicaciones — todo en uno.",
    "studio_landing_cta_start": "Comenzar a crear",
    "studio_landing_cta_instant": "Campaña Instantánea — 25 anuncios",
    "studio_landing_cta_browse": "Explorar plantillas",
    "studio_landing_kpi_projects": "Proyectos creados",
    "studio_landing_kpi_exports": "Exportaciones descargadas",
    "studio_landing_kpi_templates": "Plantillas",
    "studio_landing_kpi_formats": "Formatos de anuncio",
    "studio_landing_features_title": "Un estudio. No una presentación.",
    "studio_landing_features_sub": "Todo lo que un marketero de rendimiento realmente utiliza — una pantalla, sin pestañas.",
    "studio_landing_feat_ai_title": "Magia de IA desde URL",
    "studio_landing_feat_ai_text": "Pega un sitio web, obtén 5 conceptos completos de anuncios — colores de marca, titulares, CTAs, lienzos listos para enviar.",
    "studio_landing_feat_type_title": "Tipografía completa",
    "studio_landing_feat_type_text": "Fuentes, pesos, espaciado, contornos, sombras. Cuadros de texto que se comportan como Adobe, no PowerPoint.",
    "studio_landing_feat_img_title": "IA + imágenes de stock",
    "studio_landing_feat_img_text": "Genera fondos perfectos con GPT Image 1. Unsplash y Pexels integrados.",
    "studio_landing_feat_brand_title": "Kit de marca",
    "studio_landing_feat_brand_text": "Bloquea tus colores, fuentes, logotipos una vez. Cada nuevo anuncio los hereda automáticamente.",
    "studio_landing_feat_resize_title": "Redimensionamiento inteligente",
    "studio_landing_feat_resize_text": "Un lienzo → 10 anuncios hermanos auto-escalados a cada formato. Envía una campaña completa con un clic.",
    "studio_landing_feat_wl_title": "Listo para marca blanca",
    "studio_landing_feat_wl_text": "Diseñado para ser integrado. Inserta en tu portal de agencia a través de iframe o API. Tu marca, nuestro motor.",
    "studio_landing_formats_title": "10 formatos de anuncios. Un lienzo.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Feed, Historia, Reel.",
    "studio_landing_pricing_title": "Precios simples, basados en créditos.",
    "studio_landing_pricing_sub": "Comienza gratis. Escala cuando tus campañas lo hagan.",
    "studio_landing_pricing_extra": "Anuncios extra más allá del plan: €2.30 / crédito · cancela en cualquier momento",
    "studio_landing_price_free_credits": "3 anuncios · único",
    "studio_landing_price_starter_credits": "10 anuncios / mes",
    "studio_landing_price_pro_credits": "30 anuncios / mes",
    "studio_landing_price_agency_credits": "80 anuncios / mes",
    "studio_landing_price_free_f1": "Todos los 10 formatos",
    "studio_landing_price_free_f2": "Magia de IA desde URL",
    "studio_landing_price_free_f3": "Exportación PNG",
    "studio_landing_price_free_f4": "Sin tarjeta de crédito",
    "studio_landing_price_starter_f1": "Todo en Gratis",
    "studio_landing_price_starter_f2": "Kit de Marca",
    "studio_landing_price_starter_f3": "Redimensionamiento Inteligente",
    "studio_landing_price_starter_f4": "Cola Prioritaria",
    "studio_landing_price_pro_f1": "Todo en Starter",
    "studio_landing_price_pro_f2": "Generación de Imágenes AI (GPT Image 1)",
    "studio_landing_price_pro_f3": "Exportación de Video (próximamente)",
    "studio_landing_price_pro_f4": "Eliminar marca de agua",
    "studio_landing_price_agency_f1": "Todo en Pro",
    "studio_landing_price_agency_f2": "Asientos para el equipo (próximamente)",
    "studio_landing_price_agency_f3": "Exportación de etiqueta blanca",
    "studio_landing_price_agency_f4": "Soporte dedicado",
    "studio_landing_price_free_cta": "Comienza gratis",
    "studio_landing_price_starter_cta": "Obtener Starter",
    "studio_landing_price_pro_cta": "Obtener Pro",
    "studio_landing_price_agency_cta": "Obtener Agencia",
    "studio_landing_price_most_popular": "Más popular",
    "studio_landing_final_title": "Publica tu primer anuncio esta noche.",
    "studio_landing_final_sub": "Tres anuncios gratis. Sin tarjeta. Dos clics para publicar.",
    "studio_landing_final_btn": "Abrir el editor",
    "studio_landing_footer": "Studio · parte de",
    "studio_create_back_select": "← Volver a la selección",
    "studio_create_new_prefix": "Nuevo",
    "studio_create_type_desc_suffix": "Elige una plantilla o comienza desde un lienzo en blanco.",
    "studio_create_opt_templates_title": "Elige una plantilla",
    "studio_create_opt_templates_sub": "Cientos de diseños listos — editables",
    "studio_create_opt_blank_title": "Lienzo en blanco",
    "studio_create_opt_blank_sub": "Control total, lienzo vacío",
    "studio_create_opt_ai_title": "Magia AI ✨",
    "studio_create_opt_ai_sub": "Describe lo que deseas — AI crea la primera versión",
    "studio_create_hub_eyebrow": "¿Qué estás creando?",
    "studio_create_hub_title_a": "Vamos a ser",
    "studio_create_hub_title_b": "creativos",
    "studio_create_hub_sub": "Elige un tipo de contenido. Cada preset abre las dimensiones y plantillas correctas.",
    "studio_create_card_start": "Comenzar",
    "studio_create_type_post_label": "Publicación",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Historia",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animado · 15–60s",
    "studio_create_type_video_label": "Vídeo",
    "studio_create_type_video_desc": "16:9 · paisaje",
    "studio_create_type_ad_label": "Anuncio",
    "studio_create_type_ad_desc": "Creativo para anuncio FB/IG",
    "studio_more_title": "Más",
    "studio_more_sub": "Configuraciones, cuenta y otras herramientas.",
    "studio_more_settings": "Configuración de la cuenta",
    "studio_more_notifications": "Notificaciones",
    "studio_more_plan": "Plan y facturación",
    "studio_more_invite": "Invitar amigos",
    "studio_more_redeem": "Canjear un cupón",
    "studio_more_ai": "Magia AI",
    "studio_more_privacy": "Privacidad",
    "studio_more_help": "Ayuda y Blog",
    "studio_more_logout": "Cerrar sesión",
    "studio_nav_create": "Crear",
    "studio_nav_mine": "Mis diseños",
    "studio_nav_templates": "Plantillas",
    "studio_nav_community": "Comunidad",
    "studio_nav_more": "Más",
    "studio_nav_home": "Inicio",
    "studio_nav_projects": "Proyectos",
    "studio_nav_ai_magic": "Magia AI",
    "studio_nav_business": "Negocios",
    "studio_nav_create_aria": "Crear nuevo diseño",
    "studio_team_title": "Negocios — espacio de trabajo en equipo",
    "studio_team_sub": "Invita a colegas para trabajar juntos. Máx. 10 miembros por equipo.",
    "studio_team_load_fail": "No se pudo cargar el equipo",
    "studio_team_create_title": "Crear un nuevo equipo",
    "studio_team_create_sub": "Tú serás el propietario y podrás invitar miembros.",
    "studio_team_name_placeholder": "Nombre del equipo",
    "studio_team_create_btn": "Crear",
    "studio_team_join_title": "Unirse con una invitación existente",
    "studio_team_join_sub": "Si alguien te envió un código de invitación.",
    "studio_team_invite_code_placeholder": "Código de invitación",
    "studio_team_join_btn": "Unirse",
    "studio_team_created": "Equipo creado",
    "studio_team_failed": "Fallido",
    "studio_team_joined": "Unido al equipo",
    "studio_team_invite_invalid": "Invitación inválida",
    "studio_team_member_one": "miembro",
    "studio_team_members_many": "miembros",
    "studio_team_you_are_owner": "· eres el propietario",
    "studio_team_leave_btn": "Salir",
    "studio_team_confirm_leave": "¿Realmente quieres dejar el equipo?",
    "studio_team_left": "Dejó el equipo",
    "studio_team_invite_title": "Invitar a un nuevo miembro",
    "studio_team_invite_email_placeholder": "email@ejemplo.com",
    "studio_team_send_invite": "Enviar invitación",
    "studio_team_invite_copied": "Enlace de invitación copiado al portapapeles",
    "studio_team_auto_copy_hint": "El enlace de invitación se copia al portapapeles automáticamente.",
    "studio_team_members_header": "Miembros",
    "studio_team_owner_badge": "Propietario",
    "studio_team_pending_header": "Invitaciones pendientes",
    "studio_team_expires": "Expira"
  },
  "pt": {
    "studio_editor_back": "Voltar",
    "studio_editor_untitled": "Anúncio sem título",
    "studio_editor_credits_view": "Ver livro de créditos",
    "studio_editor_credits_label": "Créditos",
    "studio_editor_credits_unlimited": "∞ Ilimitado",
    "studio_editor_smart_resize": "Redimensionamento Inteligente",
    "studio_editor_quick_reel": "Reel Rápido",
    "studio_editor_quick_reel_title": "Auto-anime cada elemento para um reel de 15 segundos",
    "studio_editor_save": "Salvar",
    "studio_editor_export_png": "Exportar PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Exportar vídeo animado",
    "studio_editor_mp4_title_need_anim": "Adicione uma animação primeiro",
    "studio_editor_rail_magic": "Mágica",
    "studio_editor_rail_text": "Texto",
    "studio_editor_rail_shapes": "Formas",
    "studio_editor_rail_images": "Imagens",
    "studio_editor_rail_anim": "Animar",
    "studio_editor_rail_layers": "Camadas",
    "studio_editor_close_panel": "Fechar painel",
    "studio_editor_close_props": "Fechar propriedades",
    "studio_editor_open_props": "Abrir propriedades",
    "studio_editor_director_title": "Diretor de Reel AI — uma tomada",
    "studio_editor_director_sub": "Uma frase → reel animado completo (~10s).",
    "studio_editor_magic_title": "Mágica AI — URL → 5 anúncios",
    "studio_editor_magic_placeholder": "https://seu-site.com",
    "studio_editor_magic_generate": "Gerar",
    "studio_editor_text_title": "Texto",
    "studio_editor_add_heading": "Adicionar título",
    "studio_editor_shapes_title": "Formas",
    "studio_editor_rectangle": "Retângulo",
    "studio_editor_circle": "Círculo",
    "studio_editor_background_title": "Fundo",
    "studio_editor_upload_title": "Fazer upload de imagem",
    "studio_editor_stock_btn": "Fotos de estoque",
    "studio_editor_from_url": "De URL",
    "studio_editor_add": "Adicionar",
    "studio_editor_layers_title": "Camadas",
    "studio_editor_canvas_empty": "A tela está vazia.",
    "studio_editor_props_title": "Propriedades",
    "studio_editor_select_element": "Selecione um elemento para editar suas propriedades.",
    "studio_editor_prop_text": "Texto",
    "studio_editor_prop_font": "Fonte",
    "studio_editor_prop_size": "Tamanho",
    "studio_editor_prop_fill": "Preenchimento",
    "studio_editor_prop_opacity": "Opacidade",
    "studio_editor_duplicate": "Duplicar",
    "studio_editor_delete": "Excluir",
    "studio_editor_toast_offline_info": "Você está trabalhando offline. Faça login para salvar e exportar.",
    "studio_editor_toast_open_fail": "Não foi possível abrir o editor",
    "studio_editor_toast_image_fail": "Não foi possível carregar a imagem",
    "studio_editor_toast_saved": "Salvo",
    "studio_editor_toast_save_fail": "Falha ao salvar",
    "studio_editor_toast_log_in_save": "Faça login para salvar seu anúncio na nuvem.",
    "studio_editor_toast_add_elements_first": "Adicione alguns elementos primeiro, depois clique em Quick Reel.",
    "studio_editor_toast_need_animation": "Adicione pelo menos uma animação primeiro (Animate rail).",
    "studio_editor_toast_browser_no_video": "Seu navegador não suporta gravação de vídeo.",
    "studio_editor_toast_video_fail": "Falha na exportação do vídeo",
    "studio_editor_toast_export_fail": "Falha na exportação",
    "studio_editor_toast_exported": "Exportado!",
    "studio_editor_toast_exported_ext": "Exportado .{ext}!",
    "studio_editor_toast_credits_out": "Sem créditos para anúncios.",
    "studio_editor_toast_credits_out_upsell": "Você está sem créditos para anúncios. Faça upgrade para o Pro por 30/mês.",
    "studio_editor_toast_ai_fail": "Falha na AI Magic",
    "studio_editor_toast_no_variants": "Nenhuma variante retornada",
    "studio_editor_toast_applied": "Aplicado: {angle}",
    "studio_editor_toast_quick_reel_done": "Quick Reel · {n} animações · {s}s",
    "studio_editor_toast_smart_resize_done": "Criado {n} anúncio(s) irmão(ã)",
    "studio_editor_toast_smart_resize_fail": "Falha no redimensionamento inteligente",
    "studio_my_have_coupon": "Tem um cupom?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Resgatar",
    "studio_my_toast_credits_added": "+{amount} créditos adicionados 🎉",
    "studio_my_toast_not_found": "Código não encontrado",
    "studio_my_toast_already": "Já resgatado",
    "studio_my_toast_expired": "Vencido ou desativado",
    "studio_my_toast_redeem_fail": "Falha ao resgatar",
    "studio_my_toast_load_fail": "Falha ao carregar projetos",
    "studio_my_confirm_delete": "Excluir \"{title}\"?",
    "studio_my_title": "Meus designs",
    "studio_my_sub": "Todos os seus projetos e exportações salvos em um só lugar.",
    "studio_my_count_one": "{n} projeto",
    "studio_my_count_many": "{n} projetos",
    "studio_my_instant_campaign": "Campanha Instantânea",
    "studio_my_new_ad": "Novo anúncio",
    "studio_my_login_to_see": "Faça login para ver seus anúncios salvos.",
    "studio_my_login": "Fazer login",
    "studio_my_loading": "Carregando…",
    "studio_my_empty_title": "Nenhum anúncio ainda.",
    "studio_my_browse": "Navegar por modelos",
    "studio_my_badge_team": "Equipe",
    "studio_my_badge_shared": "Compartilhado",
    "studio_my_edit": "Editar",
    "studio_gallery_filter_prefix": "Filtrar",
    "studio_gallery_filter_cancel": "× limpar",
    "studio_gallery_title": "Modelos",
    "studio_gallery_lead": "Escolha um começo. Edite qualquer coisa.",
    "studio_gallery_search": "Pesquisar modelos…",
    "studio_gallery_loading_count": "Carregando…",
    "studio_gallery_count_of": "{start}–{end} de {total} modelos",
    "studio_gallery_pack_all": "Todos",
    "studio_gallery_pack_trending": "Tendências",
    "studio_gallery_pack_ai": "Poderado por AI",
    "studio_gallery_pack_editorial": "Editorial",
    "studio_gallery_pack_video": "Reels de Vídeo",
    "studio_gallery_pack_free": "Gratuito",
    "studio_gallery_video_only": "Somente vídeo",
    "studio_gallery_all_formats": "Todos os formatos",
    "studio_gallery_all_categories": "Todas as categorias",
    "studio_gallery_loading_templates": "Carregando modelos…",
    "studio_gallery_no_match": "Nenhum modelo corresponde a esses filtros.",
    "studio_gallery_opening": "Abrindo editor…",
    "studio_gallery_prev": "← Anterior",
    "studio_gallery_next": "Próximo →",
    "studio_gallery_page_of": "Página {n} de {total}",
    "studio_gallery_type_post": "Post",
    "studio_gallery_type_story": "História",
    "studio_gallery_type_reel": "Reel",
    "studio_gallery_type_video": "Vídeo",
    "studio_gallery_type_ad": "Anúncio",
    "studio_landing_meta_title": "Estúdio — Designs, reels e vídeos com IA em 60 segundos | TopRankPulse",
    "studio_landing_meta_desc": "Crie posts, reels, vídeos e anúncios com IA. Mais de 1.600 templates, exportação com um clique. Parte do TopRankPulse.",
    "studio_landing_eyebrow": "NOVO · ESTÚDIO POR TOPRANKPULSE",
    "studio_landing_hero_title_a": "Crie posts, reels e vídeos.",
    "studio_landing_hero_title_b": "Em minutos, não dias.",
    "studio_landing_hero_lead": "Escolha um tipo de conteúdo, um template ou deixe a IA criar a primeira versão. Edite em um editor estilo Canva. Exporte PNG / MP4 com um clique. Anúncios, reels, stories, vídeos e posts — tudo em um só.",
    "studio_landing_cta_start": "Comece a criar",
    "studio_landing_cta_instant": "Campanha Instantânea — 25 anúncios",
    "studio_landing_cta_browse": "Explore templates",
    "studio_landing_kpi_projects": "Projetos criados",
    "studio_landing_kpi_exports": "Exportações baixadas",
    "studio_landing_kpi_templates": "Templates",
    "studio_landing_kpi_formats": "Formatos de anúncio",
    "studio_landing_features_title": "Um estúdio. Não um slideshow.",
    "studio_landing_features_sub": "Tudo que um marketer de performance realmente usa — uma tela, sem abas.",
    "studio_landing_feat_ai_title": "Magia da IA a partir de URL",
    "studio_landing_feat_ai_text": "Cole um site, obtenha 5 conceitos completos de anúncios — cores da marca, manchetes, CTAs, templates prontos para uso.",
    "studio_landing_feat_type_title": "Tipografia completa",
    "studio_landing_feat_type_text": "Fontes, pesos, espaçamento, contornos, sombras projetadas. Caixas de texto que se comportam como Adobe, não PowerPoint.",
    "studio_landing_feat_img_title": "IA + imagens de estoque",
    "studio_landing_feat_img_text": "Gere fundos perfeitos com GPT Image 1. Unsplash e Pexels integrados.",
    "studio_landing_feat_brand_title": "Kit de marca",
    "studio_landing_feat_brand_text": "Defina suas cores, fontes, logos uma vez. Cada novo anúncio herda automaticamente.",
    "studio_landing_feat_resize_title": "Redimensionamento inteligente",
    "studio_landing_feat_resize_text": "Um canvas → 10 anúncios irmãos auto-redimensionados para cada formato. Envie uma campanha completa com um clique.",
    "studio_landing_feat_wl_title": "Pronto para marca branca",
    "studio_landing_feat_wl_text": "Construído para ser integrado. Insira em seu portal de agência via iframe ou API. Sua marca, nosso motor.",
    "studio_landing_formats_title": "10 formatos de anúncio. Um canvas.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Feed, Story, Reel.",
    "studio_landing_pricing_title": "Preços simples, baseados em créditos.",
    "studio_landing_pricing_sub": "Comece grátis. Escale quando suas campanhas crescendo.",
    "studio_landing_pricing_extra": "Anúncios extras além do plano: €2,30 / crédito · cancele a qualquer momento",
    "studio_landing_price_free_credits": "3 anúncios · um único pagamento",
    "studio_landing_price_starter_credits": "10 anúncios / mês",
    "studio_landing_price_pro_credits": "30 anúncios / mês",
    "studio_landing_price_agency_credits": "80 anúncios / mês",
    "studio_landing_price_free_f1": "Todos os 10 formatos",
    "studio_landing_price_free_f2": "Magia da IA a partir de URL",
    "studio_landing_price_free_f3": "Exportação PNG",
    "studio_landing_price_free_f4": "Sem cartão de crédito",
    "studio_landing_price_starter_f1": "Tudo no Free",
    "studio_landing_price_starter_f2": "Kit de Marca",
    "studio_landing_price_starter_f3": "Redimensionamento Inteligente",
    "studio_landing_price_starter_f4": "Fila Prioritária",
    "studio_landing_price_pro_f1": "Tudo no Starter",
    "studio_landing_price_pro_f2": "Geração de Imagens AI (GPT Image 1)",
    "studio_landing_price_pro_f3": "Exportação de Vídeo (em breve)",
    "studio_landing_price_pro_f4": "Remover Marca D'água",
    "studio_landing_price_agency_f1": "Tudo no Pro",
    "studio_landing_price_agency_f2": "Assentos de equipe (em breve)",
    "studio_landing_price_agency_f3": "Exportação White-label",
    "studio_landing_price_agency_f4": "Suporte Dedicado",
    "studio_landing_price_free_cta": "Começar grátis",
    "studio_landing_price_starter_cta": "Obter Starter",
    "studio_landing_price_pro_cta": "Obter Pro",
    "studio_landing_price_agency_cta": "Obter Agência",
    "studio_landing_price_most_popular": "Mais popular",
    "studio_landing_final_title": "Envie seu primeiro anúncio esta noite.",
    "studio_landing_final_sub": "Três anúncios gratuitos. Sem cartão. Dois cliques para publicar.",
    "studio_landing_final_btn": "Abrir o editor",
    "studio_landing_footer": "Estúdio · parte de",
    "studio_create_back_select": "← Voltar para seleção",
    "studio_create_new_prefix": "Novo",
    "studio_create_type_desc_suffix": "Escolha um modelo ou comece com uma tela em branco.",
    "studio_create_opt_templates_title": "Escolha um modelo",
    "studio_create_opt_templates_sub": "Centenas de designs prontos - editáveis",
    "studio_create_opt_blank_title": "Tela em branco",
    "studio_create_opt_blank_sub": "Controle total, tela vazia",
    "studio_create_opt_ai_title": "Magia AI ✨",
    "studio_create_opt_ai_sub": "Descreva o que você quer - a AI cria a primeira versão",
    "studio_create_hub_eyebrow": "O que você está criando?",
    "studio_create_hub_title_a": "Vamos ser",
    "studio_create_hub_title_b": "crativos",
    "studio_create_hub_sub": "Escolha um tipo de conteúdo. Cada predefinição abre as dimensões e modelos corretos.",
    "studio_create_card_start": "Começar",
    "studio_create_type_post_label": "Post",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Story",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animado · 15–60s",
    "studio_create_type_video_label": "Vídeo",
    "studio_create_type_video_desc": "16:9 · paisagem",
    "studio_create_type_ad_label": "Anúncio",
    "studio_create_type_ad_desc": "Criativo de anúncio FB/IG",
    "studio_more_title": "Mais",
    "studio_more_sub": "Configurações, conta e outras ferramentas.",
    "studio_more_settings": "Configurações da conta",
    "studio_more_notifications": "Notificações",
    "studio_more_plan": "Plano & faturamento",
    "studio_more_invite": "Convidar amigos",
    "studio_more_redeem": "Resgatar um cupom",
    "studio_more_ai": "Mágica de IA",
    "studio_more_privacy": "Privacidade",
    "studio_more_help": "Ajuda & Blog",
    "studio_more_logout": "Sair",
    "studio_nav_create": "Criar",
    "studio_nav_mine": "Meus designs",
    "studio_nav_templates": "Modelos",
    "studio_nav_community": "Comunidade",
    "studio_nav_more": "Mais",
    "studio_nav_home": "Início",
    "studio_nav_projects": "Projetos",
    "studio_nav_ai_magic": "Mágica de IA",
    "studio_nav_business": "Negócios",
    "studio_nav_create_aria": "Criar novo design",
    "studio_team_title": "Negócios — espaço de trabalho em equipe",
    "studio_team_sub": "Convide colegas para trabalhar juntos. Máx. 10 membros por equipe.",
    "studio_team_load_fail": "Não foi possível carregar a equipe",
    "studio_team_create_title": "Criar uma nova equipe",
    "studio_team_create_sub": "Você se torna o proprietário e pode convidar membros.",
    "studio_team_name_placeholder": "Nome da equipe",
    "studio_team_create_btn": "Criar",
    "studio_team_join_title": "Junte-se com um convite existente",
    "studio_team_join_sub": "Se alguém lhe enviou um código de convite.",
    "studio_team_invite_code_placeholder": "Código de convite",
    "studio_team_join_btn": "Junte-se",
    "studio_team_created": "Equipe criada",
    "studio_team_failed": "Falhou",
    "studio_team_joined": "Entrou na equipe",
    "studio_team_invite_invalid": "Convite inválido",
    "studio_team_member_one": "membro",
    "studio_team_members_many": "membros",
    "studio_team_you_are_owner": "· você é o proprietário",
    "studio_team_leave_btn": "Sair",
    "studio_team_confirm_leave": "Realmente deseja sair da equipe?",
    "studio_team_left": "Saiu da equipe",
    "studio_team_invite_title": "Convidar um novo membro",
    "studio_team_invite_email_placeholder": "email@exemplo.com",
    "studio_team_send_invite": "Enviar convite",
    "studio_team_invite_copied": "Link do convite copiado para a área de transferência",
    "studio_team_auto_copy_hint": "Link do convite copiado para a área de transferência automaticamente.",
    "studio_team_members_header": "Membros",
    "studio_team_owner_badge": "Proprietário",
    "studio_team_pending_header": "Convites pendentes",
    "studio_team_expires": "Expira"
  },
  "it": {
    "studio_editor_back": "Indietro",
    "studio_editor_untitled": "Annuncio senza titolo",
    "studio_editor_credits_view": "Visualizza registro crediti",
    "studio_editor_credits_label": "Crediti",
    "studio_editor_credits_unlimited": "∞ Illimitato",
    "studio_editor_smart_resize": "Ridimensionamento intelligente",
    "studio_editor_quick_reel": "Racconto veloce",
    "studio_editor_quick_reel_title": "Auto-anima ogni elemento per un racconto di 15 secondi",
    "studio_editor_save": "Salva",
    "studio_editor_export_png": "Esporta PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Esporta video animato",
    "studio_editor_mp4_title_need_anim": "Aggiungi prima un'animazione",
    "studio_editor_rail_magic": "Magia",
    "studio_editor_rail_text": "Testo",
    "studio_editor_rail_shapes": "Forme",
    "studio_editor_rail_images": "Immagini",
    "studio_editor_rail_anim": "Anima",
    "studio_editor_rail_layers": "Livelli",
    "studio_editor_close_panel": "Chiudi pannello",
    "studio_editor_close_props": "Chiudi proprietà",
    "studio_editor_open_props": "Apri proprietà",
    "studio_editor_director_title": "Direttore AI del Racconto — one-shot",
    "studio_editor_director_sub": "Una frase → racconto animato completo (~10s).",
    "studio_editor_magic_title": "Magia AI — URL → 5 annunci",
    "studio_editor_magic_placeholder": "https://il-tuo-sito.com",
    "studio_editor_magic_generate": "Genera",
    "studio_editor_text_title": "Testo",
    "studio_editor_add_heading": "Aggiungi intestazione",
    "studio_editor_shapes_title": "Forme",
    "studio_editor_rectangle": "Rettangolo",
    "studio_editor_circle": "Cerchio",
    "studio_editor_background_title": "Sfondo",
    "studio_editor_upload_title": "Carica immagine",
    "studio_editor_stock_btn": "Foto stock",
    "studio_editor_from_url": "Da URL",
    "studio_editor_add": "Aggiungi",
    "studio_editor_layers_title": "Livelli",
    "studio_editor_canvas_empty": "La tela è vuota.",
    "studio_editor_props_title": "Proprietà",
    "studio_editor_select_element": "Seleziona un elemento per modificare le sue proprietà.",
    "studio_editor_prop_text": "Testo",
    "studio_editor_prop_font": "Carattere",
    "studio_editor_prop_size": "Dimensione",
    "studio_editor_prop_fill": "Riempimento",
    "studio_editor_prop_opacity": "Opacità",
    "studio_editor_duplicate": "Duplica",
    "studio_editor_delete": "Elimina",
    "studio_editor_toast_offline_info": "Stai lavorando offline. Accedi per salvare ed esportare.",
    "studio_editor_toast_open_fail": "Impossibile aprire l'editor",
    "studio_editor_toast_image_fail": "Impossibile caricare l'immagine",
    "studio_editor_toast_saved": "Salvato",
    "studio_editor_toast_save_fail": "Salvataggio fallito",
    "studio_editor_toast_log_in_save": "Accedi per salvare la tua pubblicità nel cloud.",
    "studio_editor_toast_add_elements_first": "Aggiungi prima alcuni elementi, poi clicca su Quick Reel.",
    "studio_editor_toast_need_animation": "Aggiungi prima almeno un'animazione (Animate rail).",
    "studio_editor_toast_browser_no_video": "Il tuo browser non支持支持a la registrazione video.",
    "studio_editor_toast_video_fail": "Esportazione video fallita",
    "studio_editor_toast_export_fail": "Esportazione fallita",
    "studio_editor_toast_exported": "Esportato!",
    "studio_editor_toast_exported_ext": "Esportato .{ext}!",
    "studio_editor_toast_credits_out": "Esaurito il credito pubblicitario.",
    "studio_editor_toast_credits_out_upsell": "Sei a corto di crediti pubblicitari. Aggiorna a Pro per 30/mese.",
    "studio_editor_toast_ai_fail": "AI Magic fallito",
    "studio_editor_toast_no_variants": "Nessuna variante restituita",
    "studio_editor_toast_applied": "Applicato: {angle}",
    "studio_editor_toast_quick_reel_done": "Quick Reel · {n} animazioni · {s}s",
    "studio_editor_toast_smart_resize_done": "Creato {n} annuncio fraterno{plural}",
    "studio_editor_toast_smart_resize_fail": "Ridimensionamento intelligente fallito",
    "studio_my_have_coupon": "Hai un coupon?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Riscatta",
    "studio_my_toast_credits_added": "+{amount} crediti aggiunti 🎉",
    "studio_my_toast_not_found": "Codice non trovato",
    "studio_my_toast_already": "Già riscattato",
    "studio_my_toast_expired": "Scaduto o disattivato",
    "studio_my_toast_redeem_fail": "Riscatto fallito",
    "studio_my_toast_load_fail": "Impossibile caricare i progetti",
    "studio_my_confirm_delete": "Eliminare \"{title}\"?",
    "studio_my_title": "I miei progetti",
    "studio_my_sub": "Tutti i tuoi progetti salvati ed esportazioni in un unico posto.",
    "studio_my_count_one": "{n} progetto",
    "studio_my_count_many": "{n} progetti",
    "studio_my_instant_campaign": "Campagna Istantanea",
    "studio_my_new_ad": "Nuovo annuncio",
    "studio_my_login_to_see": "Accedi per vedere i tuoi annunci salvati.",
    "studio_my_login": "Accedi",
    "studio_my_loading": "Caricamento…",
    "studio_my_empty_title": "Ancora nessun annuncio.",
    "studio_my_browse": "Sfoglia modelli",
    "studio_my_badge_team": "Team",
    "studio_my_badge_shared": "Condiviso",
    "studio_my_edit": "Modifica",
    "studio_gallery_filter_prefix": "Filtra",
    "studio_gallery_filter_cancel": "× cancella",
    "studio_gallery_title": "Modelli",
    "studio_gallery_lead": "Scegli un inizio. Modifica qualsiasi cosa.",
    "studio_gallery_search": "Cerca modelli…",
    "studio_gallery_loading_count": "Caricamento…",
    "studio_gallery_count_of": "{start}–{end} di {total} modelli",
    "studio_gallery_pack_all": "Tutti",
    "studio_gallery_pack_trending": "Tendenze",
    "studio_gallery_pack_ai": "Potente AI",
    "studio_gallery_pack_editorial": "Editoriale",
    "studio_gallery_pack_video": "Video Reels",
    "studio_gallery_pack_free": "Gratuito",
    "studio_gallery_video_only": "Solo video",
    "studio_gallery_all_formats": "Tutti i formati",
    "studio_gallery_all_categories": "Tutte le categorie",
    "studio_gallery_loading_templates": "Caricamento modelli…",
    "studio_gallery_no_match": "Nessun modello corrisponde a quei filtri.",
    "studio_gallery_opening": "Apertura editor…",
    "studio_gallery_prev": "← Precedente",
    "studio_gallery_next": "Successivo →",
    "studio_gallery_page_of": "Pagina {n} di {total}",
    "studio_gallery_type_post": "Post",
    "studio_gallery_type_story": "Storia",
    "studio_gallery_type_reel": "Reel",
    "studio_gallery_type_video": "Video",
    "studio_gallery_type_ad": "Annuncio",
    "studio_landing_meta_title": "Studio — Progetti, reel e video in 60 secondi | TopRankPulse",
    "studio_landing_meta_desc": "Crea post, reel, video e annunci con l'AI. Oltre 1.600 modelli, esportazione con un clic. Parte di TopRankPulse.",
    "studio_landing_eyebrow": "NUOVO · STUDIO DI TOPRANKPULSE",
    "studio_landing_hero_title_a": "Crea post, reel e video.",
    "studio_landing_hero_title_b": "In minuti, non in giorni.",
    "studio_landing_hero_lead": "Scegli un tipo di contenuto, un modello, oppure lascia che l'AI rediga la prima versione. Modifica in un editor in stile Canva. Esporta PNG / MP4 con un clic. Annunci, reel, storie, video e post — tutto in uno.",
    "studio_landing_cta_start": "Inizia a creare",
    "studio_landing_cta_instant": "Campagna Istantanea — 25 annunci",
    "studio_landing_cta_browse": "Sfoglia i modelli",
    "studio_landing_kpi_projects": "Progetti creati",
    "studio_landing_kpi_exports": "Esportazioni scaricate",
    "studio_landing_kpi_templates": "Modelli",
    "studio_landing_kpi_formats": "Formati pubblicitari",
    "studio_landing_features_title": "Uno studio. Non una presentazione.",
    "studio_landing_features_sub": "Tutto ciò che un marketer usa realmente — un'unica schermata, niente schede.",
    "studio_landing_feat_ai_title": "Magia dell'AI da URL",
    "studio_landing_feat_ai_text": "Incolla un sito web, ottieni 5 concetti pubblicitari completi — colori del marchio, titoli, CTA, tele pronte per la spedizione.",
    "studio_landing_feat_type_title": "Tipografia completa",
    "studio_landing_feat_type_text": "Caratteri, pesi, tracciamento, contorni, ombre portate. Caselle di testo che si comportano come Adobe, non PowerPoint.",
    "studio_landing_feat_img_title": "AI + immagini stock",
    "studio_landing_feat_img_text": "Genera sfondi pixel-perfect con GPT Image 1. Unsplash e Pexels integrati.",
    "studio_landing_feat_brand_title": "Kit del marchio",
    "studio_landing_feat_brand_text": "Blocca i tuoi colori, caratteri, loghi una volta. Ogni nuovo annuncio li eredita automaticamente.",
    "studio_landing_feat_resize_title": "Ridimensionamento intelligente",
    "studio_landing_feat_resize_text": "Una tela → 10 annunci gemelli auto-scalati a ogni formato. Spedisci un'intera campagna con un clic.",
    "studio_landing_feat_wl_title": "Pronto per il white-label",
    "studio_landing_feat_wl_text": "Progettato per essere integrato. Inserisci nel tuo portale agenzia tramite iframe o API. Il tuo marchio, il nostro motore.",
    "studio_landing_formats_title": "10 formati pubblicitari. Una tela.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Feed, Storia, Reel.",
    "studio_landing_pricing_title": "Prezzi semplici basati su crediti.",
    "studio_landing_pricing_sub": "Inizia gratis. Scala quando le tue campagne lo fanno.",
    "studio_landing_pricing_extra": "Annunci extra oltre il piano: €2.30 / credito · annulla in qualsiasi momento",
    "studio_landing_price_free_credits": "3 annunci · una tantum",
    "studio_landing_price_starter_credits": "10 annunci / mese",
    "studio_landing_price_pro_credits": "30 annunci / mese",
    "studio_landing_price_agency_credits": "80 annunci / mese",
    "studio_landing_price_free_f1": "Tutti i 10 formati",
    "studio_landing_price_free_f2": "Magia dell'AI da URL",
    "studio_landing_price_free_f3": "Esportazione PNG",
    "studio_landing_price_free_f4": "Nessuna carta di credito",
    "studio_landing_price_starter_f1": "Tutto in Free",
    "studio_landing_price_starter_f2": "Kit Brand",
    "studio_landing_price_starter_f3": "Ridimensionamento intelligente",
    "studio_landing_price_starter_f4": "Coda prioritaria",
    "studio_landing_price_pro_f1": "Tutto in Starter",
    "studio_landing_price_pro_f2": "Generazione immagini AI (GPT Image 1)",
    "studio_landing_price_pro_f3": "Esportazione video (in arrivo)",
    "studio_landing_price_pro_f4": "Rimuovi filigrana",
    "studio_landing_price_agency_f1": "Tutto in Pro",
    "studio_landing_price_agency_f2": "Posti per il team (in arrivo)",
    "studio_landing_price_agency_f3": "Esportazione white-label",
    "studio_landing_price_agency_f4": "Supporto dedicato",
    "studio_landing_price_free_cta": "Inizia gratis",
    "studio_landing_price_starter_cta": "Ottieni Starter",
    "studio_landing_price_pro_cta": "Ottieni Pro",
    "studio_landing_price_agency_cta": "Ottieni Agency",
    "studio_landing_price_most_popular": "Più popolare",
    "studio_landing_final_title": "Pubblica il tuo primo annuncio stasera.",
    "studio_landing_final_sub": "Tre annunci gratuiti. Nessuna carta. Due clic per pubblicare.",
    "studio_landing_final_btn": "Apri l'editor",
    "studio_landing_footer": "Studio · parte di",
    "studio_create_back_select": "← Torna alla selezione",
    "studio_create_new_prefix": "Nuovo",
    "studio_create_type_desc_suffix": "Scegli un modello, o inizia da una tela vuota.",
    "studio_create_opt_templates_title": "Scegli un modello",
    "studio_create_opt_templates_sub": "Centinaia di design già pronti — modificabili",
    "studio_create_opt_blank_title": "Tela vuota",
    "studio_create_opt_blank_sub": "Controllo totale, tela vuota",
    "studio_create_opt_ai_title": "Magia AI ✨",
    "studio_create_opt_ai_sub": "Descrivi cosa vuoi — l'AI crea la prima versione",
    "studio_create_hub_eyebrow": "Cosa stai creando?",
    "studio_create_hub_title_a": "Iniziamo a",
    "studio_create_hub_title_b": "creare",
    "studio_create_hub_sub": "Scegli un tipo di contenuto. Ogni preset apre le giuste dimensioni e modelli.",
    "studio_create_card_start": "Inizia",
    "studio_create_type_post_label": "Post",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Storia",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animato · 15–60s",
    "studio_create_type_video_label": "Video",
    "studio_create_type_video_desc": "16:9 · panoramica",
    "studio_create_type_ad_label": "Annuncio",
    "studio_create_type_ad_desc": "Creativo per FB/IG",
    "studio_more_title": "Altro",
    "studio_more_sub": "Impostazioni, account e altri strumenti.",
    "studio_more_settings": "Impostazioni account",
    "studio_more_notifications": "Notifiche",
    "studio_more_plan": "Piano & fatturazione",
    "studio_more_invite": "Invita amici",
    "studio_more_redeem": "Riscatta un coupon",
    "studio_more_ai": "Magia AI",
    "studio_more_privacy": "Privacy",
    "studio_more_help": "Aiuto & Blog",
    "studio_more_logout": "Esci",
    "studio_nav_create": "Crea",
    "studio_nav_mine": "I miei design",
    "studio_nav_templates": "Modelli",
    "studio_nav_community": "Comunità",
    "studio_nav_more": "Altro",
    "studio_nav_home": "Home",
    "studio_nav_projects": "Progetti",
    "studio_nav_ai_magic": "Magia AI",
    "studio_nav_business": "Business",
    "studio_nav_create_aria": "Crea nuovo design",
    "studio_team_title": "Business — spazio di lavoro per il team",
    "studio_team_sub": "Invita colleghi a lavorare insieme. Max. 10 membri per team.",
    "studio_team_load_fail": "Impossibile caricare il team",
    "studio_team_create_title": "Crea un nuovo team",
    "studio_team_create_sub": "Diventi il proprietario e puoi invitare membri.",
    "studio_team_name_placeholder": "Nome del team",
    "studio_team_create_btn": "Crea",
    "studio_team_join_title": "Unisciti con un invito esistente",
    "studio_team_join_sub": "Se qualcuno ti ha inviato un codice di invito.",
    "studio_team_invite_code_placeholder": "Codice di invito",
    "studio_team_join_btn": "Unisciti",
    "studio_team_created": "Team creato",
    "studio_team_failed": "Fallito",
    "studio_team_joined": "Unito al team",
    "studio_team_invite_invalid": "Invito non valido",
    "studio_team_member_one": "membro",
    "studio_team_members_many": "membri",
    "studio_team_you_are_owner": "· sei proprietario",
    "studio_team_leave_btn": "Lascia",
    "studio_team_confirm_leave": "Vuoi davvero lasciare il team?",
    "studio_team_left": "Ha lasciato il team",
    "studio_team_invite_title": "Invita un nuovo membro",
    "studio_team_invite_email_placeholder": "email@example.com",
    "studio_team_send_invite": "Invia invito",
    "studio_team_invite_copied": "Link di invito copiato negli appunti",
    "studio_team_auto_copy_hint": "Il link di invito è stato copiato negli appunti automaticamente.",
    "studio_team_members_header": "Membri",
    "studio_team_owner_badge": "Proprietario",
    "studio_team_pending_header": "Inviti in attesa",
    "studio_team_expires": "Scade"
  },
  "nl": {
    "studio_editor_back": "Terug",
    "studio_editor_untitled": "Ongeknopte advertentie",
    "studio_editor_credits_view": "Bekijk kredietregister",
    "studio_editor_credits_label": "Credits",
    "studio_editor_credits_unlimited": "∞ Onbeperkt",
    "studio_editor_smart_resize": "Slimme resize",
    "studio_editor_quick_reel": "Snel reel",
    "studio_editor_quick_reel_title": "Auto-animeer elk element voor een reel van 15 seconden",
    "studio_editor_save": "Opslaan",
    "studio_editor_export_png": "Exporteer PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Exporteer geanimeerde video",
    "studio_editor_mp4_title_need_anim": "Voeg eerst een animatie toe",
    "studio_editor_rail_magic": "Magie",
    "studio_editor_rail_text": "Tekst",
    "studio_editor_rail_shapes": "Vormen",
    "studio_editor_rail_images": "Afbeeldingen",
    "studio_editor_rail_anim": "Animeer",
    "studio_editor_rail_layers": "Lagen",
    "studio_editor_close_panel": "Sluit paneel",
    "studio_editor_close_props": "Sluit eigenschappen",
    "studio_editor_open_props": "Open eigenschappen",
    "studio_editor_director_title": "AI Reel Regisseur — één opname",
    "studio_editor_director_sub": "Eén zin → volledige geanimeerde reel (~10s).",
    "studio_editor_magic_title": "AI Magie — URL → 5 advertenties",
    "studio_editor_magic_placeholder": "https://jouw-site.com",
    "studio_editor_magic_generate": "Genereer",
    "studio_editor_text_title": "Tekst",
    "studio_editor_add_heading": "Voeg kop toe",
    "studio_editor_shapes_title": "Vormen",
    "studio_editor_rectangle": "Rechthoek",
    "studio_editor_circle": "Cirkel",
    "studio_editor_background_title": "Achtergrond",
    "studio_editor_upload_title": "Afbeelding uploaden",
    "studio_editor_stock_btn": "Stockfoto's",
    "studio_editor_from_url": "Van URL",
    "studio_editor_add": "Toevoegen",
    "studio_editor_layers_title": "Lagen",
    "studio_editor_canvas_empty": "Canvas is leeg.",
    "studio_editor_props_title": "Eigenschappen",
    "studio_editor_select_element": "Selecteer een element om de eigenschappen te bewerken.",
    "studio_editor_prop_text": "Tekst",
    "studio_editor_prop_font": "Lettertype",
    "studio_editor_prop_size": "Grootte",
    "studio_editor_prop_fill": "Vulling",
    "studio_editor_prop_opacity": "Doorzichtigheid",
    "studio_editor_duplicate": "Dupliceren",
    "studio_editor_delete": "Verwijderen",
    "studio_editor_toast_offline_info": "Je werkt offline. Log in om op te slaan en te exporteren.",
    "studio_editor_toast_open_fail": "Editor kon niet worden geopend",
    "studio_editor_toast_image_fail": "Afbeelding kon niet worden geladen",
    "studio_editor_toast_saved": "Opgeslagen",
    "studio_editor_toast_save_fail": "Opslaan mislukt",
    "studio_editor_toast_log_in_save": "Log in om je advertentie op te slaan in de cloud.",
    "studio_editor_toast_add_elements_first": "Voeg eerst enkele elementen toe en klik dan op Snelle Reel.",
    "studio_editor_toast_need_animation": "Voeg eerst minimaal één animatie toe (Animeer rail).",
    "studio_editor_toast_browser_no_video": "Je browser ondersteunt geen video-opnames.",
    "studio_editor_toast_video_fail": "Video-export mislukt",
    "studio_editor_toast_export_fail": "Export mislukt",
    "studio_editor_toast_exported": "Geëxporteerd!",
    "studio_editor_toast_exported_ext": "Geëxporteerd .{ext}!",
    "studio_editor_toast_credits_out": "Geen advertentietegoeden meer.",
    "studio_editor_toast_credits_out_upsell": "Je hebt geen advertentietegoeden meer. Upgrade naar Pro voor 30/maand.",
    "studio_editor_toast_ai_fail": "AI Magie mislukt",
    "studio_editor_toast_no_variants": "Geen varianten teruggekeerd",
    "studio_editor_toast_applied": "Toegepast: {angle}",
    "studio_editor_toast_quick_reel_done": "Snelle Reel · {n} animaties · {s}s",
    "studio_editor_toast_smart_resize_done": "Gemaakt {n} zuster advertentie{plural}",
    "studio_editor_toast_smart_resize_fail": "Slimme resizing mislukt",
    "studio_my_have_coupon": "Heb je een kortingscode?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Inwisselen",
    "studio_my_toast_credits_added": "+{amount} tegoeden toegevoegd 🎉",
    "studio_my_toast_not_found": "Code niet gevonden",
    "studio_my_toast_already": "Al ingewisseld",
    "studio_my_toast_expired": "Verlopen of gedeactiveerd",
    "studio_my_toast_redeem_fail": "Inwisselen mislukt",
    "studio_my_toast_load_fail": "Laden van projecten mislukt",
    "studio_my_confirm_delete": "Verwijderen \"{title}\"?",
    "studio_my_title": "Mijn ontwerpen",
    "studio_my_sub": "Al uw opgeslagen projecten en exporten op één plek.",
    "studio_my_count_one": "{n} project",
    "studio_my_count_many": "{n} projecten",
    "studio_my_instant_campaign": "Instant Campagne",
    "studio_my_new_ad": "Nieuwe advertentie",
    "studio_my_login_to_see": "Log in om uw opgeslagen advertenties te zien.",
    "studio_my_login": "Inloggen",
    "studio_my_loading": "Laden…",
    "studio_my_empty_title": "Nog geen advertenties.",
    "studio_my_browse": "Blader door sjablonen",
    "studio_my_badge_team": "Team",
    "studio_my_badge_shared": "Gedeeld",
    "studio_my_edit": "Bewerken",
    "studio_gallery_filter_prefix": "Filter",
    "studio_gallery_filter_cancel": "× wissen",
    "studio_gallery_title": "Sjablonen",
    "studio_gallery_lead": "Kies een begin. Bewerk alles.",
    "studio_gallery_search": "Zoek sjablonen…",
    "studio_gallery_loading_count": "Laden…",
    "studio_gallery_count_of": "{start}–{end} van {total} sjablonen",
    "studio_gallery_pack_all": "Alle",
    "studio_gallery_pack_trending": "Trending",
    "studio_gallery_pack_ai": "AI-Aangedreven",
    "studio_gallery_pack_editorial": "Redactioneel",
    "studio_gallery_pack_video": "Video Clips",
    "studio_gallery_pack_free": "Gratis",
    "studio_gallery_video_only": "Alleen video",
    "studio_gallery_all_formats": "Alle formaten",
    "studio_gallery_all_categories": "Alle categorieën",
    "studio_gallery_loading_templates": "Laden sjablonen…",
    "studio_gallery_no_match": "Geen sjablonen die overeenkomen met die filters.",
    "studio_gallery_opening": "Editor openen…",
    "studio_gallery_prev": "← Vorige",
    "studio_gallery_next": "Volgende →",
    "studio_gallery_page_of": "Pagina {n} van {total}",
    "studio_gallery_type_post": "Bericht",
    "studio_gallery_type_story": "Verhaal",
    "studio_gallery_type_reel": "Reel",
    "studio_gallery_type_video": "Video",
    "studio_gallery_type_ad": "Advertentie",
    "studio_landing_meta_title": "Studio — AI-ontwerpen, reels & video's in 60 seconden | TopRankPulse",
    "studio_landing_meta_desc": "Maak berichten, reels, video's en advertenties met AI. Meer dan 1.600 sjablonen, één klik exporteren. Onderdeel van TopRankPulse.",
    "studio_landing_eyebrow": "NIEUW · STUDIO VAN TOPRANKPULSE",
    "studio_landing_hero_title_a": "Maak berichten, reels en video's.",
    "studio_landing_hero_title_b": "In minuten, geen dagen.",
    "studio_landing_hero_lead": "Kies een type inhoud, een sjabloon, of laat AI de eerste versie opstellen. Bewerk in een Canva-stijl editor. Exporteer PNG / MP4 met één klik. Advertenties, reels, verhalen, video's en berichten — alles in één.",
    "studio_landing_cta_start": "Begin met creëren",
    "studio_landing_cta_instant": "Directe Campagne — 25 advertenties",
    "studio_landing_cta_browse": "Blader door sjablonen",
    "studio_landing_kpi_projects": "Gemaakte projecten",
    "studio_landing_kpi_exports": "Gedownloade exports",
    "studio_landing_kpi_templates": "Sjablonen",
    "studio_landing_kpi_formats": "Advertentieformaten",
    "studio_landing_features_title": "Een studio. Geen diavoorstelling.",
    "studio_landing_features_sub": "Alles wat een performance marketeer echt gebruikt — één scherm, geen tabs.",
    "studio_landing_feat_ai_title": "AI Magie van URL",
    "studio_landing_feat_ai_text": "Plak een website, ontvang 5 volledige advertentieconcepten — merkkleuren, koppen, CTA's, kant-en-klare canvassen.",
    "studio_landing_feat_type_title": "Volledige typografie",
    "studio_landing_feat_type_text": "Lettertypen, gewichten, tracking, contouren, schaduw. Tekstvakken die zich gedragen als Adobe, niet PowerPoint.",
    "studio_landing_feat_img_title": "AI + stockafbeeldingen",
    "studio_landing_feat_img_text": "Genereer pixel-perfecte achtergronden met GPT Image 1. Unsplash en Pexels geïntegreerd.",
    "studio_landing_feat_brand_title": "Merkpakket",
    "studio_landing_feat_brand_text": "Vergrendel je kleuren, lettertypen, logo's één keer. Elke nieuwe advertentie erft ze automatisch.",
    "studio_landing_feat_resize_title": "Slimme resize",
    "studio_landing_feat_resize_text": "Één canvas → 10 zusteradvertenties automatisch geschaald naar elk formaat. Verstuur een volledige campagne met één klik.",
    "studio_landing_feat_wl_title": "White-label ready",
    "studio_landing_feat_wl_text": "Gebouwd om ingebed te worden. Plaats in je agency-portal via iframe of API. Jouw merk, onze engine.",
    "studio_landing_formats_title": "10 advertentieformaten. Één canvas.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Feed, Verhaal, Reel.",
    "studio_landing_pricing_title": "Eenvoudige, op krediet gebaseerde prijzen.",
    "studio_landing_pricing_sub": "Begin gratis. Schaal wanneer je campagnes dat doen.",
    "studio_landing_pricing_extra": "Extra advertenties bovenop het plan: €2,30 / krediet · op elk moment annuleren",
    "studio_landing_price_free_credits": "3 advertenties · eenmalig",
    "studio_landing_price_starter_credits": "10 advertenties / maand",
    "studio_landing_price_pro_credits": "30 advertenties / maand",
    "studio_landing_price_agency_credits": "80 advertenties / maand",
    "studio_landing_price_free_f1": "Alle 10 formaten",
    "studio_landing_price_free_f2": "AI Magie van URL",
    "studio_landing_price_free_f3": "PNG-export",
    "studio_landing_price_free_f4": "Geen creditcard",
    "studio_landing_price_starter_f1": "Alles in Gratis",
    "studio_landing_price_starter_f2": "Merk Kit",
    "studio_landing_price_starter_f3": "Slimme Resize",
    "studio_landing_price_starter_f4": "Prioriteitswachtrij",
    "studio_landing_price_pro_f1": "Alles in Starter",
    "studio_landing_price_pro_f2": "AI Afbeelding Gen (GPT Afbeelding 1)",
    "studio_landing_price_pro_f3": "Video-export (komende)",
    "studio_landing_price_pro_f4": "Verwijder watermerk",
    "studio_landing_price_agency_f1": "Alles in Pro",
    "studio_landing_price_agency_f2": "Teamplaatsen (komende)",
    "studio_landing_price_agency_f3": "White-label export",
    "studio_landing_price_agency_f4": "Toegewijde ondersteuning",
    "studio_landing_price_free_cta": "Gratis beginnen",
    "studio_landing_price_starter_cta": "Krijg Starter",
    "studio_landing_price_pro_cta": "Krijg Pro",
    "studio_landing_price_agency_cta": "Krijg Agency",
    "studio_landing_price_most_popular": "Meest populair",
    "studio_landing_final_title": "Verzend je eerste advertentie vanavond.",
    "studio_landing_final_sub": "Drie gratis advertenties. Geen kaart. Twee klikken om te publiceren.",
    "studio_landing_final_btn": "Open de editor",
    "studio_landing_footer": "Studio · onderdeel van",
    "studio_create_back_select": "← Terug naar selectie",
    "studio_create_new_prefix": "Nieuw",
    "studio_create_type_desc_suffix": "Kies een sjabloon of begin vanaf een leeg canvas.",
    "studio_create_opt_templates_title": "Kies een sjabloon",
    "studio_create_opt_templates_sub": "Honderden kant-en-klare ontwerpen — bewerkbaar",
    "studio_create_opt_blank_title": "Leeg canvas",
    "studio_create_opt_blank_sub": "Volledige controle, leeg canvas",
    "studio_create_opt_ai_title": "AI Magie ✨",
    "studio_create_opt_ai_sub": "Beschrijf wat je wilt — AI maakt de eerste versie",
    "studio_create_hub_eyebrow": "Wat ben je aan het creëren?",
    "studio_create_hub_title_a": "Laten we",
    "studio_create_hub_title_b": "creatief",
    "studio_create_hub_sub": "Kies een type inhoud. Elke preset opent de juiste afmetingen en sjablonen.",
    "studio_create_card_start": "Start",
    "studio_create_type_post_label": "Bericht",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Verhaal",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 geanimeerd · 15–60s",
    "studio_create_type_video_label": "Video",
    "studio_create_type_video_desc": "16:9 · liggend",
    "studio_create_type_ad_label": "Advertentie",
    "studio_create_type_ad_desc": "FB/IG advertentie creatief",
    "studio_more_title": "Meer",
    "studio_more_sub": "Instellingen, account en andere tools.",
    "studio_more_settings": "Accountinstellingen",
    "studio_more_notifications": "Meldingen",
    "studio_more_plan": "Plan & facturering",
    "studio_more_invite": "Nodig vrienden uit",
    "studio_more_redeem": "Verzilveren van een coupon",
    "studio_more_ai": "AI Magie",
    "studio_more_privacy": "Privacy",
    "studio_more_help": "Hulp & Blog",
    "studio_more_logout": "Uitloggen",
    "studio_nav_create": "Aanmaken",
    "studio_nav_mine": "Mijn ontwerpen",
    "studio_nav_templates": "Sjablonen",
    "studio_nav_community": "Gemeenschap",
    "studio_nav_more": "Meer",
    "studio_nav_home": "Startpagina",
    "studio_nav_projects": "Projecten",
    "studio_nav_ai_magic": "AI Magie",
    "studio_nav_business": "Zakelijk",
    "studio_nav_create_aria": "Nieuw ontwerp aanmaken",
    "studio_team_title": "Zakelijk — teamwerkruimte",
    "studio_team_sub": "Nodig collega's uit om samen te werken. Max. 10 leden per team.",
    "studio_team_load_fail": "Kon team niet laden",
    "studio_team_create_title": "Maak een nieuw team aan",
    "studio_team_create_sub": "Je wordt de eigenaar en kunt leden uitnodigen.",
    "studio_team_name_placeholder": "Teamnaam",
    "studio_team_create_btn": "Aanmaken",
    "studio_team_join_title": "Doe mee met een bestaande uitnodiging",
    "studio_team_join_sub": "Als iemand je een uitnodigingscode heeft gestuurd.",
    "studio_team_invite_code_placeholder": "Uitnodigingscode",
    "studio_team_join_btn": "Meedoen",
    "studio_team_created": "Team aangemaakt",
    "studio_team_failed": "Mislukt",
    "studio_team_joined": "Team toegevoegd",
    "studio_team_invite_invalid": "Ongeldige uitnodiging",
    "studio_team_member_one": "lid",
    "studio_team_members_many": "leden",
    "studio_team_you_are_owner": "· jij bent eigenaar",
    "studio_team_leave_btn": "Verlaten",
    "studio_team_confirm_leave": "Echt het team verlaten?",
    "studio_team_left": "Team verlaten",
    "studio_team_invite_title": "Nouveau lid uitnodigen",
    "studio_team_invite_email_placeholder": "email@voorbeeld.com",
    "studio_team_send_invite": "Stuur uitnodiging",
    "studio_team_invite_copied": "Uitnodigingslink gekopieerd naar klembord",
    "studio_team_auto_copy_hint": "Uitnodigingslink is automatisch naar het klembord gekopieerd.",
    "studio_team_members_header": "Leden",
    "studio_team_owner_badge": "Eigenaar",
    "studio_team_pending_header": "In afwachting van uitnodigingen",
    "studio_team_expires": "Verloopt"
  },
  "sv": {
    "studio_editor_back": "Tillbaka",
    "studio_editor_untitled": "Untitlad annons",
    "studio_editor_credits_view": "Visa kreditsaldot",
    "studio_editor_credits_label": "Krediter",
    "studio_editor_credits_unlimited": "∞ Obegränsat",
    "studio_editor_smart_resize": "SMART ÄNDRA STORLEK",
    "studio_editor_quick_reel": "Snabbt Klipp",
    "studio_editor_quick_reel_title": "Auto-animer varje element för ett 15-sekunders klipp",
    "studio_editor_save": "Spara",
    "studio_editor_export_png": "Exportera PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Exportera animerad video",
    "studio_editor_mp4_title_need_anim": "Lägg till en animation först",
    "studio_editor_rail_magic": "Magiskt",
    "studio_editor_rail_text": "Text",
    "studio_editor_rail_shapes": "Former",
    "studio_editor_rail_images": "Bilder",
    "studio_editor_rail_anim": "Animera",
    "studio_editor_rail_layers": "Skikt",
    "studio_editor_close_panel": "Stäng panel",
    "studio_editor_close_props": "Stäng egenskaper",
    "studio_editor_open_props": "Öppna egenskaper",
    "studio_editor_director_title": "AI Klipp Regissör — entagning",
    "studio_editor_director_sub": "En mening → fullt animerat klipp (~10s).",
    "studio_editor_magic_title": "AI Magi — URL → 5 annonser",
    "studio_editor_magic_placeholder": "https://ditt-site.com",
    "studio_editor_magic_generate": "Generera",
    "studio_editor_text_title": "Text",
    "studio_editor_add_heading": "Lägg till rubrik",
    "studio_editor_shapes_title": "Former",
    "studio_editor_rectangle": "Rektangel",
    "studio_editor_circle": "Cirkel",
    "studio_editor_background_title": "Bakgrund",
    "studio_editor_upload_title": "Ladda upp bild",
    "studio_editor_stock_btn": "Bildbank",
    "studio_editor_from_url": "Från URL",
    "studio_editor_add": "Lägg till",
    "studio_editor_layers_title": "Skikt",
    "studio_editor_canvas_empty": "Duken är tom.",
    "studio_editor_props_title": "Egenskaper",
    "studio_editor_select_element": "Välj ett element för att redigera dess egenskaper.",
    "studio_editor_prop_text": "Text",
    "studio_editor_prop_font": "Teckensnitt",
    "studio_editor_prop_size": "Storlek",
    "studio_editor_prop_fill": "Fyllning",
    "studio_editor_prop_opacity": "Opacitet",
    "studio_editor_duplicate": "Duplicera",
    "studio_editor_delete": "Ta bort",
    "studio_editor_toast_offline_info": "Du arbetar offline. Logga in för att spara och exportera.",
    "studio_editor_toast_open_fail": "Kunde inte öppna redigeraren",
    "studio_editor_toast_image_fail": "Kunde inte ladda bilden",
    "studio_editor_toast_saved": "Sparad",
    "studio_editor_toast_save_fail": "Sparande misslyckades",
    "studio_editor_toast_log_in_save": "Logga in för att spara din annons på molnet.",
    "studio_editor_toast_add_elements_first": "Lägg till några element först, klicka sedan på Snabbt Reel.",
    "studio_editor_toast_need_animation": "Lägg till minst en animation först (Animera spår).",
    "studio_editor_toast_browser_no_video": "Din webbläsare stöder inte videoinspelning.",
    "studio_editor_toast_video_fail": "Videohantering misslyckades",
    "studio_editor_toast_export_fail": "Export misslyckades",
    "studio_editor_toast_exported": "Exporterad!",
    "studio_editor_toast_exported_ext": "Exporterad .{ext}!",
    "studio_editor_toast_credits_out": "Slut på reklampoäng.",
    "studio_editor_toast_credits_out_upsell": "Du har slut på reklampoäng. Uppgradera till Pro för 30/månad.",
    "studio_editor_toast_ai_fail": "AI-magi misslyckades",
    "studio_editor_toast_no_variants": "Inga varianter återvände",
    "studio_editor_toast_applied": "Tillämpad: {angle}",
    "studio_editor_toast_quick_reel_done": "Snabbt Reel · {n} animationer · {s}s",
    "studio_editor_toast_smart_resize_done": "Skapade {n} syskonannons{plural}",
    "studio_editor_toast_smart_resize_fail": "Smart storleksändring misslyckades",
    "studio_my_have_coupon": "Har du en kupong?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Lös in",
    "studio_my_toast_credits_added": "+{amount} poäng tillagda 🎉",
    "studio_my_toast_not_found": "Koden hittades inte",
    "studio_my_toast_already": "Redan inlöst",
    "studio_my_toast_expired": "Utgått eller avaktiverat",
    "studio_my_toast_redeem_fail": "Inlösen misslyckades",
    "studio_my_toast_load_fail": "Misslyckades med att ladda projekt",
    "studio_my_confirm_delete": "Ta bort \"{title}\"?",
    "studio_my_title": "Mina designer",
    "studio_my_sub": "Alla dina sparade projekt och exporter samlade på ett ställe.",
    "studio_my_count_one": "{n} projekt",
    "studio_my_count_many": "{n} projekt",
    "studio_my_instant_campaign": "Omedelbar kampanj",
    "studio_my_new_ad": "Ny annons",
    "studio_my_login_to_see": "Logga in för att se dina sparade annonser.",
    "studio_my_login": "Logga in",
    "studio_my_loading": "Laddar…",
    "studio_my_empty_title": "Inga annonser ännu.",
    "studio_my_browse": "Bläddra bland mallar",
    "studio_my_badge_team": "Team",
    "studio_my_badge_shared": "Delad",
    "studio_my_edit": "Redigera",
    "studio_gallery_filter_prefix": "Filter",
    "studio_gallery_filter_cancel": "× rensa",
    "studio_gallery_title": "Mallar",
    "studio_gallery_lead": "Välj en start. Redigera vad som helst.",
    "studio_gallery_search": "Sök mallar…",
    "studio_gallery_loading_count": "Laddar…",
    "studio_gallery_count_of": "{start}–{end} av {total} mallar",
    "studio_gallery_pack_all": "Alla",
    "studio_gallery_pack_trending": "Trendande",
    "studio_gallery_pack_ai": "AI-drivna",
    "studio_gallery_pack_editorial": "Editorial",
    "studio_gallery_pack_video": "Videoklipp",
    "studio_gallery_pack_free": "Gratis",
    "studio_gallery_video_only": "Endast video",
    "studio_gallery_all_formats": "Alla format",
    "studio_gallery_all_categories": "Alla kategorier",
    "studio_gallery_loading_templates": "Laddar mallar…",
    "studio_gallery_no_match": "Inga mallar matchar dessa filter.",
    "studio_gallery_opening": "Öppnar redigeraren…",
    "studio_gallery_prev": "← Föregående",
    "studio_gallery_next": "Nästa →",
    "studio_gallery_page_of": "Sida {n} av {total}",
    "studio_gallery_type_post": "Inlägg",
    "studio_gallery_type_story": "Berättelse",
    "studio_gallery_type_reel": "Reel",
    "studio_gallery_type_video": "Video",
    "studio_gallery_type_ad": "Annons",
    "studio_landing_meta_title": "Studio — AI-designs, reels & videos på 60 sekunder | TopRankPulse",
    "studio_landing_meta_desc": "Skapa inlägg, reels, videos och annonser med AI. Över 1 600 mallar, export med ett klick. En del av TopRankPulse.",
    "studio_landing_eyebrow": "NYTT · STUDIO AV TOPRANKPULSE",
    "studio_landing_hero_title_a": "Skapa inlägg, reels och videos.",
    "studio_landing_hero_title_b": "På minuter, inte dagar.",
    "studio_landing_hero_lead": "Välj en innehållstyp, en mall eller låt AI skriva första versionen. Redigera i en Canva-liknande redigerare. Exportera PNG / MP4 med ett klick. Annonser, reels, stories, videos och inlägg — allt i ett.",
    "studio_landing_cta_start": "Börja skapa",
    "studio_landing_cta_instant": "Omedelbar kampanj — 25 annonser",
    "studio_landing_cta_browse": "Bläddra bland mallar",
    "studio_landing_kpi_projects": "Skapade projekt",
    "studio_landing_kpi_exports": "Nedladdade exporter",
    "studio_landing_kpi_templates": "Malllar",
    "studio_landing_kpi_formats": "Annonsformat",
    "studio_landing_features_title": "Ett studio. Inte en bildspel.",
    "studio_landing_features_sub": "Allt en prestandamarknadsförare faktiskt använder — en skärm, inga flikar.",
    "studio_landing_feat_ai_title": "AI-magi från URL",
    "studio_landing_feat_ai_text": "Klistra in en webbplats, få 5 fullständiga annonsskoncept — varumärkesfärger, rubriker, CTAs, färdiga kanvaser.",
    "studio_landing_feat_type_title": "Full typografi",
    "studio_landing_feat_type_text": "Typsnitt, vikter, spårning, konturer, skugga. Textlådor som beter sig som Adobe, inte PowerPoint.",
    "studio_landing_feat_img_title": "AI + bildbanker",
    "studio_landing_feat_img_text": "Generera pixelfärdiga bakgrunder med GPT Image 1. Unsplash och Pexels inbyggda.",
    "studio_landing_feat_brand_title": "Varumärkeskit",
    "studio_landing_feat_brand_text": "Låsa dina färger, typsnitt, logotyper en gång. Varje ny annons ärver dem automatiskt.",
    "studio_landing_feat_resize_title": "Smart omformatering",
    "studio_landing_feat_resize_text": "En canvas → 10 syskonannonser automatiskt skalerade till varje format. Skicka en fullständig kampanj med ett klick.",
    "studio_landing_feat_wl_title": "White-label redo",
    "studio_landing_feat_wl_text": "Byggt för att kunna bäddas in. Lägga in i din byråportal via iframe eller API. Ditt varumärke, vår motor.",
    "studio_landing_formats_title": "10 annonsformat. En canvas.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Flöde, Story, Reel.",
    "studio_landing_pricing_title": "Enkel, kreditbaserad prissättning.",
    "studio_landing_pricing_sub": "Börja gratis. Skala när dina kampanjer gör det.",
    "studio_landing_pricing_extra": "Extra annonser utöver planen: €2.30 / kredit · avbryt när som helst",
    "studio_landing_price_free_credits": "3 annonser · engångsbelopp",
    "studio_landing_price_starter_credits": "10 annonser / månad",
    "studio_landing_price_pro_credits": "30 annonser / månad",
    "studio_landing_price_agency_credits": "80 annonser / månad",
    "studio_landing_price_free_f1": "Alla 10 format",
    "studio_landing_price_free_f2": "AI-magi från URL",
    "studio_landing_price_free_f3": "PNG-export",
    "studio_landing_price_free_f4": "Inga kreditkort",
    "studio_landing_price_starter_f1": "Allt i Gratis",
    "studio_landing_price_starter_f2": "Varumärkespaket",
    "studio_landing_price_starter_f3": "Smart storleksändring",
    "studio_landing_price_starter_f4": "Prioriterad kö",
    "studio_landing_price_pro_f1": "Allt i Starter",
    "studio_landing_price_pro_f2": "AI Bildgenerering (GPT Bild 1)",
    "studio_landing_price_pro_f3": "Videoexport (kommer snart)",
    "studio_landing_price_pro_f4": "Ta bort vattenstämpel",
    "studio_landing_price_agency_f1": "Allt i Pro",
    "studio_landing_price_agency_f2": "Teamplatser (kommer snart)",
    "studio_landing_price_agency_f3": "Vitmärkesexport",
    "studio_landing_price_agency_f4": "Dedikerad support",
    "studio_landing_price_free_cta": "Börja gratis",
    "studio_landing_price_starter_cta": "Få Starter",
    "studio_landing_price_pro_cta": "Få Pro",
    "studio_landing_price_agency_cta": "Få Byrå",
    "studio_landing_price_most_popular": "Mest populär",
    "studio_landing_final_title": "Skicka din första annons ikväll.",
    "studio_landing_final_sub": "Tre gratis annonser. Ingen kort. Två klick för att publicera.",
    "studio_landing_final_btn": "Öppna redigeraren",
    "studio_landing_footer": "Studio · en del av",
    "studio_create_back_select": "← Tillbaka till urval",
    "studio_create_new_prefix": "Ny",
    "studio_create_type_desc_suffix": "Välj en mall, eller börja från en tom duk.",
    "studio_create_opt_templates_title": "Välj en mall",
    "studio_create_opt_templates_sub": "Hanterbara designalternativ — redigerbara",
    "studio_create_opt_blank_title": "Tom duk",
    "studio_create_opt_blank_sub": "Full kontroll, tom duk",
    "studio_create_opt_ai_title": "AI Magi ✨",
    "studio_create_opt_ai_sub": "Beskriv vad du vill ha — AI skapar den första versionen",
    "studio_create_hub_eyebrow": "Vad skapar du?",
    "studio_create_hub_title_a": "Låt oss bli",
    "studio_create_hub_title_b": "kreativa",
    "studio_create_hub_sub": "Välj en innehållstyp. Varje förinställning öppnar rätt dimensioner och mallar.",
    "studio_create_card_start": "Börja",
    "studio_create_type_post_label": "Inlägg",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Berättelse",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animerad · 15–60s",
    "studio_create_type_video_label": "Video",
    "studio_create_type_video_desc": "16:9 · liggande",
    "studio_create_type_ad_label": "Annons",
    "studio_create_type_ad_desc": "FB/IG annonsinnehåll",
    "studio_more_title": "Mer",
    "studio_more_sub": "Inställningar, konto och andra verktyg.",
    "studio_more_settings": "Kontoinställningar",
    "studio_more_notifications": "Notifikationer",
    "studio_more_plan": "Plan och fakturering",
    "studio_more_invite": "Bjud in vänner",
    "studio_more_redeem": "Lös in en kupong",
    "studio_more_ai": "AI Magi",
    "studio_more_privacy": "Integritet",
    "studio_more_help": "Hjälp & Blogg",
    "studio_more_logout": "Logga ut",
    "studio_nav_create": "Skapa",
    "studio_nav_mine": "Mina designer",
    "studio_nav_templates": "Mallarna",
    "studio_nav_community": "Gemenskap",
    "studio_nav_more": "Mer",
    "studio_nav_home": "Hem",
    "studio_nav_projects": "Projekt",
    "studio_nav_ai_magic": "AI Magi",
    "studio_nav_business": "Företag",
    "studio_nav_create_aria": "Skapa ny design",
    "studio_team_title": "Företag — teamarbetsyta",
    "studio_team_sub": "Bjud in kollegor att arbeta tillsammans. Max. 10 medlemmar per team.",
    "studio_team_load_fail": "Kunde inte ladda teamet",
    "studio_team_create_title": "Skapa ett nytt team",
    "studio_team_create_sub": "Du blir ägare och kan bjuda in medlemmar.",
    "studio_team_name_placeholder": "Teamnamn",
    "studio_team_create_btn": "Skapa",
    "studio_team_join_title": "Gå med med en befintlig inbjudan",
    "studio_team_join_sub": "Om någon har skickat dig en inbjudningskod.",
    "studio_team_invite_code_placeholder": "Inbjudningskod",
    "studio_team_join_btn": "Gå med",
    "studio_team_created": "Team skapat",
    "studio_team_failed": "Misslyckades",
    "studio_team_joined": "Gick med i teamet",
    "studio_team_invite_invalid": "Ogiltig inbjudan",
    "studio_team_member_one": "medlem",
    "studio_team_members_many": "medlemmar",
    "studio_team_you_are_owner": "· du är ägare",
    "studio_team_leave_btn": "Lämna",
    "studio_team_confirm_leave": "Verkligen lämna teamet?",
    "studio_team_left": "Lämnade teamet",
    "studio_team_invite_title": "Bjud in en ny medlem",
    "studio_team_invite_email_placeholder": "email@exempel.com",
    "studio_team_send_invite": "Skicka inbjudan",
    "studio_team_invite_copied": "Inbjudningslänk kopierad till urklipp",
    "studio_team_auto_copy_hint": "Inbjudningslänken kopieras automatiskt till urklipp.",
    "studio_team_members_header": "Medlemmar",
    "studio_team_owner_badge": "Ägare",
    "studio_team_pending_header": "Väntande inbjudningar",
    "studio_team_expires": "Utgår"
  },
  "no": {
    "studio_editor_back": "Tilbake",
    "studio_editor_untitled": "Uten tittel annonse",
    "studio_editor_credits_view": "Se kredittregister",
    "studio_editor_credits_label": "Kreditter",
    "studio_editor_credits_unlimited": "∞ Ubegrenset",
    "studio_editor_smart_resize": "Smart størrelse",
    "studio_editor_quick_reel": "Rask rull",
    "studio_editor_quick_reel_title": "Auto-animer hvert element for en 15-sekunders rull",
    "studio_editor_save": "Lagre",
    "studio_editor_export_png": "Eksporter PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Eksporter animert video",
    "studio_editor_mp4_title_need_anim": "Legg til en animasjon først",
    "studio_editor_rail_magic": "Magisk",
    "studio_editor_rail_text": "Tekst",
    "studio_editor_rail_shapes": "Former",
    "studio_editor_rail_images": "Bilder",
    "studio_editor_rail_anim": "Animer",
    "studio_editor_rail_layers": "Lag",
    "studio_editor_close_panel": "Lukk panel",
    "studio_editor_close_props": "Lukk egenskaper",
    "studio_editor_open_props": "Åpne egenskaper",
    "studio_editor_director_title": "AI Rull Regissør — én opptak",
    "studio_editor_director_sub": "Én setning → full animert rull (~10s).",
    "studio_editor_magic_title": "AI Magi — URL → 5 annonser",
    "studio_editor_magic_placeholder": "https://din-nettside.com",
    "studio_editor_magic_generate": "Generer",
    "studio_editor_text_title": "Tekst",
    "studio_editor_add_heading": "Legg til overskrift",
    "studio_editor_shapes_title": "Former",
    "studio_editor_rectangle": "Rektangel",
    "studio_editor_circle": "Sirkel",
    "studio_editor_background_title": "Bakgrunn",
    "studio_editor_upload_title": "Last opp bilde",
    "studio_editor_stock_btn": "Stock bilder",
    "studio_editor_from_url": "Fra URL",
    "studio_editor_add": "Legg til",
    "studio_editor_layers_title": "Lag",
    "studio_editor_canvas_empty": "Lerretet er tomt.",
    "studio_editor_props_title": "Egenskaper",
    "studio_editor_select_element": "Velg et element for å redigere egenskapene.",
    "studio_editor_prop_text": "Tekst",
    "studio_editor_prop_font": "Skrift",
    "studio_editor_prop_size": "Størrelse",
    "studio_editor_prop_fill": "Fyll",
    "studio_editor_prop_opacity": "Opasitet",
    "studio_editor_duplicate": "Dupliser",
    "studio_editor_delete": "Slett",
    "studio_editor_toast_offline_info": "Du jobber offline. Logg inn for å lagre og eksportere.",
    "studio_editor_toast_open_fail": "Kunne ikke åpne redigereren",
    "studio_editor_toast_image_fail": "Kunne ikke laste inn bilde",
    "studio_editor_toast_saved": "Lagt til",
    "studio_editor_toast_save_fail": "Lagring feilet",
    "studio_editor_toast_log_in_save": "Logg inn for å lagre annonsen din i skyen.",
    "studio_editor_toast_add_elements_first": "Legg til noen elementer først, så klikk på Quick Reel.",
    "studio_editor_toast_need_animation": "Legg til minst én animasjon først (Animer skinne).",
    "studio_editor_toast_browser_no_video": "Nettleseren din støtter ikke videoopptak.",
    "studio_editor_toast_video_fail": "Videoeksport feilet",
    "studio_editor_toast_export_fail": "Eksport feilet",
    "studio_editor_toast_exported": "Eksportert!",
    "studio_editor_toast_exported_ext": "Eksportert .{ext}!",
    "studio_editor_toast_credits_out": "Ingen annonsekredit tilgjengelig.",
    "studio_editor_toast_credits_out_upsell": "Du har ingen annonsekreditter. Oppgrader til Pro for 30/måned.",
    "studio_editor_toast_ai_fail": "AI-magi feilet",
    "studio_editor_toast_no_variants": "Ingen varianter returnert",
    "studio_editor_toast_applied": "Påført: {angle}",
    "studio_editor_toast_quick_reel_done": "Quick Reel · {n} animasjoner · {s}s",
    "studio_editor_toast_smart_resize_done": "Opprettet {n} søskenannonse{plural}",
    "studio_editor_toast_smart_resize_fail": "Smart størrelsejustering feilet",
    "studio_my_have_coupon": "Har du en kupong?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Innløse",
    "studio_my_toast_credits_added": "+{amount} kreditter lagt til 🎉",
    "studio_my_toast_not_found": "Kode ikke funnet",
    "studio_my_toast_already": "Allerede innløst",
    "studio_my_toast_expired": "Utgått eller deaktivert",
    "studio_my_toast_redeem_fail": "Innløsning feilet",
    "studio_my_toast_load_fail": "Kunne ikke laste prosjekter",
    "studio_my_confirm_delete": "Slette \"{title}\"?",
    "studio_my_title": "Mine design",
    "studio_my_sub": "Alle dine lagrede prosjekter og eksporter på ett sted.",
    "studio_my_count_one": "{n} prosjekt",
    "studio_my_count_many": "{n} prosjekter",
    "studio_my_instant_campaign": "Sofortkampanje",
    "studio_my_new_ad": "Ny annonse",
    "studio_my_login_to_see": "Logg inn for å se dine lagrede annonser.",
    "studio_my_login": "Logg inn",
    "studio_my_loading": "Laster…",
    "studio_my_empty_title": "Ingen annonser ennå.",
    "studio_my_browse": "Bla gjennom maler",
    "studio_my_badge_team": "Team",
    "studio_my_badge_shared": "Delt",
    "studio_my_edit": "Rediger",
    "studio_gallery_filter_prefix": "Filtrer",
    "studio_gallery_filter_cancel": "× nullstill",
    "studio_gallery_title": "Maler",
    "studio_gallery_lead": "Velg en start. Rediger alt.",
    "studio_gallery_search": "Søk i maler…",
    "studio_gallery_loading_count": "Laster…",
    "studio_gallery_count_of": "{start}–{end} av {total} maler",
    "studio_gallery_pack_all": "Alle",
    "studio_gallery_pack_trending": "Trendy",
    "studio_gallery_pack_ai": "AI-Drevet",
    "studio_gallery_pack_editorial": "Redaksjonell",
    "studio_gallery_pack_video": "Video Reels",
    "studio_gallery_pack_free": "Gratis",
    "studio_gallery_video_only": "Kun video",
    "studio_gallery_all_formats": "Alle formater",
    "studio_gallery_all_categories": "Alle kategorier",
    "studio_gallery_loading_templates": "Laster maler…",
    "studio_gallery_no_match": "Ingen maler matcher disse filtrene.",
    "studio_gallery_opening": "Åpner redigerer…",
    "studio_gallery_prev": "← Forrige",
    "studio_gallery_next": "Neste →",
    "studio_gallery_page_of": "Side {n} av {total}",
    "studio_gallery_type_post": "Innlegg",
    "studio_gallery_type_story": "Historie",
    "studio_gallery_type_reel": "Rull",
    "studio_gallery_type_video": "Video",
    "studio_gallery_type_ad": "Annonse",
    "studio_landing_meta_title": "Studio — AI-design, reeller & videoer på 60 sekunder | TopRankPulse",
    "studio_landing_meta_desc": "Lag innlegg, reeller, videoer og annonser med AI. 1,600+ maler, ett-klikk eksport. En del av TopRankPulse.",
    "studio_landing_eyebrow": "NYTT · STUDIO BY TOPRANKPULSE",
    "studio_landing_hero_title_a": "Lag innlegg, reeller og videoer.",
    "studio_landing_hero_title_b": "På minutter, ikke dager.",
    "studio_landing_hero_lead": "Velg en innholdstype, en mal, eller la AI utarbeide den første versjonen. Rediger i en Canva-stil editor. Eksporter PNG / MP4 med ett klikk. Annonser, reeller, historier, videoer og innlegg — alt på ett sted.",
    "studio_landing_cta_start": "Begynn å lage",
    "studio_landing_cta_instant": "Øyeblikkelig kampanje — 25 annonser",
    "studio_landing_cta_browse": "Bla gjennom maler",
    "studio_landing_kpi_projects": "Opprettede prosjekter",
    "studio_landing_kpi_exports": "Nedlastede eksporter",
    "studio_landing_kpi_templates": "Maler",
    "studio_landing_kpi_formats": "Annonsestørrelser",
    "studio_landing_features_title": "Et studio. Ikke et lysbildefremvisning.",
    "studio_landing_features_sub": "Alt som en prestasjonsmarkedsfører faktisk bruker — én skjerm, ingen faner.",
    "studio_landing_feat_ai_title": "AI-magisk fra URL",
    "studio_landing_feat_ai_text": "Lim inn en nettside, få 5 komplette annonsekonsepter — merkevarefarger, overskrifter, CTAs, klare til å sendes.",
    "studio_landing_feat_type_title": "Full typografi",
    "studio_landing_feat_type_text": "Skrifter, vekter, avstand, omriss, skygger. Tekstbokser som oppfører seg som Adobe, ikke PowerPoint.",
    "studio_landing_feat_img_title": "AI + lagerbilder",
    "studio_landing_feat_img_text": "Generer pikselskarpe bakgrunner med GPT Image 1. Unsplash og Pexels inkludert.",
    "studio_landing_feat_brand_title": "Merkepakke",
    "studio_landing_feat_brand_text": "Lås farger, skrifter, logoer én gang. Hver ny annonse arver dem automatisk.",
    "studio_landing_feat_resize_title": "Smart endring",
    "studio_landing_feat_resize_text": "Én lerret → 10 søsterannonser automatisk tilpasset til hver størrelse. Send en full kampanje med ett klikk.",
    "studio_landing_feat_wl_title": "Klar for hvitmerking",
    "studio_landing_feat_wl_text": "Laget for å bli innlemmet. Integrer i ditt byråportalen via iframe eller API. Din merkevare, vår motor.",
    "studio_landing_formats_title": "10 annonsetyper. Én lerret.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Feed, Story, Reel.",
    "studio_landing_pricing_title": "Enkel, kredittbasert prising.",
    "studio_landing_pricing_sub": "Start gratis. Skaler når kampanjene dine gjør det.",
    "studio_landing_pricing_extra": "Ekstra annonser utover planen: €2.30 / kreditt · kanseller når som helst",
    "studio_landing_price_free_credits": "3 annonser · engang",
    "studio_landing_price_starter_credits": "10 annonser / måned",
    "studio_landing_price_pro_credits": "30 annonser / måned",
    "studio_landing_price_agency_credits": "80 annonser / måned",
    "studio_landing_price_free_f1": "Alle 10 formater",
    "studio_landing_price_free_f2": "AI-magisk fra URL",
    "studio_landing_price_free_f3": "PNG eksport",
    "studio_landing_price_free_f4": "Ingen kredittkort",
    "studio_landing_price_starter_f1": "Alt i gratis",
    "studio_landing_price_starter_f2": "Merkevarepakke",
    "studio_landing_price_starter_f3": "Smart størrelse",
    "studio_landing_price_starter_f4": "Prioritert kø",
    "studio_landing_price_pro_f1": "Alt i Starter",
    "studio_landing_price_pro_f2": "AI Bildegenerering (GPT Image 1)",
    "studio_landing_price_pro_f3": "Videofrasjon (komme snart)",
    "studio_landing_price_pro_f4": "Fjern vannmerke",
    "studio_landing_price_agency_f1": "Alt i Pro",
    "studio_landing_price_agency_f2": "Teamseter (komme snart)",
    "studio_landing_price_agency_f3": "Hvitmerket eksport",
    "studio_landing_price_agency_f4": "Dedikert støtte",
    "studio_landing_price_free_cta": "Start gratis",
    "studio_landing_price_starter_cta": "Få Starter",
    "studio_landing_price_pro_cta": "Få Pro",
    "studio_landing_price_agency_cta": "Få Byrå",
    "studio_landing_price_most_popular": "Mest populær",
    "studio_landing_final_title": "Send din første annonse i kveld.",
    "studio_landing_final_sub": "Tre gratis annonser. Ingen kort. To klikk for å publisere.",
    "studio_landing_final_btn": "Åpne redaktøren",
    "studio_landing_footer": "Studio · en del av",
    "studio_create_back_select": "← Tilbake til valg",
    "studio_create_new_prefix": "Ny",
    "studio_create_type_desc_suffix": "Velg en mal, eller start fra en tom duk.",
    "studio_create_opt_templates_title": "Velg en mal",
    "studio_create_opt_templates_sub": "Hundrevis av klare design — redigerbare",
    "studio_create_opt_blank_title": "Tom duk",
    "studio_create_opt_blank_sub": "Full kontroll, tom duk",
    "studio_create_opt_ai_title": "AI Magi ✨",
    "studio_create_opt_ai_sub": "Beskriv hva du ønsker — AI lager den første versjonen",
    "studio_create_hub_eyebrow": "Hva lager du?",
    "studio_create_hub_title_a": "La oss bli",
    "studio_create_hub_title_b": "kreative",
    "studio_create_hub_sub": "Velg en innholdstype. Hver forhåndsinnstilling åpner de riktige dimensjonene og malene.",
    "studio_create_card_start": "Start",
    "studio_create_type_post_label": "Innlegg",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Historie",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animert · 15–60s",
    "studio_create_type_video_label": "Video",
    "studio_create_type_video_desc": "16:9 · liggende",
    "studio_create_type_ad_label": "Annonse",
    "studio_create_type_ad_desc": "FB/IG annonseinnhold",
    "studio_more_title": "Mer",
    "studio_more_sub": "Innstillinger, konto og andre verktøy.",
    "studio_more_settings": "Kontoinnstillinger",
    "studio_more_notifications": "Varsler",
    "studio_more_plan": "Plan og fakturering",
    "studio_more_invite": "Inviter venner",
    "studio_more_redeem": "Løs inn kupong",
    "studio_more_ai": "AI Magi",
    "studio_more_privacy": "Personvern",
    "studio_more_help": "Hjelp & Blogg",
    "studio_more_logout": "Logg ut",
    "studio_nav_create": "Opprett",
    "studio_nav_mine": "Mine design",
    "studio_nav_templates": "Malene",
    "studio_nav_community": "Samfunn",
    "studio_nav_more": "Mer",
    "studio_nav_home": "Hjem",
    "studio_nav_projects": "Prosjekter",
    "studio_nav_ai_magic": "AI Magi",
    "studio_nav_business": "Bedrift",
    "studio_nav_create_aria": "Opprett nytt design",
    "studio_team_title": "Bedrift — teamarbeidsområde",
    "studio_team_sub": "Inviter kolleger til å samarbeide. Maks. 10 medlemmer per team.",
    "studio_team_load_fail": "Kunne ikke laste teamet",
    "studio_team_create_title": "Opprett et nytt team",
    "studio_team_create_sub": "Du blir eier og kan invitere medlemmer.",
    "studio_team_name_placeholder": "Teamnavn",
    "studio_team_create_btn": "Opprett",
    "studio_team_join_title": "Bli med med en eksisterende invitasjon",
    "studio_team_join_sub": "Hvis noen har sendt deg en invitasjonskode.",
    "studio_team_invite_code_placeholder": "Invitasjonskode",
    "studio_team_join_btn": "Bli med",
    "studio_team_created": "Team opprettet",
    "studio_team_failed": "Mislyktes",
    "studio_team_joined": "Blandet team",
    "studio_team_invite_invalid": "Invitasjon ugyldig",
    "studio_team_member_one": "medlem",
    "studio_team_members_many": "medlemmer",
    "studio_team_you_are_owner": "· du er eier",
    "studio_team_leave_btn": "Forlat",
    "studio_team_confirm_leave": "Vil du virkelig forlate teamet?",
    "studio_team_left": "Forlot teamet",
    "studio_team_invite_title": "Inviter et nytt medlem",
    "studio_team_invite_email_placeholder": "epost@eksempel.com",
    "studio_team_send_invite": "Send invitasjon",
    "studio_team_invite_copied": "Invitasjonslenke kopiert til utklippstavlen",
    "studio_team_auto_copy_hint": "Invitasjonslenken er kopiert til utklippstavlen automatisk.",
    "studio_team_members_header": "Medlemmer",
    "studio_team_owner_badge": "Eier",
    "studio_team_pending_header": "Venter på invitasjoner",
    "studio_team_expires": "Utløper"
  },
  "da": {
    "studio_editor_back": "Tilbage",
    "studio_editor_untitled": "Uden titel annonce",
    "studio_editor_credits_view": "Se kreditter",
    "studio_editor_credits_label": "Kreditter",
    "studio_editor_credits_unlimited": "∞ Ubegrænset",
    "studio_editor_smart_resize": "Smart størrelse",
    "studio_editor_quick_reel": "Hurtig rulle",
    "studio_editor_quick_reel_title": "Auto-animer hvert element til en 15-sekunders rulle",
    "studio_editor_save": "Gem",
    "studio_editor_export_png": "Eksporter PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Eksporter animeret video",
    "studio_editor_mp4_title_need_anim": "Tilføj en animation først",
    "studio_editor_rail_magic": "Magisk",
    "studio_editor_rail_text": "Tekst",
    "studio_editor_rail_shapes": "Former",
    "studio_editor_rail_images": "Billeder",
    "studio_editor_rail_anim": "Animer",
    "studio_editor_rail_layers": "Lag",
    "studio_editor_close_panel": "Luk panel",
    "studio_editor_close_props": "Luk egenskaber",
    "studio_editor_open_props": "Åbn egenskaber",
    "studio_editor_director_title": "AI Rulle Direktør — one-shot",
    "studio_editor_director_sub": "Én sætning → fuld animeret rulle (~10s).",
    "studio_editor_magic_title": "AI Magi — URL → 5 annoncer",
    "studio_editor_magic_placeholder": "https://din-side.com",
    "studio_editor_magic_generate": "Generer",
    "studio_editor_text_title": "Tekst",
    "studio_editor_add_heading": "Tilføj overskrift",
    "studio_editor_shapes_title": "Former",
    "studio_editor_rectangle": "Rektangel",
    "studio_editor_circle": "Cirkel",
    "studio_editor_background_title": "Baggrund",
    "studio_editor_upload_title": "Upload billede",
    "studio_editor_stock_btn": "Stock fotos",
    "studio_editor_from_url": "Fra URL",
    "studio_editor_add": "Tilføj",
    "studio_editor_layers_title": "Lag",
    "studio_editor_canvas_empty": "Lærredet er tomt.",
    "studio_editor_props_title": "Egenskaber",
    "studio_editor_select_element": "Vælg et element for at redigere dets egenskaber.",
    "studio_editor_prop_text": "Tekst",
    "studio_editor_prop_font": "Skrifttype",
    "studio_editor_prop_size": "Størrelse",
    "studio_editor_prop_fill": "Fyld",
    "studio_editor_prop_opacity": "Opacitet",
    "studio_editor_duplicate": "Dupliker",
    "studio_editor_delete": "Slet",
    "studio_editor_toast_offline_info": "Du arbejder offline. Log ind for at gemme og eksportere.",
    "studio_editor_toast_open_fail": "Kunne ikke åbne editor",
    "studio_editor_toast_image_fail": "Kunne ikke indlæse billede",
    "studio_editor_toast_saved": "Gemt",
    "studio_editor_toast_save_fail": "Gemmen mislykkedes",
    "studio_editor_toast_log_in_save": "Log ind for at gemme din annonce i skyen.",
    "studio_editor_toast_add_elements_first": "Tilføj nogle elementer først, og klik derefter på Quick Reel.",
    "studio_editor_toast_need_animation": "Tilføj mindst én animation først (Animer skinner).",
    "studio_editor_toast_browser_no_video": "Din browser understøtter ikke videoptagelse.",
    "studio_editor_toast_video_fail": "Videoklip eksport mislykkedes",
    "studio_editor_toast_export_fail": "Eksport mislykkedes",
    "studio_editor_toast_exported": "Eksporteret!",
    "studio_editor_toast_exported_ext": "Eksporteret .{ext}!",
    "studio_editor_toast_credits_out": "Ingen annoncekreditter tilbage.",
    "studio_editor_toast_credits_out_upsell": "Du har ikke flere annoncekreditter. Opgrader til Pro for 30/måned.",
    "studio_editor_toast_ai_fail": "AI Magi mislykkedes",
    "studio_editor_toast_no_variants": "Ingen varianter returneret",
    "studio_editor_toast_applied": "Anvendt: {angle}",
    "studio_editor_toast_quick_reel_done": "Quick Reel · {n} animationer · {s}s",
    "studio_editor_toast_smart_resize_done": "Oprettet {n} søskende annonce{plural}",
    "studio_editor_toast_smart_resize_fail": "Smart ændring af størrelse mislykkedes",
    "studio_my_have_coupon": "Har du en kupon?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Indløs",
    "studio_my_toast_credits_added": "+{amount} kreditter tilføjet 🎉",
    "studio_my_toast_not_found": "Kode ikke fundet",
    "studio_my_toast_already": "Allerede indløst",
    "studio_my_toast_expired": "Udløbet eller deaktiveret",
    "studio_my_toast_redeem_fail": "Indløsning mislykkedes",
    "studio_my_toast_load_fail": "Kunne ikke indlæse projekter",
    "studio_my_confirm_delete": "Slette \"{title}\"?",
    "studio_my_title": "Mine designs",
    "studio_my_sub": "Alle dine gemte projekter og eksporter ét sted.",
    "studio_my_count_one": "{n} projekt",
    "studio_my_count_many": "{n} projekter",
    "studio_my_instant_campaign": "Øjeblikkelig kampagne",
    "studio_my_new_ad": "Ny annonce",
    "studio_my_login_to_see": "Log ind for at se dine gemte annoncer.",
    "studio_my_login": "Log ind",
    "studio_my_loading": "Indlæser…",
    "studio_my_empty_title": "Ingen annoncer endnu.",
    "studio_my_browse": "Se skabeloner",
    "studio_my_badge_team": "Hold",
    "studio_my_badge_shared": "Delt",
    "studio_my_edit": "Rediger",
    "studio_gallery_filter_prefix": "Filtrer",
    "studio_gallery_filter_cancel": "× ryd",
    "studio_gallery_title": "Skabeloner",
    "studio_gallery_lead": "Vælg en start. Rediger hvad som helst.",
    "studio_gallery_search": "Søg skabeloner…",
    "studio_gallery_loading_count": "Indlæser…",
    "studio_gallery_count_of": "{start}–{end} af {total} skabeloner",
    "studio_gallery_pack_all": "Alle",
    "studio_gallery_pack_trending": "Populære",
    "studio_gallery_pack_ai": "AI-drevet",
    "studio_gallery_pack_editorial": "Redaktionelt",
    "studio_gallery_pack_video": "Video Clips",
    "studio_gallery_pack_free": "Gratis",
    "studio_gallery_video_only": "Kun video",
    "studio_gallery_all_formats": "Alle formater",
    "studio_gallery_all_categories": "Alle kategorier",
    "studio_gallery_loading_templates": "Indlæser skabeloner…",
    "studio_gallery_no_match": "Ingen skabeloner matcher disse filtre.",
    "studio_gallery_opening": "Åbner editor…",
    "studio_gallery_prev": "← Forrige",
    "studio_gallery_next": "Næste →",
    "studio_gallery_page_of": "Side {n} af {total}",
    "studio_gallery_type_post": "Indlæg",
    "studio_gallery_type_story": "Historie",
    "studio_gallery_type_reel": "Reel",
    "studio_gallery_type_video": "Video",
    "studio_gallery_type_ad": "Annonce",
    "studio_landing_meta_title": "Studio — AI-designs, reels og videoer på 60 sekunder | TopRankPulse",
    "studio_landing_meta_desc": "Opret indlæg, reels, videoer og annoncer med AI. 1.600+ skabeloner, eksport med ét klik. En del af TopRankPulse.",
    "studio_landing_eyebrow": "NYT · STUDIO AF TOPRANKPULSE",
    "studio_landing_hero_title_a": "Opret indlæg, reels og videoer.",
    "studio_landing_hero_title_b": "På minutter, ikke dage.",
    "studio_landing_hero_lead": "Vælg en indholdstype, en skabelon eller lad AI udarbejde den første version. Rediger i en Canva-lignende editor. Eksporter PNG / MP4 med ét klik. Annoncer, reels, historier, videoer og indlæg — alt på ét sted.",
    "studio_landing_cta_start": "Begynd at skabe",
    "studio_landing_cta_instant": "Øjeblikkelig kampagne — 25 annoncer",
    "studio_landing_cta_browse": "Gennemse skabeloner",
    "studio_landing_kpi_projects": "Oprettede projekter",
    "studio_landing_kpi_exports": "Downloadede eksporter",
    "studio_landing_kpi_templates": "Skabeloner",
    "studio_landing_kpi_formats": "Annonceformater",
    "studio_landing_features_title": "Et studio. Ikke et lysbilledshow.",
    "studio_landing_features_sub": "Alt en performance marketingmedarbejder faktisk bruger — én skærm, ingen faner.",
    "studio_landing_feat_ai_title": "AI-magi fra URL",
    "studio_landing_feat_ai_text": "Indsæt en hjemmeside, få 5 komplette annoncekoncepter — brandfarver, overskrifter, CTA'er, klar til levering lærred.",
    "studio_landing_feat_type_title": "Komplet typografi",
    "studio_landing_feat_type_text": "Skrifttyper, vægte, sporing, omrids, skygger. Tekstbokse der opfører sig som Adobe, ikke PowerPoint.",
    "studio_landing_feat_img_title": "AI + stock billeder",
    "studio_landing_feat_img_text": "Generer pixelperfekte baggrunde med GPT Image 1. Unsplash og Pexels integreret.",
    "studio_landing_feat_brand_title": "Brand kit",
    "studio_landing_feat_brand_text": "Lås dine farver, skrifttyper, logoer én gang. Hver ny annonce arver dem automatisk.",
    "studio_landing_feat_resize_title": "Smart størrelseændring",
    "studio_landing_feat_resize_text": "Én lærred → 10 søsterannoncer automatisk skaleret til hvert format. Send en fuld kampagne med ét klik.",
    "studio_landing_feat_wl_title": "Hvid-label klar",
    "studio_landing_feat_wl_text": "Bygget til at blive indlejret. Indsæt i din agenturportal via iframe eller API. Dit brand, vores motor.",
    "studio_landing_formats_title": "10 annonceformater. Én lærred.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Feed, Historie, Reel.",
    "studio_landing_pricing_title": "Simpel, kreditbaseret prissætning.",
    "studio_landing_pricing_sub": "Begynd gratis. Skaler når dine kampagner gør.",
    "studio_landing_pricing_extra": "Ekstra annoncer ud over plan: €2.30 / kredit · afbestil når som helst",
    "studio_landing_price_free_credits": "3 annoncer · engangsbetaling",
    "studio_landing_price_starter_credits": "10 annoncer / måned",
    "studio_landing_price_pro_credits": "30 annoncer / måned",
    "studio_landing_price_agency_credits": "80 annoncer / måned",
    "studio_landing_price_free_f1": "Alle 10 formater",
    "studio_landing_price_free_f2": "AI-magi fra URL",
    "studio_landing_price_free_f3": "PNG eksport",
    "studio_landing_price_free_f4": "Ingen kreditkort",
    "studio_landing_price_starter_f1": "Alt i Gratis",
    "studio_landing_price_starter_f2": "Brand Kit",
    "studio_landing_price_starter_f3": "Smart Resize",
    "studio_landing_price_starter_f4": "Prioriteret kø",
    "studio_landing_price_pro_f1": "Alt i Starter",
    "studio_landing_price_pro_f2": "AI Billede Generering (GPT Billede 1)",
    "studio_landing_price_pro_f3": "Video eksport (kommer)",
    "studio_landing_price_pro_f4": "Fjern vandmærke",
    "studio_landing_price_agency_f1": "Alt i Pro",
    "studio_landing_price_agency_f2": "Teampladser (kommer)",
    "studio_landing_price_agency_f3": "White-label eksport",
    "studio_landing_price_agency_f4": "Dedikeret support",
    "studio_landing_price_free_cta": "Start gratis",
    "studio_landing_price_starter_cta": "Få Starter",
    "studio_landing_price_pro_cta": "Få Pro",
    "studio_landing_price_agency_cta": "Få Agentur",
    "studio_landing_price_most_popular": "Mest populær",
    "studio_landing_final_title": "Send din første annonce i aften.",
    "studio_landing_final_sub": "Tre gratis annoncer. Ingen kort. To klik for at offentliggøre.",
    "studio_landing_final_btn": "Åbn redaktøren",
    "studio_landing_footer": "Studio · en del af",
    "studio_create_back_select": "← Tilbage til valg",
    "studio_create_new_prefix": "Ny",
    "studio_create_type_desc_suffix": "Vælg en skabelon, eller start fra et tomt lærred.",
    "studio_create_opt_templates_title": "Vælg en skabelon",
    "studio_create_opt_templates_sub": "Hundredvis af færdige designs — redigerbare",
    "studio_create_opt_blank_title": "Tomme lærred",
    "studio_create_opt_blank_sub": "Fuld kontrol, tomt lærred",
    "studio_create_opt_ai_title": "AI Magi ✨",
    "studio_create_opt_ai_sub": "Beskriv hvad du ønsker — AI skaber den første version",
    "studio_create_hub_eyebrow": "Hvad laver du?",
    "studio_create_hub_title_a": "Lad os blive",
    "studio_create_hub_title_b": "kreative",
    "studio_create_hub_sub": "Vælg en indholdstype. Hver præindstillet åbner de rigtige dimensioner og skabeloner.",
    "studio_create_card_start": "Start",
    "studio_create_type_post_label": "Post",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Story",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animeret · 15–60s",
    "studio_create_type_video_label": "Video",
    "studio_create_type_video_desc": "16:9 · landskab",
    "studio_create_type_ad_label": "Annonce",
    "studio_create_type_ad_desc": "FB/IG annoncetekst",
    "studio_more_title": "Mere",
    "studio_more_sub": "Indstillinger, konto og andre værktøjer.",
    "studio_more_settings": "Kontoindstillinger",
    "studio_more_notifications": "Notifikationer",
    "studio_more_plan": "Plan & fakturering",
    "studio_more_invite": "Inviter venner",
    "studio_more_redeem": "Indløs en kupon",
    "studio_more_ai": "AI Magi",
    "studio_more_privacy": "Privatliv",
    "studio_more_help": "Hjælp & Blog",
    "studio_more_logout": "Log ud",
    "studio_nav_create": "Opret",
    "studio_nav_mine": "Mine designs",
    "studio_nav_templates": "Skabeloner",
    "studio_nav_community": "Fællesskab",
    "studio_nav_more": "Mere",
    "studio_nav_home": "Hjem",
    "studio_nav_projects": "Projekter",
    "studio_nav_ai_magic": "AI Magi",
    "studio_nav_business": "Virksomhed",
    "studio_nav_create_aria": "Opret nyt design",
    "studio_team_title": "Virksomhed — teamarbejdsplads",
    "studio_team_sub": "Inviter kolleger til at arbejde sammen. Max. 10 medlemmer pr. team.",
    "studio_team_load_fail": "Kunne ikke indlæse team",
    "studio_team_create_title": "Opret et nyt team",
    "studio_team_create_sub": "Du bliver ejer og kan invitere medlemmer.",
    "studio_team_name_placeholder": "Team navn",
    "studio_team_create_btn": "Opret",
    "studio_team_join_title": "Deltag med en eksisterende invitation",
    "studio_team_join_sub": "Hvis nogen har sendt dig en invitationskode.",
    "studio_team_invite_code_placeholder": "Invitationskode",
    "studio_team_join_btn": "Deltag",
    "studio_team_created": "Team oprettet",
    "studio_team_failed": "Fejlet",
    "studio_team_joined": "Deltager i team",
    "studio_team_invite_invalid": "Ugyldig invitation",
    "studio_team_member_one": "medlem",
    "studio_team_members_many": "medlemmer",
    "studio_team_you_are_owner": "· du er ejer",
    "studio_team_leave_btn": "Forlad",
    "studio_team_confirm_leave": "Vil du virkelig forlade teamet?",
    "studio_team_left": "Forlod teamet",
    "studio_team_invite_title": "Inviter et nyt medlem",
    "studio_team_invite_email_placeholder": "email@eksempel.com",
    "studio_team_send_invite": "Send invitation",
    "studio_team_invite_copied": "Invitationslink kopieret til udklipsholder",
    "studio_team_auto_copy_hint": "Invitationslinket er automatisk kopieret til udklipsholder.",
    "studio_team_members_header": "Medlemmer",
    "studio_team_owner_badge": "Ejer",
    "studio_team_pending_header": "Ventende invitationer",
    "studio_team_expires": "Udløber"
  },
  "fi": {
    "studio_editor_back": "Takaisin",
    "studio_editor_untitled": "Nimeämätön mainos",
    "studio_editor_credits_view": "Näytä luottotili",
    "studio_editor_credits_label": "Luotot",
    "studio_editor_credits_unlimited": "∞ Rajoittamaton",
    "studio_editor_smart_resize": "Älykäs koonmuutos",
    "studio_editor_quick_reel": "Nopea rulla",
    "studio_editor_quick_reel_title": "Automaattinen animaatio jokaiselle elementille 15 sekunnin rullassa",
    "studio_editor_save": "Tallenna",
    "studio_editor_export_png": "Vie PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Vie animaatiovideo",
    "studio_editor_mp4_title_need_anim": "Lisää animaatio ensin",
    "studio_editor_rail_magic": "Taika",
    "studio_editor_rail_text": "Teksti",
    "studio_editor_rail_shapes": "Muodot",
    "studio_editor_rail_images": "Kuvat",
    "studio_editor_rail_anim": "Animoida",
    "studio_editor_rail_layers": "Tasot",
    "studio_editor_close_panel": "Sulje paneeli",
    "studio_editor_close_props": "Sulje asetukset",
    "studio_editor_open_props": "Avaa asetukset",
    "studio_editor_director_title": "AI Rulladirektori — yhden otteen",
    "studio_editor_director_sub": "Yksi lause → täysi animoitu rulla (~10s).",
    "studio_editor_magic_title": "AI Taika — URL → 5 mainosta",
    "studio_editor_magic_placeholder": "https://your-site.com",
    "studio_editor_magic_generate": "Tuota",
    "studio_editor_text_title": "Teksti",
    "studio_editor_add_heading": "Lisää otsikko",
    "studio_editor_shapes_title": "Muodot",
    "studio_editor_rectangle": "Suorakulmio",
    "studio_editor_circle": "Ympyrä",
    "studio_editor_background_title": "Tausta",
    "studio_editor_upload_title": "Lataa kuva",
    "studio_editor_stock_btn": "Varastokuvat",
    "studio_editor_from_url": "URL:stä",
    "studio_editor_add": "Lisää",
    "studio_editor_layers_title": "Tasot",
    "studio_editor_canvas_empty": "Kangas on tyhjö.",
    "studio_editor_props_title": "Asetukset",
    "studio_editor_select_element": "Valitse elementti muuttaaksesi sen asetuksia.",
    "studio_editor_prop_text": "Teksti",
    "studio_editor_prop_font": "Fontti",
    "studio_editor_prop_size": "Koko",
    "studio_editor_prop_fill": "Täyttö",
    "studio_editor_prop_opacity": "Läpinäkyvyys",
    "studio_editor_duplicate": "Kloonaa",
    "studio_editor_delete": "Poista",
    "studio_editor_toast_offline_info": "Olet offline-tilassa. Kirjaudu sisään tallentaaksesi ja viedäksesi.",
    "studio_editor_toast_open_fail": "Editorin avaus epäonnistui",
    "studio_editor_toast_image_fail": "Kuvan lataaminen epäonnistui",
    "studio_editor_toast_saved": "Tallennettu",
    "studio_editor_toast_save_fail": "Tallennus epäonnistui",
    "studio_editor_toast_log_in_save": "Kirjaudu sisään tallentaaksesi mainoksesi pilveen.",
    "studio_editor_toast_add_elements_first": "Lisää ensin elementtejä, sitten napsauta Quick Reel.",
    "studio_editor_toast_need_animation": "Lisää vähintään yksi animaatio ensin (Animate rail).",
    "studio_editor_toast_browser_no_video": "Selaimesi ei tue videon tallennusta.",
    "studio_editor_toast_video_fail": "Videon vienti epäonnistui",
    "studio_editor_toast_export_fail": "Vienti epäonnistui",
    "studio_editor_toast_exported": "Viety!",
    "studio_editor_toast_exported_ext": "Viety .{ext}!",
    "studio_editor_toast_credits_out": "Mainosroposet loppu.",
    "studio_editor_toast_credits_out_upsell": "Mainosroposet on loppu. Päivitä Pro:ksi 30/kuussa.",
    "studio_editor_toast_ai_fail": "AI Taikuus epäonnistui",
    "studio_editor_toast_no_variants": "Ei varianteja palautettu",
    "studio_editor_toast_applied": "Käytetty: {angle}",
    "studio_editor_toast_quick_reel_done": "Quick Reel · {n} animaatiota · {s}s",
    "studio_editor_toast_smart_resize_done": "Luotu {n} sisarmainos{plural}",
    "studio_editor_toast_smart_resize_fail": "Älykäs uudelleenmuotoilu epäonnistui",
    "studio_my_have_coupon": "Onko sinulla kuponki?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Hyödynnä",
    "studio_my_toast_credits_added": "+{amount} ropoa lisätty 🎉",
    "studio_my_toast_not_found": "Koodia ei löytynyt",
    "studio_my_toast_already": "Jo hyödynnetty",
    "studio_my_toast_expired": "Vanhentunut tai deaktiivoitu",
    "studio_my_toast_redeem_fail": "Hyödyntäminen epäonnistui",
    "studio_my_toast_load_fail": "Projektien lataus epäonnistui",
    "studio_my_confirm_delete": "Poista \"{title}\"?",
    "studio_my_title": "Suunnitelmani",
    "studio_my_sub": "Kaikki tallennetut projektisi ja viennit yhdessä paikassa.",
    "studio_my_count_one": "{n} projekti",
    "studio_my_count_many": "{n} projektia",
    "studio_my_instant_campaign": "Välitön kampanja",
    "studio_my_new_ad": "Uusi mainos",
    "studio_my_login_to_see": "Kirjaudu nähdäksesi tallennetut mainoksesi.",
    "studio_my_login": "Kirjaudu sisään",
    "studio_my_loading": "Ladataan…",
    "studio_my_empty_title": "Ei vielä mainoksia.",
    "studio_my_browse": "Selaa malleja",
    "studio_my_badge_team": "Tiimi",
    "studio_my_badge_shared": "Jaettu",
    "studio_my_edit": "Muokkaa",
    "studio_gallery_filter_prefix": "Suodata",
    "studio_gallery_filter_cancel": "× tyhjennä",
    "studio_gallery_title": "Mallit",
    "studio_gallery_lead": "Valitse alku. Muokkaa mitä tahansa.",
    "studio_gallery_search": "Hae malleja…",
    "studio_gallery_loading_count": "Ladataan…",
    "studio_gallery_count_of": "{start}–{end} yhteensä {total} mallia",
    "studio_gallery_pack_all": "Kaikki",
    "studio_gallery_pack_trending": "Suosituimmat",
    "studio_gallery_pack_ai": "AI-vetoinen",
    "studio_gallery_pack_editorial": "Toimituksellinen",
    "studio_gallery_pack_video": "Videoleikkeet",
    "studio_gallery_pack_free": "Ilmainen",
    "studio_gallery_video_only": "Vain video",
    "studio_gallery_all_formats": "Kaikki formaatit",
    "studio_gallery_all_categories": "Kaikki kategoriat",
    "studio_gallery_loading_templates": "Ladataan malleja…",
    "studio_gallery_no_match": "Yksikään malli ei vastaa näitä suodattimia.",
    "studio_gallery_opening": "Avaamassa muokkainta…",
    "studio_gallery_prev": "← Edellinen",
    "studio_gallery_next": "Seuraava →",
    "studio_gallery_page_of": "Sivu {n} / {total}",
    "studio_gallery_type_post": "Viesti",
    "studio_gallery_type_story": "Tarina",
    "studio_gallery_type_reel": "Reel",
    "studio_gallery_type_video": "Video",
    "studio_gallery_type_ad": "Mainos",
    "studio_landing_meta_title": "Studio — AI-suunnitelmat, rehdit & videot 60 sekunnissa | TopRankPulse",
    "studio_landing_meta_desc": "Luo julkaisuja, rehdejä, videoita ja mainoksia AI:n avulla. 1,600+ mallia, yksi napsautus vientiin. Osa TopRankPulsea.",
    "studio_landing_eyebrow": "UUSI · STUDIO BY TOPRANKPULSE",
    "studio_landing_hero_title_a": "Luo julkaisuja, rehdejä ja videoita.",
    "studio_landing_hero_title_b": "Muutamassa minuutissa, ei päivissä.",
    "studio_landing_hero_lead": "Valitse sisältötyyppi, malli tai anna AI:n luonnostella ensimmäinen versio. Muokkaa Canva-tyylisessä editorissa. Vie PNG / MP4 yhdellä napsautuksella. Mainokset, rehdit, tarinat, videot ja julkaisut — kaikki yhdessä.",
    "studio_landing_cta_start": "Aloita luominen",
    "studio_landing_cta_instant": "Välitön kampanja — 25 mainosta",
    "studio_landing_cta_browse": "Selaa malleja",
    "studio_landing_kpi_projects": "Luodut projektit",
    "studio_landing_kpi_exports": "Ladatut viennit",
    "studio_landing_kpi_templates": "Mallit",
    "studio_landing_kpi_formats": "Mainosmuodot",
    "studio_landing_features_title": "Studio. Ei esitysgalleria.",
    "studio_landing_features_sub": "Kaikki, mitä suoritusmarkkinoija todella tarvitsee — yksi näyttö, ei välilehtiä.",
    "studio_landing_feat_ai_title": "AI-taikuus URL:stä",
    "studio_landing_feat_ai_text": "Liitä verkkosivusto, saa 5 täyttä mainoskäsitettä — brändivärit, otsikot, CTAt, valmiit kankaat.",
    "studio_landing_feat_type_title": "Kokonainen typografia",
    "studio_landing_feat_type_text": "Fontit, painot, seurantat, ääriviivat, varjostukset. Tekstiruudut, jotka käyttäytyvät kuten Adobe, eivät PowerPoint.",
    "studio_landing_feat_img_title": "AI + kuvapankkikuvat",
    "studio_landing_feat_img_text": "Luo pikselintarkkoja taustoja GPT Image 1:llä. Unsplash ja Pexels sisäänrakennettuna.",
    "studio_landing_feat_brand_title": "Brändipaketti",
    "studio_landing_feat_brand_text": "Lukitse värit, fontit, logot kerralla. Jokainen uusi mainos perii ne automaattisesti.",
    "studio_landing_feat_resize_title": "Älykäs koon muuttaminen",
    "studio_landing_feat_resize_text": "Yksi kangas → 10 sisarusta, jotka skaalautuvat automaattisesti jokaiseen muotoon. Toimitu täydellinen kampanja yhdellä napsautuksella.",
    "studio_landing_feat_wl_title": "Valmiina valkoiseen etikettiin",
    "studio_landing_feat_wl_text": "Rakennettu upotettavaksi. Upota toimistoportaaliisi iframe- tai API:n kautta. Sinun brändisi, meidän moottorimme.",
    "studio_landing_formats_title": "10 mainosmuotoa. Yksi kangas.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Syöttö, Tarina, Rehdit.",
    "studio_landing_pricing_title": "Yksinkertainen, krediittipohjainen hinnoittelu.",
    "studio_landing_pricing_sub": "Aloita ilmaiseksi. Kouluta, kun kampanjasi vuoksi.",
    "studio_landing_pricing_extra": "Lisämainokset suunnitelman ylitse: 2,30 €/krediitti · peruuta milloin tahansa",
    "studio_landing_price_free_credits": "3 mainosta · kertaluonteinen",
    "studio_landing_price_starter_credits": "10 mainosta / kuukausi",
    "studio_landing_price_pro_credits": "30 mainosta / kuukausi",
    "studio_landing_price_agency_credits": "80 mainosta / kuukausi",
    "studio_landing_price_free_f1": "Kaikki 10 muotoa",
    "studio_landing_price_free_f2": "AI-taikuus URL:stä",
    "studio_landing_price_free_f3": "PNG-vienti",
    "studio_landing_price_free_f4": "Ei maksukorttia",
    "studio_landing_price_starter_f1": "Kaikki ilmaiseksi",
    "studio_landing_price_starter_f2": "Brändipaketti",
    "studio_landing_price_starter_f3": "Älykäs koonmuutos",
    "studio_landing_price_starter_f4": "Prioriteettijono",
    "studio_landing_price_pro_f1": "Kaikki Starterissa",
    "studio_landing_price_pro_f2": "AI Kuvageneraattori (GPT Image 1)",
    "studio_landing_price_pro_f3": "Videovienti (tulossa)",
    "studio_landing_price_pro_f4": "Poista vesileima",
    "studio_landing_price_agency_f1": "Kaikki Prossa",
    "studio_landing_price_agency_f2": "Tiimipaikat (tulossa)",
    "studio_landing_price_agency_f3": "White-label-vienti",
    "studio_landing_price_agency_f4": "Erityistuki",
    "studio_landing_price_free_cta": "Aloita ilmaiseksi",
    "studio_landing_price_starter_cta": "Hanki Starter",
    "studio_landing_price_pro_cta": "Hanki Pro",
    "studio_landing_price_agency_cta": "Hanki Agency",
    "studio_landing_price_most_popular": "Suosituin",
    "studio_landing_final_title": "Lähetä ensimmäinen mainoksesi tänä iltana.",
    "studio_landing_final_sub": "Kolme ilmaista mainosta. Ei korttia. Kaksi klikkausta julkaisuun.",
    "studio_landing_final_btn": "Avaa editori",
    "studio_landing_footer": "Studio · osa",
    "studio_create_back_select": "← Takaisin valintaan",
    "studio_create_new_prefix": "Uusi",
    "studio_create_type_desc_suffix": "Valitse malli tai aloita tyhjältä kankaalta.",
    "studio_create_opt_templates_title": "Valitse malli",
    "studio_create_opt_templates_sub": "Satoja valmiita malleja — muokattavissa",
    "studio_create_opt_blank_title": "Tyhjät kangas",
    "studio_create_opt_blank_sub": "Täydellinen hallinta, tyhjät kentät",
    "studio_create_opt_ai_title": "AI Taika ✨",
    "studio_create_opt_ai_sub": "Kuvaile mitä haluat — AI luo ensimmäisen version",
    "studio_create_hub_eyebrow": "Mitä olet luomassa?",
    "studio_create_hub_title_a": "Aloitetaan",
    "studio_create_hub_title_b": "luovuudella",
    "studio_create_hub_sub": "Valitse sisältötyyppi. Jokainen esiasetus avaa oikeat mitat ja mallit.",
    "studio_create_card_start": "Aloita",
    "studio_create_type_post_label": "Postaus",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Tarina",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animoitu · 15–60s",
    "studio_create_type_video_label": "Video",
    "studio_create_type_video_desc": "16:9 · maisema",
    "studio_create_type_ad_label": "Mainos",
    "studio_create_type_ad_desc": "FB/IG mainosluonnos",
    "studio_more_title": "Lisää",
    "studio_more_sub": "Asetukset, tili ja muut työkalut.",
    "studio_more_settings": "Tilin asetukset",
    "studio_more_notifications": "Ilmoitukset",
    "studio_more_plan": "Suunnitelma & laskutus",
    "studio_more_invite": "Kutsu ystäviä",
    "studio_more_redeem": "Hyväksy kuponki",
    "studio_more_ai": "AI Taika",
    "studio_more_privacy": "Yksityisyys",
    "studio_more_help": "Apua & Blogi",
    "studio_more_logout": "Kirjaudu ulos",
    "studio_nav_create": "Luo",
    "studio_nav_mine": "Omat mallit",
    "studio_nav_templates": "Mallit",
    "studio_nav_community": "Yhteisö",
    "studio_nav_more": "Lisää",
    "studio_nav_home": "Koti",
    "studio_nav_projects": "Projektit",
    "studio_nav_ai_magic": "AI Taika",
    "studio_nav_business": "Liiketoiminta",
    "studio_nav_create_aria": "Luo uusi malli",
    "studio_team_title": "Liiketoiminta — tiimityötila",
    "studio_team_sub": "Kutsu kollegoita työskentelemään yhdessä. Max. 10 jäsentä tiimissä.",
    "studio_team_load_fail": "Tiimiä ei voitu ladata",
    "studio_team_create_title": "Luo uusi tiimi",
    "studio_team_create_sub": "Sinusta tulee omistaja ja voit kutsua jäseniä.",
    "studio_team_name_placeholder": "Tiimin nimi",
    "studio_team_create_btn": "Luo",
    "studio_team_join_title": "Liity olemassaolevalla kutsulla",
    "studio_team_join_sub": "Jos joku lähetti sinulle kutsukoodin.",
    "studio_team_invite_code_placeholder": "Kutsukoodi",
    "studio_team_join_btn": "Liity",
    "studio_team_created": "Tiimi luotu",
    "studio_team_failed": "Epäonnistui",
    "studio_team_joined": "Liityttiin tiimiin",
    "studio_team_invite_invalid": "Virheellinen kutsu",
    "studio_team_member_one": "jäsen",
    "studio_team_members_many": "jäsenet",
    "studio_team_you_are_owner": "· olet omistaja",
    "studio_team_leave_btn": "Poistu",
    "studio_team_confirm_leave": "Haluatko todella poistua tiimistä?",
    "studio_team_left": "Poistunut tiimistä",
    "studio_team_invite_title": "Kutsu uusi jäsen",
    "studio_team_invite_email_placeholder": "sähköposti@esimerkki.com",
    "studio_team_send_invite": "Lähetä kutsu",
    "studio_team_invite_copied": "Kutsulinkki kopioitu leikepöydälle",
    "studio_team_auto_copy_hint": "Kutsulinkki on kopioitu leikepöydälle automaattisesti.",
    "studio_team_members_header": "Jäsenet",
    "studio_team_owner_badge": "Omistaja",
    "studio_team_pending_header": "Odottavat kutsut",
    "studio_team_expires": "Vanhenee"
  },
  "ro": {
    "studio_editor_back": "Înapoi",
    "studio_editor_untitled": "Reclamă fără titlu",
    "studio_editor_credits_view": "Vizualizare carte de credit",
    "studio_editor_credits_label": "Credite",
    "studio_editor_credits_unlimited": "∞ Nelimitat",
    "studio_editor_smart_resize": "Redimensionare inteligentă",
    "studio_editor_quick_reel": "Reel rapid",
    "studio_editor_quick_reel_title": "Auto-animează fiecare element pentru un reel de 15 secunde",
    "studio_editor_save": "Salvează",
    "studio_editor_export_png": "Exportă PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Exportă video animat",
    "studio_editor_mp4_title_need_anim": "Adaugă mai întâi o animație",
    "studio_editor_rail_magic": "Magie",
    "studio_editor_rail_text": "Text",
    "studio_editor_rail_shapes": "Forme",
    "studio_editor_rail_images": "Imagini",
    "studio_editor_rail_anim": "Animează",
    "studio_editor_rail_layers": "Straturi",
    "studio_editor_close_panel": "Închide panoul",
    "studio_editor_close_props": "Închide proprietăți",
    "studio_editor_open_props": "Deschide proprietăți",
    "studio_editor_director_title": "Director Reel AI — o singură încercare",
    "studio_editor_director_sub": "O propoziție → reel animat complet (~10s).",
    "studio_editor_magic_title": "Magie AI — URL → 5 reclame",
    "studio_editor_magic_placeholder": "https://site-ul-tău.com",
    "studio_editor_magic_generate": "Generează",
    "studio_editor_text_title": "Text",
    "studio_editor_add_heading": "Adaugă titlu",
    "studio_editor_shapes_title": "Forme",
    "studio_editor_rectangle": "Dreptunghi",
    "studio_editor_circle": "Cerc",
    "studio_editor_background_title": "Fundal",
    "studio_editor_upload_title": "Încarcă imagine",
    "studio_editor_stock_btn": "Fotografii de stoc",
    "studio_editor_from_url": "Din URL",
    "studio_editor_add": "Adaugă",
    "studio_editor_layers_title": "Straturi",
    "studio_editor_canvas_empty": "Canvas-ul este gol.",
    "studio_editor_props_title": "Proprietăți",
    "studio_editor_select_element": "Selectați un element pentru a-i edita proprietățile.",
    "studio_editor_prop_text": "Text",
    "studio_editor_prop_font": "Font",
    "studio_editor_prop_size": "Dimensiune",
    "studio_editor_prop_fill": "Umplere",
    "studio_editor_prop_opacity": "Opacitate",
    "studio_editor_duplicate": "Duplicat",
    "studio_editor_delete": "Șterge",
    "studio_editor_toast_offline_info": "Lucrați offline. Conectați-vă pentru a salva și exporta.",
    "studio_editor_toast_open_fail": "Nu s-a putut deschide editorul",
    "studio_editor_toast_image_fail": "Nu s-a putut încărca imaginea",
    "studio_editor_toast_saved": "Salvat",
    "studio_editor_toast_save_fail": "Salvarea a eșuat",
    "studio_editor_toast_log_in_save": "Conectați-vă pentru a salva reclama în cloud.",
    "studio_editor_toast_add_elements_first": "Adăugați mai întâi câteva elemente, apoi faceți clic pe Quick Reel.",
    "studio_editor_toast_need_animation": "Adăugați mai întâi cel puțin o animație (Animate rail).",
    "studio_editor_toast_browser_no_video": "Browserul dvs. nu suportă înregistrarea video.",
    "studio_editor_toast_video_fail": "Exportul video a eșuat",
    "studio_editor_toast_export_fail": "Exportul a eșuat",
    "studio_editor_toast_exported": "Exportat!",
    "studio_editor_toast_exported_ext": "Exportat .{ext}!",
    "studio_editor_toast_credits_out": "Fără credite de reclamă.",
    "studio_editor_toast_credits_out_upsell": "Ați rămas fără credite de reclamă. Faceți upgrade la Pro pentru 30/lună.",
    "studio_editor_toast_ai_fail": "AI Magic a eșuat",
    "studio_editor_toast_no_variants": "Nu s-au returnat variante",
    "studio_editor_toast_applied": "Aplicat: {angle}",
    "studio_editor_toast_quick_reel_done": "Quick Reel · {n} animații · {s}s",
    "studio_editor_toast_smart_resize_done": "Creat {n} reclamă{plural} soră",
    "studio_editor_toast_smart_resize_fail": "Redimensionarea inteligentă a eșuat",
    "studio_my_have_coupon": "Aveți un cupon?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Valorifică",
    "studio_my_toast_credits_added": "+{amount} credite adăugate 🎉",
    "studio_my_toast_not_found": "Codul nu a fost găsit",
    "studio_my_toast_already": "Deja valorificat",
    "studio_my_toast_expired": "Expirat sau dezactivat",
    "studio_my_toast_redeem_fail": "Valorificarea a eșuat",
    "studio_my_toast_load_fail": "Încărcarea proiectelor a eșuat",
    "studio_my_confirm_delete": "Șterge „{title}”?",
    "studio_my_title": "Designurile mele",
    "studio_my_sub": "Toate proiectele și exporturile tale salvate într-un singur loc.",
    "studio_my_count_one": "{n} proiect",
    "studio_my_count_many": "{n} proiecte",
    "studio_my_instant_campaign": "Campanie Instant",
    "studio_my_new_ad": "Reclamă nouă",
    "studio_my_login_to_see": "Conectează-te pentru a vedea reclamele salvate.",
    "studio_my_login": "Conectează-te",
    "studio_my_loading": "Se încarcă…",
    "studio_my_empty_title": "Încă nu sunt reclame.",
    "studio_my_browse": "Răsfoiește șabloanele",
    "studio_my_badge_team": "Echipă",
    "studio_my_badge_shared": "Partajat",
    "studio_my_edit": "Editează",
    "studio_gallery_filter_prefix": "Filtru",
    "studio_gallery_filter_cancel": "× șterge",
    "studio_gallery_title": "Șabloane",
    "studio_gallery_lead": "Alege un început. Editează orice.",
    "studio_gallery_search": "Caută șabloane…",
    "studio_gallery_loading_count": "Se încarcă…",
    "studio_gallery_count_of": "{start}–{end} din {total} șabloane",
    "studio_gallery_pack_all": "Toate",
    "studio_gallery_pack_trending": "Tendințe",
    "studio_gallery_pack_ai": "Îmbunătățit de IA",
    "studio_gallery_pack_editorial": "Editorial",
    "studio_gallery_pack_video": "Clipuri Video",
    "studio_gallery_pack_free": "Gratuit",
    "studio_gallery_video_only": "Numai video",
    "studio_gallery_all_formats": "Toate formatele",
    "studio_gallery_all_categories": "Toate categoriile",
    "studio_gallery_loading_templates": "Se încarcă șabloanele…",
    "studio_gallery_no_match": "Niciun șablon nu se potrivește cu aceste filtre.",
    "studio_gallery_opening": "Se deschide editorul…",
    "studio_gallery_prev": "← Înapoi",
    "studio_gallery_next": "Următorul →",
    "studio_gallery_page_of": "Pagina {n} din {total}",
    "studio_gallery_type_post": "Postare",
    "studio_gallery_type_story": "Poveste",
    "studio_gallery_type_reel": "Reel",
    "studio_gallery_type_video": "Video",
    "studio_gallery_type_ad": "Reclamă",
    "studio_landing_meta_title": "Studio — Designuri AI, reeluri & videoclipuri în 60 de secunde | TopRankPulse",
    "studio_landing_meta_desc": "Creează postări, reeluri, videoclipuri și reclame cu AI. Peste 1.600 de șabloane, export cu un clic. Parte din TopRankPulse.",
    "studio_landing_eyebrow": "NOU · STUDIO DE LA TOPRANKPULSE",
    "studio_landing_hero_title_a": "Creează postări, reeluri și videoclipuri.",
    "studio_landing_hero_title_b": "În minute, nu zile.",
    "studio_landing_hero_lead": "Alege un tip de conținut, un șablon sau lasă AI să redacteze prima versiune. Editează într-un editor de tip Canva. Exportă PNG / MP4 cu un singur clic. Reclamă, reel, povești, videoclipuri și postări — toate într-un singur loc.",
    "studio_landing_cta_start": "Începe să creezi",
    "studio_landing_cta_instant": "Campanie instant — 25 de reclame",
    "studio_landing_cta_browse": "Răsfoiește șabloane",
    "studio_landing_kpi_projects": "Proiecte create",
    "studio_landing_kpi_exports": "Exporturi descărcate",
    "studio_landing_kpi_templates": "Șabloane",
    "studio_landing_kpi_formats": "Formate de reclamă",
    "studio_landing_features_title": "Un studio. Nu un slideshow.",
    "studio_landing_features_sub": "Tot ceea ce un marketer de performanță folosește cu adevărat — un singur ecran, fără tab-uri.",
    "studio_landing_feat_ai_title": "Magie AI din URL",
    "studio_landing_feat_ai_text": "Inserează un site web, obține 5 concepte complete de reclamă — culori de brand, titluri, CTAs, canvase gata de livrare.",
    "studio_landing_feat_type_title": "Tipografie completă",
    "studio_landing_feat_type_text": "Fonturi, greutăți, distanțare, contururi, umbre. Casete de text care se comportă ca Adobe, nu PowerPoint.",
    "studio_landing_feat_img_title": "AI + imagini stock",
    "studio_landing_feat_img_text": "Generează fundaluri perfecte cu GPT Image 1. Unsplash și Pexels incluse.",
    "studio_landing_feat_brand_title": "Kit de brand",
    "studio_landing_feat_brand_text": "Blochează-ți culorile, fonturile, siglele o dată. Fiecare reclamă nouă le va moșteni automat.",
    "studio_landing_feat_resize_title": "Redimensionare inteligentă",
    "studio_landing_feat_resize_text": "O pânză → 10 reclame surori redimensionate automat pentru fiecare format. Livrez o campanie completă cu un singur clic.",
    "studio_landing_feat_wl_title": "Pregătit pentru white-label",
    "studio_landing_feat_wl_text": "Construit pentru a fi integrat. Integrează în portalul agenției tale prin iframe sau API. Brandul tău, motorul nostru.",
    "studio_landing_formats_title": "10 formate de reclamă. O pânză.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Feed, Poveste, Reel.",
    "studio_landing_pricing_title": "Prețuri simple, bazate pe credite.",
    "studio_landing_pricing_sub": "Începe gratuit. Scalare pe măsură ce campaniile tale cresc.",
    "studio_landing_pricing_extra": "Reclame suplimentare peste plan: 2,30 € / credit · anulează oricând",
    "studio_landing_price_free_credits": "3 reclame · o singură dată",
    "studio_landing_price_starter_credits": "10 reclame / lună",
    "studio_landing_price_pro_credits": "30 reclame / lună",
    "studio_landing_price_agency_credits": "80 reclame / lună",
    "studio_landing_price_free_f1": "Toate cele 10 formate",
    "studio_landing_price_free_f2": "Magie AI din URL",
    "studio_landing_price_free_f3": "Export PNG",
    "studio_landing_price_free_f4": "Fără card de credit",
    "studio_landing_price_starter_f1": "Totul în Gratuit",
    "studio_landing_price_starter_f2": "Kit de marcă",
    "studio_landing_price_starter_f3": "Redimensionare inteligentă",
    "studio_landing_price_starter_f4": "Coada prioritară",
    "studio_landing_price_pro_f1": "Totul în Starter",
    "studio_landing_price_pro_f2": "Generare imagine AI (GPT Image 1)",
    "studio_landing_price_pro_f3": "Export video (în curând)",
    "studio_landing_price_pro_f4": "Elimină watermark-ul",
    "studio_landing_price_agency_f1": "Totul în Pro",
    "studio_landing_price_agency_f2": "Locuri pentru echipă (în curând)",
    "studio_landing_price_agency_f3": "Export white-label",
    "studio_landing_price_agency_f4": "Asistență dedicată",
    "studio_landing_price_free_cta": "Începe gratuit",
    "studio_landing_price_starter_cta": "Obține Starter",
    "studio_landing_price_pro_cta": "Obține Pro",
    "studio_landing_price_agency_cta": "Obține Agenția",
    "studio_landing_price_most_popular": "Cea mai populară",
    "studio_landing_final_title": "Publică prima ta reclamă în seara asta.",
    "studio_landing_final_sub": "Trei reclame gratuite. Fără card. Două clicuri pentru a publica.",
    "studio_landing_final_btn": "Deschide editorul",
    "studio_landing_footer": "Studio · parte din",
    "studio_create_back_select": "← Înapoi la selecție",
    "studio_create_new_prefix": "Nou",
    "studio_create_type_desc_suffix": "Alege un șablon sau începe de la un canvas gol.",
    "studio_create_opt_templates_title": "Alege un șablon",
    "studio_create_opt_templates_sub": "Sute de designuri gata de utilizat — editabile",
    "studio_create_opt_blank_title": "Canvas gol",
    "studio_create_opt_blank_sub": "Control total, canvas gol",
    "studio_create_opt_ai_title": "Magia AI ✨",
    "studio_create_opt_ai_sub": "Descrie ce vrei — AI creează prima versiune",
    "studio_create_hub_eyebrow": "Ce creezi?",
    "studio_create_hub_title_a": "Să devenim",
    "studio_create_hub_title_b": "creativi",
    "studio_create_hub_sub": "Alege un tip de conținut. Fiecare preset deschide dimensiunile și șabloanele corecte.",
    "studio_create_card_start": "Începe",
    "studio_create_type_post_label": "Postare",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Poveste",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animat · 15-60s",
    "studio_create_type_video_label": "Video",
    "studio_create_type_video_desc": "16:9 · peisaj",
    "studio_create_type_ad_label": "Reclamă",
    "studio_create_type_ad_desc": "Creativă FB/IG",
    "studio_more_title": "Mai multe",
    "studio_more_sub": "Setări, cont și alte instrumente.",
    "studio_more_settings": "Setări cont",
    "studio_more_notifications": "Notificări",
    "studio_more_plan": "Plan & facturare",
    "studio_more_invite": "Invită prieteni",
    "studio_more_redeem": "Răscumpără un coupon",
    "studio_more_ai": "Magie AI",
    "studio_more_privacy": "Confidențialitate",
    "studio_more_help": "Ajutor & Blog",
    "studio_more_logout": "Deconectare",
    "studio_nav_create": "Creează",
    "studio_nav_mine": "Desenele mele",
    "studio_nav_templates": "Șabloane",
    "studio_nav_community": "Comunitate",
    "studio_nav_more": "Mai multe",
    "studio_nav_home": "Acasă",
    "studio_nav_projects": "Proiecte",
    "studio_nav_ai_magic": "Magie AI",
    "studio_nav_business": "Business",
    "studio_nav_create_aria": "Creează un nou design",
    "studio_team_title": "Business — spațiu de lucru în echipă",
    "studio_team_sub": "Invită colegi să colaboreze. Max. 10 membri pe echipă.",
    "studio_team_load_fail": "Nu s-a putut încărca echipa",
    "studio_team_create_title": "Creează o nouă echipă",
    "studio_team_create_sub": "Devii proprietar și poți invita membri.",
    "studio_team_name_placeholder": "Numele echipei",
    "studio_team_create_btn": "Creează",
    "studio_team_join_title": "Alătură-te cu un cod de invitație existent",
    "studio_team_join_sub": "Dacă cineva ți-a trimis un cod de invitație.",
    "studio_team_invite_code_placeholder": "Cod de invitație",
    "studio_team_join_btn": "Alătură-te",
    "studio_team_created": "Echipa a fost creată",
    "studio_team_failed": "A eșuat",
    "studio_team_joined": "Echipa a fost alăturată",
    "studio_team_invite_invalid": "Invitație invalidă",
    "studio_team_member_one": "membru",
    "studio_team_members_many": "membri",
    "studio_team_you_are_owner": "· ești proprietar",
    "studio_team_leave_btn": "Părăsește",
    "studio_team_confirm_leave": "Chiar vrei să părăsești echipa?",
    "studio_team_left": "A părăsit echipa",
    "studio_team_invite_title": "Invită un nou membru",
    "studio_team_invite_email_placeholder": "email@example.com",
    "studio_team_send_invite": "Trimite invitația",
    "studio_team_invite_copied": "Linkul de invitație a fost copiat în clipboard",
    "studio_team_auto_copy_hint": "Linkul de invitație este copiat automat în clipboard.",
    "studio_team_members_header": "Membri",
    "studio_team_owner_badge": "Proprietar",
    "studio_team_pending_header": "Invitații în așteptare",
    "studio_team_expires": "Expiră"
  },
  "bg": {
    "studio_editor_back": "Назад",
    "studio_editor_untitled": "Без заглавие",
    "studio_editor_credits_view": "Преглед на кредита",
    "studio_editor_credits_label": "Кредити",
    "studio_editor_credits_unlimited": "∞ Неограничен",
    "studio_editor_smart_resize": "Умен размер",
    "studio_editor_quick_reel": "Бърз клип",
    "studio_editor_quick_reel_title": "Автоматично анимирайте всеки елемент за 15-секунден клип",
    "studio_editor_save": "Запази",
    "studio_editor_export_png": "Експорт на PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Експорт на анимирано видео",
    "studio_editor_mp4_title_need_anim": "Добавете анимация първо",
    "studio_editor_rail_magic": "Магия",
    "studio_editor_rail_text": "Текст",
    "studio_editor_rail_shapes": "Форми",
    "studio_editor_rail_images": "Изображения",
    "studio_editor_rail_anim": "Анимирайте",
    "studio_editor_rail_layers": "Слоеве",
    "studio_editor_close_panel": "Затвори панела",
    "studio_editor_close_props": "Затвори свойства",
    "studio_editor_open_props": "Отвори свойства",
    "studio_editor_director_title": "AI Режисьор на клипове — еднократен",
    "studio_editor_director_sub": "Едно изречение → пълен анимиран клип (~10с).",
    "studio_editor_magic_title": "AI Магия — URL → 5 реклами",
    "studio_editor_magic_placeholder": "https://вашият-сайт.com",
    "studio_editor_magic_generate": "Генерирай",
    "studio_editor_text_title": "Текст",
    "studio_editor_add_heading": "Добави заглавие",
    "studio_editor_shapes_title": "Форми",
    "studio_editor_rectangle": "Правоъгълник",
    "studio_editor_circle": "Кръг",
    "studio_editor_background_title": "Фон",
    "studio_editor_upload_title": "Качи изображение",
    "studio_editor_stock_btn": "Стокови снимки",
    "studio_editor_from_url": "От URL",
    "studio_editor_add": "Добави",
    "studio_editor_layers_title": "Слоеве",
    "studio_editor_canvas_empty": "Канва е празна.",
    "studio_editor_props_title": "Свойства",
    "studio_editor_select_element": "Изберете елемент за редактиране на свойствата.",
    "studio_editor_prop_text": "Текст",
    "studio_editor_prop_font": "Шрифт",
    "studio_editor_prop_size": "Размер",
    "studio_editor_prop_fill": "Запълване",
    "studio_editor_prop_opacity": "Непрозрачност",
    "studio_editor_duplicate": "Дублирайте",
    "studio_editor_delete": "Изтрий",
    "studio_editor_toast_offline_info": "Работите офлайн. Влезте, за да запазите и експортирате.",
    "studio_editor_toast_open_fail": "Неуспешно отваряне на редактора",
    "studio_editor_toast_image_fail": "Неуспешно зареждане на изображението",
    "studio_editor_toast_saved": "Запазено",
    "studio_editor_toast_save_fail": "Запазването не успя",
    "studio_editor_toast_log_in_save": "Влезте, за да запазите рекламата в облака.",
    "studio_editor_toast_add_elements_first": "Добавете няколко елемента първо, след това кликнете на Бързо руло.",
    "studio_editor_toast_need_animation": "Добавете поне една анимация първо (Анимирайте релса).",
    "studio_editor_toast_browser_no_video": "Вашият браузър не поддържа запис на видео.",
    "studio_editor_toast_video_fail": "Неуспешен експорт на видео",
    "studio_editor_toast_export_fail": "Неуспешен експорт",
    "studio_editor_toast_exported": "Експортирано!",
    "studio_editor_toast_exported_ext": "Експортирано .{ext}!",
    "studio_editor_toast_credits_out": "Нямате рекламни кредити.",
    "studio_editor_toast_credits_out_upsell": "Нямате рекламни кредити. Направете ъпгрейд до Pro за 30/месечно.",
    "studio_editor_toast_ai_fail": "AI Магията не успя",
    "studio_editor_toast_no_variants": "Не са намерени варианти",
    "studio_editor_toast_applied": "Приложено: {angle}",
    "studio_editor_toast_quick_reel_done": "Бързо руло · {n} анимации · {s}с",
    "studio_editor_toast_smart_resize_done": "Създадоха се {n} сродни реклам{plural}",
    "studio_editor_toast_smart_resize_fail": "Неуспешно умно преоразмеряване",
    "studio_my_have_coupon": "Имате купон?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Използвайте",
    "studio_my_toast_credits_added": "+{amount} кредити добавени 🎉",
    "studio_my_toast_not_found": "Кодът не е намерен",
    "studio_my_toast_already": "Вече е използван",
    "studio_my_toast_expired": "Изтекъл или деактивиран",
    "studio_my_toast_redeem_fail": "Неуспешно използване",
    "studio_my_toast_load_fail": "Неуспешно зареждане на проекти",
    "studio_my_confirm_delete": "Изтриване на \"{title}\"?",
    "studio_my_title": "Моите дизайни",
    "studio_my_sub": "Всичките ви запазени проекти и експорти на едно място.",
    "studio_my_count_one": "{n} проект",
    "studio_my_count_many": "{n} проекта",
    "studio_my_instant_campaign": "Моментална кампания",
    "studio_my_new_ad": "Нов рекламен",
    "studio_my_login_to_see": "Влезте, за да видите запазените си реклами.",
    "studio_my_login": "Вход",
    "studio_my_loading": "Зареждане…",
    "studio_my_empty_title": "Няма реклами все още.",
    "studio_my_browse": "Разгледайте шаблони",
    "studio_my_badge_team": "Екип",
    "studio_my_badge_shared": "Споделено",
    "studio_my_edit": "Редактиране",
    "studio_gallery_filter_prefix": "Филтър",
    "studio_gallery_filter_cancel": "× изчисти",
    "studio_gallery_title": "Шаблони",
    "studio_gallery_lead": "Изберете начало. Редактирайте всичко.",
    "studio_gallery_search": "Търсене на шаблони…",
    "studio_gallery_loading_count": "Зареждане…",
    "studio_gallery_count_of": "{start}–{end} от {total} шаблона",
    "studio_gallery_pack_all": "Всички",
    "studio_gallery_pack_trending": "Тенденции",
    "studio_gallery_pack_ai": "Подобрено с AI",
    "studio_gallery_pack_editorial": "Редакционен",
    "studio_gallery_pack_video": "Видеоклипове",
    "studio_gallery_pack_free": "Безплатно",
    "studio_gallery_video_only": "Само видео",
    "studio_gallery_all_formats": "Всички формати",
    "studio_gallery_all_categories": "Всички категории",
    "studio_gallery_loading_templates": "Зареждане на шаблони…",
    "studio_gallery_no_match": "Няма шаблони, които отговарят на тези филтри.",
    "studio_gallery_opening": "Отваряне на редактора…",
    "studio_gallery_prev": "← Предишна",
    "studio_gallery_next": "Следваща →",
    "studio_gallery_page_of": "Страница {n} от {total}",
    "studio_gallery_type_post": "Пост",
    "studio_gallery_type_story": "История",
    "studio_gallery_type_reel": "Клип",
    "studio_gallery_type_video": "Видео",
    "studio_gallery_type_ad": "Реклама",
    "studio_landing_meta_title": "Студио — AI дизайни, видеа и reels за 60 секунди | TopRankPulse",
    "studio_landing_meta_desc": "Създавайте публикации, reels, видеа и реклами с AI. 1,600+ шаблона, експорт с едно кликване. Част от TopRankPulse.",
    "studio_landing_eyebrow": "НОВО · СТУДИО НА TOPRANKPULSE",
    "studio_landing_hero_title_a": "Създайте публикации, reels и видеа.",
    "studio_landing_hero_title_b": "За минути, не дни.",
    "studio_landing_hero_lead": "Изберете тип съдържание, шаблон или оставете AI да направи първата версия. Редактиране в редактор, подобен на Canva. Експорт в PNG / MP4 с едно кликване. Реклами, reels, истории, видеа и публикации — всичко на едно място.",
    "studio_landing_cta_start": "Започнете създаването",
    "studio_landing_cta_instant": "Моментална кампания — 25 реклами",
    "studio_landing_cta_browse": "Разгледайте шаблони",
    "studio_landing_kpi_projects": "Създадени проекти",
    "studio_landing_kpi_exports": "Изтеглени експорти",
    "studio_landing_kpi_templates": "Шаблони",
    "studio_landing_kpi_formats": "Рекламни формати",
    "studio_landing_features_title": "Студио. А не слайдшоу.",
    "studio_landing_features_sub": "Всичко, което наистина използва един маркетолог по представяне — един екран, без табове.",
    "studio_landing_feat_ai_title": "AI магия от URL",
    "studio_landing_feat_ai_text": "Поставете уебсайт, получете 5 пълни рекламни концепции — цветове на марката, заглавия, CTA, готови за печат шаблони.",
    "studio_landing_feat_type_title": "Пълна типография",
    "studio_landing_feat_type_text": "Шрифтове, тегла, интервали, контури, сенки. Текстови кутии, които се държат като Adobe, а не PowerPoint.",
    "studio_landing_feat_img_title": "AI + стокови изображения",
    "studio_landing_feat_img_text": "Генерирайте пикселно перфектни фонове с GPT Image 1. Unsplash и Pexels вградени.",
    "studio_landing_feat_brand_title": "Кит за марка",
    "studio_landing_feat_brand_text": "Заключете цветовете, шрифтовете, логата веднъж. Всяка нова реклама автоматично ги наследява.",
    "studio_landing_feat_resize_title": "Умен размер",
    "studio_landing_feat_resize_text": "Едно платно → 10 реклами, автоматично мащабирани за всеки формат. Изпратете цяла кампания с едно кликване.",
    "studio_landing_feat_wl_title": "Готово за брандиране",
    "studio_landing_feat_wl_text": "Създадено да бъде вградено. Поставете в портала на вашата агенция чрез iframe или API. Вашата марка, нашият двигател.",
    "studio_landing_formats_title": "10 рекламни формата. Едно платно.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Feed, Story, Reel.",
    "studio_landing_pricing_title": "Прост, ценообразуван на база кредити.",
    "studio_landing_pricing_sub": "Започнете безплатно. Разширявайте, когато кампаниите ви растат.",
    "studio_landing_pricing_extra": "Допълнителни реклами извън плана: €2.30 / кредит · анулирайте по всяко време",
    "studio_landing_price_free_credits": "3 реклами · еднократно",
    "studio_landing_price_starter_credits": "10 реклами / месец",
    "studio_landing_price_pro_credits": "30 реклами / месец",
    "studio_landing_price_agency_credits": "80 реклами / месец",
    "studio_landing_price_free_f1": "Всички 10 формата",
    "studio_landing_price_free_f2": "AI магия от URL",
    "studio_landing_price_free_f3": "PNG експорт",
    "studio_landing_price_free_f4": "Без кредитна карта",
    "studio_landing_price_starter_f1": "Всичко в безплатния план",
    "studio_landing_price_starter_f2": "Бранд комплект",
    "studio_landing_price_starter_f3": "Умен размер",
    "studio_landing_price_starter_f4": "Приоритетна опашка",
    "studio_landing_price_pro_f1": "Всичко в стартер плана",
    "studio_landing_price_pro_f2": "AI генериране на изображения (GPT Image 1)",
    "studio_landing_price_pro_f3": "Експорт на видео (в предстоящо)",
    "studio_landing_price_pro_f4": "Премахване на воден знак",
    "studio_landing_price_agency_f1": "Всичко в професионалния план",
    "studio_landing_price_agency_f2": "Местата за екип (в предстоящо)",
    "studio_landing_price_agency_f3": "Експорт с бяла етикетка",
    "studio_landing_price_agency_f4": "Посветена поддръжка",
    "studio_landing_price_free_cta": "Започнете безплатно",
    "studio_landing_price_starter_cta": "Вземете Стартер",
    "studio_landing_price_pro_cta": "Вземете Профи",
    "studio_landing_price_agency_cta": "Вземете Агенция",
    "studio_landing_price_most_popular": "Най-популярен",
    "studio_landing_final_title": "Изпратете първата си реклама тази вечер.",
    "studio_landing_final_sub": "Три безплатни реклами. Без карта. Два клика за публикуване.",
    "studio_landing_final_btn": "Отворете редактора",
    "studio_landing_footer": "Студио · част от",
    "studio_create_back_select": "← Назад към избора",
    "studio_create_new_prefix": "Нов",
    "studio_create_type_desc_suffix": "Изберете шаблон или започнете от празно платно.",
    "studio_create_opt_templates_title": "Изберете шаблон",
    "studio_create_opt_templates_sub": "Хиляди готови дизайни — редактиращи се",
    "studio_create_opt_blank_title": "Празно платно",
    "studio_create_opt_blank_sub": "Пълен контрол, празно платно",
    "studio_create_opt_ai_title": "AI Магия ✨",
    "studio_create_opt_ai_sub": "Опишете какво искате — AI създава първата версия",
    "studio_create_hub_eyebrow": "Какво създавате?",
    "studio_create_hub_title_a": "Нека да станем",
    "studio_create_hub_title_b": "креативни",
    "studio_create_hub_sub": "Изберете тип съдържание. Всеки предварително зададен шаблон отваря правилните размери и шаблони.",
    "studio_create_card_start": "Започнете",
    "studio_create_type_post_label": "Пост",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "История",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Рил",
    "studio_create_type_reel_desc": "9:16 анимирано · 15–60с",
    "studio_create_type_video_label": "Видео",
    "studio_create_type_video_desc": "16:9 · пейзаж",
    "studio_create_type_ad_label": "Реклама",
    "studio_create_type_ad_desc": "FB/IG рекламно съдържание",
    "studio_more_title": "Повече",
    "studio_more_sub": "Настройки, акаунт и други инструменти.",
    "studio_more_settings": "Настройки на акаунта",
    "studio_more_notifications": "Уведомления",
    "studio_more_plan": "План и фактуриране",
    "studio_more_invite": "Покани приятели",
    "studio_more_redeem": "Използвай ваучер",
    "studio_more_ai": "AI Магия",
    "studio_more_privacy": "Поверителност",
    "studio_more_help": "Помощ и Блог",
    "studio_more_logout": "Изход",
    "studio_nav_create": "Създай",
    "studio_nav_mine": "Моите дизайни",
    "studio_nav_templates": "Шаблони",
    "studio_nav_community": "Общество",
    "studio_nav_more": "Повече",
    "studio_nav_home": "Начало",
    "studio_nav_projects": "Проекти",
    "studio_nav_ai_magic": "AI Магия",
    "studio_nav_business": "Бизнес",
    "studio_nav_create_aria": "Създай нов дизайн",
    "studio_team_title": "Бизнес — екипно работно пространство",
    "studio_team_sub": "Покани колеги да работят заедно. Макс. 10 члена на екип.",
    "studio_team_load_fail": "Не можа да зареди екипа",
    "studio_team_create_title": "Създай нов екип",
    "studio_team_create_sub": "Ставаш собственик и можеш да поканиш членове.",
    "studio_team_name_placeholder": "Име на екипа",
    "studio_team_create_btn": "Създай",
    "studio_team_join_title": "Присъедини се с вече съществуваща покана",
    "studio_team_join_sub": "Ако някой ти е изпратил код за покана.",
    "studio_team_invite_code_placeholder": "Код за покана",
    "studio_team_join_btn": "Присъедини се",
    "studio_team_created": "Екипът е създаден",
    "studio_team_failed": "Неуспех",
    "studio_team_joined": "Присъедини се към екипа",
    "studio_team_invite_invalid": "Невалидна покана",
    "studio_team_member_one": "член",
    "studio_team_members_many": "членове",
    "studio_team_you_are_owner": "· вие сте собственик",
    "studio_team_leave_btn": "Напусни",
    "studio_team_confirm_leave": "Наистина ли искаш да напуснеш екипа?",
    "studio_team_left": "Напусна екипа",
    "studio_team_invite_title": "Покани нов член",
    "studio_team_invite_email_placeholder": "email@example.com",
    "studio_team_send_invite": "Изпрати покана",
    "studio_team_invite_copied": "Линкът за покана е копиран в клипборда",
    "studio_team_auto_copy_hint": "Линкът за покана е копиран автоматично в клипборда.",
    "studio_team_members_header": "Членове",
    "studio_team_owner_badge": "Собственик",
    "studio_team_pending_header": "Чакащи покани",
    "studio_team_expires": "Изтича"
  },
  "hr": {
    "studio_editor_back": "Natrag",
    "studio_editor_untitled": "Nepodpisana reklama",
    "studio_editor_credits_view": "Pogledajte knjigu kredita",
    "studio_editor_credits_label": "Krediti",
    "studio_editor_credits_unlimited": "∞ Neograničeno",
    "studio_editor_smart_resize": "Pametno promjena veličine",
    "studio_editor_quick_reel": "Brzi video",
    "studio_editor_quick_reel_title": "Automatski animirajte svaki element za 15-sekundni video",
    "studio_editor_save": "Spremi",
    "studio_editor_export_png": "Izvezi PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Izvezi animirani video",
    "studio_editor_mp4_title_need_anim": "Prvo dodajte animaciju",
    "studio_editor_rail_magic": "Čarolija",
    "studio_editor_rail_text": "Tekst",
    "studio_editor_rail_shapes": "Oblici",
    "studio_editor_rail_images": "Slike",
    "studio_editor_rail_anim": "Animiraj",
    "studio_editor_rail_layers": "Slojevi",
    "studio_editor_close_panel": "Zatvori panel",
    "studio_editor_close_props": "Zatvori svojstva",
    "studio_editor_open_props": "Otvori svojstva",
    "studio_editor_director_title": "AI Redatelj — jedan kadar",
    "studio_editor_director_sub": "Jedna rečenica → potpuni animirani video (~10s).",
    "studio_editor_magic_title": "AI Čarolija — URL → 5 reklama",
    "studio_editor_magic_placeholder": "https://vaša-stranica.com",
    "studio_editor_magic_generate": "Generiraj",
    "studio_editor_text_title": "Tekst",
    "studio_editor_add_heading": "Dodaj naslov",
    "studio_editor_shapes_title": "Oblici",
    "studio_editor_rectangle": "Pravokutnik",
    "studio_editor_circle": "Krug",
    "studio_editor_background_title": "Pozadina",
    "studio_editor_upload_title": "Prenesi sliku",
    "studio_editor_stock_btn": "Stock fotografije",
    "studio_editor_from_url": "Iz URL-a",
    "studio_editor_add": "Dodaj",
    "studio_editor_layers_title": "Slojevi",
    "studio_editor_canvas_empty": "Platno je prazno.",
    "studio_editor_props_title": "Svojstva",
    "studio_editor_select_element": "Odaberite element za uređivanje njegovih svojstava.",
    "studio_editor_prop_text": "Tekst",
    "studio_editor_prop_font": "Font",
    "studio_editor_prop_size": "Veličina",
    "studio_editor_prop_fill": "Ispuna",
    "studio_editor_prop_opacity": "Prozirnost",
    "studio_editor_duplicate": "Duplicit",
    "studio_editor_delete": "Izbriši",
    "studio_editor_toast_offline_info": "Radite offline. Prijavite se za spremanje i izvođenje.",
    "studio_editor_toast_open_fail": "Nije moguće otvoriti uređivač",
    "studio_editor_toast_image_fail": "Nije moguće učitati sliku",
    "studio_editor_toast_saved": "Spremjeno",
    "studio_editor_toast_save_fail": "Spremanje nije uspjelo",
    "studio_editor_toast_log_in_save": "Prijavite se da biste spremili svoju reklamu u oblak.",
    "studio_editor_toast_add_elements_first": "Prvo dodajte neke elemente, a zatim kliknite Brzi Reel.",
    "studio_editor_toast_need_animation": "Prvo dodajte barem jednu animaciju (Animiraj tračnicu).",
    "studio_editor_toast_browser_no_video": "Vaš preglednik ne podržava snimanje videa.",
    "studio_editor_toast_video_fail": "Izvoz videa nije uspio",
    "studio_editor_toast_export_fail": "Izvoz nije uspio",
    "studio_editor_toast_exported": "Izvezeno!",
    "studio_editor_toast_exported_ext": "Izvezeno .{ext}!",
    "studio_editor_toast_credits_out": "Istekli su krediti za reklamu.",
    "studio_editor_toast_credits_out_upsell": "Istekli su vam krediti za reklamu. Nadogradite na Pro za 30/mjesečno.",
    "studio_editor_toast_ai_fail": "AI čarolija nije uspjela",
    "studio_editor_toast_no_variants": "Nema vraćenih varijanti",
    "studio_editor_toast_applied": "Primijenjeno: {angle}",
    "studio_editor_toast_quick_reel_done": "Brzi Reel · {n} animacija · {s}s",
    "studio_editor_toast_smart_resize_done": "Stvoreno {n} srodnih reklama{plural}",
    "studio_editor_toast_smart_resize_fail": "Pametno promjenjivanje veličine nije uspjelo",
    "studio_my_have_coupon": "Imate kupon?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Iskoristi",
    "studio_my_toast_credits_added": "+{amount} kredita dodano 🎉",
    "studio_my_toast_not_found": "Kod nije pronađen",
    "studio_my_toast_already": "Već iskorišten",
    "studio_my_toast_expired": "Isteklo ili deaktivirano",
    "studio_my_toast_redeem_fail": "Iskorištavanje nije uspjelo",
    "studio_my_toast_load_fail": "Nije uspjelo učitati projekte",
    "studio_my_confirm_delete": "Izbrisati \"{title}\"?",
    "studio_my_title": "Moji dizajni",
    "studio_my_sub": "Svi vaši spremljeni projekti i izvozi na jednom mjestu.",
    "studio_my_count_one": "{n} projekt",
    "studio_my_count_many": "{n} projekti",
    "studio_my_instant_campaign": "Brza kampanja",
    "studio_my_new_ad": "Nova reklama",
    "studio_my_login_to_see": "Prijavite se da vidite svoje spremljene reklame.",
    "studio_my_login": "Prijava",
    "studio_my_loading": "Učitavanje…",
    "studio_my_empty_title": "Još nema reklama.",
    "studio_my_browse": "Istraži predloške",
    "studio_my_badge_team": "Tim",
    "studio_my_badge_shared": "Dijeljeno",
    "studio_my_edit": "Uredi",
    "studio_gallery_filter_prefix": "Filtriraj",
    "studio_gallery_filter_cancel": "× očisti",
    "studio_gallery_title": "Predlošci",
    "studio_gallery_lead": "Odaberite početak. Uredite bilo što.",
    "studio_gallery_search": "Pretraži predloške…",
    "studio_gallery_loading_count": "Učitavanje…",
    "studio_gallery_count_of": "{start}–{end} od {total} predložaka",
    "studio_gallery_pack_all": "Sve",
    "studio_gallery_pack_trending": "Trendovi",
    "studio_gallery_pack_ai": "Pokreće AI",
    "studio_gallery_pack_editorial": "Uređivački",
    "studio_gallery_pack_video": "Video Reels",
    "studio_gallery_pack_free": "Besplatno",
    "studio_gallery_video_only": "Samo video",
    "studio_gallery_all_formats": "Svi formati",
    "studio_gallery_all_categories": "Sve kategorije",
    "studio_gallery_loading_templates": "Učitavanje predložaka…",
    "studio_gallery_no_match": "Nema predložaka koji odgovaraju tim filtrima.",
    "studio_gallery_opening": "Otvaram uređivač…",
    "studio_gallery_prev": "← Prethodno",
    "studio_gallery_next": "Sljedeće →",
    "studio_gallery_page_of": "Stranica {n} od {total}",
    "studio_gallery_type_post": "Objava",
    "studio_gallery_type_story": "Priča",
    "studio_gallery_type_reel": "Reel",
    "studio_gallery_type_video": "Video",
    "studio_gallery_type_ad": "Reklama",
    "studio_landing_meta_title": "Studio — AI dizajni, reels i video u 60 sekundi | TopRankPulse",
    "studio_landing_meta_desc": "Kreirajte objave, reels, videe i oglase s AI. 1.600+ predložaka, izvoz jednim klikom. Dio TopRankPulsea.",
    "studio_landing_eyebrow": "NOVO · STUDIO BY TOPRANKPULSE",
    "studio_landing_hero_title_a": "Kreirajte objave, reels i videe.",
    "studio_landing_hero_title_b": "U minutama, ne danima.",
    "studio_landing_hero_lead": "Odaberite tip sadržaja, predložak ili dopustite AI da izradi prvu verziju. Uredite u editoru nalik Canvi. Izvezite PNG / MP4 jednim klikom. Oglasi, reels, priče, videi i objave — sve na jednom mjestu.",
    "studio_landing_cta_start": "Započnite s kreiranjem",
    "studio_landing_cta_instant": "Instant kampanja — 25 oglasa",
    "studio_landing_cta_browse": "Pretraži predloške",
    "studio_landing_kpi_projects": "Kreirani projekti",
    "studio_landing_kpi_exports": "Preuzeti eksporti",
    "studio_landing_kpi_templates": "Predlošci",
    "studio_landing_kpi_formats": "Formati oglasa",
    "studio_landing_features_title": "Studio. Ne prezentacija.",
    "studio_landing_features_sub": "Sve što stvarni marketinški stručnjak koristi — jedan ekran, bez kartica.",
    "studio_landing_feat_ai_title": "AI čarolija s URL-a",
    "studio_landing_feat_ai_text": "Zalijepite web stranicu, dobijte 5 cjelovitih ideja za oglase — boje brenda, naslovi, CTA, predloški spremni za isporuku.",
    "studio_landing_feat_type_title": "Potpuna tipografija",
    "studio_landing_feat_type_text": "Fontovi, težine, razmak, obrisi, sjene. Okviri za tekst koji se ponašaju poput Adobea, a ne PowerPointa.",
    "studio_landing_feat_img_title": "AI + slike s priloga",
    "studio_landing_feat_img_text": "Generirajte pozadine savršene piksela s GPT Image 1. Unsplash i Pexels integrirani.",
    "studio_landing_feat_brand_title": "Brand paket",
    "studio_landing_feat_brand_text": "Zaključajte svoje boje, fontove, logotipe jednokratno. Svaki novi oglas automatski ih nasljeđuje.",
    "studio_landing_feat_resize_title": "Pametno promjenjivanje veličine",
    "studio_landing_feat_resize_text": "Jedan platno → 10 srodnih oglasa automatski skaliranih na svaki format. Isporuka cjelokupne kampanje jednim klikom.",
    "studio_landing_feat_wl_title": "Pripremljeno za bijeli label",
    "studio_landing_feat_wl_text": "Dizajnirano za ugrađivanje. Umetnite u svoj agencijski portal putem iframe-a ili API-ja. Vaš brand, naš motor.",
    "studio_landing_formats_title": "10 formata oglasa. Jedno platno.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Feed, Priča, Reel.",
    "studio_landing_pricing_title": "Jednostavno, cjenovno temeljeno na kreditima.",
    "studio_landing_pricing_sub": "Započnite besplatno. Skalirajte kada vaša kampanja raste.",
    "studio_landing_pricing_extra": "Dodatni oglasi iznad plana: €2.30 / kredit · otkažite u bilo kojem trenutku",
    "studio_landing_price_free_credits": "3 oglasa · jednokratno",
    "studio_landing_price_starter_credits": "10 oglasa / mjesec",
    "studio_landing_price_pro_credits": "30 oglasa / mjesec",
    "studio_landing_price_agency_credits": "80 oglasa / mjesec",
    "studio_landing_price_free_f1": "Svi 10 formata",
    "studio_landing_price_free_f2": "AI čarolija s URL-a",
    "studio_landing_price_free_f3": "PNG eksport",
    "studio_landing_price_free_f4": "Bez kreditne kartice",
    "studio_landing_price_starter_f1": "Sve u Besplatnom",
    "studio_landing_price_starter_f2": "Set brenda",
    "studio_landing_price_starter_f3": "Pametno prilagođavanje",
    "studio_landing_price_starter_f4": "Prioritetna lista",
    "studio_landing_price_pro_f1": "Sve u Starteru",
    "studio_landing_price_pro_f2": "AI generacija slika (GPT slika 1)",
    "studio_landing_price_pro_f3": "Izvoz videa (uskoro)",
    "studio_landing_price_pro_f4": "Ukloni vodeni žig",
    "studio_landing_price_agency_f1": "Sve u Pro",
    "studio_landing_price_agency_f2": "Tim mjesta (uskoro)",
    "studio_landing_price_agency_f3": "Izvoz bez oznake",
    "studio_landing_price_agency_f4": "Posvećena podrška",
    "studio_landing_price_free_cta": "Započni besplatno",
    "studio_landing_price_starter_cta": "Nabavite Starter",
    "studio_landing_price_pro_cta": "Nabavite Pro",
    "studio_landing_price_agency_cta": "Nabavite Agenciju",
    "studio_landing_price_most_popular": "Najpopularnije",
    "studio_landing_final_title": "Objavite svoju prvu reklamu večeras.",
    "studio_landing_final_sub": "Tri besplatne reklame. Bez kartice. Dva klika za objavu.",
    "studio_landing_final_btn": "Otvorite uređivač",
    "studio_landing_footer": "Studio · dio od",
    "studio_create_back_select": "← Natrag na izbore",
    "studio_create_new_prefix": "Novo",
    "studio_create_type_desc_suffix": "Odaberite predložak ili započnite od praznog platna.",
    "studio_create_opt_templates_title": "Odaberite predložak",
    "studio_create_opt_templates_sub": "Stotine gotovih dizajna — uređivih",
    "studio_create_opt_blank_title": "Prazno platno",
    "studio_create_opt_blank_sub": "Potpuna kontrola, prazno platno",
    "studio_create_opt_ai_title": "AI Magija ✨",
    "studio_create_opt_ai_sub": "Opisujte što želite — AI stvara prvu verziju",
    "studio_create_hub_eyebrow": "Što stvarate?",
    "studio_create_hub_title_a": "Započnimo",
    "studio_create_hub_title_b": "kreativno",
    "studio_create_hub_sub": "Odaberite tip sadržaja. Svaki unaprijed postavljeni izbor otvara prave dimenzije i predloške.",
    "studio_create_card_start": "Započni",
    "studio_create_type_post_label": "Objava",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Priča",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animirano · 15–60s",
    "studio_create_type_video_label": "Video",
    "studio_create_type_video_desc": "16:9 · pejzažno",
    "studio_create_type_ad_label": "Oglas",
    "studio_create_type_ad_desc": "FB/IG oglasni kreator",
    "studio_more_title": "Više",
    "studio_more_sub": "Postavke, račun i ostali alati.",
    "studio_more_settings": "Postavke računa",
    "studio_more_notifications": "Obavijesti",
    "studio_more_plan": "Plan i naplata",
    "studio_more_invite": "Pozovi prijatelje",
    "studio_more_redeem": "Iskoristi kupon",
    "studio_more_ai": "AI Magija",
    "studio_more_privacy": "Privatnost",
    "studio_more_help": "Pomoć i Blog",
    "studio_more_logout": "Odjavi se",
    "studio_nav_create": "Kreiraj",
    "studio_nav_mine": "Moji dizajni",
    "studio_nav_templates": "Predlošci",
    "studio_nav_community": "Zajednica",
    "studio_nav_more": "Više",
    "studio_nav_home": "Početna",
    "studio_nav_projects": "Projekti",
    "studio_nav_ai_magic": "AI Magija",
    "studio_nav_business": "Posao",
    "studio_nav_create_aria": "Kreiraj novi dizajn",
    "studio_team_title": "Posao — timski radni prostor",
    "studio_team_sub": "Pozovi kolege da rade zajedno. Maks. 10 članova po timu.",
    "studio_team_load_fail": "Nije moguće učitati tim",
    "studio_team_create_title": "Kreiraj novi tim",
    "studio_team_create_sub": "Postaješ vlasnik i možeš pozvati članove.",
    "studio_team_name_placeholder": "Ime tima",
    "studio_team_create_btn": "Kreiraj",
    "studio_team_join_title": "Pridruži se s postojećim pozivom",
    "studio_team_join_sub": "Ako ti je netko poslao pozivni kod.",
    "studio_team_invite_code_placeholder": "Pozivni kod",
    "studio_team_join_btn": "Pridruži se",
    "studio_team_created": "Tim kreiran",
    "studio_team_failed": "Neuspješno",
    "studio_team_joined": "Pridružen timu",
    "studio_team_invite_invalid": "Poziv nevažeći",
    "studio_team_member_one": "član",
    "studio_team_members_many": "članovi",
    "studio_team_you_are_owner": "· ti si vlasnik",
    "studio_team_leave_btn": "Odlazak",
    "studio_team_confirm_leave": "Zaista želiš napustiti tim?",
    "studio_team_left": "Napustio tim",
    "studio_team_invite_title": "Pozovi novog člana",
    "studio_team_invite_email_placeholder": "email@primjer.com",
    "studio_team_send_invite": "Pošalji poziv",
    "studio_team_invite_copied": "Veza za poziv kopirana u međuspremnik",
    "studio_team_auto_copy_hint": "Veza za poziv je automatski kopirana u međuspremnik.",
    "studio_team_members_header": "Članovi",
    "studio_team_owner_badge": "Vlasnik",
    "studio_team_pending_header": "Na čekanju pozivi",
    "studio_team_expires": "Ima rok"
  },
  "uk": {
    "studio_editor_back": "Назад",
    "studio_editor_untitled": "Без заголовка",
    "studio_editor_credits_view": "Переглянути баланс кредитів",
    "studio_editor_credits_label": "Кредити",
    "studio_editor_credits_unlimited": "∞ Безлімітні",
    "studio_editor_smart_resize": "Розумне зміщення",
    "studio_editor_quick_reel": "Швидке відео",
    "studio_editor_quick_reel_title": "Авто-анімація кожного елемента для 15-секундного відео",
    "studio_editor_save": "Зберегти",
    "studio_editor_export_png": "Експортувати PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Експортувати анімоване відео",
    "studio_editor_mp4_title_need_anim": "Спочатку додайте анімацію",
    "studio_editor_rail_magic": "Чарівність",
    "studio_editor_rail_text": "Текст",
    "studio_editor_rail_shapes": "Фігури",
    "studio_editor_rail_images": "Зображення",
    "studio_editor_rail_anim": "Анімувати",
    "studio_editor_rail_layers": "Шари",
    "studio_editor_close_panel": "Закрити панель",
    "studio_editor_close_props": "Закрити властивості",
    "studio_editor_open_props": "Відкрити властивості",
    "studio_editor_director_title": "AI Режисер Відео — одного разу",
    "studio_editor_director_sub": "Одне речення → повне анімоване відео (~10с).",
    "studio_editor_magic_title": "AI Чарівність — URL → 5 оголошень",
    "studio_editor_magic_placeholder": "https://ваш-сайт.com",
    "studio_editor_magic_generate": "Генерувати",
    "studio_editor_text_title": "Текст",
    "studio_editor_add_heading": "Додати заголовок",
    "studio_editor_shapes_title": "Фігури",
    "studio_editor_rectangle": "Прямокутник",
    "studio_editor_circle": "Коло",
    "studio_editor_background_title": "Фон",
    "studio_editor_upload_title": "Завантажити зображення",
    "studio_editor_stock_btn": "Стокові фото",
    "studio_editor_from_url": "З URL",
    "studio_editor_add": "Додати",
    "studio_editor_layers_title": "Шари",
    "studio_editor_canvas_empty": "Полотно порожнє.",
    "studio_editor_props_title": "Властивості",
    "studio_editor_select_element": "Виберіть елемент для редагування його властивостей.",
    "studio_editor_prop_text": "Текст",
    "studio_editor_prop_font": "Шрифт",
    "studio_editor_prop_size": "Розмір",
    "studio_editor_prop_fill": "Заливка",
    "studio_editor_prop_opacity": "Прозорість",
    "studio_editor_duplicate": "Дублювати",
    "studio_editor_delete": "Видалити",
    "studio_editor_toast_offline_info": "Ви працюєте офлайн. Увійдіть, щоб зберегти та експортувати.",
    "studio_editor_toast_open_fail": "Не вдалося відкрити редактор",
    "studio_editor_toast_image_fail": "Не вдалося завантажити зображення",
    "studio_editor_toast_saved": "Збережено",
    "studio_editor_toast_save_fail": "Не вдалось зберегти",
    "studio_editor_toast_log_in_save": "Увійдіть, щоб зберегти вашу рекламу в хмарі.",
    "studio_editor_toast_add_elements_first": "Спочатку додайте деякі елементи, а потім натисніть Швидкий ролик.",
    "studio_editor_toast_need_animation": "Спочатку додайте принаймні одну анімацію (Анімувати рейку).",
    "studio_editor_toast_browser_no_video": "Ваш браузер не підтримує запис відео.",
    "studio_editor_toast_video_fail": "Експорт відео не вдався",
    "studio_editor_toast_export_fail": "Експорт не вдався",
    "studio_editor_toast_exported": "Експортувалось!",
    "studio_editor_toast_exported_ext": "Експортувалось .{ext}!",
    "studio_editor_toast_credits_out": "Вичерпані рекламні кредити.",
    "studio_editor_toast_credits_out_upsell": "У вас вичерпані рекламні кредити. Увійдіть в Pro за 30/місяць.",
    "studio_editor_toast_ai_fail": "Не вдалось виконати AI Magic",
    "studio_editor_toast_no_variants": "Не повернено жодних варіантів",
    "studio_editor_toast_applied": "Застосовано: {angle}",
    "studio_editor_toast_quick_reel_done": "Швидкий ролик · {n} анімацій · {s}с",
    "studio_editor_toast_smart_resize_done": "Створено {n} сестринську рекламу{plural}",
    "studio_editor_toast_smart_resize_fail": "Не вдалось виконати розумний розмір",
    "studio_my_have_coupon": "Є купон?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Обміняти",
    "studio_my_toast_credits_added": "+{amount} кредитів додано 🎉",
    "studio_my_toast_not_found": "Код не знайдено",
    "studio_my_toast_already": "Вже обміняно",
    "studio_my_toast_expired": "Термін дії завершено або деактивовано",
    "studio_my_toast_redeem_fail": "Не вдалось обміняти",
    "studio_my_toast_load_fail": "Не вдалося завантажити проекти",
    "studio_my_confirm_delete": "Видалити \"{title}\"?",
    "studio_my_title": "Мої дизайни",
    "studio_my_sub": "Усі ваші збережені проекти та експорти в одному місці.",
    "studio_my_count_one": "{n} проект",
    "studio_my_count_many": "{n} проекти",
    "studio_my_instant_campaign": "Миттєва кампанія",
    "studio_my_new_ad": "Нове оголошення",
    "studio_my_login_to_see": "Увійдіть, щоб побачити свої збережені оголошення.",
    "studio_my_login": "Увійти",
    "studio_my_loading": "Завантаження…",
    "studio_my_empty_title": "Ще немає оголошень.",
    "studio_my_browse": "Переглянути шаблони",
    "studio_my_badge_team": "Команда",
    "studio_my_badge_shared": "Спільно",
    "studio_my_edit": "Редагувати",
    "studio_gallery_filter_prefix": "Фільтр",
    "studio_gallery_filter_cancel": "× очистити",
    "studio_gallery_title": "Шаблони",
    "studio_gallery_lead": "Обрати початок. Редагувати все.",
    "studio_gallery_search": "Шукати шаблони…",
    "studio_gallery_loading_count": "Завантаження…",
    "studio_gallery_count_of": "{start}–{end} із {total} шаблонів",
    "studio_gallery_pack_all": "Усі",
    "studio_gallery_pack_trending": "Популярні",
    "studio_gallery_pack_ai": "На базі AI",
    "studio_gallery_pack_editorial": "Редакційні",
    "studio_gallery_pack_video": "Відеоролики",
    "studio_gallery_pack_free": "Безкоштовно",
    "studio_gallery_video_only": "Тільки відео",
    "studio_gallery_all_formats": "Усі формати",
    "studio_gallery_all_categories": "Усі категорії",
    "studio_gallery_loading_templates": "Завантаження шаблонів…",
    "studio_gallery_no_match": "Немає шаблонів, які відповідають цим фільтрам.",
    "studio_gallery_opening": "Відкриваю редактор…",
    "studio_gallery_prev": "← Попередня",
    "studio_gallery_next": "Далі →",
    "studio_gallery_page_of": "Сторінка {n} з {total}",
    "studio_gallery_type_post": "Пост",
    "studio_gallery_type_story": "Історія",
    "studio_gallery_type_reel": "Ріл",
    "studio_gallery_type_video": "Відео",
    "studio_gallery_type_ad": "Оголошення",
    "studio_landing_meta_title": "Студія — AI дизайни, рекламні ролики та відео за 60 секунд | TopRankPulse",
    "studio_landing_meta_desc": "Створюйте пости, ролики, відео та рекламу за допомогою AI. 1600+ шаблонів, експорт в один клік. Частина TopRankPulse.",
    "studio_landing_eyebrow": "НОВИНКА · СТУДІЯ ВІД TOPRANKPULSE",
    "studio_landing_hero_title_a": "Створюйте пости, ролики та відео.",
    "studio_landing_hero_title_b": "За хвилини, а не дні.",
    "studio_landing_hero_lead": "Виберіть тип контенту, шаблон або дозвольте AI створити першу версію. Редагуйте в редакторі, як у Canva. Експортуйте PNG / MP4 в один клік. Реклама, ролики, історії, відео та пости — все в одному.",
    "studio_landing_cta_start": "Почати створення",
    "studio_landing_cta_instant": "Миттєва кампанія — 25 оголошень",
    "studio_landing_cta_browse": "Переглянути шаблони",
    "studio_landing_kpi_projects": "Створених проектів",
    "studio_landing_kpi_exports": "Завантажених експортів",
    "studio_landing_kpi_templates": "Шаблони",
    "studio_landing_kpi_formats": "Формати реклами",
    "studio_landing_features_title": "Студія. Не слайд-шоу.",
    "studio_landing_features_sub": "Все, що насправді використовує маркетолог з продуктивності — один екран, ніяких вкладок.",
    "studio_landing_feat_ai_title": "AI магія з URL",
    "studio_landing_feat_ai_text": "Вставте веб-сайт, отримайте 5 повних концепцій реклами — кольори бренду, заголовки, CTA, готові до відправки макети.",
    "studio_landing_feat_type_title": "Повна типографіка",
    "studio_landing_feat_type_text": "Шрифти, ваги, трекінг, обводки, тіні. Текстові поля, що поводяться як Adobe, а не PowerPoint.",
    "studio_landing_feat_img_title": "AI + стокові зображення",
    "studio_landing_feat_img_text": "Генеруйте піксельні фони з GPT Image 1. Вбудовані Unsplash та Pexels.",
    "studio_landing_feat_brand_title": "Брендовий набір",
    "studio_landing_feat_brand_text": "Зарезервуйте свої кольори, шрифти, логотипи один раз. Кожне нове оголошення автоматично успадковує їх.",
    "studio_landing_feat_resize_title": "Розумне масштабування",
    "studio_landing_feat_resize_text": "Один макет → 10 оголошень-сусідів, автоматично масштабованих під кожен формат. Відправте повну кампанію в один клік.",
    "studio_landing_feat_wl_title": "Готовий до білого етикетування",
    "studio_landing_feat_wl_text": "Розроблено для вбудовування. Вставте у свій агентський портал через iframe або API. Ваш бренд, наш двигун.",
    "studio_landing_formats_title": "10 форматів реклами. Один макет.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Стрічка, історія, ролик.",
    "studio_landing_pricing_title": "Проста, кредитна ціна.",
    "studio_landing_pricing_sub": "Почніть безкоштовно. Масштабуйте, коли ваші кампанії ростуть.",
    "studio_landing_pricing_extra": "Додаткові оголошення за межами плану: €2.30 / кредит · скасувати в будь-який час",
    "studio_landing_price_free_credits": "3 оголошення · одноразово",
    "studio_landing_price_starter_credits": "10 оголошень / місяць",
    "studio_landing_price_pro_credits": "30 оголошень / місяць",
    "studio_landing_price_agency_credits": "80 оголошень / місяць",
    "studio_landing_price_free_f1": "Усі 10 форматів",
    "studio_landing_price_free_f2": "AI магія з URL",
    "studio_landing_price_free_f3": "Експорт PNG",
    "studio_landing_price_free_f4": "Без кредитної картки",
    "studio_landing_price_starter_f1": "Усе безкоштовно",
    "studio_landing_price_starter_f2": "Набір бренду",
    "studio_landing_price_starter_f3": "Смарт-розмір",
    "studio_landing_price_starter_f4": "Пріоритетна черга",
    "studio_landing_price_pro_f1": "Усе в Starter",
    "studio_landing_price_pro_f2": "Генерація зображень AI (GPT Image 1)",
    "studio_landing_price_pro_f3": "Експорт відео (скоро)",
    "studio_landing_price_pro_f4": "Прибрати водяний знак",
    "studio_landing_price_agency_f1": "Усе в Pro",
    "studio_landing_price_agency_f2": "Місця для команди (скоро)",
    "studio_landing_price_agency_f3": "Експорт без бренду",
    "studio_landing_price_agency_f4": "Присвячена підтримка",
    "studio_landing_price_free_cta": "Почати безкоштовно",
    "studio_landing_price_starter_cta": "Отримати Starter",
    "studio_landing_price_pro_cta": "Отримати Pro",
    "studio_landing_price_agency_cta": "Отримати Agency",
    "studio_landing_price_most_popular": "Найпопулярніше",
    "studio_landing_final_title": "Запустіть свою першу рекламу сьогодні ввечері.",
    "studio_landing_final_sub": "Три безкоштовні оголошення. Без картки. Два кліки для публікації.",
    "studio_landing_final_btn": "Відкрити редактор",
    "studio_landing_footer": "Студія · частина",
    "studio_create_back_select": "← Назад до вибору",
    "studio_create_new_prefix": "Новий",
    "studio_create_type_desc_suffix": "Оберіть шаблон або почніть з пустого полотна.",
    "studio_create_opt_templates_title": "Оберіть шаблон",
    "studio_create_opt_templates_sub": "Сотні готових дизайнів — редагованих",
    "studio_create_opt_blank_title": "Пусте полотно",
    "studio_create_opt_blank_sub": "Повний контроль, порожнє полотно",
    "studio_create_opt_ai_title": "AI Чарівність ✨",
    "studio_create_opt_ai_sub": "Опишіть, що ви хочете — AI створить першу версію",
    "studio_create_hub_eyebrow": "Що ви створюєте?",
    "studio_create_hub_title_a": "Давайте",
    "studio_create_hub_title_b": "творити",
    "studio_create_hub_sub": "Оберіть тип контенту. Кожен пресет відкриває правильні розміри та шаблони.",
    "studio_create_card_start": "Розпочати",
    "studio_create_type_post_label": "Пост",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Сторіс",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Рілс",
    "studio_create_type_reel_desc": "9:16 анімований · 15–60с",
    "studio_create_type_video_label": "Відео",
    "studio_create_type_video_desc": "16:9 · портретний",
    "studio_create_type_ad_label": "Реклама",
    "studio_create_type_ad_desc": "Креатив для FB/IG реклами",
    "studio_more_title": "Більше",
    "studio_more_sub": "Налаштування, обліковий запис та інші інструменти.",
    "studio_more_settings": "Налаштування облікового запису",
    "studio_more_notifications": "Сповіщення",
    "studio_more_plan": "План та виставлення рахунків",
    "studio_more_invite": "Запросити друзів",
    "studio_more_redeem": "Використати купон",
    "studio_more_ai": "AI Магія",
    "studio_more_privacy": "Конфіденційність",
    "studio_more_help": "Допомога та Блог",
    "studio_more_logout": "Вийти",
    "studio_nav_create": "Створити",
    "studio_nav_mine": "Мої дизайни",
    "studio_nav_templates": "Шаблони",
    "studio_nav_community": "Спільнота",
    "studio_nav_more": "Більше",
    "studio_nav_home": "Головна",
    "studio_nav_projects": "Проекти",
    "studio_nav_ai_magic": "AI Магія",
    "studio_nav_business": "Бізнес",
    "studio_nav_create_aria": "Створити новий дизайн",
    "studio_team_title": "Бізнес — командне робоче місце",
    "studio_team_sub": "Запросіть колег для спільної роботи. Макс. 10 учасників на команду.",
    "studio_team_load_fail": "Не вдалося завантажити команду",
    "studio_team_create_title": "Створити нову команду",
    "studio_team_create_sub": "Ви станете власником і зможете запрошувати учасників.",
    "studio_team_name_placeholder": "Назва команди",
    "studio_team_create_btn": "Створити",
    "studio_team_join_title": "Приєднатися за наявним запрошенням",
    "studio_team_join_sub": "Якщо хтось надіслав вам код запрошення.",
    "studio_team_invite_code_placeholder": "Код запрошення",
    "studio_team_join_btn": "Приєднатися",
    "studio_team_created": "Команда створена",
    "studio_team_failed": "Не вдалось",
    "studio_team_joined": "Приєднано до команди",
    "studio_team_invite_invalid": "Недійсне запрошення",
    "studio_team_member_one": "учасник",
    "studio_team_members_many": "учасники",
    "studio_team_you_are_owner": "· ви є власником",
    "studio_team_leave_btn": "Покинути",
    "studio_team_confirm_leave": "Справді покинути команду?",
    "studio_team_left": "Покинув команду",
    "studio_team_invite_title": "Запросити нового учасника",
    "studio_team_invite_email_placeholder": "email@example.com",
    "studio_team_send_invite": "Надіслати запрошення",
    "studio_team_invite_copied": "Посилання на запрошення скопійовано в буфер обміну",
    "studio_team_auto_copy_hint": "Посилання на запрошення автоматично скопійовано в буфер обміну.",
    "studio_team_members_header": "Учасники",
    "studio_team_owner_badge": "Власник",
    "studio_team_pending_header": "Очікують запрошення",
    "studio_team_expires": "Закінчується"
  },
  "tr": {
    "studio_editor_back": "Geri",
    "studio_editor_untitled": "Başlıksız reklam",
    "studio_editor_credits_view": "Kredileri görüntüle",
    "studio_editor_credits_label": "Krediler",
    "studio_editor_credits_unlimited": "∞ Sınırsız",
    "studio_editor_smart_resize": "Akıllı Yeniden Boyutlandır",
    "studio_editor_quick_reel": "Hızlı Reel",
    "studio_editor_quick_reel_title": "Her bir öğeyi otomatik olarak 15 saniyelik reel için animasyona geçir",
    "studio_editor_save": "Kaydet",
    "studio_editor_export_png": "PNG Olarak Dışa Aktar",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Animasyonlu videoyu dışa aktar",
    "studio_editor_mp4_title_need_anim": "Öncelikle bir animasyon ekle",
    "studio_editor_rail_magic": "Sihir",
    "studio_editor_rail_text": "Metin",
    "studio_editor_rail_shapes": "Şekiller",
    "studio_editor_rail_images": "Görseller",
    "studio_editor_rail_anim": "Animasyon",
    "studio_editor_rail_layers": "Katmanlar",
    "studio_editor_close_panel": "Paneli kapat",
    "studio_editor_close_props": "Özellikleri kapat",
    "studio_editor_open_props": "Özellikleri aç",
    "studio_editor_director_title": "AI Reel Yönetmeni — tek çekim",
    "studio_editor_director_sub": "Bir cümle → tam animasyonlu reel (~10s).",
    "studio_editor_magic_title": "AI Sihri — URL → 5 reklam",
    "studio_editor_magic_placeholder": "https://your-site.com",
    "studio_editor_magic_generate": "Oluştur",
    "studio_editor_text_title": "Metin",
    "studio_editor_add_heading": "Başlık ekle",
    "studio_editor_shapes_title": "Şekiller",
    "studio_editor_rectangle": "Dikdörtgen",
    "studio_editor_circle": "Çember",
    "studio_editor_background_title": "Arka Plan",
    "studio_editor_upload_title": "Görsel yükle",
    "studio_editor_stock_btn": "Stok fotoğraflar",
    "studio_editor_from_url": "URL'den",
    "studio_editor_add": "Ekle",
    "studio_editor_layers_title": "Katmanlar",
    "studio_editor_canvas_empty": "Tuval boş.",
    "studio_editor_props_title": "Özellikler",
    "studio_editor_select_element": "Düzenlemek için bir öğe seçin.",
    "studio_editor_prop_text": "Metin",
    "studio_editor_prop_font": "Yazı Tipi",
    "studio_editor_prop_size": "Boyut",
    "studio_editor_prop_fill": "Doldurma",
    "studio_editor_prop_opacity": "Şeffaflık",
    "studio_editor_duplicate": "Kopyala",
    "studio_editor_delete": "Sil",
    "studio_editor_toast_offline_info": "Çevrimdışısınız. Kaydetmek ve dışa aktarmak için giriş yapın.",
    "studio_editor_toast_open_fail": "Editör açılamadı",
    "studio_editor_toast_image_fail": "Görüntü yüklenemedi",
    "studio_editor_toast_saved": "Kaydedildi",
    "studio_editor_toast_save_fail": "Kaydetme başarısız",
    "studio_editor_toast_log_in_save": "Reklamınızı buluta kaydetmek için giriş yapın.",
    "studio_editor_toast_add_elements_first": "Önce bazı öğeler ekleyin, ardından Hızlı Reel'e tıklayın.",
    "studio_editor_toast_need_animation": "Önce en az bir animasyon ekleyin (Animasyon rayı).",
    "studio_editor_toast_browser_no_video": "Tarayıcınız video kaydını desteklemiyor.",
    "studio_editor_toast_video_fail": "Video dışa aktarma başarısız",
    "studio_editor_toast_export_fail": "Dışa aktarma başarısız",
    "studio_editor_toast_exported": "Dışa aktarıldı!",
    "studio_editor_toast_exported_ext": ".{ext} dışa aktarıldı!",
    "studio_editor_toast_credits_out": "Reklam kredileri tükendi.",
    "studio_editor_toast_credits_out_upsell": "Reklam krediniz bitti. Pro'ya geçiş yaparak 30/ay yükseltin.",
    "studio_editor_toast_ai_fail": "AI Büyüsü başarısız",
    "studio_editor_toast_no_variants": "Hiç variant dönmedi",
    "studio_editor_toast_applied": "Uygulandı: {angle}",
    "studio_editor_toast_quick_reel_done": "Hızlı Reel · {n} animasyon · {s}s",
    "studio_editor_toast_smart_resize_done": "{n} kardeş reklam oluşturuldu",
    "studio_editor_toast_smart_resize_fail": "Akıllı yeniden boyutlandırma başarısız",
    "studio_my_have_coupon": "Bir kuponunuz var mı?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Kullan",
    "studio_my_toast_credits_added": "+{amount} kredi eklendi 🎉",
    "studio_my_toast_not_found": "Kod bulunamadı",
    "studio_my_toast_already": "Zaten kullanıldı",
    "studio_my_toast_expired": "Süresi dolmuş veya devre dışı",
    "studio_my_toast_redeem_fail": "Kullanma başarısız",
    "studio_my_toast_load_fail": "Projeleri yükleme başarısız",
    "studio_my_confirm_delete": "\"{title}\" silinsin mi?",
    "studio_my_title": "Tasarımım",
    "studio_my_sub": "Tüm kaydedilmiş projeleriniz ve ihracatlarınız tek bir yerde.",
    "studio_my_count_one": "{n} proje",
    "studio_my_count_many": "{n} projeler",
    "studio_my_instant_campaign": "Anlık Kampanya",
    "studio_my_new_ad": "Yeni reklam",
    "studio_my_login_to_see": "Kaydedilmiş reklamlarınızı görmek için giriş yapın.",
    "studio_my_login": "Giriş yap",
    "studio_my_loading": "Yükleniyor…",
    "studio_my_empty_title": "Henüz reklam yok.",
    "studio_my_browse": "Şablonları göz at",
    "studio_my_badge_team": "Takım",
    "studio_my_badge_shared": "Paylaşılan",
    "studio_my_edit": "Düzenle",
    "studio_gallery_filter_prefix": "Filtre",
    "studio_gallery_filter_cancel": "× temizle",
    "studio_gallery_title": "Şablonlar",
    "studio_gallery_lead": "Bir başlangıç seçin. Her şeyi düzenleyin.",
    "studio_gallery_search": "Şablonları ara…",
    "studio_gallery_loading_count": "Yükleniyor…",
    "studio_gallery_count_of": "{start}–{end} / {total} şablon",
    "studio_gallery_pack_all": "Hepsi",
    "studio_gallery_pack_trending": "Trend",
    "studio_gallery_pack_ai": "AI Destekli",
    "studio_gallery_pack_editorial": "Editöryal",
    "studio_gallery_pack_video": "Video Kısa Filmleri",
    "studio_gallery_pack_free": "Ücretsiz",
    "studio_gallery_video_only": "Sadece video",
    "studio_gallery_all_formats": "Tüm formatlar",
    "studio_gallery_all_categories": "Tüm kategoriler",
    "studio_gallery_loading_templates": "Şablonlar yükleniyor…",
    "studio_gallery_no_match": "Bu filtrelere uyan şablon yok.",
    "studio_gallery_opening": "Düzenleyici açılıyor…",
    "studio_gallery_prev": "← Önceki",
    "studio_gallery_next": "Sonraki →",
    "studio_gallery_page_of": "Sayfa {n} / {total}",
    "studio_gallery_type_post": "Gönderi",
    "studio_gallery_type_story": "Hikaye",
    "studio_gallery_type_reel": "Kısa Film",
    "studio_gallery_type_video": "Video",
    "studio_gallery_type_ad": "Reklam",
    "studio_landing_meta_title": "Stüdyo — 60 saniyede AI tasarımları, video ve makaralar | TopRankPulse",
    "studio_landing_meta_desc": "AI ile gönderi, makaralar, videolar ve reklamlar oluşturun. 1.600'den fazla şablon, tek tıkla ihracat. TopRankPulse'ın bir parçası.",
    "studio_landing_eyebrow": "YENİ · TOPRANKPULSE STÜDYOSU",
    "studio_landing_hero_title_a": "Gönderi, makaralar ve videolar oluşturun.",
    "studio_landing_hero_title_b": "Dakikalar içinde, günler değil.",
    "studio_landing_hero_lead": "Bir içerik türü, bir şablon seçin veya AI'nın ilk taslağı oluşturmasına izin verin. Canva ile benzer bir düzenleyicide düzenleyin. Tek tıkla PNG / MP4 olarak dışa aktarın. Reklamlar, makaralar, hikayeler, videolar ve gönderiler — hepsi bir arada.",
    "studio_landing_cta_start": "Yaratmaya başlayın",
    "studio_landing_cta_instant": "Anlık Kampanya — 25 reklam",
    "studio_landing_cta_browse": "Şablonları gözden geçirin",
    "studio_landing_kpi_projects": "Oluşturulan projeler",
    "studio_landing_kpi_exports": "İndirilen dışa aktarım",
    "studio_landing_kpi_templates": "Şablonlar",
    "studio_landing_kpi_formats": "Reklam formatları",
    "studio_landing_features_title": "Bir stüdyo. Slayt gösterisi değil.",
    "studio_landing_features_sub": "Bir performans pazarlamacısının gerçekten kullandığı her şey — tek ekran, sekme yok.",
    "studio_landing_feat_ai_title": "URL'den AI Büyüsü",
    "studio_landing_feat_ai_text": "Bir web sitesi yapıştırın, 5 tam reklam konsepti alın — marka renkleri, başlıklar, CTA'lar, gönderilmeye hazır şablonlar.",
    "studio_landing_feat_type_title": "Tam tipografi",
    "studio_landing_feat_type_text": "Yazı tipleri, ağırlıklar, izleme, ana hatlar, gölge. Adobe gibi davranan metin kutuları, PowerPoint gibi değil.",
    "studio_landing_feat_img_title": "AI + stok görseller",
    "studio_landing_feat_img_text": "GPT Görüntü 1 ile piksel mükemmel arka planlar oluşturun. Unsplash ve Pexels entegre.",
    "studio_landing_feat_brand_title": "Marka kiti",
    "studio_landing_feat_brand_text": "Renklerinizi, yazı tiplerinizi, logolarınızı bir kez kilitleyin. Her yeni reklam otomatik olarak onları devralır.",
    "studio_landing_feat_resize_title": "Akıllı yeniden boyutlandırma",
    "studio_landing_feat_resize_text": "Bir şablon → Her formata otomatik ölçeklendirilmiş 10 kardeş reklam. Tek tıkla tam bir kampanya gönderin.",
    "studio_landing_feat_wl_title": "Beyaz etiket hazır",
    "studio_landing_feat_wl_text": "Gömülmek için tasarlandı. Ajans portalınıza iframe veya API ile ekleyin. Sizin markanız, bizim motorumuz.",
    "studio_landing_formats_title": "10 reklam formatı. Bir şablon.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Akış, Hikaye, Makaralar.",
    "studio_landing_pricing_title": "Basit, kredi bazlı fiyatlandırma.",
    "studio_landing_pricing_sub": "Ücretsiz başlayın. Kampanyalarınız büyüdükçe ölçeklenin.",
    "studio_landing_pricing_extra": "Planın ötesinde ek reklamlar: €2.30 / kredi · istediğiniz zaman iptal edin",
    "studio_landing_price_free_credits": "3 reklam · bir defalık",
    "studio_landing_price_starter_credits": "10 reklam / ay",
    "studio_landing_price_pro_credits": "30 reklam / ay",
    "studio_landing_price_agency_credits": "80 reklam / ay",
    "studio_landing_price_free_f1": "Tüm 10 format",
    "studio_landing_price_free_f2": "URL'den AI Büyüsü",
    "studio_landing_price_free_f3": "PNG dışa aktarma",
    "studio_landing_price_free_f4": "Kredi kartı yok",
    "studio_landing_price_starter_f1": "Ücretsizdeki her şey",
    "studio_landing_price_starter_f2": "Marka Kiti",
    "studio_landing_price_starter_f3": "Akıllı Yeniden Boyutlandırma",
    "studio_landing_price_starter_f4": "Öncelikli sıra",
    "studio_landing_price_pro_f1": "Starter'daki her şey",
    "studio_landing_price_pro_f2": "AI Görüntü Üretimi (GPT Görüntü 1)",
    "studio_landing_price_pro_f3": "Video dışa aktarımı (yakında)",
    "studio_landing_price_pro_f4": "Filigranı kaldır",
    "studio_landing_price_agency_f1": "Pro'daki her şey",
    "studio_landing_price_agency_f2": "Takım koltukları (yakında)",
    "studio_landing_price_agency_f3": "Beyaz etiketli dışa aktarma",
    "studio_landing_price_agency_f4": "Özel destek",
    "studio_landing_price_free_cta": "Ücretsiz başlayın",
    "studio_landing_price_starter_cta": "Starter'ı Al",
    "studio_landing_price_pro_cta": "Pro'yu Al",
    "studio_landing_price_agency_cta": "Ajansı Al",
    "studio_landing_price_most_popular": "En popüler",
    "studio_landing_final_title": "İlk ilanınızı bu gece yayınlayın.",
    "studio_landing_final_sub": "Üç ücretsiz ilan. Kart yok. Yayınlamak için iki tıklama.",
    "studio_landing_final_btn": "Editörü aç",
    "studio_landing_footer": "Stüdyo · parçası",
    "studio_create_back_select": "← Seçime geri",
    "studio_create_new_prefix": "Yeni",
    "studio_create_type_desc_suffix": "Bir şablon seçin veya boş bir tuvalden başlayın.",
    "studio_create_opt_templates_title": "Bir şablon seçin",
    "studio_create_opt_templates_sub": "Yüzlerce hazır tasarım — düzenlenebilir",
    "studio_create_opt_blank_title": "Boş tuval",
    "studio_create_opt_blank_sub": "Tam kontrol, boş tuval",
    "studio_create_opt_ai_title": "AI Büyüsü ✨",
    "studio_create_opt_ai_sub": "Ne istediğinizi tanımlayın — AI ilk versiyonu oluşturur",
    "studio_create_hub_eyebrow": "Ne yaratıyorsunuz?",
    "studio_create_hub_title_a": "Haydi",
    "studio_create_hub_title_b": "yaratıcı olalım",
    "studio_create_hub_sub": "Bir içerik türü seçin. Her ön ayar doğru boyutları ve şablonları açar.",
    "studio_create_card_start": "Başla",
    "studio_create_type_post_label": "Gönderi",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Hikaye",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animasyonlu · 15–60s",
    "studio_create_type_video_label": "Video",
    "studio_create_type_video_desc": "16:9 · yatay",
    "studio_create_type_ad_label": "Reklam",
    "studio_create_type_ad_desc": "FB/IG reklam tasarımı",
    "studio_more_title": "Daha Fazla",
    "studio_more_sub": "Ayarlar, hesap ve diğer araçlar.",
    "studio_more_settings": "Hesap ayarları",
    "studio_more_notifications": "Bildirimler",
    "studio_more_plan": "Plan & fatura",
    "studio_more_invite": "Arkadaşları davet et",
    "studio_more_redeem": "Kuponu kullan",
    "studio_more_ai": "AI Büyüsü",
    "studio_more_privacy": "Gizlilik",
    "studio_more_help": "Yardım & Blog",
    "studio_more_logout": "Çıkış yap",
    "studio_nav_create": "Oluştur",
    "studio_nav_mine": "Tasarımım",
    "studio_nav_templates": "Şablonlar",
    "studio_nav_community": "Topluluk",
    "studio_nav_more": "Daha Fazla",
    "studio_nav_home": "Ana Sayfa",
    "studio_nav_projects": "Projeler",
    "studio_nav_ai_magic": "AI Büyüsü",
    "studio_nav_business": "İş",
    "studio_nav_create_aria": "Yeni tasarım oluştur",
    "studio_team_title": "İş — takım çalışma alanı",
    "studio_team_sub": "Beraber çalışmak için meslektaşlarını davet et. Max. 10 üye ile sınırlı.",
    "studio_team_load_fail": "Takım yüklenemedi",
    "studio_team_create_title": "Yeni bir takım oluştur",
    "studio_team_create_sub": "Sahibi olursunuz ve üyeleri davet edebilirsiniz.",
    "studio_team_name_placeholder": "Takım adı",
    "studio_team_create_btn": "Oluştur",
    "studio_team_join_title": "Mevcut bir davet ile katıl",
    "studio_team_join_sub": "Eğer birisi size davet kodu gönderdiyse.",
    "studio_team_invite_code_placeholder": "Davet kodu",
    "studio_team_join_btn": "Katıl",
    "studio_team_created": "Takım oluşturuldu",
    "studio_team_failed": "Başarısız",
    "studio_team_joined": "Takıma katıldı",
    "studio_team_invite_invalid": "Davet geçersiz",
    "studio_team_member_one": "üye",
    "studio_team_members_many": "üyeler",
    "studio_team_you_are_owner": "· sahip sizsiniz",
    "studio_team_leave_btn": "Ayrıl",
    "studio_team_confirm_leave": "Gerçekten takımdan ayrılmak istiyor musunuz?",
    "studio_team_left": "Takımdan ayrıldı",
    "studio_team_invite_title": "Yeni bir üye davet et",
    "studio_team_invite_email_placeholder": "email@example.com",
    "studio_team_send_invite": "Davet gönder",
    "studio_team_invite_copied": "Davet bağlantısı panoya kopyalandı",
    "studio_team_auto_copy_hint": "Davet bağlantısı otomatik olarak panoya kopyalandı.",
    "studio_team_members_header": "Üyeler",
    "studio_team_owner_badge": "Sahip",
    "studio_team_pending_header": "Bekleyen davetler",
    "studio_team_expires": "Süresi doluyor"
  },
  "ja": {
    "studio_editor_back": "戻る",
    "studio_editor_untitled": "無題の広告",
    "studio_editor_credits_view": "クレジット台帳を見る",
    "studio_editor_credits_label": "クレジット",
    "studio_editor_credits_unlimited": "∞ 無制限",
    "studio_editor_smart_resize": "スマートリサイズ",
    "studio_editor_quick_reel": "クイックリール",
    "studio_editor_quick_reel_title": "15秒リール用にすべての要素を自動アニメーション",
    "studio_editor_save": "保存",
    "studio_editor_export_png": "PNGをエクスポート",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "アニメーション動画をエクスポート",
    "studio_editor_mp4_title_need_anim": "先にアニメーションを追加してください",
    "studio_editor_rail_magic": "マジック",
    "studio_editor_rail_text": "テキスト",
    "studio_editor_rail_shapes": "形状",
    "studio_editor_rail_images": "画像",
    "studio_editor_rail_anim": "アニメーション",
    "studio_editor_rail_layers": "レイヤー",
    "studio_editor_close_panel": "パネルを閉じる",
    "studio_editor_close_props": "プロパティを閉じる",
    "studio_editor_open_props": "プロパティを開く",
    "studio_editor_director_title": "AIリールディレクター — ワンショット",
    "studio_editor_director_sub": "1文 → 完全アニメーションリール（約10秒）。",
    "studio_editor_magic_title": "AIマジック — URL → 5つの広告",
    "studio_editor_magic_placeholder": "https://your-site.com",
    "studio_editor_magic_generate": "生成",
    "studio_editor_text_title": "テキスト",
    "studio_editor_add_heading": "見出しを追加",
    "studio_editor_shapes_title": "形状",
    "studio_editor_rectangle": "長方形",
    "studio_editor_circle": "円",
    "studio_editor_background_title": "背景",
    "studio_editor_upload_title": "画像をアップロード",
    "studio_editor_stock_btn": "ストック写真",
    "studio_editor_from_url": "URLから",
    "studio_editor_add": "追加",
    "studio_editor_layers_title": "レイヤー",
    "studio_editor_canvas_empty": "キャンバスは空です。",
    "studio_editor_props_title": "プロパティ",
    "studio_editor_select_element": "編集するプロパティを選択してください。",
    "studio_editor_prop_text": "テキスト",
    "studio_editor_prop_font": "フォント",
    "studio_editor_prop_size": "サイズ",
    "studio_editor_prop_fill": "塗りつぶし",
    "studio_editor_prop_opacity": "不透明度",
    "studio_editor_duplicate": "複製",
    "studio_editor_delete": "削除",
    "studio_editor_toast_offline_info": "オフラインで作業中です。ログインして保存およびエクスポートしてください。",
    "studio_editor_toast_open_fail": "エディタを開けませんでした",
    "studio_editor_toast_image_fail": "画像を読み込めませんでした",
    "studio_editor_toast_saved": "保存されました",
    "studio_editor_toast_save_fail": "保存に失敗しました",
    "studio_editor_toast_log_in_save": "クラウドに広告を保存するにはログインしてください。",
    "studio_editor_toast_add_elements_first": "最初にいくつかの要素を追加してから、クイックリールをクリックしてください。",
    "studio_editor_toast_need_animation": "最初に少なくとも1つのアニメーションを追加してください（アニメートレール）。",
    "studio_editor_toast_browser_no_video": "ブラウザが動画録画をサポートしていません。",
    "studio_editor_toast_video_fail": "動画のエクスポートに失敗しました",
    "studio_editor_toast_export_fail": "エクスポートに失敗しました",
    "studio_editor_toast_exported": "エクスポートされました！",
    "studio_editor_toast_exported_ext": ".{ext}としてエクスポートされました！",
    "studio_editor_toast_credits_out": "広告クレジットが不足しています。",
    "studio_editor_toast_credits_out_upsell": "広告クレジットが不足しています。Proにアップグレードすると月30で使用できます。",
    "studio_editor_toast_ai_fail": "AIマジックに失敗しました",
    "studio_editor_toast_no_variants": "バリアントが返されませんでした",
    "studio_editor_toast_applied": "適用済み: {angle}",
    "studio_editor_toast_quick_reel_done": "クイックリール · {n} アニメーション · {s}秒",
    "studio_editor_toast_smart_resize_done": "{n}の兄弟広告{plural}を作成しました",
    "studio_editor_toast_smart_resize_fail": "スマートリサイズに失敗しました",
    "studio_my_have_coupon": "クーポンをお持ちですか？",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "引き換える",
    "studio_my_toast_credits_added": "+{amount} クレジットを追加しました 🎉",
    "studio_my_toast_not_found": "コードが見つかりません",
    "studio_my_toast_already": "すでに引き換え済み",
    "studio_my_toast_expired": "期限切れまたは無効化されています",
    "studio_my_toast_redeem_fail": "引換えに失敗しました",
    "studio_my_toast_load_fail": "プロジェクトの読み込みに失敗しました",
    "studio_my_confirm_delete": "「{title}」を削除しますか？",
    "studio_my_title": "私のデザイン",
    "studio_my_sub": "すべての保存されたプロジェクトとエクスポートを一か所で管理。",
    "studio_my_count_one": "{n} プロジェクト",
    "studio_my_count_many": "{n} プロジェクト",
    "studio_my_instant_campaign": "即時キャンペーン",
    "studio_my_new_ad": "新しい広告",
    "studio_my_login_to_see": "保存した広告を見るにはログインしてください。",
    "studio_my_login": "ログイン",
    "studio_my_loading": "読み込み中…",
    "studio_my_empty_title": "広告はまだありません。",
    "studio_my_browse": "テンプレートを参照",
    "studio_my_badge_team": "チーム",
    "studio_my_badge_shared": "共有",
    "studio_my_edit": "編集",
    "studio_gallery_filter_prefix": "フィルター",
    "studio_gallery_filter_cancel": "× クリア",
    "studio_gallery_title": "テンプレート",
    "studio_gallery_lead": "スタートを選択。何でも編集。",
    "studio_gallery_search": "テンプレートを検索…",
    "studio_gallery_loading_count": "読み込み中…",
    "studio_gallery_count_of": "{start}–{end} / {total} テンプレート",
    "studio_gallery_pack_all": "すべて",
    "studio_gallery_pack_trending": "トレンド",
    "studio_gallery_pack_ai": "AI活用",
    "studio_gallery_pack_editorial": "エディトリアル",
    "studio_gallery_pack_video": "ビデオリール",
    "studio_gallery_pack_free": "無料",
    "studio_gallery_video_only": "ビデオのみ",
    "studio_gallery_all_formats": "すべてのフォーマット",
    "studio_gallery_all_categories": "すべてのカテゴリ",
    "studio_gallery_loading_templates": "テンプレートを読み込み中…",
    "studio_gallery_no_match": "そのフィルターに一致するテンプレートはありません。",
    "studio_gallery_opening": "エディターを開いています…",
    "studio_gallery_prev": "← 前へ",
    "studio_gallery_next": "次へ →",
    "studio_gallery_page_of": "ページ {n} / {total}",
    "studio_gallery_type_post": "投稿",
    "studio_gallery_type_story": "ストーリー",
    "studio_gallery_type_reel": "リール",
    "studio_gallery_type_video": "ビデオ",
    "studio_gallery_type_ad": "広告",
    "studio_landing_meta_title": "スタジオ — 60秒で作るAIデザイン、リール＆ビデオ | TopRankPulse",
    "studio_landing_meta_desc": "AIで投稿、リール、ビデオ、広告を作成します。1,600以上のテンプレート、ワンクリックエクスポート。TopRankPulseの一部です。",
    "studio_landing_eyebrow": "新着 · TOPRANKPULSEによるスタジオ",
    "studio_landing_hero_title_a": "投稿、リール、ビデオを作成。",
    "studio_landing_hero_title_b": "数分で、数日ではなく。",
    "studio_landing_hero_lead": "コンテンツタイプ、テンプレートを選ぶか、AIに初版をドラフトさせましょう。Canvaスタイルのエディタで編集。ワンクリックでPNG / MP4をエクスポート。広告、リール、ストーリー、ビデオ、投稿 — すべて一つに。",
    "studio_landing_cta_start": "作成を開始",
    "studio_landing_cta_instant": "インスタントキャンペーン — 25広告",
    "studio_landing_cta_browse": "テンプレートを参照",
    "studio_landing_kpi_projects": "作成されたプロジェクト",
    "studio_landing_kpi_exports": "ダウンロードされたエクスポート",
    "studio_landing_kpi_templates": "テンプレート",
    "studio_landing_kpi_formats": "広告フォーマット",
    "studio_landing_features_title": "スタジオ。スライドショーではない。",
    "studio_landing_features_sub": "パフォーマンスマーケターが実際に使用するすべて — 一画面、タブなし。",
    "studio_landing_feat_ai_title": "URLからのAIマジック",
    "studio_landing_feat_ai_text": "ウェブサイトを貼り付けると、5つの完全な広告コンセプトが得られます — ブランドカラー、見出し、CTA、発送準備完了のキャンバス。",
    "studio_landing_feat_type_title": "フルタイポグラフィ",
    "studio_landing_feat_type_text": "フォント、ウェイト、トラッキング、アウトライン、ドロップシャドウ。Adobeのように動作するテキストボックス、PowerPointではなく。",
    "studio_landing_feat_img_title": "AI + ストック画像",
    "studio_landing_feat_img_text": "GPT Image 1を使用してピクセルパーフェクトな背景を生成。UnsplashとPexelsが統合されています。",
    "studio_landing_feat_brand_title": "ブランドキット",
    "studio_landing_feat_brand_text": "カラー、フォント、ロゴを一度ロック。新しい広告は自動的にこれを引き継ぎます。",
    "studio_landing_feat_resize_title": "スマートリサイズ",
    "studio_landing_feat_resize_text": "1つのキャンバス → 10の兄弟広告がすべてのフォーマットに自動スケーリング。ワンクリックでフルキャンペーンを出荷。",
    "studio_landing_feat_wl_title": "ホワイトラベル対応",
    "studio_landing_feat_wl_text": "埋め込み用に構築されています。あなたの代理店ポータルにiframeまたはAPI経由でドロップ。あなたのブランド、私たちのエンジン。",
    "studio_landing_formats_title": "10の広告フォーマット。1つのキャンバス。",
    "studio_landing_formats_sub": "Facebook、Instagram、Googleディスプレイ、LinkedIn。フィード、ストーリー、リール。",
    "studio_landing_pricing_title": "シンプルなクレジットベースの価格設定。",
    "studio_landing_pricing_sub": "無料で開始。キャンペーンが拡大する際にスケール。",
    "studio_landing_pricing_extra": "プランを超える追加広告: €2.30 / クレジット · いつでもキャンセル可能",
    "studio_landing_price_free_credits": "3広告 · 一度限り",
    "studio_landing_price_starter_credits": "10広告 / 月",
    "studio_landing_price_pro_credits": "30広告 / 月",
    "studio_landing_price_agency_credits": "80広告 / 月",
    "studio_landing_price_free_f1": "すべての10フォーマット",
    "studio_landing_price_free_f2": "URLからのAIマジック",
    "studio_landing_price_free_f3": "PNGエクスポート",
    "studio_landing_price_free_f4": "クレジットカード不要",
    "studio_landing_price_starter_f1": "無料のすべて",
    "studio_landing_price_starter_f2": "ブランドキット",
    "studio_landing_price_starter_f3": "スマートリサイズ",
    "studio_landing_price_starter_f4": "優先キュー",
    "studio_landing_price_pro_f1": "スターターのすべて",
    "studio_landing_price_pro_f2": "AI画像生成 (GPT画像1)",
    "studio_landing_price_pro_f3": "ビデオエクスポート (近日公開)",
    "studio_landing_price_pro_f4": "透かしを削除",
    "studio_landing_price_agency_f1": "プロのすべて",
    "studio_landing_price_agency_f2": "チームシート (近日公開)",
    "studio_landing_price_agency_f3": "ホワイトラベルエクスポート",
    "studio_landing_price_agency_f4": "専用サポート",
    "studio_landing_price_free_cta": "無料で始める",
    "studio_landing_price_starter_cta": "スターターを取得",
    "studio_landing_price_pro_cta": "プロを取得",
    "studio_landing_price_agency_cta": "エージェンシーを取得",
    "studio_landing_price_most_popular": "最も人気",
    "studio_landing_final_title": "今夜、最初の広告を出稿しよう。",
    "studio_landing_final_sub": "無料広告3件。カード不要。2クリックで公開。",
    "studio_landing_final_btn": "エディタを開く",
    "studio_landing_footer": "スタジオ · の一部",
    "studio_create_back_select": "← 選択に戻る",
    "studio_create_new_prefix": "新しい",
    "studio_create_type_desc_suffix": "テンプレートを選ぶか、空白のキャンバスから始めます。",
    "studio_create_opt_templates_title": "テンプレートを選ぶ",
    "studio_create_opt_templates_sub": "編集可能な数百の既製デザイン",
    "studio_create_opt_blank_title": "空白のキャンバス",
    "studio_create_opt_blank_sub": "完全なコントロール、空のキャンバス",
    "studio_create_opt_ai_title": "AIマジック ✨",
    "studio_create_opt_ai_sub": "希望する内容を説明してください — AIが最初のバージョンを作成します",
    "studio_create_hub_eyebrow": "何を作成していますか？",
    "studio_create_hub_title_a": "クリエイティブに",
    "studio_create_hub_title_b": "なろう",
    "studio_create_hub_sub": "コンテンツタイプを選択します。各プリセットが適切な寸法とテンプレートを開きます。",
    "studio_create_card_start": "始める",
    "studio_create_type_post_label": "投稿",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "ストーリー",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "リール",
    "studio_create_type_reel_desc": "9:16 アニメーション · 15～60秒",
    "studio_create_type_video_label": "動画",
    "studio_create_type_video_desc": "16:9 · 横向き",
    "studio_create_type_ad_label": "広告",
    "studio_create_type_ad_desc": "FB/IG広告クリエイティブ",
    "studio_more_title": "もっと見る",
    "studio_more_sub": "設定、アカウント、その他のツール。",
    "studio_more_settings": "アカウント設定",
    "studio_more_notifications": "通知",
    "studio_more_plan": "プランと請求",
    "studio_more_invite": "友達を招待",
    "studio_more_redeem": "クーポンを利用",
    "studio_more_ai": "AIマジック",
    "studio_more_privacy": "プライバシー",
    "studio_more_help": "ヘルプ & ブログ",
    "studio_more_logout": "ログアウト",
    "studio_nav_create": "作成",
    "studio_nav_mine": "私のデザイン",
    "studio_nav_templates": "テンプレート",
    "studio_nav_community": "コミュニティ",
    "studio_nav_more": "もっと見る",
    "studio_nav_home": "ホーム",
    "studio_nav_projects": "プロジェクト",
    "studio_nav_ai_magic": "AIマジック",
    "studio_nav_business": "ビジネス",
    "studio_nav_create_aria": "新しいデザインを作成",
    "studio_team_title": "ビジネス — チームワークスペース",
    "studio_team_sub": "同僚を招待して一緒に作業。最大10名のメンバー。",
    "studio_team_load_fail": "チームを読み込めませんでした",
    "studio_team_create_title": "新しいチームを作成",
    "studio_team_create_sub": "あなたがオーナーになり、メンバーを招待できます。",
    "studio_team_name_placeholder": "チーム名",
    "studio_team_create_btn": "作成",
    "studio_team_join_title": "既存の招待で参加",
    "studio_team_join_sub": "誰かがあなたに招待コードを送った場合。",
    "studio_team_invite_code_placeholder": "招待コード",
    "studio_team_join_btn": "参加",
    "studio_team_created": "チームが作成されました",
    "studio_team_failed": "失敗しました",
    "studio_team_joined": "チームに参加しました",
    "studio_team_invite_invalid": "招待が無効です",
    "studio_team_member_one": "メンバー",
    "studio_team_members_many": "メンバー",
    "studio_team_you_are_owner": "・あなたはオーナーです",
    "studio_team_leave_btn": "退会",
    "studio_team_confirm_leave": "本当にチームを離れますか？",
    "studio_team_left": "チームを離れました",
    "studio_team_invite_title": "新しいメンバーを招待",
    "studio_team_invite_email_placeholder": "email@example.com",
    "studio_team_send_invite": "招待を送信",
    "studio_team_invite_copied": "招待リンクがクリップボードにコピーされました",
    "studio_team_auto_copy_hint": "招待リンクは自動的にクリップボードにコピーされます。",
    "studio_team_members_header": "メンバー",
    "studio_team_owner_badge": "オーナー",
    "studio_team_pending_header": "招待待ち",
    "studio_team_expires": "期限切れ"
  },
  "ko": {
    "studio_editor_back": "뒤로",
    "studio_editor_untitled": "제목 없는 광고",
    "studio_editor_credits_view": "크레딧 장부 보기",
    "studio_editor_credits_label": "크레딧",
    "studio_editor_credits_unlimited": "∞ 무제한",
    "studio_editor_smart_resize": "스마트 리사이즈",
    "studio_editor_quick_reel": "퀵 릴",
    "studio_editor_quick_reel_title": "15초 릴을 위해 모든 요소 자동 애니메이션",
    "studio_editor_save": "저장",
    "studio_editor_export_png": "PNG 내보내기",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "애니메이션 비디오 내보내기",
    "studio_editor_mp4_title_need_anim": "먼저 애니메이션 추가",
    "studio_editor_rail_magic": "매직",
    "studio_editor_rail_text": "텍스트",
    "studio_editor_rail_shapes": "도형",
    "studio_editor_rail_images": "이미지",
    "studio_editor_rail_anim": "애니메이션",
    "studio_editor_rail_layers": "레이어",
    "studio_editor_close_panel": "패널 닫기",
    "studio_editor_close_props": "속성 닫기",
    "studio_editor_open_props": "속성 열기",
    "studio_editor_director_title": "AI 릴 디렉터 — 원샷",
    "studio_editor_director_sub": "한 문장 → 전체 애니메이션 릴 (~10초).",
    "studio_editor_magic_title": "AI 매직 — URL → 5 광고",
    "studio_editor_magic_placeholder": "https://your-site.com",
    "studio_editor_magic_generate": "생성",
    "studio_editor_text_title": "텍스트",
    "studio_editor_add_heading": "헤딩 추가",
    "studio_editor_shapes_title": "도형",
    "studio_editor_rectangle": "사각형",
    "studio_editor_circle": "원",
    "studio_editor_background_title": "배경",
    "studio_editor_upload_title": "이미지 업로드",
    "studio_editor_stock_btn": "스톡 사진",
    "studio_editor_from_url": "URL에서",
    "studio_editor_add": "추가",
    "studio_editor_layers_title": "레이어",
    "studio_editor_canvas_empty": "캔버스가 비어 있습니다.",
    "studio_editor_props_title": "속성",
    "studio_editor_select_element": "편집할 요소를 선택하세요.",
    "studio_editor_prop_text": "텍스트",
    "studio_editor_prop_font": "폰트",
    "studio_editor_prop_size": "크기",
    "studio_editor_prop_fill": "채우기",
    "studio_editor_prop_opacity": "불투명도",
    "studio_editor_duplicate": "복제",
    "studio_editor_delete": "삭제",
    "studio_editor_toast_offline_info": "오프라인 상태입니다. 로그인하여 저장하고 내보내세요.",
    "studio_editor_toast_open_fail": "편집기를 열 수 없습니다.",
    "studio_editor_toast_image_fail": "이미지를 로드할 수 없습니다.",
    "studio_editor_toast_saved": "저장되었습니다.",
    "studio_editor_toast_save_fail": "저장 실패",
    "studio_editor_toast_log_in_save": "클라우드에 광고를 저장하려면 로그인하세요.",
    "studio_editor_toast_add_elements_first": "먼저 요소를 추가한 다음 Quick Reel을 클릭하세요.",
    "studio_editor_toast_need_animation": "먼저 최소한 하나의 애니메이션을 추가하세요 (애니메이션 레일).",
    "studio_editor_toast_browser_no_video": "귀하의 브라우저는 비디오 녹화를 지원하지 않습니다.",
    "studio_editor_toast_video_fail": "비디오 내보내기 실패",
    "studio_editor_toast_export_fail": "내보내기 실패",
    "studio_editor_toast_exported": "내보내기 완료!",
    "studio_editor_toast_exported_ext": ".{ext} 내보내기 완료!",
    "studio_editor_toast_credits_out": "광고 크레딧이 부족합니다.",
    "studio_editor_toast_credits_out_upsell": "광고 크레딧이 다 됐습니다. Pro로 업그레이드하여 월 30에 이용하세요.",
    "studio_editor_toast_ai_fail": "AI 매직 실패",
    "studio_editor_toast_no_variants": "변형이 반환되지 않았습니다.",
    "studio_editor_toast_applied": "적용됨: {angle}",
    "studio_editor_toast_quick_reel_done": "Quick Reel · {n} 애니메이션 · {s}초",
    "studio_editor_toast_smart_resize_done": "{n} 형제 광고{plural} 생성됨",
    "studio_editor_toast_smart_resize_fail": "스마트 크기 조정 실패",
    "studio_my_have_coupon": "쿠폰이 있나요?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "교환하기",
    "studio_my_toast_credits_added": "+{amount} 크레딧이 추가되었습니다 🎉",
    "studio_my_toast_not_found": "코드를 찾을 수 없습니다.",
    "studio_my_toast_already": "이미 교환되었습니다.",
    "studio_my_toast_expired": "만료되었거나 비활성화되었습니다.",
    "studio_my_toast_redeem_fail": "교환 실패",
    "studio_my_toast_load_fail": "프로젝트를 로드하는 데 실패했습니다.",
    "studio_my_confirm_delete": "\"{title}\"을 삭제하시겠습니까?",
    "studio_my_title": "내 디자인",
    "studio_my_sub": "모든 저장된 프로젝트와 내보내기가 한 곳에 있습니다.",
    "studio_my_count_one": "{n} 프로젝트",
    "studio_my_count_many": "{n} 프로젝트",
    "studio_my_instant_campaign": "즉시 캠페인",
    "studio_my_new_ad": "새 광고",
    "studio_my_login_to_see": "저장된 광고를 보려면 로그인하세요.",
    "studio_my_login": "로그인",
    "studio_my_loading": "로딩 중…",
    "studio_my_empty_title": "아직 광고가 없습니다.",
    "studio_my_browse": "템플릿 탐색",
    "studio_my_badge_team": "팀",
    "studio_my_badge_shared": "공유됨",
    "studio_my_edit": "편집",
    "studio_gallery_filter_prefix": "필터",
    "studio_gallery_filter_cancel": "× 지우기",
    "studio_gallery_title": "템플릿",
    "studio_gallery_lead": "시작을 선택하세요. 무엇이든 편집하세요.",
    "studio_gallery_search": "템플릿 검색…",
    "studio_gallery_loading_count": "로딩 중…",
    "studio_gallery_count_of": "{start}–{end} / {total} 템플릿",
    "studio_gallery_pack_all": "모든",
    "studio_gallery_pack_trending": "트렌드",
    "studio_gallery_pack_ai": "AI 기반",
    "studio_gallery_pack_editorial": "편집",
    "studio_gallery_pack_video": "비디오 릴",
    "studio_gallery_pack_free": "무료",
    "studio_gallery_video_only": "비디오만",
    "studio_gallery_all_formats": "모든 형식",
    "studio_gallery_all_categories": "모든 카테고리",
    "studio_gallery_loading_templates": "템플릿 로딩 중…",
    "studio_gallery_no_match": "해당 필터에 맞는 템플릿이 없습니다.",
    "studio_gallery_opening": "편집기 열기 중…",
    "studio_gallery_prev": "← 이전",
    "studio_gallery_next": "다음 →",
    "studio_gallery_page_of": "페이지 {n} / {total}",
    "studio_gallery_type_post": "게시물",
    "studio_gallery_type_story": "스토리",
    "studio_gallery_type_reel": "릴",
    "studio_gallery_type_video": "비디오",
    "studio_gallery_type_ad": "광고",
    "studio_landing_meta_title": "스튜디오 — 60초 만에 AI 디자인, 릴 및 비디오 제작 | TopRankPulse",
    "studio_landing_meta_desc": "AI로 게시물, 릴, 비디오 및 광고를 만드세요. 1,600개 이상의 템플릿, 원클릭 내보내기. TopRankPulse의 일부입니다.",
    "studio_landing_eyebrow": "NEW · TOPRANKPULSE의 스튜디오",
    "studio_landing_hero_title_a": "게시물, 릴 및 비디오 만들기.",
    "studio_landing_hero_title_b": "몇 분 만에, 며칠이 아니라.",
    "studio_landing_hero_lead": "콘텐츠 유형을 선택하거나 템플릿을 선택하거나 AI가 첫 번째 버전을 작성하도록 하세요. Canva 스타일의 편집기에서 수정 가능합니다. 한 번의 클릭으로 PNG / MP4 내보내기. 광고, 릴, 스토리, 비디오 및 게시물 — 모두 하나로.",
    "studio_landing_cta_start": "제작 시작",
    "studio_landing_cta_instant": "즉시 캠페인 — 25개 광고",
    "studio_landing_cta_browse": "템플릿 탐색",
    "studio_landing_kpi_projects": "생성된 프로젝트 수",
    "studio_landing_kpi_exports": "다운로드한 내보내기",
    "studio_landing_kpi_templates": "템플릿",
    "studio_landing_kpi_formats": "광고 형식",
    "studio_landing_features_title": "스튜디오. 슬라이드쇼가 아닙니다.",
    "studio_landing_features_sub": "퍼포먼스 마케터가 실제로 사용하는 모든 것 — 한 화면에, 탭 없음.",
    "studio_landing_feat_ai_title": "URL에서 AI 마법",
    "studio_landing_feat_ai_text": "웹사이트를 붙여넣으면 5개의 전체 광고 개념을 얻을 수 있습니다 — 브랜드 색상, 헤드라인, CTA, 준비된 캔버스.",
    "studio_landing_feat_type_title": "완전한 타이포그래피",
    "studio_landing_feat_type_text": "폰트, 두께, 여백, 윤곽선, 드롭 섀도우. Adobe처럼 작동하는 텍스트 박스, PowerPoint는 아닙니다.",
    "studio_landing_feat_img_title": "AI + 스톡 이미지",
    "studio_landing_feat_img_text": "GPT 이미지 1로 픽셀 완벽한 배경을 생성하세요. Unsplash와 Pexels 포함.",
    "studio_landing_feat_brand_title": "브랜드 키트",
    "studio_landing_feat_brand_text": "색상, 폰트, 로고를 한 번만 잠급니다. 모든 새로운 광고는 자동으로 이를 상속받습니다.",
    "studio_landing_feat_resize_title": "스마트 리사이즈",
    "studio_landing_feat_resize_text": "하나의 캔버스 → 모든 형식에 자동 조정되는 10개의 형제 광고. 한 번의 클릭으로 전체 캠페인을 배송하세요.",
    "studio_landing_feat_wl_title": "화이트 라벨 준비 완료",
    "studio_landing_feat_wl_text": "임베드할 수 있도록 설계되었습니다. iframe 또는 API를 통해 귀하의 에이전시 포털에 삽입하세요. 귀하의 브랜드, 우리의 엔진.",
    "studio_landing_formats_title": "10개 광고 형식. 하나의 캔버스.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. 피드, 스토리, 릴.",
    "studio_landing_pricing_title": "간단한 크레딧 기반 가격.",
    "studio_landing_pricing_sub": "무료로 시작하세요. 캠페인이 성장할 때 확장하세요.",
    "studio_landing_pricing_extra": "플랜 초과 광고: €2.30 / 크레딧 · 언제든지 취소 가능",
    "studio_landing_price_free_credits": "3개 광고 · 일회성",
    "studio_landing_price_starter_credits": "10개 광고 / 월",
    "studio_landing_price_pro_credits": "30개 광고 / 월",
    "studio_landing_price_agency_credits": "80개 광고 / 월",
    "studio_landing_price_free_f1": "모든 10개 형식",
    "studio_landing_price_free_f2": "URL에서 AI 마법",
    "studio_landing_price_free_f3": "PNG 내보내기",
    "studio_landing_price_free_f4": "신용 카드 없음",
    "studio_landing_price_starter_f1": "무료의 모든 기능",
    "studio_landing_price_starter_f2": "브랜드 키트",
    "studio_landing_price_starter_f3": "스마트 리사이즈",
    "studio_landing_price_starter_f4": "우선 순위 대기열",
    "studio_landing_price_pro_f1": "시작 패키지의 모든 기능",
    "studio_landing_price_pro_f2": "AI 이미지 생성 (GPT 이미지 1)",
    "studio_landing_price_pro_f3": "비디오 내보내기 (예정)",
    "studio_landing_price_pro_f4": "워터마크 제거",
    "studio_landing_price_agency_f1": "프로의 모든 기능",
    "studio_landing_price_agency_f2": "팀 좌석 (예정)",
    "studio_landing_price_agency_f3": "화이트 라벨 내보내기",
    "studio_landing_price_agency_f4": "전담 지원",
    "studio_landing_price_free_cta": "무료 시작",
    "studio_landing_price_starter_cta": "스타터 받기",
    "studio_landing_price_pro_cta": "프로 받기",
    "studio_landing_price_agency_cta": "에이전시 받기",
    "studio_landing_price_most_popular": "가장 인기 있는",
    "studio_landing_final_title": "오늘 밤 첫 광고를 발송하세요.",
    "studio_landing_final_sub": "세 개의 무료 광고. 카드 필요 없음. 두 번의 클릭으로 게시.",
    "studio_landing_final_btn": "편집기 열기",
    "studio_landing_footer": "스튜디오 · 의 일부",
    "studio_create_back_select": "← 선택으로 돌아가기",
    "studio_create_new_prefix": "새로운",
    "studio_create_type_desc_suffix": "템플릿을 선택하거나 빈 캔버스에서 시작하세요.",
    "studio_create_opt_templates_title": "템플릿 선택",
    "studio_create_opt_templates_sub": "수백 개의 준비된 디자인 — 편집 가능",
    "studio_create_opt_blank_title": "빈 캔버스",
    "studio_create_opt_blank_sub": "전체 제어, 빈 캔버스",
    "studio_create_opt_ai_title": "AI 매직 ✨",
    "studio_create_opt_ai_sub": "원하는 내용을 설명하세요 — AI가 첫 버전을 생성합니다.",
    "studio_create_hub_eyebrow": "무엇을 만들고 있나요?",
    "studio_create_hub_title_a": "크리에이티브하게",
    "studio_create_hub_title_b": "시작합시다",
    "studio_create_hub_sub": "콘텐츠 유형을 선택하세요. 각 프리셋은 올바른 크기와 템플릿을 엽니다.",
    "studio_create_card_start": "시작",
    "studio_create_type_post_label": "포스트",
    "studio_create_type_post_desc": "인스타그램 1:1 · 페이스북 4:5",
    "studio_create_type_story_label": "스토리",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "릴",
    "studio_create_type_reel_desc": "9:16 애니메이션 · 15–60초",
    "studio_create_type_video_label": "비디오",
    "studio_create_type_video_desc": "16:9 · 가로형",
    "studio_create_type_ad_label": "광고",
    "studio_create_type_ad_desc": "FB/IG 광고 크리에이티브",
    "studio_more_title": "더보기",
    "studio_more_sub": "설정, 계정 및 기타 도구.",
    "studio_more_settings": "계정 설정",
    "studio_more_notifications": "알림",
    "studio_more_plan": "계획 및 청구",
    "studio_more_invite": "친구 초대",
    "studio_more_redeem": "쿠폰 사용",
    "studio_more_ai": "AI 마법",
    "studio_more_privacy": "개인정보 보호",
    "studio_more_help": "도움말 & 블로그",
    "studio_more_logout": "로그아웃",
    "studio_nav_create": "생성",
    "studio_nav_mine": "내 디자인",
    "studio_nav_templates": "템플릿",
    "studio_nav_community": "커뮤니티",
    "studio_nav_more": "더보기",
    "studio_nav_home": "홈",
    "studio_nav_projects": "프로젝트",
    "studio_nav_ai_magic": "AI 마법",
    "studio_nav_business": "비즈니스",
    "studio_nav_create_aria": "새 디자인 생성",
    "studio_team_title": "비즈니스 — 팀 작업공간",
    "studio_team_sub": "동료와 함께 작업하려면 초대하세요. 최대 10명 팀원.",
    "studio_team_load_fail": "팀을 불러올 수 없습니다.",
    "studio_team_create_title": "새 팀 생성",
    "studio_team_create_sub": "당신이 소유자가 되어 팀원을 초대할 수 있습니다.",
    "studio_team_name_placeholder": "팀 이름",
    "studio_team_create_btn": "생성",
    "studio_team_join_title": "기존 초대와 함께 참여",
    "studio_team_join_sub": "누군가가 초대 코드를 보냈다면.",
    "studio_team_invite_code_placeholder": "초대 코드",
    "studio_team_join_btn": "참여",
    "studio_team_created": "팀이 생성되었습니다.",
    "studio_team_failed": "실패",
    "studio_team_joined": "팀에 참여했습니다.",
    "studio_team_invite_invalid": "초대가 유효하지 않습니다",
    "studio_team_member_one": "회원",
    "studio_team_members_many": "회원들",
    "studio_team_you_are_owner": "· 당신은 소유자입니다",
    "studio_team_leave_btn": "팀 종료",
    "studio_team_confirm_leave": "정말로 팀을 떠나시겠습니까?",
    "studio_team_left": "팀을 떠났습니다",
    "studio_team_invite_title": "새 멤버 초대",
    "studio_team_invite_email_placeholder": "email@example.com",
    "studio_team_send_invite": "초대 전송",
    "studio_team_invite_copied": "초대 링크가 클립보드에 복사되었습니다",
    "studio_team_auto_copy_hint": "초대 링크가 자동으로 클립보드에 복사되었습니다.",
    "studio_team_members_header": "회원",
    "studio_team_owner_badge": "소유자",
    "studio_team_pending_header": "대기 중인 초대",
    "studio_team_expires": "유효기간 만료"
  },
  "zh": {
    "studio_editor_back": "返回",
    "studio_editor_untitled": "未命名广告",
    "studio_editor_credits_view": "查看积分账本",
    "studio_editor_credits_label": "积分",
    "studio_editor_credits_unlimited": "∞ 无限",
    "studio_editor_smart_resize": "智能调整大小",
    "studio_editor_quick_reel": "快速剪辑",
    "studio_editor_quick_reel_title": "自动动画化每个元素以制作15秒剪辑",
    "studio_editor_save": "保存",
    "studio_editor_export_png": "导出 PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "导出动画视频",
    "studio_editor_mp4_title_need_anim": "请先添加动画",
    "studio_editor_rail_magic": "特效",
    "studio_editor_rail_text": "文本",
    "studio_editor_rail_shapes": "形状",
    "studio_editor_rail_images": "图片",
    "studio_editor_rail_anim": "动画",
    "studio_editor_rail_layers": "图层",
    "studio_editor_close_panel": "关闭面板",
    "studio_editor_close_props": "关闭属性",
    "studio_editor_open_props": "打开属性",
    "studio_editor_director_title": "AI 剪辑导演 — 一次性",
    "studio_editor_director_sub": "一句话 → 完整动画剪辑（约10秒）。",
    "studio_editor_magic_title": "AI 魔法 — URL → 5 个广告",
    "studio_editor_magic_placeholder": "https://your-site.com",
    "studio_editor_magic_generate": "生成",
    "studio_editor_text_title": "文本",
    "studio_editor_add_heading": "添加标题",
    "studio_editor_shapes_title": "形状",
    "studio_editor_rectangle": "矩形",
    "studio_editor_circle": "圆形",
    "studio_editor_background_title": "背景",
    "studio_editor_upload_title": "上传图片",
    "studio_editor_stock_btn": "图库照片",
    "studio_editor_from_url": "来自 URL",
    "studio_editor_add": "添加",
    "studio_editor_layers_title": "图层",
    "studio_editor_canvas_empty": "画布是空的。",
    "studio_editor_props_title": "属性",
    "studio_editor_select_element": "选择一个元素以编辑其属性。",
    "studio_editor_prop_text": "文本",
    "studio_editor_prop_font": "字体",
    "studio_editor_prop_size": "大小",
    "studio_editor_prop_fill": "填充",
    "studio_editor_prop_opacity": "不透明度",
    "studio_editor_duplicate": "复制",
    "studio_editor_delete": "删除",
    "studio_editor_toast_offline_info": "您正在离线工作。请登录以保存和导出。",
    "studio_editor_toast_open_fail": "无法打开编辑器",
    "studio_editor_toast_image_fail": "无法加载图像",
    "studio_editor_toast_saved": "已保存",
    "studio_editor_toast_save_fail": "保存失败",
    "studio_editor_toast_log_in_save": "登录以将您的广告保存到云端。",
    "studio_editor_toast_add_elements_first": "请先添加一些元素，然后单击快速轮播。",
    "studio_editor_toast_need_animation": "请先添加至少一个动画（动画轨道）。",
    "studio_editor_toast_browser_no_video": "您的浏览器不支持视频录制。",
    "studio_editor_toast_video_fail": "视频导出失败",
    "studio_editor_toast_export_fail": "导出失败",
    "studio_editor_toast_exported": "已导出！",
    "studio_editor_toast_exported_ext": "已导出 .{ext}！",
    "studio_editor_toast_credits_out": "广告积分不足。",
    "studio_editor_toast_credits_out_upsell": "您的广告积分已用尽。升级到专业版每月30。",
    "studio_editor_toast_ai_fail": "AI 魔法失败",
    "studio_editor_toast_no_variants": "没有返回变体",
    "studio_editor_toast_applied": "已应用：{angle}",
    "studio_editor_toast_quick_reel_done": "快速轮播 · {n} 动画 · {s}秒",
    "studio_editor_toast_smart_resize_done": "创建了 {n} 个兄弟广告{plural}",
    "studio_editor_toast_smart_resize_fail": "智能调整大小失败",
    "studio_my_have_coupon": "有优惠券吗？",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "兑换",
    "studio_my_toast_credits_added": "+{amount} 积分已添加 🎉",
    "studio_my_toast_not_found": "代码未找到",
    "studio_my_toast_already": "已兑换",
    "studio_my_toast_expired": "已过期或已停用",
    "studio_my_toast_redeem_fail": "兑换失败",
    "studio_my_toast_load_fail": "加载项目失败",
    "studio_my_confirm_delete": "删除 \"{title}\" 吗？",
    "studio_my_title": "我的设计",
    "studio_my_sub": "所有保存的项目和导出集中在一个地方。",
    "studio_my_count_one": "{n} 个项目",
    "studio_my_count_many": "{n} 个项目",
    "studio_my_instant_campaign": "即时活动",
    "studio_my_new_ad": "新广告",
    "studio_my_login_to_see": "请登录查看您的保存广告。",
    "studio_my_login": "登录",
    "studio_my_loading": "加载中…",
    "studio_my_empty_title": "暂无广告。",
    "studio_my_browse": "浏览模板",
    "studio_my_badge_team": "团队",
    "studio_my_badge_shared": "共享",
    "studio_my_edit": "编辑",
    "studio_gallery_filter_prefix": "筛选",
    "studio_gallery_filter_cancel": "× 清除",
    "studio_gallery_title": "模板",
    "studio_gallery_lead": "选择一个开始。编辑任何内容。",
    "studio_gallery_search": "搜索模板…",
    "studio_gallery_loading_count": "加载中…",
    "studio_gallery_count_of": "{start}–{end} / {total} 个模板",
    "studio_gallery_pack_all": "所有",
    "studio_gallery_pack_trending": "热门",
    "studio_gallery_pack_ai": "AI 驱动",
    "studio_gallery_pack_editorial": "编辑版",
    "studio_gallery_pack_video": "视频片段",
    "studio_gallery_pack_free": "免费",
    "studio_gallery_video_only": "仅视频",
    "studio_gallery_all_formats": "所有格式",
    "studio_gallery_all_categories": "所有类别",
    "studio_gallery_loading_templates": "加载模板中…",
    "studio_gallery_no_match": "没有模板与这些筛选条件匹配。",
    "studio_gallery_opening": "打开编辑器…",
    "studio_gallery_prev": "← 上一",
    "studio_gallery_next": "下一 →",
    "studio_gallery_page_of": "第 {n} 页，共 {total} 页",
    "studio_gallery_type_post": "帖子",
    "studio_gallery_type_story": "故事",
    "studio_gallery_type_reel": "短片",
    "studio_gallery_type_video": "视频",
    "studio_gallery_type_ad": "广告",
    "studio_landing_meta_title": "工作室 - 60秒内实现AI设计、短视频和视频 | TopRankPulse",
    "studio_landing_meta_desc": "使用AI创建帖子、短视频、视频和广告。1600多个模板，一键导出。TopRankPulse的一部分。",
    "studio_landing_eyebrow": "新功能 · 由TOPRANKPULSE提供的工作室",
    "studio_landing_hero_title_a": "创建帖子、短视频和视频。",
    "studio_landing_hero_title_b": "几分钟，而不是几天。",
    "studio_landing_hero_lead": "选择内容类型、模板，或让AI撰写第一版。在类似Canva的编辑器中编辑。一键导出PNG / MP4。广告、短视频、故事、视频和帖子 - 一应俱全。",
    "studio_landing_cta_start": "开始创建",
    "studio_landing_cta_instant": "即时活动 - 25个广告",
    "studio_landing_cta_browse": "浏览模板",
    "studio_landing_kpi_projects": "创建的项目",
    "studio_landing_kpi_exports": "下载的导出",
    "studio_landing_kpi_templates": "模板",
    "studio_landing_kpi_formats": "广告格式",
    "studio_landing_features_title": "一个工作室。不是幻灯片放映。",
    "studio_landing_features_sub": "绩效营销人员实际使用的一切 - 一屏，无标签。",
    "studio_landing_feat_ai_title": "链接的AI魔法",
    "studio_landing_feat_ai_text": "粘贴一个网站，获得5个完整的广告概念 - 品牌颜色、标题、行动号召，准备好交付的画布。",
    "studio_landing_feat_type_title": "完整排版",
    "studio_landing_feat_type_text": "字体、粗细、字距、轮廓、阴影。文本框行为类似Adobe，而不是PowerPoint。",
    "studio_landing_feat_img_title": "AI + 压缩图片",
    "studio_landing_feat_img_text": "使用GPT图像1生成像素完美的背景。内置Unsplash和Pexels。",
    "studio_landing_feat_brand_title": "品牌工具包",
    "studio_landing_feat_brand_text": "一次性锁定颜色、字体、标志。每个新广告自动继承它们。",
    "studio_landing_feat_resize_title": "智能调整大小",
    "studio_landing_feat_resize_text": "一个画布 → 10个兄弟广告自动缩放至每种格式。一键交付完整活动。",
    "studio_landing_feat_wl_title": "白标准备就绪",
    "studio_landing_feat_wl_text": "为嵌入而构建。通过iframe或API放入您的代理门户。您的品牌，我们的引擎。",
    "studio_landing_formats_title": "10种广告格式。一个画布。",
    "studio_landing_formats_sub": "Facebook、Instagram、Google展示、LinkedIn。信息流、故事、短视频。",
    "studio_landing_pricing_title": "简单的基于信用的定价。",
    "studio_landing_pricing_sub": "免费开始。当您的活动扩展时再规模化。",
    "studio_landing_pricing_extra": "超出计划的额外广告：€2.30 / 信用 · 随时取消",
    "studio_landing_price_free_credits": "3个广告 · 一次性",
    "studio_landing_price_starter_credits": "每月10个广告",
    "studio_landing_price_pro_credits": "每月30个广告",
    "studio_landing_price_agency_credits": "每月80个广告",
    "studio_landing_price_free_f1": "所有10种格式",
    "studio_landing_price_free_f2": "链接的AI魔法",
    "studio_landing_price_free_f3": "PNG导出",
    "studio_landing_price_free_f4": "无需信用卡",
    "studio_landing_price_starter_f1": "免费版的所有功能",
    "studio_landing_price_starter_f2": "品牌工具包",
    "studio_landing_price_starter_f3": "智能调整",
    "studio_landing_price_starter_f4": "优先队列",
    "studio_landing_price_pro_f1": "初级版的所有功能",
    "studio_landing_price_pro_f2": "AI 图像生成 (GPT 图像 1)",
    "studio_landing_price_pro_f3": "视频导出 (即将推出)",
    "studio_landing_price_pro_f4": "去除水印",
    "studio_landing_price_agency_f1": "专业版的所有功能",
    "studio_landing_price_agency_f2": "团队席位 (即将推出)",
    "studio_landing_price_agency_f3": "白标导出",
    "studio_landing_price_agency_f4": "专属支持",
    "studio_landing_price_free_cta": "免费开始",
    "studio_landing_price_starter_cta": "获取初级版",
    "studio_landing_price_pro_cta": "获取专业版",
    "studio_landing_price_agency_cta": "获取代理商版",
    "studio_landing_price_most_popular": "最受欢迎",
    "studio_landing_final_title": "今晚发布你的第一条广告。",
    "studio_landing_final_sub": "三条免费广告，无需信用卡，两次点击即可发布。",
    "studio_landing_final_btn": "打开编辑器",
    "studio_landing_footer": "Studio · 是的一部分",
    "studio_create_back_select": "← 返回选择",
    "studio_create_new_prefix": "新建",
    "studio_create_type_desc_suffix": "选择一个模板，或从空白画布开始。",
    "studio_create_opt_templates_title": "选择模板",
    "studio_create_opt_templates_sub": "数百个现成的设计 — 可编辑",
    "studio_create_opt_blank_title": "空白画布",
    "studio_create_opt_blank_sub": "完全控制，空白画布",
    "studio_create_opt_ai_title": "AI 魔法 ✨",
    "studio_create_opt_ai_sub": "描述你想要的内容 — AI 创建第一个版本",
    "studio_create_hub_eyebrow": "你正在创建什么？",
    "studio_create_hub_title_a": "让我们",
    "studio_create_hub_title_b": "创造",
    "studio_create_hub_sub": "选择一种内容类型。每个预设打开合适的尺寸和模板。",
    "studio_create_card_start": "开始",
    "studio_create_type_post_label": "帖子",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "故事",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "短视频",
    "studio_create_type_reel_desc": "9:16 动画 · 15–60s",
    "studio_create_type_video_label": "视频",
    "studio_create_type_video_desc": "16:9 · 横向",
    "studio_create_type_ad_label": "广告",
    "studio_create_type_ad_desc": "FB/IG 广告创意",
    "studio_more_title": "更多",
    "studio_more_sub": "设置、账户及其他工具。",
    "studio_more_settings": "账户设置",
    "studio_more_notifications": "通知",
    "studio_more_plan": "计划与账单",
    "studio_more_invite": "邀请朋友",
    "studio_more_redeem": "兑换优惠券",
    "studio_more_ai": "AI 魔法",
    "studio_more_privacy": "隐私",
    "studio_more_help": "帮助与博客",
    "studio_more_logout": "登出",
    "studio_nav_create": "创建",
    "studio_nav_mine": "我的设计",
    "studio_nav_templates": "模板",
    "studio_nav_community": "社区",
    "studio_nav_more": "更多",
    "studio_nav_home": "首页",
    "studio_nav_projects": "项目",
    "studio_nav_ai_magic": "AI 魔法",
    "studio_nav_business": "业务",
    "studio_nav_create_aria": "创建新设计",
    "studio_team_title": "业务 — 团队工作区",
    "studio_team_sub": "邀请同事一起工作。每队最多 10 名成员。",
    "studio_team_load_fail": "无法加载团队",
    "studio_team_create_title": "创建新团队",
    "studio_team_create_sub": "您将成为所有者并可以邀请成员。",
    "studio_team_name_placeholder": "团队名称",
    "studio_team_create_btn": "创建",
    "studio_team_join_title": "使用现有邀请加入",
    "studio_team_join_sub": "如果有人发送了邀请代码给您。",
    "studio_team_invite_code_placeholder": "邀请代码",
    "studio_team_join_btn": "加入",
    "studio_team_created": "团队创建成功",
    "studio_team_failed": "失败",
    "studio_team_joined": "已加入团队",
    "studio_team_invite_invalid": "邀请无效",
    "studio_team_member_one": "成员",
    "studio_team_members_many": "成员",
    "studio_team_you_are_owner": "· 您是所有者",
    "studio_team_leave_btn": "离开",
    "studio_team_confirm_leave": "真的要离开团队吗？",
    "studio_team_left": "已离开团队",
    "studio_team_invite_title": "邀请新成员",
    "studio_team_invite_email_placeholder": "email@example.com",
    "studio_team_send_invite": "发送邀请",
    "studio_team_invite_copied": "邀请链接已复制到剪贴板",
    "studio_team_auto_copy_hint": "邀请链接已自动复制到剪贴板。",
    "studio_team_members_header": "成员",
    "studio_team_owner_badge": "所有者",
    "studio_team_pending_header": "待处理邀请",
    "studio_team_expires": "过期"
  },
  "hi": {
    "studio_editor_back": "वापस",
    "studio_editor_untitled": "बिना शीर्षक विज्ञापन",
    "studio_editor_credits_view": "क्रेडिट लेजर देखें",
    "studio_editor_credits_label": "क्रेडिट",
    "studio_editor_credits_unlimited": "∞ अनलिमिटेड",
    "studio_editor_smart_resize": "स्मार्ट रिसाइज",
    "studio_editor_quick_reel": "क्विक रील",
    "studio_editor_quick_reel_title": "15 सेकंड की रील के लिए हर तत्व को ऑटो-एनिमेट करें",
    "studio_editor_save": "सहेजें",
    "studio_editor_export_png": "PNG निर्यात करें",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "एनिमेटेड वीडियो निर्यात करें",
    "studio_editor_mp4_title_need_anim": "पहले एक एनीमेशन जोड़ें",
    "studio_editor_rail_magic": "मैजिक",
    "studio_editor_rail_text": "पाठ",
    "studio_editor_rail_shapes": "आकृतियाँ",
    "studio_editor_rail_images": "छवियाँ",
    "studio_editor_rail_anim": "एनिमेट करें",
    "studio_editor_rail_layers": "परतें",
    "studio_editor_close_panel": "पैनल बंद करें",
    "studio_editor_close_props": "विशेषताएँ बंद करें",
    "studio_editor_open_props": "विशेषताएँ खोलें",
    "studio_editor_director_title": "AI रील निर्देशक — एक-शॉट",
    "studio_editor_director_sub": "एक वाक्य → पूर्ण एनिमेटेड रील (~10s)।",
    "studio_editor_magic_title": "AI मैजिक — URL → 5 विज्ञापन",
    "studio_editor_magic_placeholder": "https://your-site.com",
    "studio_editor_magic_generate": "उत्पन्न करें",
    "studio_editor_text_title": "पाठ",
    "studio_editor_add_heading": "शीर्षक जोड़ें",
    "studio_editor_shapes_title": "आकृतियाँ",
    "studio_editor_rectangle": "आयत",
    "studio_editor_circle": "वृत्त",
    "studio_editor_background_title": "पृष्ठभूमि",
    "studio_editor_upload_title": "छवि अपलोड करें",
    "studio_editor_stock_btn": "स्टॉक फ़ोटो",
    "studio_editor_from_url": "URL से",
    "studio_editor_add": "जोड़ें",
    "studio_editor_layers_title": "परतें",
    "studio_editor_canvas_empty": "कैनवास खाली है।",
    "studio_editor_props_title": "विशेषताएँ",
    "studio_editor_select_element": "संपत्तियों को संपादित करने के लिए एक तत्व चुनें।",
    "studio_editor_prop_text": "पाठ",
    "studio_editor_prop_font": "फॉन्ट",
    "studio_editor_prop_size": "आकार",
    "studio_editor_prop_fill": "भरना",
    "studio_editor_prop_opacity": "पारदर्शिता",
    "studio_editor_duplicate": "प्रतिलिपि बनाएँ",
    "studio_editor_delete": "हटाएँ",
    "studio_editor_toast_offline_info": "आप ऑफलाइन हैं। सहेजने और निर्यात करने के लिए लॉग इन करें।",
    "studio_editor_toast_open_fail": "संपादक खोलने में विफल",
    "studio_editor_toast_image_fail": "छवि लोड करने में विफल",
    "studio_editor_toast_saved": "सहेजा गया",
    "studio_editor_toast_save_fail": "सहेजने में विफल",
    "studio_editor_toast_log_in_save": "अपने विज्ञापन को क्लाउड में सहेजने के लिए लॉग इन करें।",
    "studio_editor_toast_add_elements_first": "पहले कुछ तत्व जोड़ें, फिर क्विक रील पर क्लिक करें।",
    "studio_editor_toast_need_animation": "पहले कम से कम एक एनीमेशन जोड़ें (एनिमेट रेल)।",
    "studio_editor_toast_browser_no_video": "आपका ब्राउज़र वीडियो रिकॉर्डिंग का समर्थन नहीं करता।",
    "studio_editor_toast_video_fail": "वीडियो निर्यात विफल",
    "studio_editor_toast_export_fail": "निर्यात विफल",
    "studio_editor_toast_exported": "निर्यातित!",
    "studio_editor_toast_exported_ext": "निर्यातित .{ext}!",
    "studio_editor_toast_credits_out": "विज्ञापन क्रेडिट समाप्त हो गए।",
    "studio_editor_toast_credits_out_upsell": "आपके विज्ञापन क्रेडिट समाप्त हो गए हैं। 30/महीने के लिए प्रो में अपग्रेड करें।",
    "studio_editor_toast_ai_fail": "AI मैजिक विफल",
    "studio_editor_toast_no_variants": "कोई वेरिएंट प्राप्त नहीं हुए",
    "studio_editor_toast_applied": "लागू किया: {angle}",
    "studio_editor_toast_quick_reel_done": "क्विक रील · {n} एनीमेशन · {s} सेकंड",
    "studio_editor_toast_smart_resize_done": "{n} सिबलिंग विज्ञापन बनाए गए",
    "studio_editor_toast_smart_resize_fail": "स्मार्ट रीसाइज विफल",
    "studio_my_have_coupon": "क्या आपके पास कूपन है?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "भुना",
    "studio_my_toast_credits_added": "+{amount} क्रेडिट जुड़ गए 🎉",
    "studio_my_toast_not_found": "कोड नहीं मिला",
    "studio_my_toast_already": "पहले से ही भुनाया गया",
    "studio_my_toast_expired": "समय समाप्त या निष्क्रिय",
    "studio_my_toast_redeem_fail": "भुनाने में विफल",
    "studio_my_toast_load_fail": "परियोजनाएं लोड करने में विफल",
    "studio_my_confirm_delete": "\"{title}\" हटाएँ?",
    "studio_my_title": "मेरे डिज़ाइन",
    "studio_my_sub": "सभी सहेजे गए प्रोजेक्ट और एक्सपोर्ट एक ही जगह पर।",
    "studio_my_count_one": "{n} प्रोजेक्ट",
    "studio_my_count_many": "{n} प्रोजेक्ट्स",
    "studio_my_instant_campaign": "तत्काल अभियान",
    "studio_my_new_ad": "नया विज्ञापन",
    "studio_my_login_to_see": "अपने सहेजे हुए विज्ञापन देखने के लिए लॉग इन करें।",
    "studio_my_login": "लॉग इन करें",
    "studio_my_loading": "लोड हो रहा है…",
    "studio_my_empty_title": "अभी तक कोई विज्ञापन नहीं।",
    "studio_my_browse": "टेम्प्लेट ब्राउज़ करें",
    "studio_my_badge_team": "टीम",
    "studio_my_badge_shared": "साझा किया गया",
    "studio_my_edit": "संपादित करें",
    "studio_gallery_filter_prefix": "फ़िल्टर",
    "studio_gallery_filter_cancel": "× साफ करें",
    "studio_gallery_title": "टेम्प्लेट",
    "studio_gallery_lead": "एक शुरुआत चुनें। कुछ भी संपादित करें।",
    "studio_gallery_search": "टेम्प्लेट खोजें…",
    "studio_gallery_loading_count": "लोड हो रहा है…",
    "studio_gallery_count_of": "{start}–{end} में {total} टेम्प्लेट",
    "studio_gallery_pack_all": "सभी",
    "studio_gallery_pack_trending": "चलन में",
    "studio_gallery_pack_ai": "AI-संचालित",
    "studio_gallery_pack_editorial": "संपादकीय",
    "studio_gallery_pack_video": "वीडियो रील",
    "studio_gallery_pack_free": "मुफ्त",
    "studio_gallery_video_only": "सिर्फ वीडियो",
    "studio_gallery_all_formats": "सभी फ़ॉर्मेट",
    "studio_gallery_all_categories": "सभी श्रेणियाँ",
    "studio_gallery_loading_templates": "टेम्प्लेट लोड हो रहे हैं…",
    "studio_gallery_no_match": "इन फ़िल्टरों से मेल खाने वाले कोई टेम्प्लेट नहीं हैं।",
    "studio_gallery_opening": "संपादक खोलना…",
    "studio_gallery_prev": "← पहले",
    "studio_gallery_next": "अगला →",
    "studio_gallery_page_of": "पृष्ठ {n} का {total}",
    "studio_gallery_type_post": "पोस्ट",
    "studio_gallery_type_story": "कहानी",
    "studio_gallery_type_reel": "रील",
    "studio_gallery_type_video": "वीडियो",
    "studio_gallery_type_ad": "विज्ञापन",
    "studio_landing_meta_title": "स्टूडियो — 60 सेकंड में AI डिज़ाइन, रील और वीडियो | TopRankPulse",
    "studio_landing_meta_desc": "AI के साथ पोस्ट, रील, वीडियो और विज्ञापन बनाएं। 1,600+ टेम्पलेट, एक-क्लिक में एक्सपोर्ट। TopRankPulse का हिस्सा।",
    "studio_landing_eyebrow": "नया · TopRankPulse द्वारा स्टूडियो",
    "studio_landing_hero_title_a": "पोस्ट, रील और वीडियो बनाएं।",
    "studio_landing_hero_title_b": "मिनटों में, दिनों में नहीं।",
    "studio_landing_hero_lead": "कंटेंट का प्रकार, टेम्पलेट चुनें, या AI को पहला संस्करण तैयार करने दें। Canva-शैली संपादक में संपादित करें। एक क्लिक में PNG / MP4 एक्सपोर्ट करें। विज्ञापन, रील, कहानियाँ, वीडियो और पोस्ट — सभी एक में।",
    "studio_landing_cta_start": "बनाना शुरू करें",
    "studio_landing_cta_instant": "तत्काल अभियान — 25 विज्ञापन",
    "studio_landing_cta_browse": "टेम्पलेट ब्राउज़ करें",
    "studio_landing_kpi_projects": "बनाए गए प्रोजेक्ट",
    "studio_landing_kpi_exports": "डाउनलोड किए गए एक्सपोर्ट",
    "studio_landing_kpi_templates": "टेम्पलेट",
    "studio_landing_kpi_formats": "विज्ञापन प्रारूप",
    "studio_landing_features_title": "एक स्टूडियो। स्लाइडशो नहीं।",
    "studio_landing_features_sub": "हर चीज़ जो एक प्रदर्शन मार्केटर वास्तव में उपयोग करता है — एक स्क्रीन, कोई टैब नहीं।",
    "studio_landing_feat_ai_title": "URL से AI जादू",
    "studio_landing_feat_ai_text": "एक वेबसाइट पेस्ट करें, 5 पूर्ण विज्ञापन अवधारणाएँ प्राप्त करें — ब्रांड के रंग, शीर्षक, CTA, शिप करने के लिए तैयार कैनवस।",
    "studio_landing_feat_type_title": "पूर्ण टाइपोग्राफी",
    "studio_landing_feat_type_text": "फॉन्ट, वजन, ट्रैकिंग, आउटलाइन्स, ड्रॉप शैडोज़। टेक्स्टबॉक्स जो Adobe की तरह व्यवहार करते हैं, PowerPoint की तरह नहीं।",
    "studio_landing_feat_img_title": "AI + स्टॉक इमेज",
    "studio_landing_feat_img_text": "GPT इमेज 1 के साथ पिक्सेल-परफेक्ट बैकग्राउंड्स उत्पन्न करें। Unsplash और Pexels शामिल हैं।",
    "studio_landing_feat_brand_title": "ब्रांड किट",
    "studio_landing_feat_brand_text": "अपने रंग, फॉन्ट, और लोगो को एक बार लॉक करें। हर नया विज्ञापन स्वचालित रूप से उन्हें विरासत में प्राप्त करता है।",
    "studio_landing_feat_resize_title": "स्मार्ट रिसाइज़",
    "studio_landing_feat_resize_text": "एक कैनवस → हर प्रारूप के लिए 10 सिबलिंग विज्ञापनों का ऑटो-स्केल। एक क्लिक में पूरा अभियान भेजें।",
    "studio_landing_feat_wl_title": "व्हाइट-लेबल तैयार",
    "studio_landing_feat_wl_text": "एंबेड करने के लिए बनाया गया। अपने एजेंसी पोर्टल में iframe या API के माध्यम से डालें। आपका ब्रांड, हमारा इंजन।",
    "studio_landing_formats_title": "10 विज्ञापन प्रारूप। एक कैनवस।",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn। फ़ीड, कहानी, रील।",
    "studio_landing_pricing_title": "सादा, क्रेडिट-आधारित मूल्य निर्धारण।",
    "studio_landing_pricing_sub": "मुफ्त में शुरू करें। जब आपके अभियान बढ़ें, तब स्केल करें।",
    "studio_landing_pricing_extra": "योजना से बाहर अतिरिक्त विज्ञापन: €2.30 / क्रेडिट · किसी भी समय कैंसल करें",
    "studio_landing_price_free_credits": "3 विज्ञापन · एक बार",
    "studio_landing_price_starter_credits": "10 विज्ञापन / महीना",
    "studio_landing_price_pro_credits": "30 विज्ञापन / महीना",
    "studio_landing_price_agency_credits": "80 विज्ञापन / महीना",
    "studio_landing_price_free_f1": "सभी 10 प्रारूप",
    "studio_landing_price_free_f2": "URL से AI जादू",
    "studio_landing_price_free_f3": "PNG एक्सपोर्ट",
    "studio_landing_price_free_f4": "कोई क्रेडिट कार्ड नहीं",
    "studio_landing_price_starter_f1": "फ्री में सब कुछ",
    "studio_landing_price_starter_f2": "ब्रांड किट",
    "studio_landing_price_starter_f3": "स्मार्ट रिसाइज",
    "studio_landing_price_starter_f4": "प्राथमिकता कतार",
    "studio_landing_price_pro_f1": "स्टार्टर में सब कुछ",
    "studio_landing_price_pro_f2": "AI इमेज जन (GPT इमेज 1)",
    "studio_landing_price_pro_f3": "वीडियो निर्यात (आ रहा है)",
    "studio_landing_price_pro_f4": "वाटरमार्क हटाएं",
    "studio_landing_price_agency_f1": "प्रो में सब कुछ",
    "studio_landing_price_agency_f2": "टीम सीटें (आ रही हैं)",
    "studio_landing_price_agency_f3": "व्हाइट-लेबल निर्यात",
    "studio_landing_price_agency_f4": "विशेष समर्थन",
    "studio_landing_price_free_cta": "फ्री शुरू करें",
    "studio_landing_price_starter_cta": "स्टार्टर प्राप्त करें",
    "studio_landing_price_pro_cta": "प्रो प्राप्त करें",
    "studio_landing_price_agency_cta": "एजेंसी प्राप्त करें",
    "studio_landing_price_most_popular": "सबसे लोकप्रिय",
    "studio_landing_final_title": "आज रात अपना पहला विज्ञापन भेजें।",
    "studio_landing_final_sub": "तीन फ्री विज्ञापन। कोई कार्ड नहीं। प्रकाशित करने के लिए दो क्लिक।",
    "studio_landing_final_btn": "संपादक खोलें",
    "studio_landing_footer": "स्टूडियो · का हिस्सा",
    "studio_create_back_select": "← चयन पर वापस",
    "studio_create_new_prefix": "नया",
    "studio_create_type_desc_suffix": "एक टेम्पलेट चुनें, या एक ख़ाली कैनवास से शुरू करें।",
    "studio_create_opt_templates_title": "एक टेम्पलेट चुनें",
    "studio_create_opt_templates_sub": "सैकड़ों तैयार डिज़ाइन - संपादन योग्य",
    "studio_create_opt_blank_title": "खाली कैनवास",
    "studio_create_opt_blank_sub": "पूर्ण नियंत्रण, ख़ाली कैनवास",
    "studio_create_opt_ai_title": "AI जादू ✨",
    "studio_create_opt_ai_sub": "जो आप चाहते हैं उसका वर्णन करें - AI पहला संस्करण बनाती है",
    "studio_create_hub_eyebrow": "आप क्या बना रहे हैं?",
    "studio_create_hub_title_a": "चलो बनाएं",
    "studio_create_hub_title_b": "रचनात्मक",
    "studio_create_hub_sub": "एक सामग्री प्रकार चुनें। प्रत्येक प्रीसेट सही आयाम और टेम्पलेट खोलता है।",
    "studio_create_card_start": "शुरू करें",
    "studio_create_type_post_label": "पोस्ट",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "स्टोरी",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "रील",
    "studio_create_type_reel_desc": "9:16 एनिमेटेड · 15–60सेकंड",
    "studio_create_type_video_label": "वीडियो",
    "studio_create_type_video_desc": "16:9 · लैंडस्केप",
    "studio_create_type_ad_label": "विज्ञापन",
    "studio_create_type_ad_desc": "FB/IG विज्ञापन सामग्री",
    "studio_more_title": "अधिक",
    "studio_more_sub": "सेटिंग्स, खाता और अन्य उपकरण।",
    "studio_more_settings": "खाता सेटिंग्स",
    "studio_more_notifications": "सूचनाएँ",
    "studio_more_plan": "योजना और बिलिंग",
    "studio_more_invite": "दोस्तों को आमंत्रित करें",
    "studio_more_redeem": "कूपन भुनाएँ",
    "studio_more_ai": "AI जादू",
    "studio_more_privacy": "गोपनीयता",
    "studio_more_help": "सहायता और ब्लॉग",
    "studio_more_logout": "लॉग आउट",
    "studio_nav_create": "बनाएँ",
    "studio_nav_mine": "मेरे डिज़ाइन",
    "studio_nav_templates": "टेम्पलेट्स",
    "studio_nav_community": "समुदाय",
    "studio_nav_more": "अधिक",
    "studio_nav_home": "मुख्य पृष्ठ",
    "studio_nav_projects": "परियोजनाएँ",
    "studio_nav_ai_magic": "AI जादू",
    "studio_nav_business": "व्यापार",
    "studio_nav_create_aria": "नया डिज़ाइन बनाएँ",
    "studio_team_title": "व्यापार — टीम कार्यक्षेत्र",
    "studio_team_sub": "साथ में काम करने के लिए सहयोगियों को आमंत्रित करें। अधिकतम 10 सदस्य प्रति टीम।",
    "studio_team_load_fail": "टीम लोड नहीं कर पाया",
    "studio_team_create_title": "एक नई टीम बनाएँ",
    "studio_team_create_sub": "आप मालिक बनते हैं और सदस्यों को आमंत्रित कर सकते हैं।",
    "studio_team_name_placeholder": "टीम का नाम",
    "studio_team_create_btn": "बनाएँ",
    "studio_team_join_title": "मौजूदा आमंत्रण से जुड़ें",
    "studio_team_join_sub": "यदि किसी ने आपको आमंत्रण कोड भेजा है।",
    "studio_team_invite_code_placeholder": "आमंत्रण कोड",
    "studio_team_join_btn": "जुड़ें",
    "studio_team_created": "टीम बनाई गई",
    "studio_team_failed": "असफल",
    "studio_team_joined": "टीम से जुड़े",
    "studio_team_invite_invalid": "निमंत्रण अमान्य",
    "studio_team_member_one": "सदस्य",
    "studio_team_members_many": "सदस्य",
    "studio_team_you_are_owner": "· आप स्वामी हैं",
    "studio_team_leave_btn": "छोड़ें",
    "studio_team_confirm_leave": "क्या वास्तव में टीम छोड़ना है?",
    "studio_team_left": "टीम छोड़ी",
    "studio_team_invite_title": "एक नए सदस्य को आमंत्रित करें",
    "studio_team_invite_email_placeholder": "email@example.com",
    "studio_team_send_invite": "निमंत्रण भेजें",
    "studio_team_invite_copied": "निमंत्रण लिंक क्लिपबोर्ड पर कॉपी किया गया",
    "studio_team_auto_copy_hint": "निमंत्रण लिंक स्वचालित रूप से क्लिपबोर्ड पर कॉपी किया गया है।",
    "studio_team_members_header": "सदस्य",
    "studio_team_owner_badge": "स्वामी",
    "studio_team_pending_header": "लंबित निमंत्रण",
    "studio_team_expires": "समाप्त"
  },
  "ar": {
    "studio_editor_back": "رجوع",
    "studio_editor_untitled": "إعلان بلا عنوان",
    "studio_editor_credits_view": "عرض دفاتر الاعتمادات",
    "studio_editor_credits_label": "الاعتمادات",
    "studio_editor_credits_unlimited": "∞ غير محدود",
    "studio_editor_smart_resize": "تغيير الحجم الذكي",
    "studio_editor_quick_reel": "كرات سريعة",
    "studio_editor_quick_reel_title": "تلقائيًا تحريك كل عنصر لفيديو مدته 15 ثانية",
    "studio_editor_save": "احفظ",
    "studio_editor_export_png": "تصدير PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "تصدير الفيديو المتحرك",
    "studio_editor_mp4_title_need_anim": "أضف حركة أولاً",
    "studio_editor_rail_magic": "سحر",
    "studio_editor_rail_text": "نص",
    "studio_editor_rail_shapes": "أشكال",
    "studio_editor_rail_images": "صور",
    "studio_editor_rail_anim": "حرّك",
    "studio_editor_rail_layers": "طبقات",
    "studio_editor_close_panel": "إغلاق اللوحة",
    "studio_editor_close_props": "إغلاق الخصائص",
    "studio_editor_open_props": "فتح الخصائص",
    "studio_editor_director_title": "مخرج فيديو AI — لقطة واحدة",
    "studio_editor_director_sub": "جملة واحدة → فيديو متحرك كامل (~10 ثواني).",
    "studio_editor_magic_title": "سحر AI — URL → 5 إعلانات",
    "studio_editor_magic_placeholder": "https://your-site.com",
    "studio_editor_magic_generate": "توليد",
    "studio_editor_text_title": "نص",
    "studio_editor_add_heading": "إضافة عنوان",
    "studio_editor_shapes_title": "أشكال",
    "studio_editor_rectangle": "مستطيل",
    "studio_editor_circle": "دائرة",
    "studio_editor_background_title": "خلفية",
    "studio_editor_upload_title": "تحميل صورة",
    "studio_editor_stock_btn": "صور مخزنة",
    "studio_editor_from_url": "من URL",
    "studio_editor_add": "أضف",
    "studio_editor_layers_title": "طبقات",
    "studio_editor_canvas_empty": "اللوحة فارغة.",
    "studio_editor_props_title": "الخصائص",
    "studio_editor_select_element": "اختر عنصرًا لتحرير خصائصه.",
    "studio_editor_prop_text": "نص",
    "studio_editor_prop_font": "خط",
    "studio_editor_prop_size": "حجم",
    "studio_editor_prop_fill": "مليء",
    "studio_editor_prop_opacity": "شفافية",
    "studio_editor_duplicate": "تكرار",
    "studio_editor_delete": "حذف",
    "studio_editor_toast_offline_info": "أنت تعمل في وضع عدم الاتصال. سجل الدخول للحفظ والتصدير.",
    "studio_editor_toast_open_fail": "تعذر فتح المحرر",
    "studio_editor_toast_image_fail": "تعذر تحميل الصورة",
    "studio_editor_toast_saved": "تم الحفظ",
    "studio_editor_toast_save_fail": "فشل الحفظ",
    "studio_editor_toast_log_in_save": "سجل الدخول لحفظ إعلانك في السحابة.",
    "studio_editor_toast_add_elements_first": "أضف بعض العناصر أولاً، ثم انقر على Quick Reel.",
    "studio_editor_toast_need_animation": "أضف على الأقل حركة واحدة أولاً (تحريك المسار).",
    "studio_editor_toast_browser_no_video": "المتصفح الخاص بك لا يدعم تسجيل الفيديو.",
    "studio_editor_toast_video_fail": "فشل تصدير الفيديو",
    "studio_editor_toast_export_fail": "فشل التصدير",
    "studio_editor_toast_exported": "تم التصدير!",
    "studio_editor_toast_exported_ext": "تم التصدير .{ext}!",
    "studio_editor_toast_credits_out": "م credits الإعلانات نفدت.",
    "studio_editor_toast_credits_out_upsell": "لقد نفدت ائتمانات الإعلانات. ترقى إلى Pro مقابل 30/شهر.",
    "studio_editor_toast_ai_fail": "فشل سحر الذكاء الاصطناعي",
    "studio_editor_toast_no_variants": "لم يتم إرجاع أي خيارات",
    "studio_editor_toast_applied": "تم التطبيق: {angle}",
    "studio_editor_toast_quick_reel_done": "Quick Reel · {n} حركات · {s}s",
    "studio_editor_toast_smart_resize_done": "تم إنشاء {n} إعلان شقيق{plural}",
    "studio_editor_toast_smart_resize_fail": "فشل تغيير الحجم الذكي",
    "studio_my_have_coupon": "هل لديك كوبون؟",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "استرداد",
    "studio_my_toast_credits_added": "+{amount} ائتمانات تمت إضافتها 🎉",
    "studio_my_toast_not_found": "الرمز غير موجود",
    "studio_my_toast_already": "تم استرداده بالفعل",
    "studio_my_toast_expired": "منتهي الصلاحية أو معطّل",
    "studio_my_toast_redeem_fail": "فشل الاسترداد",
    "studio_my_toast_load_fail": "فشل في تحميل المشاريع",
    "studio_my_confirm_delete": "حذف \"{title}\"؟",
    "studio_my_title": "تصاميمي",
    "studio_my_sub": "جميع مشاريعك وتصديرها المحفوظة في مكان واحد.",
    "studio_my_count_one": "{n} مشروع",
    "studio_my_count_many": "{n} مشاريع",
    "studio_my_instant_campaign": "حملة فورية",
    "studio_my_new_ad": "إعلان جديد",
    "studio_my_login_to_see": "قم بتسجيل الدخول لرؤية إعلاناتك المحفوظة.",
    "studio_my_login": "تسجيل الدخول",
    "studio_my_loading": "جارٍ التحميل…",
    "studio_my_empty_title": "لا توجد إعلانات بعد.",
    "studio_my_browse": "تصفح القوالب",
    "studio_my_badge_team": "فريق",
    "studio_my_badge_shared": "مشترك",
    "studio_my_edit": "تعديل",
    "studio_gallery_filter_prefix": "تصنيف",
    "studio_gallery_filter_cancel": "× مسح",
    "studio_gallery_title": "القوالب",
    "studio_gallery_lead": "اختر بداية. قم بتعديل أي شيء.",
    "studio_gallery_search": "ابحث عن القوالب…",
    "studio_gallery_loading_count": "جارٍ التحميل…",
    "studio_gallery_count_of": "{start}–{end} من {total} قوالب",
    "studio_gallery_pack_all": "الجميع",
    "studio_gallery_pack_trending": "الأكثر رواجًا",
    "studio_gallery_pack_ai": "مدعوم بالذكاء الاصطناعي",
    "studio_gallery_pack_editorial": "تحريري",
    "studio_gallery_pack_video": "مقاطع الفيديو",
    "studio_gallery_pack_free": "مجاني",
    "studio_gallery_video_only": "فيديو فقط",
    "studio_gallery_all_formats": "جميع الصيغ",
    "studio_gallery_all_categories": "جميع الفئات",
    "studio_gallery_loading_templates": "جارٍ تحميل القوالب…",
    "studio_gallery_no_match": "لا توجد قوالب تتناسب مع تلك الفلاتر.",
    "studio_gallery_opening": "جارٍ فتح المحرر…",
    "studio_gallery_prev": "← السابق",
    "studio_gallery_next": "التالي →",
    "studio_gallery_page_of": "الصفحة {n} من {total}",
    "studio_gallery_type_post": "مقال",
    "studio_gallery_type_story": "قصة",
    "studio_gallery_type_reel": "شريط",
    "studio_gallery_type_video": "فيديو",
    "studio_gallery_type_ad": "إعلان",
    "studio_landing_meta_title": "استوديو — تصميمات الذكاء الاصطناعي، reels & مقاطع الفيديو في 60 ثانية | TopRankPulse",
    "studio_landing_meta_desc": "إنشاء منشورات، reels، مقاطع فيديو وإعلانات باستخدام الذكاء الاصطناعي. أكثر من 1,600 قالب، تصدير بنقرة واحدة. جزء من TopRankPulse.",
    "studio_landing_eyebrow": "جديد · استوديو بواسطة TOPRANKPULSE",
    "studio_landing_hero_title_a": "إنشاء منشورات، reels ومقاطع فيديو.",
    "studio_landing_hero_title_b": "في دقائق، وليس أيام.",
    "studio_landing_hero_lead": "اختر نوع المحتوى، قالب، أو دع الذكاء الاصطناعي يضع المسودة الأولى. تعديل في محرر على نمط Canva. تصدير PNG / MP4 بنقرة واحدة. إعلانات، reels، قصص، مقاطع فيديو ومنشورات — كلها في واحدة.",
    "studio_landing_cta_start": "ابدأ الإبداع",
    "studio_landing_cta_instant": "حملة فورية — 25 إعلان",
    "studio_landing_cta_browse": "تصفح القوالب",
    "studio_landing_kpi_projects": "المشاريع التي أنشئت",
    "studio_landing_kpi_exports": "التصديرات التي تم تحميلها",
    "studio_landing_kpi_templates": "القوالب",
    "studio_landing_kpi_formats": "أشكال الإعلانات",
    "studio_landing_features_title": "استوديو. ليس عرض شرائح.",
    "studio_landing_features_sub": "كل ما يستخدمه مسوق الأداء فعليًا — شاشة واحدة، بلا علامات تبويب.",
    "studio_landing_feat_ai_title": "سحر الذكاء الاصطناعي من URL",
    "studio_landing_feat_ai_text": "الصق موقعًا، احصل على 5 مفاهيم إعلانات كاملة — ألوان العلامة التجارية، عناوين، CTAs، قضايا جاهزة للشحن.",
    "studio_landing_feat_type_title": "الطباعة الكاملة",
    "studio_landing_feat_type_text": "خطوط، أوزان، تتبع، خطوط خارجية، ظلال ملقاة. مربعات نص تصرف مثل Adobe، وليس PowerPoint.",
    "studio_landing_feat_img_title": "الذكاء الاصطناعي + الصور المخزنة",
    "studio_landing_feat_img_text": "إنشاء خلفيات دقيقة بكسل مع GPT Image 1. مكتبة Unsplash و Pexels مضمنة.",
    "studio_landing_feat_brand_title": "حزمة العلامة التجارية",
    "studio_landing_feat_brand_text": "قم بتثبيت ألوانك، خطوطك، شعاراتك مرة واحدة. كل إعلان جديد يرثها تلقائيًا.",
    "studio_landing_feat_resize_title": "تغيير الحجم الذكي",
    "studio_landing_feat_resize_text": "قماش واحد → 10 إعلانات شقيقة يتم تغيير حجمها تلقائيًا لكل تنسيق. شحن حملة كاملة بنقرة واحدة.",
    "studio_landing_feat_wl_title": "جاهز للعلامة البيضاء",
    "studio_landing_feat_wl_text": "مصمم ليتم تضمينه. قم بإسقاطه في بوابة وكالتك عبر iframe أو API. علامتك التجارية، محركنا.",
    "studio_landing_formats_title": "10 أشكال إعلانات. قماش واحد.",
    "studio_landing_formats_sub": "فيسبوك، إنستغرام، عرض Google، لينكد إن. الخلاصة، القصة، reel.",
    "studio_landing_pricing_title": "أسعار بسيطة تعتمد على الائتمان.",
    "studio_landing_pricing_sub": "ابدأ مجانًا. قم بالتوسع عندما تنموا حملاتك.",
    "studio_landing_pricing_extra": "إعلانات إضافية تتجاوز الخطة: €2.30 / ائتمان · إلغاء في أي وقت",
    "studio_landing_price_free_credits": "3 إعلانات · لمرة واحدة",
    "studio_landing_price_starter_credits": "10 إعلانات / شهر",
    "studio_landing_price_pro_credits": "30 إعلانات / شهر",
    "studio_landing_price_agency_credits": "80 إعلانات / شهر",
    "studio_landing_price_free_f1": "جميع الأشكال العشرة",
    "studio_landing_price_free_f2": "سحر الذكاء الاصطناعي من URL",
    "studio_landing_price_free_f3": "تصدير PNG",
    "studio_landing_price_free_f4": "لا بطاقة ائتمان",
    "studio_landing_price_starter_f1": "كل شيء في النسخة المجانية",
    "studio_landing_price_starter_f2": "حزمة العلامة التجارية",
    "studio_landing_price_starter_f3": "تغيير الحجم الذكي",
    "studio_landing_price_starter_f4": "أولوية في الانتظار",
    "studio_landing_price_pro_f1": "كل شيء في النسخة المبدئية",
    "studio_landing_price_pro_f2": "توليد الصور بالذكاء الاصطناعي (صورة GPT 1)",
    "studio_landing_price_pro_f3": "تصدير الفيديو (قريبًا)",
    "studio_landing_price_pro_f4": "إزالة علامة المياه",
    "studio_landing_price_agency_f1": "كل شيء في النسخة الاحترافية",
    "studio_landing_price_agency_f2": "أعضاء الفريق (قريبًا)",
    "studio_landing_price_agency_f3": "تصدير العلامة البيضاء",
    "studio_landing_price_agency_f4": "دعم مخصص",
    "studio_landing_price_free_cta": "ابدأ مجانًا",
    "studio_landing_price_starter_cta": "احصل على النسخة المبدئية",
    "studio_landing_price_pro_cta": "احصل على النسخة الاحترافية",
    "studio_landing_price_agency_cta": "احصل على وكالة",
    "studio_landing_price_most_popular": "الأكثر شعبية",
    "studio_landing_final_title": "أطلق إعلانك الأول الليلة.",
    "studio_landing_final_sub": "ثلاث إعلانات مجانية. بدون بطاقة. خطوتان للنشر.",
    "studio_landing_final_btn": "افتح المحرر",
    "studio_landing_footer": "استوديو · جزء من",
    "studio_create_back_select": "← العودة للاختيار",
    "studio_create_new_prefix": "جديد",
    "studio_create_type_desc_suffix": "اختر قالبًا، أو ابدأ من لوحة فارغة.",
    "studio_create_opt_templates_title": "اختر قالبًا",
    "studio_create_opt_templates_sub": "مئات التصاميم الجاهزة - قابلة للتعديل",
    "studio_create_opt_blank_title": "لوحة فارغة",
    "studio_create_opt_blank_sub": "تحكم كامل، لوحة فارغة",
    "studio_create_opt_ai_title": "سحر الذكاء الاصطناعي ✨",
    "studio_create_opt_ai_sub": "صف ما تريده - الذكاء الاصطناعي يصنع النسخة الأولى",
    "studio_create_hub_eyebrow": "ماذا تصنع؟",
    "studio_create_hub_title_a": "لنبدأ",
    "studio_create_hub_title_b": "الإبداع",
    "studio_create_hub_sub": "اختر نوع المحتوى. كل إعداد يفتح الأبعاد والقوالب المناسبة.",
    "studio_create_card_start": "ابدأ",
    "studio_create_type_post_label": "منشور",
    "studio_create_type_post_desc": "إنستغرام 1:1 · فيسبوك 4:5",
    "studio_create_type_story_label": "قصة",
    "studio_create_type_story_desc": "9:16 · إنستغرام / فيسبوك / تيك توك",
    "studio_create_type_reel_label": "ريل",
    "studio_create_type_reel_desc": "9:16 متحرك · 15–60 ث",
    "studio_create_type_video_label": "فيديو",
    "studio_create_type_video_desc": "16:9 · أفقي",
    "studio_create_type_ad_label": "إعلان",
    "studio_create_type_ad_desc": "إبداع إعلان FB/IG",
    "studio_more_title": "المزيد",
    "studio_more_sub": "الإعدادات، الحساب وأدوات أخرى.",
    "studio_more_settings": "إعدادات الحساب",
    "studio_more_notifications": "الإشعارات",
    "studio_more_plan": "الخطة والفواتير",
    "studio_more_invite": "دعوة الأصدقاء",
    "studio_more_redeem": "استرداد القسيمة",
    "studio_more_ai": "سحر الذكاء الاصطناعي",
    "studio_more_privacy": "الخصوصية",
    "studio_more_help": "المساعدة والمدونة",
    "studio_more_logout": "تسجيل الخروج",
    "studio_nav_create": "إنشاء",
    "studio_nav_mine": "تصاميمي",
    "studio_nav_templates": "النماذج",
    "studio_nav_community": "المجتمع",
    "studio_nav_more": "المزيد",
    "studio_nav_home": "الرئيسية",
    "studio_nav_projects": "المشاريع",
    "studio_nav_ai_magic": "سحر الذكاء الاصطناعي",
    "studio_nav_business": "الأعمال",
    "studio_nav_create_aria": "إنشاء تصميم جديد",
    "studio_team_title": "الأعمال — مساحة العمل الجماعي",
    "studio_team_sub": "دعوة الزملاء للعمل معًا. الحد الأقصى 10 أعضاء لكل فريق.",
    "studio_team_load_fail": "تعذر تحميل الفريق",
    "studio_team_create_title": "إنشاء فريق جديد",
    "studio_team_create_sub": "ستصبح المالك ويمكنك دعوة الأعضاء.",
    "studio_team_name_placeholder": "اسم الفريق",
    "studio_team_create_btn": "إنشاء",
    "studio_team_join_title": "انضم عبر دعوة موجودة",
    "studio_team_join_sub": "إذا أرسل لك شخص ما رمز الدعوة.",
    "studio_team_invite_code_placeholder": "رمز الدعوة",
    "studio_team_join_btn": "انضم",
    "studio_team_created": "تم إنشاء الفريق",
    "studio_team_failed": "فشل",
    "studio_team_joined": "انضممت إلى الفريق",
    "studio_team_invite_invalid": "دعوة غير صالحة",
    "studio_team_member_one": "عضو",
    "studio_team_members_many": "أعضاء",
    "studio_team_you_are_owner": "· أنت المالك",
    "studio_team_leave_btn": "مغادرة",
    "studio_team_confirm_leave": "هل تريد حقًا مغادرة الفريق؟",
    "studio_team_left": "غادر الفريق",
    "studio_team_invite_title": "دعوة عضو جديد",
    "studio_team_invite_email_placeholder": "البريد الإلكتروني@example.com",
    "studio_team_send_invite": "إرسال الدعوة",
    "studio_team_invite_copied": "رابط الدعوة تم نسخه إلى الحافظة",
    "studio_team_auto_copy_hint": "رابط الدعوة يتم نسخه إلى الحافظة تلقائيًا.",
    "studio_team_members_header": "الأعضاء",
    "studio_team_owner_badge": "المالك",
    "studio_team_pending_header": "دعوات معلقة",
    "studio_team_expires": "تنتهي صلاحيتها"
  },
  "id": {
    "studio_editor_back": "Kembali",
    "studio_editor_untitled": "Iklan tanpa judul",
    "studio_editor_credits_view": "Lihat buku besar kredit",
    "studio_editor_credits_label": "Kredit",
    "studio_editor_credits_unlimited": "∞ Tak Terbatas",
    "studio_editor_smart_resize": "Ukuran Cerdas",
    "studio_editor_quick_reel": "Reel Cepat",
    "studio_editor_quick_reel_title": "Animasi otomatis setiap elemen untuk reel 15 detik",
    "studio_editor_save": "Simpan",
    "studio_editor_export_png": "Ekspor PNG",
    "studio_editor_mp4": "MP4",
    "studio_editor_mp4_title_ok": "Ekspor video animasi",
    "studio_editor_mp4_title_need_anim": "Tambahkan animasi terlebih dahulu",
    "studio_editor_rail_magic": "Sihir",
    "studio_editor_rail_text": "Teks",
    "studio_editor_rail_shapes": "Bentuk",
    "studio_editor_rail_images": "Gambar",
    "studio_editor_rail_anim": "Animasi",
    "studio_editor_rail_layers": "Lapisan",
    "studio_editor_close_panel": "Tutup panel",
    "studio_editor_close_props": "Tutup properti",
    "studio_editor_open_props": "Buka properti",
    "studio_editor_director_title": "Sutradara Reel AI — satu pengambilan",
    "studio_editor_director_sub": "Satu kalimat → reel animasi penuh (~10s).",
    "studio_editor_magic_title": "Sihir AI — URL → 5 iklan",
    "studio_editor_magic_placeholder": "https://situs-anda.com",
    "studio_editor_magic_generate": "Hasilkan",
    "studio_editor_text_title": "Teks",
    "studio_editor_add_heading": "Tambah judul",
    "studio_editor_shapes_title": "Bentuk",
    "studio_editor_rectangle": "Persegi Panjang",
    "studio_editor_circle": "Lingkaran",
    "studio_editor_background_title": "Latar Belakang",
    "studio_editor_upload_title": "Unggah gambar",
    "studio_editor_stock_btn": "Foto stok",
    "studio_editor_from_url": "Dari URL",
    "studio_editor_add": "Tambah",
    "studio_editor_layers_title": "Lapisan",
    "studio_editor_canvas_empty": "Kanvas kosong.",
    "studio_editor_props_title": "Properti",
    "studio_editor_select_element": "Pilih elemen untuk mengedit propertinya.",
    "studio_editor_prop_text": "Teks",
    "studio_editor_prop_font": "Font",
    "studio_editor_prop_size": "Ukuran",
    "studio_editor_prop_fill": "Isi",
    "studio_editor_prop_opacity": "Kecerahan",
    "studio_editor_duplicate": "Duplikat",
    "studio_editor_delete": "Hapus",
    "studio_editor_toast_offline_info": "Anda sedang bekerja offline. Masuk untuk menyimpan dan mengekspor.",
    "studio_editor_toast_open_fail": "Gagal membuka editor",
    "studio_editor_toast_image_fail": "Gagal memuat gambar",
    "studio_editor_toast_saved": "Disimpan",
    "studio_editor_toast_save_fail": "Gagal menyimpan",
    "studio_editor_toast_log_in_save": "Masuk untuk menyimpan iklan Anda ke cloud.",
    "studio_editor_toast_add_elements_first": "Tambahkan beberapa elemen terlebih dahulu, lalu klik Quick Reel.",
    "studio_editor_toast_need_animation": "Tambahkan setidaknya satu animasi terlebih dahulu (Animasi rel).",
    "studio_editor_toast_browser_no_video": "Browser Anda tidak mendukung perekaman video.",
    "studio_editor_toast_video_fail": "Ekspor video gagal",
    "studio_editor_toast_export_fail": "Ekspor gagal",
    "studio_editor_toast_exported": "Diekspor!",
    "studio_editor_toast_exported_ext": "Diekspor .{ext}!",
    "studio_editor_toast_credits_out": "Kredit iklan habis.",
    "studio_editor_toast_credits_out_upsell": "Kredit iklan Anda habis. Tingkatkan ke Pro seharga 30/bulan.",
    "studio_editor_toast_ai_fail": "AI Magic gagal",
    "studio_editor_toast_no_variants": "Tidak ada varian yang dikembalikan",
    "studio_editor_toast_applied": "Diterapkan: {angle}",
    "studio_editor_toast_quick_reel_done": "Quick Reel · {n} animasi · {s}s",
    "studio_editor_toast_smart_resize_done": "Dibuat {n} iklan saudara{plural}",
    "studio_editor_toast_smart_resize_fail": "Pengubahan ukuran pintar gagal",
    "studio_my_have_coupon": "Punya kupon?",
    "studio_my_coupon_placeholder": "ABCD-EFGH-IJKL",
    "studio_my_redeem": "Tukarkan",
    "studio_my_toast_credits_added": "+{amount} kredit ditambahkan 🎉",
    "studio_my_toast_not_found": "Kode tidak ditemukan",
    "studio_my_toast_already": "Sudah ditukarkan",
    "studio_my_toast_expired": "Berlaku kadaluarsa atau dinonaktifkan",
    "studio_my_toast_redeem_fail": "Gagal menukarkan",
    "studio_my_toast_load_fail": "Gagal memuat proyek",
    "studio_my_confirm_delete": "Hapus \"{title}\"?",
    "studio_my_title": "Desain saya",
    "studio_my_sub": "Semua proyek dan ekspor yang Anda simpan dalam satu tempat.",
    "studio_my_count_one": "{n} proyek",
    "studio_my_count_many": "{n} proyek",
    "studio_my_instant_campaign": "Kampanye Instan",
    "studio_my_new_ad": "Iklan baru",
    "studio_my_login_to_see": "Masuk untuk melihat iklan yang disimpan.",
    "studio_my_login": "Masuk",
    "studio_my_loading": "Memuat…",
    "studio_my_empty_title": "Belum ada iklan.",
    "studio_my_browse": "Jelajahi template",
    "studio_my_badge_team": "Tim",
    "studio_my_badge_shared": "Dibagikan",
    "studio_my_edit": "Sunting",
    "studio_gallery_filter_prefix": "Filter",
    "studio_gallery_filter_cancel": "× hapus",
    "studio_gallery_title": "Template",
    "studio_gallery_lead": "Pilih awal. Sunting apa saja.",
    "studio_gallery_search": "Cari template…",
    "studio_gallery_loading_count": "Memuat…",
    "studio_gallery_count_of": "{start}–{end} dari {total} template",
    "studio_gallery_pack_all": "Semua",
    "studio_gallery_pack_trending": "Sedang Tren",
    "studio_gallery_pack_ai": "Didukung AI",
    "studio_gallery_pack_editorial": "Editorial",
    "studio_gallery_pack_video": "Reel Video",
    "studio_gallery_pack_free": "Gratis",
    "studio_gallery_video_only": "Hanya Video",
    "studio_gallery_all_formats": "Semua format",
    "studio_gallery_all_categories": "Semua kategori",
    "studio_gallery_loading_templates": "Memuat template…",
    "studio_gallery_no_match": "Tidak ada template yang cocok dengan filter tersebut.",
    "studio_gallery_opening": "Membuka editor…",
    "studio_gallery_prev": "← Sebelumnya",
    "studio_gallery_next": "Selanjutnya →",
    "studio_gallery_page_of": "Halaman {n} dari {total}",
    "studio_gallery_type_post": "Post",
    "studio_gallery_type_story": "Cerita",
    "studio_gallery_type_reel": "Reel",
    "studio_gallery_type_video": "Video",
    "studio_gallery_type_ad": "Iklan",
    "studio_landing_meta_title": "Studio — Desain AI, reel & video dalam 60 detik | TopRankPulse",
    "studio_landing_meta_desc": "Buat pos, reel, video dan iklan dengan AI. 1.600+ template, ekspor sekali klik. Bagian dari TopRankPulse.",
    "studio_landing_eyebrow": "BARU · STUDIO OLEH TOPRANKPULSE",
    "studio_landing_hero_title_a": "Buat pos, reel, dan video.",
    "studio_landing_hero_title_b": "Dalam hitungan menit, bukan hari.",
    "studio_landing_hero_lead": "Pilih jenis konten, template, atau biarkan AI menyusun versi pertama. Edit di editor gaya Canva. Ekspor PNG / MP4 dengan sekali klik. Iklan, reel, cerita, video, dan pos — semua dalam satu.",
    "studio_landing_cta_start": "Mulai membuat",
    "studio_landing_cta_instant": "Kampanye Instan — 25 iklan",
    "studio_landing_cta_browse": "Jelajahi template",
    "studio_landing_kpi_projects": "Proyek dibuat",
    "studio_landing_kpi_exports": "Ekspor diunduh",
    "studio_landing_kpi_templates": "Template",
    "studio_landing_kpi_formats": "Format iklan",
    "studio_landing_features_title": "Sebuah studio. Bukan tayangan slide.",
    "studio_landing_features_sub": "Semua yang sebenarnya digunakan pemasar kinerja — satu layar, tanpa tab.",
    "studio_landing_feat_ai_title": "Sihir AI dari URL",
    "studio_landing_feat_ai_text": "Tempelkan sebuah situs web, dapatkan 5 konsep iklan lengkap — warna merek, judul, CTA, kanvas siap bagi.",
    "studio_landing_feat_type_title": "Tipografi lengkap",
    "studio_landing_feat_type_text": "Font, bobot, pelacakan, garis besar, bayangan jatuh. Kotak teks yang berperilaku seperti Adobe, bukan PowerPoint.",
    "studio_landing_feat_img_title": "AI + gambar stok",
    "studio_landing_feat_img_text": "Hasilkan latar belakang sempurna dengan GPT Image 1. Unsplash dan Pexels sudah terintegrasi.",
    "studio_landing_feat_brand_title": "Kit merek",
    "studio_landing_feat_brand_text": "Kunci warna, font, logo Anda sekali. Setiap iklan baru mewarisi secara otomatis.",
    "studio_landing_feat_resize_title": "Penyusunan ulang cerdas",
    "studio_landing_feat_resize_text": "Satu kanvas → 10 iklan sejenis yang secara otomatis disesuaikan untuk setiap format. Kirim kampanye lengkap dalam sekali klik.",
    "studio_landing_feat_wl_title": "Siap label putih",
    "studio_landing_feat_wl_text": "Dibangun untuk disematkan. Sisipkan ke dalam portal agensi Anda melalui iframe atau API. Merek Anda, mesin kami.",
    "studio_landing_formats_title": "10 format iklan. Satu kanvas.",
    "studio_landing_formats_sub": "Facebook, Instagram, Google Display, LinkedIn. Feed, Cerita, Reel.",
    "studio_landing_pricing_title": "Harga sederhana berbasis kredit.",
    "studio_landing_pricing_sub": "Mulai gratis. Skala saat kampanye Anda berkembang.",
    "studio_landing_pricing_extra": "Iklan tambahan di luar paket: €2.30 / kredit · batalkan kapan saja",
    "studio_landing_price_free_credits": "3 iklan · sekali saja",
    "studio_landing_price_starter_credits": "10 iklan / bulan",
    "studio_landing_price_pro_credits": "30 iklan / bulan",
    "studio_landing_price_agency_credits": "80 iklan / bulan",
    "studio_landing_price_free_f1": "Semua 10 format",
    "studio_landing_price_free_f2": "Sihir AI dari URL",
    "studio_landing_price_free_f3": "Ekspor PNG",
    "studio_landing_price_free_f4": "Tanpa kartu kredit",
    "studio_landing_price_starter_f1": "Semua di Free",
    "studio_landing_price_starter_f2": "Kit Merek",
    "studio_landing_price_starter_f3": "Ukuran Cerdas",
    "studio_landing_price_starter_f4": "Antrian Prioritas",
    "studio_landing_price_pro_f1": "Semua di Starter",
    "studio_landing_price_pro_f2": "Gen Gambar AI (GPT Image 1)",
    "studio_landing_price_pro_f3": "Ekspor video (akan datang)",
    "studio_landing_price_pro_f4": "Hapus watermark",
    "studio_landing_price_agency_f1": "Semua di Pro",
    "studio_landing_price_agency_f2": "Tempat tim (akan datang)",
    "studio_landing_price_agency_f3": "Ekspor label putih",
    "studio_landing_price_agency_f4": "Dukungan khusus",
    "studio_landing_price_free_cta": "Mulai gratis",
    "studio_landing_price_starter_cta": "Dapatkan Starter",
    "studio_landing_price_pro_cta": "Dapatkan Pro",
    "studio_landing_price_agency_cta": "Dapatkan Agency",
    "studio_landing_price_most_popular": "Paling populer",
    "studio_landing_final_title": "Kirim iklan pertamamu malam ini.",
    "studio_landing_final_sub": "Tiga iklan gratis. Tanpa kartu. Dua klik untuk menerbitkan.",
    "studio_landing_final_btn": "Buka editor",
    "studio_landing_footer": "Studio · bagian dari",
    "studio_create_back_select": "← Kembali ke pilihan",
    "studio_create_new_prefix": "Baru",
    "studio_create_type_desc_suffix": "Pilih template, atau mulai dari kanvas kosong.",
    "studio_create_opt_templates_title": "Pilih template",
    "studio_create_opt_templates_sub": "Ratusan desain siap pakai — dapat diedit",
    "studio_create_opt_blank_title": "Kanvas kosong",
    "studio_create_opt_blank_sub": "Kontrol penuh, kanvas kosong",
    "studio_create_opt_ai_title": "Sihir AI ✨",
    "studio_create_opt_ai_sub": "Deskripsikan apa yang Anda inginkan — AI membuat versi pertama",
    "studio_create_hub_eyebrow": "Apa yang Anda buat?",
    "studio_create_hub_title_a": "Mari kita",
    "studio_create_hub_title_b": "berkreasi",
    "studio_create_hub_sub": "Pilih jenis konten. Setiap preset membuka dimensi dan template yang sesuai.",
    "studio_create_card_start": "Mulai",
    "studio_create_type_post_label": "Post",
    "studio_create_type_post_desc": "Instagram 1:1 · Facebook 4:5",
    "studio_create_type_story_label": "Story",
    "studio_create_type_story_desc": "9:16 · IG / FB / TikTok",
    "studio_create_type_reel_label": "Reel",
    "studio_create_type_reel_desc": "9:16 animasi · 15–60s",
    "studio_create_type_video_label": "Video",
    "studio_create_type_video_desc": "16:9 · lanskap",
    "studio_create_type_ad_label": "Iklan",
    "studio_create_type_ad_desc": "Kreatif iklan FB/IG",
    "studio_more_title": "Lainnya",
    "studio_more_sub": "Pengaturan, akun, dan alat lainnya.",
    "studio_more_settings": "Pengaturan akun",
    "studio_more_notifications": "Notifikasi",
    "studio_more_plan": "Rencana & tagihan",
    "studio_more_invite": "Undang teman",
    "studio_more_redeem": "Tukarkan kupon",
    "studio_more_ai": "Keajaiban AI",
    "studio_more_privacy": "Privasi",
    "studio_more_help": "Bantuan & Blog",
    "studio_more_logout": "Keluar",
    "studio_nav_create": "Buat",
    "studio_nav_mine": "Desain saya",
    "studio_nav_templates": "Template",
    "studio_nav_community": "Komunitas",
    "studio_nav_more": "Lainnya",
    "studio_nav_home": "Beranda",
    "studio_nav_projects": "Proyek",
    "studio_nav_ai_magic": "Keajaiban AI",
    "studio_nav_business": "Bisnis",
    "studio_nav_create_aria": "Buat desain baru",
    "studio_team_title": "Bisnis — ruang kerja tim",
    "studio_team_sub": "Undang rekan untuk bekerja sama. Max. 10 anggota per tim.",
    "studio_team_load_fail": "Gagal memuat tim",
    "studio_team_create_title": "Buat tim baru",
    "studio_team_create_sub": "Anda menjadi pemilik dan dapat mengundang anggota.",
    "studio_team_name_placeholder": "Nama tim",
    "studio_team_create_btn": "Buat",
    "studio_team_join_title": "Bergabung dengan undangan yang ada",
    "studio_team_join_sub": "Jika seseorang mengirimkan kode undangan kepada Anda.",
    "studio_team_invite_code_placeholder": "Kode undangan",
    "studio_team_join_btn": "Bergabung",
    "studio_team_created": "Tim dibuat",
    "studio_team_failed": "Gagal",
    "studio_team_joined": "Bergabung dengan tim",
    "studio_team_invite_invalid": "Undangan tidak valid",
    "studio_team_member_one": "anggota",
    "studio_team_members_many": "anggota",
    "studio_team_you_are_owner": "· Anda adalah pemilik",
    "studio_team_leave_btn": "Keluar",
    "studio_team_confirm_leave": "Benarkah Anda ingin keluar dari tim?",
    "studio_team_left": "Keluar dari tim",
    "studio_team_invite_title": "Undang anggota baru",
    "studio_team_invite_email_placeholder": "email@contoh.com",
    "studio_team_send_invite": "Kirim undangan",
    "studio_team_invite_copied": "Tautan undangan disalin ke papan klip",
    "studio_team_auto_copy_hint": "Tautan undangan disalin ke papan klip secara otomatis.",
    "studio_team_members_header": "Anggota",
    "studio_team_owner_badge": "Pemilik",
    "studio_team_pending_header": "Undangan tertunda",
    "studio_team_expires": "Kedaluwarsa"
  }
};
